function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("jgVsb", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$917e50e7374c5801$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $kdO7l;
    var $cUyQo;
    const $917e50e7374c5801$var$headerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBlockEnd: -(0, (0, parcelRequire("cUyQo")).keylineHeight),
        paddingBlockEnd: "var(--ds-space-200, 16px)",
        paddingBlockStart: "var(--ds-space-300, 24px)",
        paddingInline: "var(--ds-space-300, 24px)"
    });
    const $917e50e7374c5801$var$ModalHeader = (props)=>{
        const { children: children, testId: userDefinedTestId } = props;
        const { testId: modalTestId } = (0, (0, parcelRequire("kdO7l")).useModal)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $917e50e7374c5801$var$headerStyles,
            "data-testid": testId
        }, children);
    };
    var $917e50e7374c5801$export$2e2bcd8739ae039 = $917e50e7374c5801$var$ModalHeader;
});
parcelRegister("kdO7l", function(module, exports) {
    $parcel$export(module.exports, "useModal", ()=>$ba226b18ae1f0093$export$33ffd74ebf07f060);
    var $5uXOq = parcelRequire("5uXOq");
    var $fYbIt;
    const $ba226b18ae1f0093$export$33ffd74ebf07f060 = ()=>{
        const modalContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("fYbIt")).ModalContext));
        if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
        return modalContext;
    };
});
parcelRegister("fYbIt", function(module, exports) {
    $parcel$export(module.exports, "ModalContext", ()=>$086829fa8fafdd69$export$ab57792b9b6974a6);
    $parcel$export(module.exports, "ScrollContext", ()=>$086829fa8fafdd69$export$dece24112a937f92);
    var $5uXOq = parcelRequire("5uXOq");
    const $086829fa8fafdd69$export$ab57792b9b6974a6 = (0, $5uXOq.createContext)(null);
    const $086829fa8fafdd69$export$dece24112a937f92 = (0, $5uXOq.createContext)(null);
});
parcelRegister("cUyQo", function(module, exports) {
    $parcel$export(module.exports, "width", ()=>$30e3c27ee4264249$export$7e3df82ee760448c);
    $parcel$export(module.exports, "gutter", ()=>$30e3c27ee4264249$export$f2b922cb4a245974);
    $parcel$export(module.exports, "borderRadius", ()=>$30e3c27ee4264249$export$7a57f79000377ca2);
    $parcel$export(module.exports, "verticalOffset", ()=>$30e3c27ee4264249$export$9212741279b5f103);
    $parcel$export(module.exports, "keylineHeight", ()=>$30e3c27ee4264249$export$4c317248f944c2a9);
    $parcel$export(module.exports, "keylineColor", ()=>$30e3c27ee4264249$export$d901150a4cc83165);
    $parcel$export(module.exports, "textColor", ()=>$30e3c27ee4264249$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "iconColor", ()=>$30e3c27ee4264249$export$3797a580396e3639);
    var $k5uoT;
    const $30e3c27ee4264249$export$7e3df82ee760448c = {
        values: [
            'small',
            'medium',
            'large',
            'x-large'
        ],
        widths: {
            small: 400,
            medium: 600,
            large: 800,
            'x-large': 968
        },
        defaultValue: 'medium'
    };
    const $30e3c27ee4264249$export$f2b922cb4a245974 = 60;
    const $30e3c27ee4264249$var$gridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $30e3c27ee4264249$export$7a57f79000377ca2 = (0, (0, parcelRequire("k5uoT")).borderRadius)();
    const $30e3c27ee4264249$export$9212741279b5f103 = $30e3c27ee4264249$var$gridSize * 2;
    const $30e3c27ee4264249$export$4c317248f944c2a9 = 2;
    const $30e3c27ee4264249$export$d901150a4cc83165 = `var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $30e3c27ee4264249$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
    const $30e3c27ee4264249$export$3797a580396e3639 = {
        danger: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        warning: "var(--ds-icon-warning, #D97008)"
    };
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("gofOI", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$c302b95a5bf85006$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dD7Zc;
    var $bU3PY;
    var $kdO7l;
    var $cUyQo;
    function $c302b95a5bf85006$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c302b95a5bf85006$var$titleStyles = {
        name: "1yaejj3",
        styles: "display:flex;min-width:0;margin:var(--ds-space-0, 0px);gap:var(--ds-space-100, 8px);font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $c302b95a5bf85006$var$textStyles = {
        name: "1k30s2j",
        styles: "min-width:0;flex:1 1 auto;word-wrap:break-word"
    };
    const $c302b95a5bf85006$var$iconStyles = {
        name: "1cdsq8b",
        styles: "flex:0 0 auto;color:inherit;font-size:inherit;font-style:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit"
    };
    const $c302b95a5bf85006$var$truncatedTextStyles = {
        name: "1h52dri",
        styles: "overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $c302b95a5bf85006$var$TitleIcon = ({ appearance: appearance })=>{
        const Icon = appearance === 'danger' ? (0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))) : (0, ($parcel$interopDefault((0, parcelRequire("bU3PY")))));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $c302b95a5bf85006$var$iconStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
            label: appearance,
            color: (0, (0, parcelRequire("cUyQo")).iconColor)[appearance],
            spacing: "spacious"
        }));
    };
    const $c302b95a5bf85006$var$ModalTitle = (props)=>{
        const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
        const { titleId: titleId, testId: modalTestId } = (0, (0, parcelRequire("kdO7l")).useModal)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("h1", {
            css: $c302b95a5bf85006$var$titleStyles,
            "data-testid": testId
        }, appearance && (0, (0, parcelRequire("f8Sb3")).jsx)($c302b95a5bf85006$var$TitleIcon, {
            appearance: appearance
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: titleId,
            css: [
                $c302b95a5bf85006$var$textStyles,
                !isMultiline && $c302b95a5bf85006$var$truncatedTextStyles
            ],
            "data-testid": testId && `${testId}-text`
        }, children));
    };
    var $c302b95a5bf85006$export$2e2bcd8739ae039 = $c302b95a5bf85006$var$ModalTitle;
});
parcelRegister("dD7Zc", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9ec51cc6530104e1$var$_react = $9ec51cc6530104e1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9ec51cc6530104e1$var$_error = $9ec51cc6530104e1$var$_interopRequireDefault((parcelRequire("hMVoD")));
    var $9ec51cc6530104e1$var$_error2 = $9ec51cc6530104e1$var$_interopRequireDefault((parcelRequire("7nnPp")));
    function $9ec51cc6530104e1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9ec51cc6530104e1$var$ErrorIcon = (props)=>$9ec51cc6530104e1$var$_react.default.createElement($9ec51cc6530104e1$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $9ec51cc6530104e1$var$_error2.default
        }, props));
    $9ec51cc6530104e1$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $9ec51cc6530104e1$var$_default = module.exports.default = $9ec51cc6530104e1$var$ErrorIcon;
});
parcelRegister("hMVoD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cf33711b0175a169$var$_react = $cf33711b0175a169$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $cf33711b0175a169$var$_UNSAFE_baseNew = $cf33711b0175a169$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $cf33711b0175a169$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cf33711b0175a169$var$ErrorIcon = (props)=>$cf33711b0175a169$var$_react.default.createElement($cf33711b0175a169$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
        }, props));
    $cf33711b0175a169$var$ErrorIcon.displayName = 'ErrorIcon';
    var $cf33711b0175a169$var$_default = module.exports.default = $cf33711b0175a169$var$ErrorIcon;
});
parcelRegister("7nnPp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $55ed2a2e9aa38bb0$var$_react = $55ed2a2e9aa38bb0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $55ed2a2e9aa38bb0$var$_error = $55ed2a2e9aa38bb0$var$_interopRequireDefault((parcelRequire("hMVoD")));
    function $55ed2a2e9aa38bb0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $55ed2a2e9aa38bb0$var$ErrorIcon = (props)=>$55ed2a2e9aa38bb0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
        }, props, {
            newIcon: $55ed2a2e9aa38bb0$var$_error.default
        }));
    $55ed2a2e9aa38bb0$var$ErrorIcon.displayName = 'ErrorIcon';
    var $55ed2a2e9aa38bb0$var$_default = module.exports.default = $55ed2a2e9aa38bb0$var$ErrorIcon;
});
parcelRegister("bU3PY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8aa7e6aabd9c587d$var$_react = $8aa7e6aabd9c587d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8aa7e6aabd9c587d$var$_warning = $8aa7e6aabd9c587d$var$_interopRequireDefault((parcelRequire("34Rrn")));
    var $8aa7e6aabd9c587d$var$_warning2 = $8aa7e6aabd9c587d$var$_interopRequireDefault((parcelRequire("gtreQ")));
    function $8aa7e6aabd9c587d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8aa7e6aabd9c587d$var$WarningIcon = (props)=>$8aa7e6aabd9c587d$var$_react.default.createElement($8aa7e6aabd9c587d$var$_warning.default, Object.assign({
            LEGACY_fallbackIcon: $8aa7e6aabd9c587d$var$_warning2.default
        }, props));
    $8aa7e6aabd9c587d$var$WarningIcon.Name = 'WarningIconMigration';
    var $8aa7e6aabd9c587d$var$_default = module.exports.default = $8aa7e6aabd9c587d$var$WarningIcon;
});
parcelRegister("34Rrn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $23db3304004ad7e6$var$_react = $23db3304004ad7e6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $23db3304004ad7e6$var$_UNSAFE_baseNew = $23db3304004ad7e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $23db3304004ad7e6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $23db3304004ad7e6$var$WarningIcon = (props)=>$23db3304004ad7e6$var$_react.default.createElement($23db3304004ad7e6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.757-1.395 2.76-1.395 3.516 0l5.9 10.878C16.381 13.38 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
        }, props));
    $23db3304004ad7e6$var$WarningIcon.displayName = 'WarningIcon';
    var $23db3304004ad7e6$var$_default = module.exports.default = $23db3304004ad7e6$var$WarningIcon;
});
parcelRegister("gtreQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bfe47bbe11245bb9$var$_react = $bfe47bbe11245bb9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $bfe47bbe11245bb9$var$_warning = $bfe47bbe11245bb9$var$_interopRequireDefault((parcelRequire("34Rrn")));
    function $bfe47bbe11245bb9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bfe47bbe11245bb9$var$WarningIcon = (props)=>$bfe47bbe11245bb9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
        }, props, {
            newIcon: $bfe47bbe11245bb9$var$_warning.default
        }));
    $bfe47bbe11245bb9$var$WarningIcon.displayName = 'WarningIcon';
    var $bfe47bbe11245bb9$var$_default = module.exports.default = $bfe47bbe11245bb9$var$WarningIcon;
});
parcelRegister("7QSqG", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$2169e0f4dcf60dbd$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $2alJM = parcelRequire("2alJM");
    var $kdO7l;
    var $ke3x4;
    var $cUyQo;
    var $9sx7u;
    function $2169e0f4dcf60dbd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2169e0f4dcf60dbd$var$bodyStyles = {
        name: "mkkf9p",
        styles: "flex:1 1 auto"
    };
    const $2169e0f4dcf60dbd$var$bodyScrollStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingBlock: (0, (0, parcelRequire("cUyQo")).keylineHeight),
        paddingInline: "var(--ds-space-300, 24px)"
    });
    const $2169e0f4dcf60dbd$var$viewportScrollStyles = {
        name: "1g6ejo8",
        styles: "padding-inline:var(--ds-space-300, 24px)"
    };
    const $2169e0f4dcf60dbd$var$ModalBody = (props)=>{
        const { children: children, testId: userDefinedTestId } = props;
        const { testId: modalTestId } = (0, (0, parcelRequire("kdO7l")).useModal)();
        const shouldScrollInViewport = (0, (0, parcelRequire("9sx7u")).default)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
        return shouldScrollInViewport ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $2169e0f4dcf60dbd$var$bodyStyles,
                $2169e0f4dcf60dbd$var$viewportScrollStyles
            ],
            "data-testid": testId
        }, children) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, $2alJM.TouchScrollable), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ke3x4")).default), {
            testId: userDefinedTestId || modalTestId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $2169e0f4dcf60dbd$var$bodyStyles,
                $2169e0f4dcf60dbd$var$bodyScrollStyles
            ],
            "data-testid": testId
        }, children)));
    };
    var $2169e0f4dcf60dbd$export$2e2bcd8739ae039 = $2169e0f4dcf60dbd$var$ModalBody;
});
parcelRegister("ke3x4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3670e1796fbbd4c6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $7nRxN;
    var $5JjdN;
    var $eGmKJ;
    var $i65Nq;
    var $jhVLw;
    var $h9kUS;
    var $cUyQo;
    const $3670e1796fbbd4c6$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inherit',
        margin: "var(--ds-space-0, 0px)",
        flex: 'inherit',
        flexDirection: 'inherit',
        flexGrow: 1,
        overflowX: 'hidden',
        overflowY: 'auto',
        [(0, (0, parcelRequire("h9kUS")).media).above.xs]: {
            height: 'unset',
            overflowY: 'auto'
        }
    });
    const $3670e1796fbbd4c6$var$topKeylineStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockStart: `${(0, (0, parcelRequire("cUyQo")).keylineHeight)}px solid ${(0, (0, parcelRequire("cUyQo")).keylineColor)}`
    });
    const $3670e1796fbbd4c6$var$bottomKeylineStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockEnd: `${(0, (0, parcelRequire("cUyQo")).keylineHeight)}px solid ${(0, (0, parcelRequire("cUyQo")).keylineColor)}`
    });
    const $3670e1796fbbd4c6$var$ScrollContainer = (0, $5uXOq.forwardRef)(({ testId: testId, children: children }, ref)=>{
        const scrollableRef = (0, $5uXOq.useRef)(null);
        const [showTopKeyline, setTopKeyline] = (0, $5uXOq.useState)(false);
        const [showBottomKeyline, setBottomKeyline] = (0, $5uXOq.useState)(false);
        const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            const schedule = (0, (0, parcelRequire("7nRxN")).default)(()=>{
                const target = scrollableRef.current;
                target && setContentFocus(target.scrollHeight > target.clientHeight);
            });
            schedule();
        }, [
            scrollableRef
        ]);
        const setLazyKeylines = (0, (0, parcelRequire("i65Nq")).default)((0, (0, parcelRequire("7nRxN")).default)(()=>{
            const target = scrollableRef.current;
            if (target) {
                const scrollableDistance = target.scrollHeight - target.clientHeight;
                if (target.previousElementSibling) setTopKeyline(target.scrollTop > (0, (0, parcelRequire("cUyQo")).keylineHeight));
                if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, (0, parcelRequire("cUyQo")).keylineHeight));
            }
        }));
        (0, $5uXOq.useEffect)(()=>{
            const target = scrollableRef.current;
            setLazyKeylines();
            const unbindWindowEvent = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'resize',
                listener: setLazyKeylines
            });
            const unbindTargetEvent = target ? (0, (0, parcelRequire("cBeZP")).bind)(target, {
                type: 'scroll',
                listener: setLazyKeylines
            }) : (0, (0, parcelRequire("eGmKJ")).default);
            return ()=>{
                unbindWindowEvent();
                unbindTargetEvent();
            };
        }, [
            setLazyKeylines
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            tabIndex: showContentFocus ? 0 : undefined,
            role: showContentFocus ? 'region' : undefined,
            "aria-label": showContentFocus ? 'Scrollable content' : undefined,
            "data-testid": testId && `${testId}--scrollable`,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                scrollableRef
            ]),
            css: [
                $3670e1796fbbd4c6$var$baseStyles,
                showTopKeyline && $3670e1796fbbd4c6$var$topKeylineStyles,
                showBottomKeyline && $3670e1796fbbd4c6$var$bottomKeylineStyles
            ]
        }, children));
    });
    $3670e1796fbbd4c6$var$ScrollContainer.displayName = 'ScrollContainer';
    var $3670e1796fbbd4c6$export$2e2bcd8739ae039 = $3670e1796fbbd4c6$var$ScrollContainer;
});
parcelRegister("5JjdN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$633359c4b482af8b$export$2e2bcd8739ae039);
    function $633359c4b482af8b$export$2e2bcd8739ae039(refs) {
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref !== null) ref.current = value;
            });
        };
    }
});
parcelRegister("i65Nq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8170a624321a7900$export$2e2bcd8739ae039);
    var $f8qry;
    function $8170a624321a7900$export$2e2bcd8739ae039(callback) {
        const ref = (0, (0, parcelRequire("f8qry")).default)(()=>callback);
        return ref.current;
    }
});
parcelRegister("f8qry", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f294347e0efb6c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $6f294347e0efb6c9$var$uniqueReferencedValue = {};
    function $6f294347e0efb6c9$export$2e2bcd8739ae039(initializer) {
        const ref = (0, $5uXOq.useRef)($6f294347e0efb6c9$var$uniqueReferencedValue);
        if (ref.current === $6f294347e0efb6c9$var$uniqueReferencedValue) ref.current = initializer();
        return ref;
    }
});
parcelRegister("h9kUS", function(module, exports) {
    $parcel$export(module.exports, "media", ()=>$e6a0601943d9b8d2$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "UNSAFE_media", ()=>$e6a0601943d9b8d2$export$c881183ca713c214);
    const $e6a0601943d9b8d2$export$987d49ffe1b0900f = {
        above: {
            xxs: '@media all',
            xs: '@media (min-width: 30rem)',
            sm: '@media (min-width: 48rem)',
            md: '@media (min-width: 64rem)',
            lg: '@media (min-width: 90rem)',
            xl: '@media (min-width: 110.5rem)'
        },
        only: {
            xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
            xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
            sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
            md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
            lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
            xl: '@media (min-width: 110.5rem)'
        },
        below: {
            xs: '@media not all and (min-width: 30rem)',
            sm: '@media not all and (min-width: 48rem)',
            md: '@media not all and (min-width: 64rem)',
            lg: '@media not all and (min-width: 90rem)',
            xl: '@media not all and (min-width: 110.5rem)'
        }
    };
    const $e6a0601943d9b8d2$export$c881183ca713c214 = $e6a0601943d9b8d2$export$987d49ffe1b0900f;
});
parcelRegister("9sx7u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6267dd4dabfabb6f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fYbIt;
    function $6267dd4dabfabb6f$export$2e2bcd8739ae039() {
        const shouldScrollInViewport = (0, $5uXOq.useContext)((0, (0, parcelRequire("fYbIt")).ScrollContext));
        if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
        return shouldScrollInViewport;
    }
});
parcelRegister("juxqI", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$4eb21c8acfa6cbdd$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $kdO7l;
    var $cUyQo;
    const $4eb21c8acfa6cbdd$var$footerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: "var(--ds-space-100, 8px)",
        marginBlockStart: -(0, (0, parcelRequire("cUyQo")).keylineHeight),
        paddingBlockEnd: "var(--ds-space-300, 24px)",
        paddingBlockStart: "var(--ds-space-200, 16px)",
        paddingInline: "var(--ds-space-300, 24px)"
    });
    const $4eb21c8acfa6cbdd$var$ModalFooter = (props)=>{
        const { children: children, testId: userDefinedTestId } = props;
        const { testId: modalTestId } = (0, (0, parcelRequire("kdO7l")).useModal)();
        const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $4eb21c8acfa6cbdd$var$footerStyles,
            "data-testid": testId
        }, children);
    };
    var $4eb21c8acfa6cbdd$export$2e2bcd8739ae039 = $4eb21c8acfa6cbdd$var$ModalFooter;
});
parcelRegister("hPSf5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cfc14681ddf388d2$var$_react = $cfc14681ddf388d2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $cfc14681ddf388d2$var$_dashboard = $cfc14681ddf388d2$var$_interopRequireDefault((parcelRequire("gsyzJ")));
    function $cfc14681ddf388d2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cfc14681ddf388d2$var$ActivityIcon = (props)=>$cfc14681ddf388d2$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M19.004 17C19 17 19 7.006 19 7.006 19 7 4.996 7 4.996 7 5 7 5 16.994 5 16.994 5 17 19.004 17 19.004 17M3 7.006A2 2 0 0 1 4.995 5h14.01A2 2 0 0 1 21 7.006v9.988A2 2 0 0 1 19.005 19H4.995A2 2 0 0 1 3 16.994z"/><path d="M4 6h16v5H4zm5 2c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01C9.455 7 9 7.448 9 8M5 8c0 .556.448 1 1 1 .556 0 1-.448 1-1 0-.556-.448-1-1-1-.556 0-1 .448-1 1"/></g></svg>`
        }, props, {
            newIcon: $cfc14681ddf388d2$var$_dashboard.default
        }));
    $cfc14681ddf388d2$var$ActivityIcon.displayName = 'ActivityIcon';
    var $cfc14681ddf388d2$var$_default = module.exports.default = $cfc14681ddf388d2$var$ActivityIcon;
});
parcelRegister("gsyzJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bfba14cfc1d5c2b2$var$_react = $bfba14cfc1d5c2b2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bfba14cfc1d5c2b2$var$_UNSAFE_baseNew = $bfba14cfc1d5c2b2$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $bfba14cfc1d5c2b2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bfba14cfc1d5c2b2$var$DashboardIcon = (props)=>$bfba14cfc1d5c2b2$var$_react.default.createElement($bfba14cfc1d5c2b2$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h5m0-12.5h5c.69 0 1.25.56 1.25 1.25v5M8 1.75V8m0 6.25h5c.69 0 1.25-.56 1.25-1.25V8M8 14.25V8m0 0h6.25"/>`
        }, props));
    $bfba14cfc1d5c2b2$var$DashboardIcon.displayName = 'DashboardIcon';
    var $bfba14cfc1d5c2b2$var$_default = module.exports.default = $bfba14cfc1d5c2b2$var$DashboardIcon;
});
parcelRegister("apKqz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $795040bc4792cf5e$var$_react = $795040bc4792cf5e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $795040bc4792cf5e$var$_app = $795040bc4792cf5e$var$_interopRequireDefault((parcelRequire("hRf4g")));
    function $795040bc4792cf5e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $795040bc4792cf5e$var$AddonIcon = (props)=>$795040bc4792cf5e$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m5.376 6.455 5.248-3.104c.792-.469 1.963-.467 2.752 0l5.248 3.104C19.416 6.923 20 7.962 20 8.895v6.21c0 .936-.587 1.973-1.376 2.44l-5.248 3.104c-.792.469-1.963.467-2.752 0l-5.248-3.104C4.584 17.077 4 16.038 4 15.105v-6.21c0-.936.587-1.973 1.376-2.44m6.99-1.314c-.165-.098-.566-.098-.733 0L6.385 8.245c-.166.098-.367.454-.367.65v6.21c0 .195.2.551.367.65l5.248 3.104c.166.098.567.098.734 0l5.248-3.104c.166-.098.367-.454.367-.65v-6.21c0-.195-.2-.551-.367-.65z"/><path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></g></svg>`
        }, props, {
            newIcon: $795040bc4792cf5e$var$_app.default
        }));
    $795040bc4792cf5e$var$AddonIcon.displayName = 'AddonIcon';
    var $795040bc4792cf5e$var$_default = module.exports.default = $795040bc4792cf5e$var$AddonIcon;
});
parcelRegister("hRf4g", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d003130f2c1019f5$var$_react = $d003130f2c1019f5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d003130f2c1019f5$var$_UNSAFE_baseNew = $d003130f2c1019f5$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $d003130f2c1019f5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d003130f2c1019f5$var$AppIcon = (props)=>$d003130f2c1019f5$var$_react.default.createElement($d003130f2c1019f5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2.357 4.136 5-3a1.25 1.25 0 0 1 1.286 0l5 3c.377.226.607.633.607 1.072v5.584c0 .44-.23.846-.607 1.072l-5 3a1.25 1.25 0 0 1-1.286 0l-5-3a1.25 1.25 0 0 1-.607-1.072V5.208c0-.44.23-.846.607-1.072Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
        }, props));
    $d003130f2c1019f5$var$AppIcon.displayName = 'AppIcon';
    var $d003130f2c1019f5$var$_default = module.exports.default = $d003130f2c1019f5$var$AppIcon;
});
parcelRegister("4PKNr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $385039a59389c30c$var$_react = $385039a59389c30c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $385039a59389c30c$var$_appSwitcher = $385039a59389c30c$var$_interopRequireDefault((parcelRequire("3fDjf")));
    function $385039a59389c30c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $385039a59389c30c$var$AppSwitcherIcon = (props)=>$385039a59389c30c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01z"/></svg>`
        }, props, {
            newIcon: $385039a59389c30c$var$_appSwitcher.default
        }));
    $385039a59389c30c$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
    var $385039a59389c30c$var$_default = module.exports.default = $385039a59389c30c$var$AppSwitcherIcon;
});
parcelRegister("3fDjf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25e143d7635b2d95$var$_react = $25e143d7635b2d95$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $25e143d7635b2d95$var$_UNSAFE_baseNew = $25e143d7635b2d95$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $25e143d7635b2d95$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25e143d7635b2d95$var$AppSwitcherIcon = (props)=>$25e143d7635b2d95$var$_react.default.createElement($25e143d7635b2d95$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25zm8 0c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25zm-8 8c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25zm8 0c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25z"/>`
        }, props));
    $25e143d7635b2d95$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
    var $25e143d7635b2d95$var$_default = module.exports.default = $25e143d7635b2d95$var$AppSwitcherIcon;
});
parcelRegister("3gt3f", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $260966be5d9bd0f6$var$_react = $260966be5d9bd0f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $260966be5d9bd0f6$var$_arrowLeft = $260966be5d9bd0f6$var$_interopRequireDefault((parcelRequire("ctqwA")));
    function $260966be5d9bd0f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $260966be5d9bd0f6$var$ArrowLeftIcon = (props)=>$260966be5d9bd0f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
        }, props, {
            newIcon: $260966be5d9bd0f6$var$_arrowLeft.default
        }));
    $260966be5d9bd0f6$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
    var $260966be5d9bd0f6$var$_default = module.exports.default = $260966be5d9bd0f6$var$ArrowLeftIcon;
});
parcelRegister("ctqwA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $914cc4b222e651e0$var$_react = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $914cc4b222e651e0$var$_UNSAFE_baseNew = $914cc4b222e651e0$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $914cc4b222e651e0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $914cc4b222e651e0$var$ArrowLeftIcon = (props)=>$914cc4b222e651e0$var$_react.default.createElement($914cc4b222e651e0$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
        }, props));
    $914cc4b222e651e0$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
    var $914cc4b222e651e0$var$_default = module.exports.default = $914cc4b222e651e0$var$ArrowLeftIcon;
});
parcelRegister("5DSin", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $41bab6388b256edf$var$_react = $41bab6388b256edf$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $41bab6388b256edf$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $41bab6388b256edf$var$BillingIcon = (props)=>$41bab6388b256edf$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M7 4v16h10V4zm-2-.01C5 2.892 5.897 2 7.006 2h9.988C18.102 2 19 2.898 19 3.99v16.02c0 1.099-.897 1.99-2.006 1.99H7.006A2.003 2.003 0 0 1 5 20.01z"/><rect width="8" height="2" x="8" y="6" rx="1"/><rect width="5" height="2" x="8" y="9" rx="1"/><rect width="5" height="2" x="8" y="12" rx="1"/><rect width="5" height="2" x="8" y="15" rx="1"/><rect width="2" height="2" x="14" y="12" rx="1"/><rect width="2" height="2" x="14" y="15" rx="1"/><rect width="2" height="2" x="14" y="9" rx="1"/></g></svg>`
        }, props));
    $41bab6388b256edf$var$BillingIcon.displayName = 'BillingIcon';
    var $41bab6388b256edf$var$_default = module.exports.default = $41bab6388b256edf$var$BillingIcon;
});
parcelRegister("6Ingq", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4e38e5e3b0c66004$var$_react = $4e38e5e3b0c66004$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4e38e5e3b0c66004$var$_chevronDown = $4e38e5e3b0c66004$var$_interopRequireDefault((parcelRequire("hORKG")));
    function $4e38e5e3b0c66004$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4e38e5e3b0c66004$var$ChevronDownIcon = (props)=>$4e38e5e3b0c66004$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
        }, props, {
            newIcon: $4e38e5e3b0c66004$var$_chevronDown.default,
            iconType: "utility"
        }));
    $4e38e5e3b0c66004$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
    var $4e38e5e3b0c66004$var$_default = module.exports.default = $4e38e5e3b0c66004$var$ChevronDownIcon;
});
parcelRegister("ebd3R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a52c39769ffb7919$var$_react = $a52c39769ffb7919$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $a52c39769ffb7919$var$_chevronRight = $a52c39769ffb7919$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $a52c39769ffb7919$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a52c39769ffb7919$var$ChevronRightIcon = (props)=>$a52c39769ffb7919$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></svg>`
        }, props, {
            newIcon: $a52c39769ffb7919$var$_chevronRight.default,
            iconType: "utility"
        }));
    $a52c39769ffb7919$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
    var $a52c39769ffb7919$var$_default = module.exports.default = $a52c39769ffb7919$var$ChevronRightIcon;
});
parcelRegister("3dGN0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2583c710897a95e5$var$_react = $2583c710897a95e5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2583c710897a95e5$var$_UNSAFE_baseNew = $2583c710897a95e5$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2583c710897a95e5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2583c710897a95e5$var$ChevronRightIcon = (props)=>$2583c710897a95e5$var$_react.default.createElement($2583c710897a95e5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 10.5 9 6 4.5 1.5"/>`,
            type: 'utility'
        }, props));
    $2583c710897a95e5$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
    var $2583c710897a95e5$var$_default = module.exports.default = $2583c710897a95e5$var$ChevronRightIcon;
});
parcelRegister("kbAiU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb20feef8ba5b644$var$_react = $eb20feef8ba5b644$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $eb20feef8ba5b644$var$_creditCard = $eb20feef8ba5b644$var$_interopRequireDefault((parcelRequire("yJt0Y")));
    function $eb20feef8ba5b644$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb20feef8ba5b644$var$CreditcardFilledIcon = (props)=>$eb20feef8ba5b644$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M3 10.99h18V17c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2zM6.01 16h2v-2h-2zM21 8.99V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v1.99"/></svg>`
        }, props, {
            newIcon: $eb20feef8ba5b644$var$_creditCard.default
        }));
    $eb20feef8ba5b644$var$CreditcardFilledIcon.displayName = 'CreditcardFilledIcon';
    var $eb20feef8ba5b644$var$_default = module.exports.default = $eb20feef8ba5b644$var$CreditcardFilledIcon;
});
parcelRegister("yJt0Y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $068671e2aa0a9124$var$_react = $068671e2aa0a9124$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $068671e2aa0a9124$var$_UNSAFE_baseNew = $068671e2aa0a9124$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $068671e2aa0a9124$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $068671e2aa0a9124$var$CreditCardIcon = (props)=>$068671e2aa0a9124$var$_react.default.createElement($068671e2aa0a9124$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 6.25V12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6.25m-14.5 0V4c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v2.25m-14.5 0h14.5m-2.25 4H9"/>`
        }, props));
    $068671e2aa0a9124$var$CreditCardIcon.displayName = 'CreditCardIcon';
    var $068671e2aa0a9124$var$_default = module.exports.default = $068671e2aa0a9124$var$CreditCardIcon;
});
parcelRegister("hSLU7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d04ca3956c274a75$var$_react = $d04ca3956c274a75$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d04ca3956c274a75$var$_dashboard = $d04ca3956c274a75$var$_interopRequireDefault((parcelRequire("gsyzJ")));
    function $d04ca3956c274a75$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d04ca3956c274a75$var$DashboardIcon = (props)=>$d04ca3956c274a75$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0 1 20.01 20H3.99A1.994 1.994 0 0 1 2 18.006z"/><path d="M7 5v14h2V5z"/><path d="M7 11h14V9H7z"/></g></svg>`
        }, props, {
            newIcon: $d04ca3956c274a75$var$_dashboard.default
        }));
    $d04ca3956c274a75$var$DashboardIcon.displayName = 'DashboardIcon';
    var $d04ca3956c274a75$var$_default = module.exports.default = $d04ca3956c274a75$var$DashboardIcon;
});
parcelRegister("9lMrf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6ceba61d72cb155b$var$_react = $6ceba61d72cb155b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6ceba61d72cb155b$var$_add = $6ceba61d72cb155b$var$_interopRequireDefault((parcelRequire("dZbEw")));
    function $6ceba61d72cb155b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6ceba61d72cb155b$var$EditorAddIcon = (props)=>$6ceba61d72cb155b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V7a1 1 0 0 0-2 0v4H7a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2z"/></svg>`
        }, props, {
            newIcon: $6ceba61d72cb155b$var$_add.default
        }));
    $6ceba61d72cb155b$var$EditorAddIcon.displayName = 'EditorAddIcon';
    var $6ceba61d72cb155b$var$_default = module.exports.default = $6ceba61d72cb155b$var$EditorAddIcon;
});
parcelRegister("dZbEw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a2ea02ce9c6e0054$var$_react = $a2ea02ce9c6e0054$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a2ea02ce9c6e0054$var$_UNSAFE_baseNew = $a2ea02ce9c6e0054$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a2ea02ce9c6e0054$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a2ea02ce9c6e0054$var$AddIcon = (props)=>$a2ea02ce9c6e0054$var$_react.default.createElement($a2ea02ce9c6e0054$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 8h7M8 8H1m7 0V1m0 7v7"/>`
        }, props));
    $a2ea02ce9c6e0054$var$AddIcon.displayName = 'AddIcon';
    var $a2ea02ce9c6e0054$var$_default = module.exports.default = $a2ea02ce9c6e0054$var$AddIcon;
});
parcelRegister("kkuz9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eccd62a69c1a1c51$var$_react = $eccd62a69c1a1c51$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $eccd62a69c1a1c51$var$_information = $eccd62a69c1a1c51$var$_interopRequireDefault((parcelRequire("2Yv61")));
    function $eccd62a69c1a1c51$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eccd62a69c1a1c51$var$EditorPanelIcon = (props)=>$eccd62a69c1a1c51$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
        }, props, {
            newIcon: $eccd62a69c1a1c51$var$_information.default
        }));
    $eccd62a69c1a1c51$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
    var $eccd62a69c1a1c51$var$_default = module.exports.default = $eccd62a69c1a1c51$var$EditorPanelIcon;
});
parcelRegister("2Yv61", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $22a94e6465a5d701$var$_react = $22a94e6465a5d701$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $22a94e6465a5d701$var$_UNSAFE_baseNew = $22a94e6465a5d701$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $22a94e6465a5d701$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $22a94e6465a5d701$var$InformationIcon = (props)=>$22a94e6465a5d701$var$_react.default.createElement($22a94e6465a5d701$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
        }, props));
    $22a94e6465a5d701$var$InformationIcon.displayName = 'InformationIcon';
    var $22a94e6465a5d701$var$_default = module.exports.default = $22a94e6465a5d701$var$InformationIcon;
});
parcelRegister("23aI7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $17e42b7e07778bdb$var$_react = $17e42b7e07778bdb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $17e42b7e07778bdb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $17e42b7e07778bdb$var$EmojiAtlassianIcon = (props)=>$17e42b7e07778bdb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.7 11.48c-.24-.25-.61-.24-.77.09l-3.88 7.76a.46.46 0 0 0 .42.67h5.41a.45.45 0 0 0 .42-.26c1.17-2.41.46-6.08-1.59-8.27m2.84-7.06c-2.17 3.44-2.03 7.26-.6 10.12l2.61 5.22c.08.16.24.26.42.26h5.41a.46.46 0 0 0 .42-.67S12.53 4.77 12.35 4.41c-.17-.32-.58-.33-.79 0"/></svg>`
        }, props));
    $17e42b7e07778bdb$var$EmojiAtlassianIcon.displayName = 'EmojiAtlassianIcon';
    var $17e42b7e07778bdb$var$_default = module.exports.default = $17e42b7e07778bdb$var$EmojiAtlassianIcon;
});
parcelRegister("bTqXB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8a89be8174ef75ee$var$_react = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $8a89be8174ef75ee$var$_filter = $8a89be8174ef75ee$var$_interopRequireDefault((parcelRequire("jX361")));
    function $8a89be8174ef75ee$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8a89be8174ef75ee$var$FilterIcon = (props)=>$8a89be8174ef75ee$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 13h10l1-2H6zM3.99 6c-.55 0-.79.41-.55.9L4 8h16l.55-1.1c.25-.5.01-.9-.54-.9zm6.79 11.56a.87.87 0 0 0 .73.44h.99c.28 0 .61-.2.73-.44L14 16h-4z"/></svg>`
        }, props, {
            newIcon: $8a89be8174ef75ee$var$_filter.default
        }));
    $8a89be8174ef75ee$var$FilterIcon.displayName = 'FilterIcon';
    var $8a89be8174ef75ee$var$_default = module.exports.default = $8a89be8174ef75ee$var$FilterIcon;
});
parcelRegister("jX361", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e865edd1a40a2be5$var$_react = $e865edd1a40a2be5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e865edd1a40a2be5$var$_UNSAFE_baseNew = $e865edd1a40a2be5$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e865edd1a40a2be5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e865edd1a40a2be5$var$FilterIcon = (props)=>$e865edd1a40a2be5$var$_react.default.createElement($e865edd1a40a2be5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M3 8h10M1 2.75h14M5 13.25h6"/>`
        }, props));
    $e865edd1a40a2be5$var$FilterIcon.displayName = 'FilterIcon';
    var $e865edd1a40a2be5$var$_default = module.exports.default = $e865edd1a40a2be5$var$FilterIcon;
});
parcelRegister("bP37O", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $89b6e1b4c0102ce3$var$_react = $89b6e1b4c0102ce3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $89b6e1b4c0102ce3$var$_folderClosed = $89b6e1b4c0102ce3$var$_interopRequireDefault((parcelRequire("9xuGL")));
    function $89b6e1b4c0102ce3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $89b6e1b4c0102ce3$var$FolderIcon = (props)=>$89b6e1b4c0102ce3$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862z"/></svg>`
        }, props, {
            newIcon: $89b6e1b4c0102ce3$var$_folderClosed.default
        }));
    $89b6e1b4c0102ce3$var$FolderIcon.displayName = 'FolderIcon';
    var $89b6e1b4c0102ce3$var$_default = module.exports.default = $89b6e1b4c0102ce3$var$FolderIcon;
});
parcelRegister("9xuGL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6f1f0046e553e72e$var$_react = $6f1f0046e553e72e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6f1f0046e553e72e$var$_UNSAFE_baseNew = $6f1f0046e553e72e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $6f1f0046e553e72e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6f1f0046e553e72e$var$FolderClosedIcon = (props)=>$6f1f0046e553e72e$var$_react.default.createElement($6f1f0046e553e72e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h3.25L8 3.5h5c.69 0 1.25.56 1.25 1.25v2m-12.5 0h12.5"/>`
        }, props));
    $6f1f0046e553e72e$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
    var $6f1f0046e553e72e$var$_default = module.exports.default = $6f1f0046e553e72e$var$FolderClosedIcon;
});
parcelRegister("8sgpE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $627dab81872ead3d$var$_react = $627dab81872ead3d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $627dab81872ead3d$var$_issues = $627dab81872ead3d$var$_interopRequireDefault((parcelRequire("gmyWi")));
    function $627dab81872ead3d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $627dab81872ead3d$var$IssuesIcon = (props)=>$627dab81872ead3d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 12.99C5 13 19.01 13 19.01 13 19 13 19 5.01 19 5.01 19 5 5 5 5 5zM3 5.01C3 3.9 3.89 3 5 3h14.01A2 2 0 0 1 21 5.01v7.98A2 2 0 0 1 19.01 15H5a2 2 0 0 1-2-2.01zM19 19c0 1.11-.9 2-2.01 2H7.01A2.01 2.01 0 0 1 5 19zm1-3a2 2 0 0 1-1.99 2H5.99A2 2 0 0 1 4 16z"/><path d="M10.674 11.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
        }, props, {
            newIcon: $627dab81872ead3d$var$_issues.default
        }));
    $627dab81872ead3d$var$IssuesIcon.displayName = 'IssuesIcon';
    var $627dab81872ead3d$var$_default = module.exports.default = $627dab81872ead3d$var$IssuesIcon;
});
parcelRegister("gmyWi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $be99cd9cde9dc967$var$_react = $be99cd9cde9dc967$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $be99cd9cde9dc967$var$_UNSAFE_baseNew = $be99cd9cde9dc967$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $be99cd9cde9dc967$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $be99cd9cde9dc967$var$IssuesIcon = (props)=>$be99cd9cde9dc967$var$_react.default.createElement($be99cd9cde9dc967$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.125 7 1.583 1.875 3.167-3.75M.75 10V4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v6c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25Z"/><path stroke="currentcolor" stroke-width="1.5" d="M5 14.25h7.75a2.5 2.5 0 0 0 2.5-2.5V7"/>`
        }, props));
    $be99cd9cde9dc967$var$IssuesIcon.displayName = 'IssuesIcon';
    var $be99cd9cde9dc967$var$_default = module.exports.default = $be99cd9cde9dc967$var$IssuesIcon;
});
parcelRegister("3oUqw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $279f6226088164aa$var$_react = $279f6226088164aa$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $279f6226088164aa$var$_showMoreHorizontal = $279f6226088164aa$var$_interopRequireDefault((parcelRequire("8U6zd")));
    function $279f6226088164aa$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $279f6226088164aa$var$MoreIcon = (props)=>$279f6226088164aa$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></g></svg>`
        }, props, {
            newIcon: $279f6226088164aa$var$_showMoreHorizontal.default
        }));
    $279f6226088164aa$var$MoreIcon.displayName = 'MoreIcon';
    var $279f6226088164aa$var$_default = module.exports.default = $279f6226088164aa$var$MoreIcon;
});
parcelRegister("8U6zd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $67b8a5c31f137a02$var$_react = $67b8a5c31f137a02$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $67b8a5c31f137a02$var$_UNSAFE_baseNew = $67b8a5c31f137a02$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $67b8a5c31f137a02$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $67b8a5c31f137a02$var$ShowMoreHorizontalIcon = (props)=>$67b8a5c31f137a02$var$_react.default.createElement($67b8a5c31f137a02$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path stroke="currentcolor" stroke-width="1.5" d="M2.25 8a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm6.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>`
        }, props));
    $67b8a5c31f137a02$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
    var $67b8a5c31f137a02$var$_default = module.exports.default = $67b8a5c31f137a02$var$ShowMoreHorizontalIcon;
});
parcelRegister("825vU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5d92c98d74042315$var$_react = $5d92c98d74042315$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5d92c98d74042315$var$_notification = $5d92c98d74042315$var$_interopRequireDefault((parcelRequire("jDorM")));
    function $5d92c98d74042315$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5d92c98d74042315$var$NotificationIcon = (props)=>$5d92c98d74042315$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.49 17.67a2 2 0 0 0 2.83 0l-2.83-2.83a2 2 0 0 0 0 2.83m4.89-12.19-.72.73c-.78.78-2.21 1.81-3.21 2.31l-3.02 1.51c-.49.25-.58.77-.19 1.17l8.56 8.56c.4.4.92.31 1.17-.19l1.51-3.02c.49-.99 1.53-2.42 2.31-3.21l.73-.73a5.05 5.05 0 0 0 .64-6.36 1.01 1.01 0 1 0-1.35-1.49q-.04.04-.07.08A5.04 5.04 0 0 0 14.95 4a5.04 5.04 0 0 0-3.57 1.48"/></svg>`
        }, props, {
            newIcon: $5d92c98d74042315$var$_notification.default
        }));
    $5d92c98d74042315$var$NotificationIcon.displayName = 'NotificationIcon';
    var $5d92c98d74042315$var$_default = module.exports.default = $5d92c98d74042315$var$NotificationIcon;
});
parcelRegister("jDorM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e4b49f7de9b103d8$var$_react = $e4b49f7de9b103d8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e4b49f7de9b103d8$var$_UNSAFE_baseNew = $e4b49f7de9b103d8$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e4b49f7de9b103d8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e4b49f7de9b103d8$var$NotificationIcon = (props)=>$e4b49f7de9b103d8$var$_react.default.createElement($e4b49f7de9b103d8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.5 12.75a2.5 2.5 0 0 1-5 0m6.75-4.114V5a4.25 4.25 0 0 0-8.5 0v3.636a.4.4 0 0 1-.06.21l-1.842 2.948a.625.625 0 0 0 .53.956h11.244c.491 0 .79-.54.53-.956l-1.841-2.947a.4.4 0 0 1-.061-.211Z"/>`
        }, props));
    $e4b49f7de9b103d8$var$NotificationIcon.displayName = 'NotificationIcon';
    var $e4b49f7de9b103d8$var$_default = module.exports.default = $e4b49f7de9b103d8$var$NotificationIcon;
});
parcelRegister("6Njc0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4f2634e9f5bc5da4$var$_react = $4f2634e9f5bc5da4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4f2634e9f5bc5da4$var$_notification = $4f2634e9f5bc5da4$var$_interopRequireDefault((parcelRequire("jDorM")));
    function $4f2634e9f5bc5da4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4f2634e9f5bc5da4$var$NotificationDirectIcon = (props)=>$4f2634e9f5bc5da4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6.59 17.83a2 2 0 0 0 2.83 0L6.59 15a2 2 0 0 0 0 2.83m4.79-12.35A5.04 5.04 0 0 1 14.95 4c.97 0 1.95.28 2.79.84q.03-.04.07-.07a1.01 1.01 0 1 1 1.35 1.49 5.05 5.05 0 0 1-.64 6.36l-.72.73c-.78.78-1.81 2.21-2.31 3.21l-1.51 3.02c-.25.5-.77.58-1.17.19l-8.56-8.55c-.4-.4-.31-.92.19-1.17l3.02-1.51c.99-.49 2.42-1.53 3.21-2.31zm2.74 9.63c.52-.97 1.57-2.4 2.35-3.18l.73-.73a3.05 3.05 0 0 0 .39-3.83c-.19-.29-.72-.77-.86-.86A3.04 3.04 0 0 0 15.05 6c-.8 0-1.57.31-2.16.89l-.95.95c-.78.79-2.22 1.82-3.2 2.31L7 11.02l6.07 6.07z"/></svg>`
        }, props, {
            newIcon: $4f2634e9f5bc5da4$var$_notification.default
        }));
    $4f2634e9f5bc5da4$var$NotificationDirectIcon.displayName = 'NotificationDirectIcon';
    var $4f2634e9f5bc5da4$var$_default = module.exports.default = $4f2634e9f5bc5da4$var$NotificationDirectIcon;
});
parcelRegister("1FouZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $136c9fbd1122fba5$var$_react = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $136c9fbd1122fba5$var$_arrowUpRight = $136c9fbd1122fba5$var$_interopRequireDefault((parcelRequire("3sGLB")));
    function $136c9fbd1122fba5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $136c9fbd1122fba5$var$OpenIcon = (props)=>$136c9fbd1122fba5$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.031 7A1.03 1.03 0 0 0 10 8.036a1.05 1.05 0 0 0 1.044 1.045l3.121.014.014 3.121a1.05 1.05 0 0 0 1.045 1.044 1.03 1.03 0 0 0 1.036-1.035l-.019-4.161a1.053 1.053 0 0 0-1.045-1.045L11.035 7z"/><path d="m13.364 8.292-7.071 7.071a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0l7.071-7.071A1.002 1.002 0 0 0 14.071 8a1 1 0 0 0-.707.292"/></g></svg>`
        }, props, {
            newIcon: $136c9fbd1122fba5$var$_arrowUpRight.default
        }));
    $136c9fbd1122fba5$var$OpenIcon.displayName = 'OpenIcon';
    var $136c9fbd1122fba5$var$_default = module.exports.default = $136c9fbd1122fba5$var$OpenIcon;
});
parcelRegister("3sGLB", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2855293259c2814d$var$_react = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2855293259c2814d$var$_UNSAFE_baseNew = $2855293259c2814d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2855293259c2814d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2855293259c2814d$var$ArrowUpRightIcon = (props)=>$2855293259c2814d$var$_react.default.createElement($2855293259c2814d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3 13 9.25-9.25m-6.5-.5h7v7"/>`
        }, props));
    $2855293259c2814d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
    var $2855293259c2814d$var$_default = module.exports.default = $2855293259c2814d$var$ArrowUpRightIcon;
});
parcelRegister("kFO36", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f0ce75b3f6725a8c$var$_react = $f0ce75b3f6725a8c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f0ce75b3f6725a8c$var$_peopleGroup = $f0ce75b3f6725a8c$var$_interopRequireDefault((parcelRequire("fptva")));
    function $f0ce75b3f6725a8c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f0ce75b3f6725a8c$var$PeopleGroupIcon = (props)=>$f0ce75b3f6725a8c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M8.13 10H4a2 2 0 0 0-2 2v3.73c0 1.31 1.87 2.05 4 2.23V15a3 3 0 0 1 3-3h.35a4 4 0 0 1-1.23-2m7.75 0H20c1.11 0 2 .89 2 2v3.73c0 1.31-1.87 2.05-4 2.23V15a3 3 0 0 0-3-3h-.35a4 4 0 0 0 1.23-2M9.97 5.55a3 3 0 1 0-1.96 3.27 4 4 0 0 1 1.96-3.27M16 8.83a3 3 0 1 0-1.96-3.28A4 4 0 0 1 16 8.83"/><path d="M7 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><circle cx="12" cy="9" r="3"/></g></svg>`
        }, props, {
            newIcon: $f0ce75b3f6725a8c$var$_peopleGroup.default
        }));
    $f0ce75b3f6725a8c$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
    var $f0ce75b3f6725a8c$var$_default = module.exports.default = $f0ce75b3f6725a8c$var$PeopleGroupIcon;
});
parcelRegister("fptva", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b3801338456dce10$var$_react = $b3801338456dce10$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b3801338456dce10$var$_UNSAFE_baseNew = $b3801338456dce10$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $b3801338456dce10$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b3801338456dce10$var$PeopleGroupIcon = (props)=>$b3801338456dce10$var$_react.default.createElement($b3801338456dce10$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5 9.75H2.625C1.59 9.75.75 10.59.75 11.625V13m14.5 1v-1.5a2.75 2.75 0 0 0-2.75-2.75h-3a2.75 2.75 0 0 0-2.75 2.75V14m7-9.5a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Zm-8 1a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
        }, props));
    $b3801338456dce10$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
    var $b3801338456dce10$var$_default = module.exports.default = $b3801338456dce10$var$PeopleGroupIcon;
});
parcelRegister("j85Tc", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ded35532616fdba1$var$_react = $ded35532616fdba1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $ded35532616fdba1$var$_person = $ded35532616fdba1$var$_interopRequireDefault((parcelRequire("1bKdn")));
    function $ded35532616fdba1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ded35532616fdba1$var$PersonIcon = (props)=>$ded35532616fdba1$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
        }, props, {
            newIcon: $ded35532616fdba1$var$_person.default
        }));
    $ded35532616fdba1$var$PersonIcon.displayName = 'PersonIcon';
    var $ded35532616fdba1$var$_default = module.exports.default = $ded35532616fdba1$var$PersonIcon;
});
parcelRegister("1bKdn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0ddaaacfb131e12e$var$_react = $0ddaaacfb131e12e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0ddaaacfb131e12e$var$_UNSAFE_baseNew = $0ddaaacfb131e12e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0ddaaacfb131e12e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0ddaaacfb131e12e$var$PersonIcon = (props)=>$0ddaaacfb131e12e$var$_react.default.createElement($0ddaaacfb131e12e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15v-2.25a3 3 0 0 0-3-3h-4.5a3 3 0 0 0-3 3V15m8.5-11a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"/>`
        }, props));
    $0ddaaacfb131e12e$var$PersonIcon.displayName = 'PersonIcon';
    var $0ddaaacfb131e12e$var$_default = module.exports.default = $0ddaaacfb131e12e$var$PersonIcon;
});
parcelRegister("3B33y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $29e732b528688c5f$var$_react = $29e732b528688c5f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $29e732b528688c5f$var$_personAvatar = $29e732b528688c5f$var$_interopRequireDefault((parcelRequire("bdVbi")));
    function $29e732b528688c5f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $29e732b528688c5f$var$PersonCircleIcon = (props)=>$29e732b528688c5f$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M14.5 13.009h-5c-1.38 0-2.5 1.12-2.5 2.503v3.978a8.95 8.95 0 0 0 5 1.519 8.95 8.95 0 0 0 5-1.519v-3.978a2.5 2.5 0 0 0-2.5-2.503"/><circle cx="12" cy="9" r="3"/><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></g></svg>`
        }, props, {
            newIcon: $29e732b528688c5f$var$_personAvatar.default
        }));
    $29e732b528688c5f$var$PersonCircleIcon.displayName = 'PersonCircleIcon';
    var $29e732b528688c5f$var$_default = module.exports.default = $29e732b528688c5f$var$PersonCircleIcon;
});
parcelRegister("bdVbi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $82bd439e3b283de9$var$_react = $82bd439e3b283de9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $82bd439e3b283de9$var$_UNSAFE_baseNew = $82bd439e3b283de9$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $82bd439e3b283de9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $82bd439e3b283de9$var$PersonAvatarIcon = (props)=>$82bd439e3b283de9$var$_react.default.createElement($82bd439e3b283de9$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 14.35v-.6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v.6m-.75-7.85a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0Z"/>`
        }, props));
    $82bd439e3b283de9$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
    var $82bd439e3b283de9$var$_default = module.exports.default = $82bd439e3b283de9$var$PersonAvatarIcon;
});
parcelRegister("8EYBJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $64e11291068cd489$var$_react = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $64e11291068cd489$var$_premium = $64e11291068cd489$var$_interopRequireDefault((parcelRequire("41hx5")));
    function $64e11291068cd489$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $64e11291068cd489$var$PremiumIcon = (props)=>$64e11291068cd489$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.276 4.382 7.357 9.247l-4.863 1.917a.78.78 0 0 0 0 1.45l4.863 1.918 1.919 4.863a.78.78 0 0 0 1.45 0h-.001l1.918-4.863 4.864-1.919a.781.781 0 0 0 0-1.45l-4.864-1.916-1.918-4.865a.78.78 0 0 0-.44-.438.78.78 0 0 0-1.01.438m8.297-2.03-.743 1.886-1.884.743a.56.56 0 0 0 0 1.038l1.884.743.743 1.886a.558.558 0 0 0 1.038 0l.745-1.886 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.743-.745-1.885a.55.55 0 0 0-.314-.314.56.56 0 0 0-.724.314m-.704 13.003-.744 1.883-1.883.744a.55.55 0 0 0-.316.314.56.56 0 0 0 .316.724l1.883.743.744 1.884c.057.144.17.258.314.315a.56.56 0 0 0 .724-.315l.744-1.884 1.883-.743a.557.557 0 0 0 0-1.038l-1.883-.744-.744-1.883a.55.55 0 0 0-.315-.316.56.56 0 0 0-.723.316"/></svg>`
        }, props, {
            newIcon: $64e11291068cd489$var$_premium.default
        }));
    $64e11291068cd489$var$PremiumIcon.displayName = 'PremiumIcon';
    var $64e11291068cd489$var$_default = module.exports.default = $64e11291068cd489$var$PremiumIcon;
});
parcelRegister("41hx5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ed4db10c38a4841$var$_react = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ed4db10c38a4841$var$_UNSAFE_baseNew = $2ed4db10c38a4841$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ed4db10c38a4841$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ed4db10c38a4841$var$PremiumIcon = (props)=>$2ed4db10c38a4841$var$_react.default.createElement($2ed4db10c38a4841$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.5 13.75h2.25m0 0H16m-2.25 0V11.5m0 2.25V16M0 2.25h2.25m0 0H4.5m-2.25 0V0m0 2.25V4.5M8 1.75l1.75 4.5L14.25 8l-4.5 1.75L8 14.25l-1.75-4.5L1.75 8l4.5-1.75z"/>`
        }, props));
    $2ed4db10c38a4841$var$PremiumIcon.displayName = 'PremiumIcon';
    var $2ed4db10c38a4841$var$_default = module.exports.default = $2ed4db10c38a4841$var$PremiumIcon;
});
parcelRegister("eJS47", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $abaf34f2ab9c61b9$var$_react = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $abaf34f2ab9c61b9$var$_questionCircle = $abaf34f2ab9c61b9$var$_interopRequireDefault((parcelRequire("8nk07")));
    function $abaf34f2ab9c61b9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $abaf34f2ab9c61b9$var$QuestionCircleIcon = (props)=>$abaf34f2ab9c61b9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
        }, props, {
            newIcon: $abaf34f2ab9c61b9$var$_questionCircle.default
        }));
    $abaf34f2ab9c61b9$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
    var $abaf34f2ab9c61b9$var$_default = module.exports.default = $abaf34f2ab9c61b9$var$QuestionCircleIcon;
});
parcelRegister("8nk07", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $618ffc7dfbf067c7$var$_react = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $618ffc7dfbf067c7$var$_UNSAFE_baseNew = $618ffc7dfbf067c7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $618ffc7dfbf067c7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $618ffc7dfbf067c7$var$QuestionCircleIcon = (props)=>$618ffc7dfbf067c7$var$_react.default.createElement($618ffc7dfbf067c7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.25 6C6.25 5 7 4.25 8 4.25S9.75 5 9.75 6C9.75 7.5 8 7.5 8 8.75v.75M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
        }, props));
    $618ffc7dfbf067c7$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
    var $618ffc7dfbf067c7$var$_default = module.exports.default = $618ffc7dfbf067c7$var$QuestionCircleIcon;
});
parcelRegister("5IlYG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $42921c21e7131d9e$var$_react = $42921c21e7131d9e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $42921c21e7131d9e$var$_clock = $42921c21e7131d9e$var$_interopRequireDefault((parcelRequire("hyKRO")));
    function $42921c21e7131d9e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $42921c21e7131d9e$var$RecentIcon = (props)=>$42921c21e7131d9e$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 8.002v4.002c0 .28.116.53.301.712l2.47 2.47a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.415L13 11.586V6a1 1 0 0 0-2 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/></svg>`
        }, props, {
            newIcon: $42921c21e7131d9e$var$_clock.default
        }));
    $42921c21e7131d9e$var$RecentIcon.displayName = 'RecentIcon';
    var $42921c21e7131d9e$var$_default = module.exports.default = $42921c21e7131d9e$var$RecentIcon;
});
parcelRegister("hyKRO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cc89f770b0677de5$var$_react = $cc89f770b0677de5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $cc89f770b0677de5$var$_UNSAFE_baseNew = $cc89f770b0677de5$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $cc89f770b0677de5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cc89f770b0677de5$var$ClockIcon = (props)=>$cc89f770b0677de5$var$_react.default.createElement($cc89f770b0677de5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 3.25V8l2.5 2m4.75-2A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Z"/>`
        }, props));
    $cc89f770b0677de5$var$ClockIcon.displayName = 'ClockIcon';
    var $cc89f770b0677de5$var$_default = module.exports.default = $cc89f770b0677de5$var$ClockIcon;
});
parcelRegister("3Jz4b", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2b80c68588d37bf1$var$_react = $2b80c68588d37bf1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $2b80c68588d37bf1$var$_screen = $2b80c68588d37bf1$var$_interopRequireDefault((parcelRequire("9fIhE")));
    function $2b80c68588d37bf1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2b80c68588d37bf1$var$ScreenIcon = (props)=>$2b80c68588d37bf1$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M3 6.009C3 4.899 3.893 4 4.995 4h14.01C20.107 4 21 4.902 21 6.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 13.991zM5 14h14V6H5z"/><path d="M10 17h4v3h-4zm-1 3.5a.5.5 0 0 1 .49-.5h5.02a.5.5 0 0 1 .49.5v.5H9z"/></g></svg>`
        }, props, {
            newIcon: $2b80c68588d37bf1$var$_screen.default
        }));
    $2b80c68588d37bf1$var$ScreenIcon.displayName = 'ScreenIcon';
    var $2b80c68588d37bf1$var$_default = module.exports.default = $2b80c68588d37bf1$var$ScreenIcon;
});
parcelRegister("9fIhE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6bc7dd9da70c6d51$var$_react = $6bc7dd9da70c6d51$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6bc7dd9da70c6d51$var$_UNSAFE_baseNew = $6bc7dd9da70c6d51$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $6bc7dd9da70c6d51$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6bc7dd9da70c6d51$var$ScreenIcon = (props)=>$6bc7dd9da70c6d51$var$_react.default.createElement($6bc7dd9da70c6d51$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 11.25h5c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25zm0 0v3m0 0h4m-4 0H4"/>`
        }, props));
    $6bc7dd9da70c6d51$var$ScreenIcon.displayName = 'ScreenIcon';
    var $6bc7dd9da70c6d51$var$_default = module.exports.default = $6bc7dd9da70c6d51$var$ScreenIcon;
});
parcelRegister("tvuR8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $058b2421e8b6ab38$var$_react = $058b2421e8b6ab38$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $058b2421e8b6ab38$var$_search = $058b2421e8b6ab38$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $058b2421e8b6ab38$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $058b2421e8b6ab38$var$SearchIcon = (props)=>$058b2421e8b6ab38$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m16.436 15.085 3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406M10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"/></svg>`
        }, props, {
            newIcon: $058b2421e8b6ab38$var$_search.default
        }));
    $058b2421e8b6ab38$var$SearchIcon.displayName = 'SearchIcon';
    var $058b2421e8b6ab38$var$_default = module.exports.default = $058b2421e8b6ab38$var$SearchIcon;
});
parcelRegister("hyOJh", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cc8cf66814b59134$var$_react = $cc8cf66814b59134$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $cc8cf66814b59134$var$_UNSAFE_baseNew = $cc8cf66814b59134$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $cc8cf66814b59134$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cc8cf66814b59134$var$SearchIcon = (props)=>$cc8cf66814b59134$var$_react.default.createElement($cc8cf66814b59134$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m14.5 14.5-3.788-3.788m0 0a5.25 5.25 0 1 0-7.425-7.425 5.25 5.25 0 0 0 7.425 7.425Z"/>`
        }, props));
    $cc8cf66814b59134$var$SearchIcon.displayName = 'SearchIcon';
    var $cc8cf66814b59134$var$_default = module.exports.default = $cc8cf66814b59134$var$SearchIcon;
});
parcelRegister("lzUP9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fb58f1f2f3adb0d0$var$_react = $fb58f1f2f3adb0d0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $fb58f1f2f3adb0d0$var$_settings = $fb58f1f2f3adb0d0$var$_interopRequireDefault((parcelRequire("epOG5")));
    function $fb58f1f2f3adb0d0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fb58f1f2f3adb0d0$var$SettingsIcon = (props)=>$fb58f1f2f3adb0d0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.701 16.7a5.002 5.002 0 1 1 0-10.003 5.002 5.002 0 0 1 0 10.004m8.368-3.117a1.995 1.995 0 0 1-1.346-1.885c0-.876.563-1.613 1.345-1.885a.48.48 0 0 0 .315-.574 9 9 0 0 0-.836-1.993.48.48 0 0 0-.598-.195 2.04 2.04 0 0 1-1.29.08 1.99 1.99 0 0 1-1.404-1.395 2.04 2.04 0 0 1 .076-1.297.48.48 0 0 0-.196-.597 9 9 0 0 0-1.975-.826.48.48 0 0 0-.574.314 1.995 1.995 0 0 1-1.885 1.346 1.99 1.99 0 0 1-1.884-1.345.48.48 0 0 0-.575-.315c-.708.2-1.379.485-2.004.842a.47.47 0 0 0-.198.582A2.002 2.002 0 0 1 4.445 7.06a.48.48 0 0 0-.595.196 9 9 0 0 0-.833 1.994.48.48 0 0 0 .308.572 1.995 1.995 0 0 1 1.323 1.877c0 .867-.552 1.599-1.324 1.877a.48.48 0 0 0-.308.57 9 9 0 0 0 .723 1.79.477.477 0 0 0 .624.194c.595-.273 1.343-.264 2.104.238.117.077.225.185.302.3.527.8.512 1.58.198 2.188a.473.473 0 0 0 .168.628 9 9 0 0 0 2.11.897.474.474 0 0 0 .57-.313 1.995 1.995 0 0 1 1.886-1.353c.878 0 1.618.567 1.887 1.353a.475.475 0 0 0 .57.313 9 9 0 0 0 2.084-.883.473.473 0 0 0 .167-.631c-.318-.608-.337-1.393.191-2.195.077-.116.185-.225.302-.302.772-.511 1.527-.513 2.125-.23a.477.477 0 0 0 .628-.19 9 9 0 0 0 .728-1.793.48.48 0 0 0-.314-.573"/></svg>`
        }, props, {
            newIcon: $fb58f1f2f3adb0d0$var$_settings.default
        }));
    $fb58f1f2f3adb0d0$var$SettingsIcon.displayName = 'SettingsIcon';
    var $fb58f1f2f3adb0d0$var$_default = module.exports.default = $fb58f1f2f3adb0d0$var$SettingsIcon;
});
parcelRegister("epOG5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a7eab60df9d4cfd1$var$_react = $a7eab60df9d4cfd1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a7eab60df9d4cfd1$var$_UNSAFE_baseNew = $a7eab60df9d4cfd1$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a7eab60df9d4cfd1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a7eab60df9d4cfd1$var$SettingsIcon = (props)=>$a7eab60df9d4cfd1$var$_react.default.createElement($a7eab60df9d4cfd1$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75.75 5.687 3.302a.625.625 0 0 1-.667.378l-2.674-.388-1.25 2.166L2.72 7.625a.625.625 0 0 1 0 .75l-1.624 2.168 1.25 2.165 2.674-.388a.625.625 0 0 1 .667.378L6.75 15.25h2.5l1.063-2.552a.625.625 0 0 1 .667-.378l2.674.388 1.25-2.165-1.623-2.168a.625.625 0 0 1 0-.75l1.623-2.167-1.25-2.166-2.674.388a.625.625 0 0 1-.667-.378L9.25.75z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
        }, props));
    $a7eab60df9d4cfd1$var$SettingsIcon.displayName = 'SettingsIcon';
    var $a7eab60df9d4cfd1$var$_default = module.exports.default = $a7eab60df9d4cfd1$var$SettingsIcon;
});
parcelRegister("jUUuf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e7ff1067bfd2c51e$var$_react = $e7ff1067bfd2c51e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $e7ff1067bfd2c51e$var$_release = $e7ff1067bfd2c51e$var$_interopRequireDefault((parcelRequire("2Ljwn")));
    function $e7ff1067bfd2c51e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e7ff1067bfd2c51e$var$ShipIcon = (props)=>$e7ff1067bfd2c51e$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
        }, props, {
            newIcon: $e7ff1067bfd2c51e$var$_release.default
        }));
    $e7ff1067bfd2c51e$var$ShipIcon.displayName = 'ShipIcon';
    var $e7ff1067bfd2c51e$var$_default = module.exports.default = $e7ff1067bfd2c51e$var$ShipIcon;
});
parcelRegister("2Ljwn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $202f1d0bd9c274bb$var$_react = $202f1d0bd9c274bb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $202f1d0bd9c274bb$var$_UNSAFE_baseNew = $202f1d0bd9c274bb$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $202f1d0bd9c274bb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $202f1d0bd9c274bb$var$ReleaseIcon = (props)=>$202f1d0bd9c274bb$var$_react.default.createElement($202f1d0bd9c274bb$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M.75 7.75V7a.75.75 0 0 0-.75.75zm14.5 0 .646.382A.75.75 0 0 0 15.25 7zm-12.5-3V4a.75.75 0 0 0-.75.75zm6.25 0 .648-.378A.75.75 0 0 0 9 4zm-4.25-2V2H4v.75zm1.5 0H7V2h-.75zm6.113 9.886.646.382zm2.241-5.268-2.887 4.886 1.292.764 2.887-4.886zM11.287 12.5H2V14h9.287zM1.5 12V7.75H0V12zM.75 8.5h2V7h-2zm2.75-.75v-3H2v3zm-.75.75h8V7h-8zm8 0h4.5V7h-4.5zM8.352 5.128l1.75 3 1.296-.756-1.75-3zM2.75 5.5h2V4h-2zm2.75-.75v-2H4v2zM4.75 3.5h1.5V2h-1.5zm0 2h1.5V4h-1.5zm1.5 0H9V4H6.25zM5.5 2.75v2H7v-2zM2 12.5a.5.5 0 0 1-.5-.5H0a2 2 0 0 0 2 2zm9.717-.246a.5.5 0 0 1-.43.246V14a2 2 0 0 0 1.722-.982z"/>`
        }, props));
    $202f1d0bd9c274bb$var$ReleaseIcon.displayName = 'ReleaseIcon';
    var $202f1d0bd9c274bb$var$_default = module.exports.default = $202f1d0bd9c274bb$var$ReleaseIcon;
});
parcelRegister("17Ngn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0d1ca88a8f82a5bd$var$_react = $0d1ca88a8f82a5bd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $0d1ca88a8f82a5bd$var$_linkExternal = $0d1ca88a8f82a5bd$var$_interopRequireDefault((parcelRequire("ggICg")));
    function $0d1ca88a8f82a5bd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0d1ca88a8f82a5bd$var$ShortcutIcon = (props)=>$0d1ca88a8f82a5bd$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M5 19.01V19zM5 4.99V5zM19 19v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6v2H5v14zM5 4.99V5zM11 5H5v14h14v-6h2v6a2 2 0 0 1-1.99 2H5a2 2 0 0 1-2-1.99V4.99C3 3.89 3.9 3 5 3h6zm8 0v3a1 1 0 0 0 2 0V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="m12.707 12.707 8-8a1 1 0 1 0-1.414-1.414l-8 8a1 1 0 0 0 1.414 1.414"/></g></svg>`
        }, props, {
            newIcon: $0d1ca88a8f82a5bd$var$_linkExternal.default
        }));
    $0d1ca88a8f82a5bd$var$ShortcutIcon.displayName = 'ShortcutIcon';
    var $0d1ca88a8f82a5bd$var$_default = module.exports.default = $0d1ca88a8f82a5bd$var$ShortcutIcon;
});
parcelRegister("ggICg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bd80bfcc708167b5$var$_react = $bd80bfcc708167b5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bd80bfcc708167b5$var$_UNSAFE_baseNew = $bd80bfcc708167b5$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $bd80bfcc708167b5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bd80bfcc708167b5$var$LinkExternalIcon = (props)=>$bd80bfcc708167b5$var$_react.default.createElement($bd80bfcc708167b5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-3M7 9l6.75-6.75m.5 3.75V1.75H10"/>`
        }, props));
    $bd80bfcc708167b5$var$LinkExternalIcon.displayName = 'LinkExternalIcon';
    var $bd80bfcc708167b5$var$_default = module.exports.default = $bd80bfcc708167b5$var$LinkExternalIcon;
});
parcelRegister("71IBF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $51db3a542c2bbfd0$var$_react = $51db3a542c2bbfd0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $51db3a542c2bbfd0$var$_logIn = $51db3a542c2bbfd0$var$_interopRequireDefault((parcelRequire("pkYLA")));
    function $51db3a542c2bbfd0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $51db3a542c2bbfd0$var$SignInIcon = (props)=>$51db3a542c2bbfd0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M15.503 3H12v2h7v14h-7v2h7.006c1.1 0 1.994-.893 1.994-1.995V4.995A1.993 1.993 0 0 0 19.006 3z"/><path d="M3.977 11A.99.99 0 0 0 3 12.001c0 .551.437.999.977.999h11.047a.99.99 0 0 0 .976-.999.99.99 0 0 0-.976-1.001z"/><path d="M12.303 8.305a1.053 1.053 0 0 0 0 1.478L14.5 12l-2.197 2.217a1.05 1.05 0 0 0 0 1.476c.404.409 1.06.409 1.465 0l2.93-2.955a1.055 1.055 0 0 0 0-1.477l-2.93-2.956a1.034 1.034 0 0 0-1.465 0"/></g></svg>`
        }, props, {
            newIcon: $51db3a542c2bbfd0$var$_logIn.default
        }));
    $51db3a542c2bbfd0$var$SignInIcon.displayName = 'SignInIcon';
    var $51db3a542c2bbfd0$var$_default = module.exports.default = $51db3a542c2bbfd0$var$SignInIcon;
});
parcelRegister("pkYLA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $04c29bed890774ab$var$_react = $04c29bed890774ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $04c29bed890774ab$var$_UNSAFE_baseNew = $04c29bed890774ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $04c29bed890774ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $04c29bed890774ab$var$LogInIcon = (props)=>$04c29bed890774ab$var$_react.default.createElement($04c29bed890774ab$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75h5c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25H8M5.75 4.5 9.25 8m0 0-3.5 3.5M9.25 8H1"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 4.5 9.25 8l-3.5 3.5"/>`
        }, props));
    $04c29bed890774ab$var$LogInIcon.displayName = 'LogInIcon';
    var $04c29bed890774ab$var$_default = module.exports.default = $04c29bed890774ab$var$LogInIcon;
});
parcelRegister("5oTeF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3eea0a48351333dc$var$_react = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3eea0a48351333dc$var$_starUnstarred = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("dAf5R")));
    function $3eea0a48351333dc$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3eea0a48351333dc$var$StarIcon = (props)=>$3eea0a48351333dc$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
        }, props, {
            newIcon: $3eea0a48351333dc$var$_starUnstarred.default
        }));
    $3eea0a48351333dc$var$StarIcon.displayName = 'StarIcon';
    var $3eea0a48351333dc$var$_default = module.exports.default = $3eea0a48351333dc$var$StarIcon;
});
parcelRegister("dAf5R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9e3a586d66f39291$var$_react = $9e3a586d66f39291$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9e3a586d66f39291$var$_UNSAFE_baseNew = $9e3a586d66f39291$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $9e3a586d66f39291$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9e3a586d66f39291$var$StarUnstarredIcon = (props)=>$9e3a586d66f39291$var$_react.default.createElement($9e3a586d66f39291$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.619a.75.75 0 0 0 1.148-.813zm-4.8-3.618-4.374 3 .848 1.237 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.237 4.375 3z"/>`
        }, props));
    $9e3a586d66f39291$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
    var $9e3a586d66f39291$var$_default = module.exports.default = $9e3a586d66f39291$var$StarUnstarredIcon;
});
parcelRegister("bH1hf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8834b3797a7b4177$var$_react = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $8834b3797a7b4177$var$_starStarred = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("dm1qi")));
    function $8834b3797a7b4177$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8834b3797a7b4177$var$StarFilledIcon = (props)=>$8834b3797a7b4177$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
        }, props, {
            newIcon: $8834b3797a7b4177$var$_starStarred.default
        }));
    $8834b3797a7b4177$var$StarFilledIcon.displayName = 'StarFilledIcon';
    var $8834b3797a7b4177$var$_default = module.exports.default = $8834b3797a7b4177$var$StarFilledIcon;
});
parcelRegister("dm1qi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9b8e6f0febff8b04$var$_react = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9b8e6f0febff8b04$var$_UNSAFE_baseNew = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $9b8e6f0febff8b04$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9b8e6f0febff8b04$var$StarStarredIcon = (props)=>$9b8e6f0febff8b04$var$_react.default.createElement($9b8e6f0febff8b04$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m8 11.25-4.375 3L5 9.125 1.25 6l4.875-.375L8 .75l1.875 4.875L14.75 6 11 9.125l1.375 5.125z"/><path fill="currentcolor" d="m8 11.25.424-.618L8 10.34l-.424.29zm-4.375 3-.724-.194a.75.75 0 0 0 1.148.813zM5 9.125l.724.194.125-.463-.369-.307zM1.25 6l-.058-.748A.75.75 0 0 0 .77 6.576zm4.875-.375.058.748.472-.037.17-.442zM8 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.875 4.875-.7.27.17.441.472.037zM14.75 6l.48.576a.75.75 0 0 0-.423-1.324zM11 9.125l-.48-.576-.369.307.125.463zm1.375 5.125-.424.618a.75.75 0 0 0 1.148-.812zm-4.8-3.618-4.374 3 .848 1.236 4.375-3zM4.35 14.444 5.724 9.32l-1.448-.388L2.9 14.056zM5.48 8.55 1.73 5.424.77 6.576l3.75 3.125zM1.308 6.748l4.875-.375-.116-1.496-4.875.375zm5.517-.854L8.7 1.02 7.3.481 5.425 5.356zM7.3 1.02l1.875 4.875 1.4-.538L8.7.48zm2.517 5.354 4.876.375.114-1.496-4.874-.375zm4.453-.95L10.52 8.55l.96 1.152 3.75-3.125zM10.276 9.32l1.375 5.125 1.448-.388-1.375-5.125zm2.523 4.313-4.375-3-.848 1.236 4.375 3z"/>`
        }, props));
    $9b8e6f0febff8b04$var$StarStarredIcon.displayName = 'StarStarredIcon';
    var $9b8e6f0febff8b04$var$_default = module.exports.default = $9b8e6f0febff8b04$var$StarStarredIcon;
});
parcelRegister("iZZ4y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $dd4d4c38eee85cd6$var$_react = $dd4d4c38eee85cd6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $dd4d4c38eee85cd6$var$_personAvatar = $dd4d4c38eee85cd6$var$_interopRequireDefault((parcelRequire("bdVbi")));
    function $dd4d4c38eee85cd6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $dd4d4c38eee85cd6$var$UserAvatarCircleIcon = (props)=>$dd4d4c38eee85cd6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
        }, props, {
            newIcon: $dd4d4c38eee85cd6$var$_personAvatar.default
        }));
    $dd4d4c38eee85cd6$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
    var $dd4d4c38eee85cd6$var$_default = module.exports.default = $dd4d4c38eee85cd6$var$UserAvatarCircleIcon;
});
parcelRegister("29YN9", function(module, exports) {
    $parcel$export(module.exports, "JiraIcon", ()=>$232c206a39097f42$export$c4b5b1f965d8b3eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $232c206a39097f42$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
    };
    const $232c206a39097f42$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $232c206a39097f42$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("hxoiH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0bb205476692ad1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSyk1;
    var $8Zdb4;
    const $b0bb205476692ad1$var$useThemeObserver = ()=>{
        const [theme, setTheme] = (0, $5uXOq.useState)((0, (0, parcelRequire("cSyk1")).default)());
        (0, $5uXOq.useEffect)(()=>{
            const observer = new (0, (0, parcelRequire("8Zdb4")).default)((theme)=>setTheme(theme));
            observer.observe();
            return ()=>observer.disconnect();
        }, []);
        return theme;
    };
    var $b0bb205476692ad1$export$2e2bcd8739ae039 = $b0bb205476692ad1$var$useThemeObserver;
});
parcelRegister("cSyk1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29d05f12610acfc6$export$2e2bcd8739ae039);
    var $f8twK;
    var $hdU6u;
    var $imVhc;
    const $29d05f12610acfc6$var$isThemeColorMode = (colorMode)=>{
        return (0, (0, parcelRequire("hdU6u")).themeColorModes).find((mode)=>mode === colorMode) !== undefined;
    };
    const $29d05f12610acfc6$var$getGlobalTheme = ()=>{
        if (typeof document === 'undefined') return {};
        const element = document.documentElement;
        const colorMode = element.getAttribute((0, (0, parcelRequire("f8twK")).COLOR_MODE_ATTRIBUTE)) || '';
        const theme = element.getAttribute((0, (0, parcelRequire("f8twK")).THEME_DATA_ATTRIBUTE)) || '';
        return {
            ...(0, (0, parcelRequire("imVhc")).themeStringToObject)(theme),
            ...$29d05f12610acfc6$var$isThemeColorMode(colorMode) && {
                colorMode: colorMode
            }
        };
    };
    var $29d05f12610acfc6$export$2e2bcd8739ae039 = $29d05f12610acfc6$var$getGlobalTheme;
});
parcelRegister("hdU6u", function(module, exports) {
    $parcel$export(module.exports, "themeColorModes", ()=>$25f91216499731dd$export$83993de8eb66733);
    $parcel$export(module.exports, "themeIds", ()=>$25f91216499731dd$export$7d43e72a58e3283f);
    $parcel$export(module.exports, "themeIdsWithOverrides", ()=>$25f91216499731dd$export$92ba366331403db2);
    $parcel$export(module.exports, "themeStateDefaults", ()=>$25f91216499731dd$export$9aedcfa7336a207);
    $parcel$export(module.exports, "default", ()=>$25f91216499731dd$export$2e2bcd8739ae039);
    var $VSDnB;
    const $25f91216499731dd$export$83993de8eb66733 = [
        'light',
        'dark',
        'auto'
    ];
    const $25f91216499731dd$export$8ce7e340c74e86c5 = [
        'more',
        'no-preference',
        'auto'
    ];
    const $25f91216499731dd$export$7d43e72a58e3283f = [
        'light-increased-contrast',
        'light',
        'light-future',
        'light-brand-refresh',
        'dark',
        'dark-future',
        'dark-increased-contrast',
        'dark-brand-refresh',
        'legacy-light',
        'legacy-dark',
        'spacing',
        'shape',
        'typography-adg3',
        'typography-modernized',
        'typography-refreshed'
    ];
    const $25f91216499731dd$export$ba8a43b83ecc69f8 = [];
    const $25f91216499731dd$export$92ba366331403db2 = [
        ...$25f91216499731dd$export$7d43e72a58e3283f,
        ...$25f91216499731dd$export$ba8a43b83ecc69f8
    ];
    const $25f91216499731dd$var$themeConfig = {
        'atlassian-light': {
            id: 'light',
            displayName: 'Light Theme',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            }
        },
        'atlassian-light-future': {
            id: 'light-future',
            displayName: 'Future Light Theme',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            },
            override: 'light'
        },
        'atlassian-light-increased-contrast': {
            id: 'light-increased-contrast',
            displayName: 'Light Theme (increased contrast)',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            },
            extends: 'light',
            increasesContrastFor: 'light'
        },
        'atlassian-dark': {
            id: 'dark',
            displayName: 'Dark Theme',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            }
        },
        'atlassian-dark-future': {
            id: 'dark-future',
            displayName: 'Future Dark Theme',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            },
            override: 'light'
        },
        'atlassian-dark-increased-contrast': {
            id: 'dark-increased-contrast',
            displayName: 'Dark Theme (increased contrast)',
            palette: 'defaultPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            },
            extends: 'dark',
            increasesContrastFor: 'dark'
        },
        'atlassian-legacy-light': {
            id: 'legacy-light',
            displayName: 'Light Theme (legacy)',
            palette: 'legacyPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            }
        },
        'atlassian-legacy-dark': {
            id: 'legacy-dark',
            displayName: 'Dark Theme (legacy)',
            palette: 'legacyPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            }
        },
        'atlassian-spacing': {
            id: 'spacing',
            displayName: 'Atlassian Spacing',
            palette: 'spacingScale',
            attributes: {
                type: 'spacing'
            }
        },
        'atlassian-typography-adg3': {
            id: 'typography-adg3',
            displayName: 'ADG3 Typography',
            palette: 'typographyPalette',
            attributes: {
                type: 'typography'
            }
        },
        'atlassian-shape': {
            id: 'shape',
            displayName: 'Atlassian Shape',
            palette: 'shapePalette',
            attributes: {
                type: 'shape'
            }
        },
        'atlassian-typography-modernized': {
            id: 'typography-modernized',
            displayName: 'Atlassian Typography (Modernized)',
            palette: 'typographyPalette',
            attributes: {
                type: 'typography'
            }
        },
        'atlassian-typography-refreshed': {
            id: 'typography-refreshed',
            displayName: 'Atlassian Typography (Refreshed)',
            palette: 'typographyPalette',
            attributes: {
                type: 'typography'
            }
        },
        'atlassian-light-brand-refresh': {
            id: 'light-brand-refresh',
            displayName: 'Light theme (Brand refresh)',
            palette: 'brandRefreshPalette',
            attributes: {
                type: 'color',
                mode: 'light'
            }
        },
        'atlassian-dark-brand-refresh': {
            id: 'dark-brand-refresh',
            displayName: 'Dark theme (Brand refresh)',
            palette: 'brandRefreshPalette',
            attributes: {
                type: 'color',
                mode: 'dark'
            }
        }
    };
    const $25f91216499731dd$export$9aedcfa7336a207 = {
        colorMode: 'auto',
        contrastMode: 'auto',
        dark: 'dark',
        light: 'light',
        shape: undefined,
        spacing: 'spacing',
        typography: ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-default-typography-modernized')) return 'typography-modernized';
            return undefined;
        },
        UNSAFE_themeOptions: undefined
    };
    var $25f91216499731dd$export$2e2bcd8739ae039 = $25f91216499731dd$var$themeConfig;
});
parcelRegister("imVhc", function(module, exports) {
    $parcel$export(module.exports, "themeStringToObject", ()=>$67939390e238a0f3$export$f19b488f7c0547ee);
    $parcel$export(module.exports, "themeObjectToString", ()=>$67939390e238a0f3$export$62c37ab81302621a);
    var $hdU6u;
    const $67939390e238a0f3$var$themeKinds = [
        'light',
        'dark',
        'spacing',
        'typography',
        'shape'
    ];
    const $67939390e238a0f3$var$customThemeOptions = 'UNSAFE_themeOptions';
    const $67939390e238a0f3$var$isThemeKind = (themeKind)=>{
        return $67939390e238a0f3$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
    };
    const $67939390e238a0f3$var$isThemeIds = (themeId)=>{
        return (0, (0, parcelRequire("hdU6u")).themeIds).find((id)=>id === themeId) !== undefined;
    };
    const $67939390e238a0f3$var$isColorMode = (modeId)=>{
        return [
            'light',
            'dark',
            'auto'
        ].includes(modeId);
    };
    const $67939390e238a0f3$export$f19b488f7c0547ee = (themeState)=>{
        return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
            if (kind === 'colorMode' && $67939390e238a0f3$var$isColorMode(id)) themeObject[kind] = id;
            if ($67939390e238a0f3$var$isThemeKind(kind) && $67939390e238a0f3$var$isThemeIds(id)) themeObject[kind] = id;
            if (kind === $67939390e238a0f3$var$customThemeOptions) try {
                themeObject[$67939390e238a0f3$var$customThemeOptions] = JSON.parse(id);
            } catch (e) {
                new Error('Invalid custom theme string');
            }
            return themeObject;
        }, {});
    };
    const $67939390e238a0f3$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
            if (kind === 'colorMode' && typeof id === 'string' && $67939390e238a0f3$var$isColorMode(id) || kind === $67939390e238a0f3$var$customThemeOptions && typeof id === 'object' || $67939390e238a0f3$var$isThemeKind(kind) && typeof id === 'string' && $67939390e238a0f3$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
            return themeString;
        }, '');
});
parcelRegister("8Zdb4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$332f5cb1aec7999c$export$2e2bcd8739ae039);
    var $f8twK;
    var $cSyk1;
    class $332f5cb1aec7999c$export$2e2bcd8739ae039 {
        static{
            this.observer = null;
        }
        static{
            this.callbacks = new Set();
        }
        constructor(callback){
            this.legacyObserver = null;
            this.callback = callback;
            $332f5cb1aec7999c$export$2e2bcd8739ae039.callbacks.add(callback);
        }
        observe() {
            if (!$332f5cb1aec7999c$export$2e2bcd8739ae039.observer) {
                $332f5cb1aec7999c$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                    const theme = (0, (0, parcelRequire("cSyk1")).default)();
                    $332f5cb1aec7999c$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
                });
                $332f5cb1aec7999c$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                    attributeFilter: [
                        (0, (0, parcelRequire("f8twK")).THEME_DATA_ATTRIBUTE),
                        (0, (0, parcelRequire("f8twK")).COLOR_MODE_ATTRIBUTE)
                    ]
                });
            }
        }
        disconnect() {
            if (this.callback) $332f5cb1aec7999c$export$2e2bcd8739ae039.callbacks.delete(this.callback);
            if ($332f5cb1aec7999c$export$2e2bcd8739ae039.callbacks.size === 0 && $332f5cb1aec7999c$export$2e2bcd8739ae039.observer) {
                $332f5cb1aec7999c$export$2e2bcd8739ae039.observer.disconnect();
                $332f5cb1aec7999c$export$2e2bcd8739ae039.observer = null;
            }
        }
    }
});
parcelRegister("lEsIP", function(module, exports) {
    $parcel$export(module.exports, "defaultLogoParams", ()=>$90614d6f5902a55a$export$438460117ae6b7ee);
    $parcel$export(module.exports, "legacyDefaultLogoParams", ()=>$90614d6f5902a55a$export$793fba32aed8942a);
    $parcel$export(module.exports, "sizes", ()=>$90614d6f5902a55a$export$c647cb0ee6e282fe);
    const $90614d6f5902a55a$export$438460117ae6b7ee = {
        iconColor: 'inherit',
        label: '',
        size: 'medium',
        textColor: 'currentColor'
    };
    const $90614d6f5902a55a$export$793fba32aed8942a = {
        iconGradientStart: 'inherit',
        iconGradientStop: 'inherit'
    };
    const $90614d6f5902a55a$export$c647cb0ee6e282fe = {
        xsmall: 16,
        small: 24,
        medium: 32,
        large: 40,
        xlarge: 48
    };
    const $90614d6f5902a55a$export$31d7044b7540a6d8 = $90614d6f5902a55a$export$438460117ae6b7ee;
});
parcelRegister("6PPEt", function(module, exports) {
    $parcel$export(module.exports, "getColorsFromAppearanceOldLogos", ()=>$b6578d83d04b350e$export$362a25f017e2bc8a);
    $parcel$export(module.exports, "getColorsFromAppearance", ()=>$b6578d83d04b350e$export$bbacc3980e0f3029);
    $parcel$export(module.exports, "getColorsForLoom", ()=>$b6578d83d04b350e$export$7818df200941dbbf);
    const $b6578d83d04b350e$export$362a25f017e2bc8a = (appearance, colorMode)=>{
        let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
        switch(appearance){
            case 'brand':
                iconGradientStart = (0, $829f609a65d26a98$export$b3de0ae08da2ce64);
                iconGradientStop = (0, $829f609a65d26a98$export$215b7063051591f1);
                iconColor = (0, $829f609a65d26a98$export$215b7063051591f1);
                textColor = `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`;
                atlassianLogoTextColor = (0, $829f609a65d26a98$export$b3de0ae08da2ce64);
                break;
            case 'neutral':
                iconGradientStart = (0, $829f609a65d26a98$export$7090862dc3038a9f);
                iconGradientStop = (0, $829f609a65d26a98$export$d6447c357493214f);
                iconColor = (0, $829f609a65d26a98$export$d6447c357493214f);
                textColor = (0, $829f609a65d26a98$export$eece5f492e429f08);
                atlassianLogoTextColor = (0, $829f609a65d26a98$export$eece5f492e429f08);
                break;
            case 'inverse':
                iconGradientStart = '#FFFFFF66';
                iconGradientStop = '#FFFFFF';
                iconColor = '#FFFFFF';
                textColor = '#FFFFFF';
                atlassianLogoTextColor = '#FFFFFF';
                break;
        }
        if (colorMode === 'dark' && appearance === 'inverse') {
            iconGradientStart = '#161A1D66';
            iconGradientStop = '#161A1D';
            iconColor = '#161A1D';
            textColor = '#161A1D';
            atlassianLogoTextColor = '#161A1D';
        }
        return {
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor,
            atlassianLogoTextColor: atlassianLogoTextColor
        };
    };
    const $b6578d83d04b350e$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
        let iconColor, textColor, atlassianLogoTextColor;
        if (colorMode === 'dark') switch(appearance){
            case 'brand':
                iconColor = '#357DE8';
                textColor = '#E2E3E4';
                atlassianLogoTextColor = '#357DE8';
                break;
            case 'neutral':
                iconColor = '#96999E';
                textColor = '#BFC1C4';
                atlassianLogoTextColor = '#96999E';
                break;
            case 'inverse':
                iconColor = '#101214';
                textColor = '#101214';
                atlassianLogoTextColor = '#101214';
                break;
        }
        else switch(appearance){
            case 'brand':
                iconColor = '#1868DB';
                textColor = '#101214';
                atlassianLogoTextColor = '#1868DB';
                break;
            case 'neutral':
                iconColor = '#6C6F77';
                textColor = '#3B3D42';
                atlassianLogoTextColor = '#6C6F77';
                break;
            case 'inverse':
                iconColor = (0, $829f609a65d26a98$export$29a4f05edc054374);
                textColor = (0, $829f609a65d26a98$export$29a4f05edc054374);
                atlassianLogoTextColor = (0, $829f609a65d26a98$export$29a4f05edc054374);
                break;
        }
        return {
            iconColor: iconColor,
            textColor: textColor,
            atlassianLogoTextColor: atlassianLogoTextColor
        };
    };
    const $b6578d83d04b350e$export$7818df200941dbbf = (appearance, colorMode)=>{
        let iconColor = $b6578d83d04b350e$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
        let textColor = $b6578d83d04b350e$export$bbacc3980e0f3029(appearance, colorMode).textColor;
        if (colorMode === 'dark') switch(appearance){
            case 'brand':
                iconColor = '#625DF5';
                textColor = '#EFF0FF';
                break;
        }
        else switch(appearance){
            case 'brand':
                iconColor = '#625DF5';
                textColor = '#252434';
                break;
        }
        return {
            iconColor: iconColor,
            textColor: textColor
        };
    };
});
parcelRegister("iVs6J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e738af8b5a2657f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $lEsIP;
    function $4e738af8b5a2657f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4e738af8b5a2657f$var$CSS_VAR_COLOR = '--logo-color';
    const $4e738af8b5a2657f$var$CSS_VAR_FILL = '--logo-fill';
    const $4e738af8b5a2657f$var$baseWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        position: 'relative',
        color: `var(${$4e738af8b5a2657f$var$CSS_VAR_COLOR})`,
        fill: `var(${$4e738af8b5a2657f$var$CSS_VAR_FILL})`,
        lineHeight: 1,
        userSelect: 'none',
        whiteSpace: 'normal',
        '> svg': {
            height: '100%',
            fill: 'inherit'
        }
    });
    const $4e738af8b5a2657f$var$stopColorStyles = {
        name: "1hl44m8",
        styles: "stop{stop-color:currentColor;}"
    };
    const $4e738af8b5a2657f$var$sizeStyles = Object.entries((0, (0, parcelRequire("lEsIP")).sizes)).reduce((acc, [key, val])=>{
        acc[key] = (0, (0, parcelRequire("f8Sb3")).css)({
            height: `${val}px`
        });
        return acc;
    }, {});
    const $4e738af8b5a2657f$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
        const shouldApplyStopColor = appearance === undefined;
        const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $4e738af8b5a2657f$var$baseWrapperStyles,
                shouldApplyStopColor && $4e738af8b5a2657f$var$stopColorStyles,
                size && $4e738af8b5a2657f$var$sizeStyles[size]
            ],
            "data-testid": testId,
            style: {
                [$4e738af8b5a2657f$var$CSS_VAR_COLOR]: iconColor,
                [$4e738af8b5a2657f$var$CSS_VAR_FILL]: textColor
            },
            "aria-label": label ? label : undefined,
            role: label ? 'img' : undefined,
            dangerouslySetInnerHTML: {
                __html: svg
            },
            ...rest
        });
    };
    var $4e738af8b5a2657f$export$2e2bcd8739ae039 = $4e738af8b5a2657f$var$Wrapper;
});
parcelRegister("3bDjY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a32ae7efc436f22$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $cVP8B;
    var $eGmKJ;
    var $71YXv;
    var $98OXW;
    var $9Mkr0;
    var $35XSW;
    var $4uxPN;
    var $lObw7;
    var $4oNEb;
    var $k8nZq;
    var $k5uoT;
    var $7r5w3;
    var $hujyS;
    var $i7NyT;
    var $2GU2Y;
    var $BCDGx;
    const $6a32ae7efc436f22$var$tooltipZIndex = (0, (0, parcelRequire("k5uoT")).layers).tooltip();
    const $6a32ae7efc436f22$var$analyticsAttributes = {
        componentName: 'tooltip',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $6a32ae7efc436f22$var$invertedDirection = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
    };
    const $6a32ae7efc436f22$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
    function $6a32ae7efc436f22$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, component: Container = (0, (0, parcelRequire("2GU2Y")).default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, (0, parcelRequire("eGmKJ")).default), onHide: onHide = (0, (0, parcelRequire("eGmKJ")).default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false }) {
        const tooltipPosition = position === 'mouse' ? mousePosition : position;
        const onShowHandler = (0, (0, parcelRequire("cVP8B")).usePlatformLeafSyntheticEventHandler)({
            fn: onShow,
            action: 'displayed',
            analyticsData: analyticsContext,
            ...$6a32ae7efc436f22$var$analyticsAttributes
        });
        const onHideHandler = (0, (0, parcelRequire("cVP8B")).usePlatformLeafSyntheticEventHandler)({
            fn: onHide,
            action: 'hidden',
            analyticsData: analyticsContext,
            ...$6a32ae7efc436f22$var$analyticsAttributes
        });
        const apiRef = (0, $5uXOq.useRef)(null);
        const [state, setState] = (0, $5uXOq.useState)('hide');
        const targetRef = (0, $5uXOq.useRef)(null);
        const containerRef = (0, $5uXOq.useRef)(null);
        const setImplicitRefFromChildren = (node)=>{
            containerRef.current = node;
            targetRef.current = node ? node.firstElementChild : null;
        };
        const setDirectRef = (0, $5uXOq.useCallback)((node)=>{
            targetRef.current = node;
        }, []);
        const stableState = (0, (0, parcelRequire("98OXW")).default)(state);
        const onShowHandlerStable = (0, (0, parcelRequire("98OXW")).default)(onShowHandler);
        const onHideHandlerStable = (0, (0, parcelRequire("98OXW")).default)(onHideHandler);
        const delayStable = (0, (0, parcelRequire("98OXW")).default)(delay);
        const canAppearStable = (0, (0, parcelRequire("98OXW")).default)(canAppear);
        const hasCalledShowHandler = (0, $5uXOq.useRef)(false);
        const start = (0, $5uXOq.useCallback)((api)=>{
            apiRef.current = api;
            hasCalledShowHandler.current = false;
        }, []);
        const done = (0, $5uXOq.useCallback)(()=>{
            if (!apiRef.current) return;
            if (hasCalledShowHandler.current) onHideHandlerStable.current();
            apiRef.current = null;
            hasCalledShowHandler.current = false;
            setState('hide');
        }, [
            onHideHandlerStable
        ]);
        const abort = (0, $5uXOq.useCallback)(()=>{
            if (!apiRef.current) return;
            apiRef.current.abort();
            if (hasCalledShowHandler.current) onHideHandlerStable.current();
            apiRef.current = null;
        }, [
            onHideHandlerStable
        ]);
        (0, $5uXOq.useEffect)(function mount() {
            return function unmount() {
                if (apiRef.current) abort();
            };
        }, [
            abort
        ]);
        const isDraggingRef = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            return (0, (0, parcelRequire("7r5w3")).register)({
                onRegister ({ isDragging: isDragging }) {
                    isDraggingRef.current = isDragging;
                },
                onDragStart () {
                    apiRef.current?.requestHide({
                        isImmediate: true
                    });
                    isDraggingRef.current = true;
                },
                onDragEnd () {
                    isDraggingRef.current = false;
                }
            });
        }, []);
        const tryShowTooltip = (0, $5uXOq.useCallback)((source)=>{
            if (isDraggingRef.current) return;
            if (apiRef.current && !apiRef.current.isActive()) abort();
            if (apiRef.current && apiRef.current.isActive()) {
                apiRef.current.keep();
                return;
            }
            if (canAppearStable.current && !canAppearStable.current?.()) return;
            const entry = {
                source: source,
                delay: delayStable.current,
                show: ({ isImmediate: isImmediate })=>{
                    if (!hasCalledShowHandler.current) {
                        hasCalledShowHandler.current = true;
                        onShowHandlerStable.current();
                    }
                    setState(isImmediate ? 'show-immediate' : 'fade-in');
                },
                hide: ({ isImmediate: isImmediate })=>{
                    if (isImmediate) setState('hide');
                    else setState('before-fade-out');
                },
                done: done
            };
            const api = (0, (0, parcelRequire("hujyS")).show)(entry);
            start(api);
        }, [
            canAppearStable,
            delayStable,
            done,
            start,
            abort,
            onShowHandlerStable
        ]);
        const hideTooltipOnEsc = (0, $5uXOq.useCallback)(()=>{
            apiRef.current?.requestHide({
                isImmediate: true
            });
        }, [
            apiRef
        ]);
        (0, (0, parcelRequire("71YXv")).default)({
            onClose: hideTooltipOnEsc,
            isDisabled: state === 'hide' || state === 'fade-out'
        });
        (0, $5uXOq.useEffect)(()=>{
            if (state === 'hide') return 0, (0, parcelRequire("eGmKJ")).default;
            if (state === 'before-fade-out') setState('fade-out');
            const unbind = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'scroll',
                listener: ()=>{
                    if (apiRef.current) apiRef.current.requestHide({
                        isImmediate: true
                    });
                },
                options: {
                    capture: true,
                    passive: true,
                    once: true
                }
            });
            return unbind;
        }, [
            state
        ]);
        const onMouseDown = (0, $5uXOq.useCallback)(()=>{
            if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
                isImmediate: true
            });
        }, [
            hideTooltipOnMouseDown
        ]);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
                isImmediate: true
            });
        }, [
            hideTooltipOnClick
        ]);
        const onMouseOver = (0, $5uXOq.useCallback)((event)=>{
            if (containerRef.current && event.target === containerRef.current) return;
            if (event.defaultPrevented) return;
            event.preventDefault();
            const source = position === 'mouse' ? {
                type: 'mouse',
                mouse: (0, (0, parcelRequire("BCDGx")).getMousePosition)({
                    left: event.clientX,
                    top: event.clientY
                })
            } : {
                type: 'keyboard'
            };
            tryShowTooltip(source);
        }, [
            position,
            tryShowTooltip
        ]);
        const onMouseOut = (0, $5uXOq.useCallback)((event)=>{
            if (containerRef.current && event.target === containerRef.current) return;
            if (event.defaultPrevented) return;
            event.preventDefault();
            if (apiRef.current) apiRef.current.requestHide({
                isImmediate: false
            });
        }, []);
        const onMouseMove = position === 'mouse' ? (event)=>{
            if (apiRef.current?.isActive()) apiRef.current.mousePosition = (0, (0, parcelRequire("BCDGx")).getMousePosition)({
                left: event.clientX,
                top: event.clientY
            });
        } : undefined;
        const onMouseOverTooltip = (0, $5uXOq.useCallback)(()=>{
            if (apiRef.current && apiRef.current.isActive()) {
                apiRef.current.keep();
                return;
            }
        }, []);
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            tryShowTooltip({
                type: 'keyboard'
            });
        }, [
            tryShowTooltip
        ]);
        const onBlur = (0, $5uXOq.useCallback)(()=>{
            if (apiRef.current) apiRef.current.requestHide({
                isImmediate: false
            });
        }, []);
        const onAnimationFinished = (0, $5uXOq.useCallback)((transition)=>{
            if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
        }, [
            stableState
        ]);
        const CastTargetContainer = TargetContainer;
        const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
        const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
        const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
        (0, (0, parcelRequire("9Mkr0")).useNotifyOpenLayerObserver)({
            isOpen: shouldRenderTooltipPopup
        });
        const getReferenceElement = ()=>{
            if (position === 'mouse' && apiRef.current?.mousePosition) return apiRef.current?.mousePosition;
            return targetRef.current || undefined;
        };
        const tooltipIdForHiddenContent = (0, (0, parcelRequire("i7NyT")).default)('tooltip', shouldRenderHiddenContent);
        const tooltipTriggerProps = {
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            onMouseMove: onMouseMove,
            onMouseDown: onMouseDown,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur
        };
        if (testId) tooltipTriggerProps['data-testid'] = `${testId}--container`;
        const isChildrenAFunction = typeof children === 'function';
        (0, $5uXOq.useEffect)(()=>{
            if (isChildrenAFunction) return;
            const target = targetRef.current;
            if (!target || !tooltipIdForHiddenContent) return;
            target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
            return ()=>target.removeAttribute('aria-describedby');
        }, [
            isChildrenAFunction,
            tooltipIdForHiddenContent
        ]);
        const hiddenContent = shouldRenderHiddenContent ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": testId ? `${testId}-hidden` : undefined,
            hidden: true,
            id: tooltipIdForHiddenContent
        }, typeof content === 'function' ? content({}) : content) : null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, typeof children === 'function' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children({
            ...tooltipTriggerProps,
            'aria-describedby': tooltipIdForHiddenContent,
            ref: setDirectRef
        }), hiddenContent) : (0, ($parcel$interopDefault($5uXOq))).createElement(CastTargetContainer, {
            ...tooltipTriggerProps,
            ref: setImplicitRefFromChildren,
            role: "presentation"
        }, children, hiddenContent), shouldRenderTooltipPopup ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8nZq")).default), {
            zIndex: $6a32ae7efc436f22$var$tooltipZIndex
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), {
            placement: tooltipPosition,
            referenceElement: getReferenceElement(),
            strategy: strategy
        }, ({ ref: ref, style: style, update: update, placement: placement })=>{
            const direction = position === 'mouse' ? undefined : $6a32ae7efc436f22$var$invertedDirection[$6a32ae7efc436f22$var$getDirectionFromPlacement(placement)];
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35XSW")).default), {
                appear: true
            }, shouldRenderTooltipChildren && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uxPN")).default), {
                distance: "constant",
                entranceDirection: direction,
                exitDirection: direction,
                onFinish: onAnimationFinished,
                duration: state === 'show-immediate' ? 0 : (0, (0, parcelRequire("lObw7")).mediumDurationMs)
            }, ({ className: className })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Container, {
                    ref: ref,
                    className: `Tooltip ${className}`,
                    style: {
                        ...style,
                        ...ignoreTooltipPointerEvents && {
                            pointerEvents: 'none'
                        }
                    },
                    truncate: truncate,
                    placement: tooltipPosition,
                    testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                    onMouseOut: onMouseOut,
                    onMouseOver: onMouseOverTooltip
                }, typeof content === 'function' ? content({
                    update: update
                }) : content)));
        })) : null);
    }
    $6a32ae7efc436f22$var$Tooltip.displayName = 'Tooltip';
    var $6a32ae7efc436f22$export$2e2bcd8739ae039 = $6a32ae7efc436f22$var$Tooltip;
});
parcelRegister("71YXv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3279c389e4b2ed8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    function $c3279c389e4b2ed8$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
        const escapePressed = (0, $5uXOq.useRef)(false);
        const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (isDisabled || escapePressed.current || e.key !== (0, $5e71d9a7b5ef77ee$export$2bb790b9008907b4)) return;
            escapePressed.current = true;
            onClose(e);
        }, [
            onClose,
            isDisabled
        ]);
        const onKeyUp = (0, $5uXOq.useCallback)(()=>{
            escapePressed.current = false;
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            return (0, (0, parcelRequire("cBeZP")).bindAll)(document, [
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'keyup',
                    listener: onKeyUp
                }
            ], {
                capture: false
            });
        }, [
            onKeyDown,
            onKeyUp
        ]);
    }
});
const $5e71d9a7b5ef77ee$export$390330c10ff2b9a1 = 'ArrowUp';
const $5e71d9a7b5ef77ee$export$a80636c6f41931fe = 'ArrowDown';
const $5e71d9a7b5ef77ee$export$4af703091671bc = 'Home';
const $5e71d9a7b5ef77ee$export$e2bc30913faa5db7 = 'End';
const $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b = 'Tab';
const $5e71d9a7b5ef77ee$export$8152f929a25a0ff4 = 'Enter';
const $5e71d9a7b5ef77ee$export$e51a3576c045c8d5 = 'Space';
const $5e71d9a7b5ef77ee$export$2bb790b9008907b4 = 'Escape';
parcelRegister("98OXW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16857c6631d3f677$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $16857c6631d3f677$export$2e2bcd8739ae039(value) {
        const ref = (0, $5uXOq.useRef)(value);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref;
    }
});
parcelRegister("9Mkr0", function(module, exports) {
    $parcel$export(module.exports, "useNotifyOpenLayerObserver", ()=>$cae134e314e7af2c$export$469bb693f11edc7f);
    var $5uXOq = parcelRequire("5uXOq");
    var $kEhTY;
    function $cae134e314e7af2c$export$469bb693f11edc7f({ isOpen: isOpen = true } = {}) {
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("kEhTY")).OpenLayerObserverContext));
        (0, $5uXOq.useEffect)(()=>{
            if (context === null) return;
            if (!isOpen) return;
            context.increment();
            return ()=>{
                context.decrement();
            };
        }, [
            context,
            isOpen
        ]);
    }
});
parcelRegister("kEhTY", function(module, exports) {
    $parcel$export(module.exports, "OpenLayerObserverContext", ()=>$b69a64f72818831f$export$5fbf4d7fae6cdc00);
    var $5uXOq = parcelRequire("5uXOq");
    const $b69a64f72818831f$export$5fbf4d7fae6cdc00 = (0, $5uXOq.createContext)(null);
});
parcelRegister("7r5w3", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$30d13d24dfc1dd2d$export$6503ec6e8aabbaf);
    var $cBeZP;
    const $30d13d24dfc1dd2d$var$registrations = new Set();
    let $30d13d24dfc1dd2d$var$cleanupEndEventListeners = null;
    function $30d13d24dfc1dd2d$var$onDragStart() {
        if ($30d13d24dfc1dd2d$var$cleanupEndEventListeners) return;
        $30d13d24dfc1dd2d$var$cleanupEndEventListeners = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'dragend',
                listener: $30d13d24dfc1dd2d$var$onDragEnd
            },
            {
                type: 'pointerdown',
                listener: $30d13d24dfc1dd2d$var$onDragEnd
            },
            {
                type: 'pointermove',
                listener: (()=>{
                    let callCount = 0;
                    return function listener() {
                        if (callCount < 20) {
                            callCount++;
                            return;
                        }
                        $30d13d24dfc1dd2d$var$onDragEnd();
                    };
                })()
            }
        ]);
        const clone = Array.from($30d13d24dfc1dd2d$var$registrations);
        clone.forEach((subscriber)=>{
            subscriber.onDragStart();
        });
    }
    function $30d13d24dfc1dd2d$var$onDragEnd() {
        $30d13d24dfc1dd2d$var$cleanupEndEventListeners?.();
        $30d13d24dfc1dd2d$var$cleanupEndEventListeners = null;
        const clone = Array.from($30d13d24dfc1dd2d$var$registrations);
        clone.forEach((subscriber)=>{
            subscriber.onDragEnd();
        });
    }
    function $30d13d24dfc1dd2d$var$bindStartEvents() {
        return (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'dragstart',
                listener: $30d13d24dfc1dd2d$var$onDragStart
            },
            {
                type: 'dragenter',
                listener: $30d13d24dfc1dd2d$var$onDragStart
            }
        ]);
    }
    let $30d13d24dfc1dd2d$var$cleanupStartEventListeners = null;
    function $30d13d24dfc1dd2d$export$6503ec6e8aabbaf(registration) {
        if (!$30d13d24dfc1dd2d$var$cleanupStartEventListeners) $30d13d24dfc1dd2d$var$cleanupStartEventListeners = $30d13d24dfc1dd2d$var$bindStartEvents();
        $30d13d24dfc1dd2d$var$registrations.add(registration);
        registration.onRegister({
            isDragging: $30d13d24dfc1dd2d$var$cleanupEndEventListeners !== null
        });
        return function unregister() {
            $30d13d24dfc1dd2d$var$registrations.delete(registration);
            if ($30d13d24dfc1dd2d$var$registrations.size === 0) {
                $30d13d24dfc1dd2d$var$cleanupStartEventListeners?.();
                $30d13d24dfc1dd2d$var$cleanupStartEventListeners = null;
            }
        };
    }
});
parcelRegister("hujyS", function(module, exports) {
    $parcel$export(module.exports, "show", ()=>$20cb1f7c3bdaaaba$export$57bf213be019eeb0);
    var $fDxFB;
    let $20cb1f7c3bdaaaba$var$active = null;
    function $20cb1f7c3bdaaaba$export$57bf213be019eeb0(entry) {
        let phase = 'waiting-to-show';
        function isActive() {
            return Boolean($20cb1f7c3bdaaaba$var$active && $20cb1f7c3bdaaaba$var$active.entry === entry);
        }
        function cleanup() {
            if (isActive()) {
                (0, (0, parcelRequire("fDxFB")).clearScheduled)();
                $20cb1f7c3bdaaaba$var$active = null;
            }
        }
        function done() {
            if (isActive()) entry.done();
            phase = 'done';
            cleanup();
        }
        function immediatelyHideAndDone() {
            if (isActive()) entry.hide({
                isImmediate: true
            });
            done();
        }
        function keep() {
            if (!isActive()) return;
            if (phase === 'waiting-to-hide') {
                phase = 'shown';
                (0, (0, parcelRequire("fDxFB")).clearScheduled)();
                return;
            }
            if (phase === 'hide-animating') {
                phase = 'shown';
                (0, (0, parcelRequire("fDxFB")).clearScheduled)();
                entry.show({
                    isImmediate: false
                });
                return;
            }
        }
        function requestHide({ isImmediate: isImmediate }) {
            if (!isActive()) return;
            if (phase === 'waiting-to-show') {
                immediatelyHideAndDone();
                return;
            }
            if (phase === 'waiting-to-hide') return;
            if (isImmediate) {
                immediatelyHideAndDone();
                return;
            }
            phase = 'waiting-to-hide';
            (0, (0, parcelRequire("fDxFB")).scheduleTimeout)(()=>{
                phase = 'hide-animating';
                entry.hide({
                    isImmediate: false
                });
            }, entry.delay);
        }
        function finishHideAnimation() {
            if (isActive() && phase === 'hide-animating') done();
        }
        function isVisible() {
            return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
        }
        function getInitialMouse() {
            if (entry.source.type === 'mouse') return entry.source.mouse;
            return null;
        }
        function start() {
            const showImmediately = Boolean($20cb1f7c3bdaaaba$var$active && $20cb1f7c3bdaaaba$var$active.isVisible());
            if ($20cb1f7c3bdaaaba$var$active) {
                (0, (0, parcelRequire("fDxFB")).clearScheduled)();
                $20cb1f7c3bdaaaba$var$active.entry.hide({
                    isImmediate: true
                });
                $20cb1f7c3bdaaaba$var$active.entry.done();
                $20cb1f7c3bdaaaba$var$active = null;
            }
            $20cb1f7c3bdaaaba$var$active = {
                entry: entry,
                isVisible: isVisible
            };
            function show() {
                phase = 'shown';
                entry.show({
                    isImmediate: showImmediately
                });
            }
            if (showImmediately) {
                show();
                return;
            }
            phase = 'waiting-to-show';
            (0, (0, parcelRequire("fDxFB")).scheduleTimeout)(show, entry.delay);
        }
        start();
        const result = {
            keep: keep,
            abort: cleanup,
            isActive: isActive,
            requestHide: requestHide,
            finishHideAnimation: finishHideAnimation,
            mousePosition: getInitialMouse()
        };
        return result;
    }
});
parcelRegister("fDxFB", function(module, exports) {
    $parcel$export(module.exports, "clearScheduled", ()=>$a0c696065026d985$export$eaf678f6f93f5250);
    $parcel$export(module.exports, "scheduleTimeout", ()=>$a0c696065026d985$export$5f4d6617421d489b);
    let $a0c696065026d985$var$delayId = null;
    function $a0c696065026d985$export$eaf678f6f93f5250() {
        if ($a0c696065026d985$var$delayId != null) {
            window.clearTimeout($a0c696065026d985$var$delayId);
            $a0c696065026d985$var$delayId = null;
        }
    }
    function $a0c696065026d985$export$5f4d6617421d489b(fn, delay) {
        $a0c696065026d985$export$eaf678f6f93f5250();
        $a0c696065026d985$var$delayId = window.setTimeout(()=>{
            $a0c696065026d985$var$delayId = null;
            fn();
        }, delay);
    }
});
parcelRegister("i7NyT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6abe69a0276ee72$export$2e2bcd8739ae039);
    var $9KnKW;
    function $a6abe69a0276ee72$export$2e2bcd8739ae039(prefix, shouldRenderId) {
        const seed = (0, (0, parcelRequire("9KnKW")).useIdSeed)();
        return shouldRenderId ? `${seed(prefix)}` : undefined;
    }
});
parcelRegister("9KnKW", function(module, exports) {
    $parcel$export(module.exports, "useId", ()=>$62a5d20aa68cb64e$export$f680877a34711e37);
    $parcel$export(module.exports, "IdProvider", ()=>$62a5d20aa68cb64e$export$6be90bcb437e928f);
    $parcel$export(module.exports, "useIdSeed", ()=>$62a5d20aa68cb64e$export$6ee17796e3d70de2);
    var $5uXOq = parcelRequire("5uXOq");
    var $22Gxp;
    var $VSDnB;
    const $62a5d20aa68cb64e$var$react18UseId = (0, ($parcel$interopDefault($5uXOq))).useId ?? undefined;
    function $62a5d20aa68cb64e$export$f680877a34711e37() {
        if ($62a5d20aa68cb64e$var$react18UseId && (0, (0, parcelRequire("VSDnB")).fg)('platform.design-system-team.react-18-use-id_mn8q4')) return $62a5d20aa68cb64e$var$react18UseId();
        return `uid${(0, (0, parcelRequire("22Gxp")).useUID)()}`;
    }
    const $62a5d20aa68cb64e$export$6be90bcb437e928f = (0, $5uXOq.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
        const id = `${prefix}${$62a5d20aa68cb64e$export$f680877a34711e37()}${postfix}`;
        (0, $5uXOq.useEffect)(()=>{
            if (!ref) return;
            switch(typeof ref){
                case 'function':
                    ref(id);
                    break;
                case 'object':
                    ref.current = id;
                    break;
                default:
                    throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
            }
        }, [
            id,
            ref
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, typeof children === 'function' ? children({
            id: id
        }) : children);
    });
    function $62a5d20aa68cb64e$export$6ee17796e3d70de2() {
        if ($62a5d20aa68cb64e$var$react18UseId && (0, (0, parcelRequire("VSDnB")).fg)('platform.design-system-team.react-18-use-id_mn8q4')) {
            const uid = $62a5d20aa68cb64e$var$react18UseId();
            return (id)=>`${uid}-${id.toString()}`;
        }
        return (0, (0, parcelRequire("22Gxp")).useUIDSeed)();
    }
});
parcelRegister("2GU2Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5329ae62da69c819$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $btzsC;
    function $5329ae62da69c819$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5329ae62da69c819$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        maxWidth: '240px',
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
        backgroundColor: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        insetBlockStart: "var(--ds-space-0, 0px)",
        insetInlineStart: "var(--ds-space-0, 0px)",
        overflowWrap: 'break-word',
        wordWrap: 'break-word'
    });
    const $5329ae62da69c819$var$truncateStyles = {
        name: "1e1ci1f",
        styles: "max-width:420px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $5329ae62da69c819$var$TooltipContainer = (0, $5uXOq.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("btzsC")).default), {
            ref: ref,
            style: style,
            className: className,
            placement: placement,
            testId: testId,
            id: id,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            css: [
                $5329ae62da69c819$var$baseStyles,
                truncate ? $5329ae62da69c819$var$truncateStyles : null
            ]
        }, children);
    });
    $5329ae62da69c819$var$TooltipContainer.displayName = 'TooltipContainer';
    var $5329ae62da69c819$export$2e2bcd8739ae039 = $5329ae62da69c819$var$TooltipContainer;
});
parcelRegister("btzsC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ffa256b65532dda$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $k5uoT;
    const $5ffa256b65532dda$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
    const $5ffa256b65532dda$var$primitiveStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zindex: `var(${$5ffa256b65532dda$var$VAR_PRIMITIVE_ZINDEX})`,
        cursor: `default`
    });
    const $5ffa256b65532dda$var$TooltipPrimitive = (0, $5uXOq.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id }, ref) {
        const styleWithZIndex = {
            ...style,
            [$5ffa256b65532dda$var$VAR_PRIMITIVE_ZINDEX]: (0, (0, parcelRequire("k5uoT")).layers).tooltip()
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            style: styleWithZIndex,
            "data-testid": testId ? `${testId}--wrapper` : undefined
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "tooltip",
            className: className,
            onMouseOut: onMouseOut,
            onMouseOver: onMouseOver,
            css: $5ffa256b65532dda$var$primitiveStyles,
            "data-placement": placement,
            "data-testid": testId,
            id: id
        }, children));
    });
    $5ffa256b65532dda$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
    var $5ffa256b65532dda$export$2e2bcd8739ae039 = $5ffa256b65532dda$var$TooltipPrimitive;
});
parcelRegister("BCDGx", function(module, exports) {
    $parcel$export(module.exports, "getMousePosition", ()=>$525a92fc84f54d7e$export$642213d516a9b928);
    function $525a92fc84f54d7e$export$642213d516a9b928(mouseCoordinates) {
        const safeMouse = mouseCoordinates || {
            top: 0,
            left: 0
        };
        const getBoundingClientRect = ()=>({
                top: safeMouse.top,
                left: safeMouse.left,
                bottom: safeMouse.top,
                right: safeMouse.left,
                width: 0,
                height: 0
            });
        return {
            getBoundingClientRect: getBoundingClientRect,
            clientWidth: 0,
            clientHeight: 0
        };
    }
});
parcelRegister("i8Qvm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9e1183b83a373acd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $35XSW;
    const $9e1183b83a373acd$var$ModalTransition = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35XSW")).default), {
            appear: true
        }, props.children);
    };
    var $9e1183b83a373acd$export$2e2bcd8739ae039 = $9e1183b83a373acd$var$ModalTransition;
});
parcelRegister("e4yMr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c4e7f5fe5d003ac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $jhmo0;
    function $8c4e7f5fe5d003ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8c4e7f5fe5d003ac$var$visitedLinkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':visited': {
            color: 'color.link.visited'
        },
        ':visited:hover': {
            color: 'color.link.visited'
        },
        ':visited:active': {
            color: 'color.link.visited.pressed'
        }
    });
    const $8c4e7f5fe5d003ac$var$defaultAppearanceStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textDecoration: 'underline',
        color: 'color.link',
        ':hover': {
            color: 'color.link',
            textDecoration: 'none'
        },
        ':active': {
            color: 'color.link.pressed'
        },
        ':focus': {
            textDecoration: 'underline'
        }
    });
    const $8c4e7f5fe5d003ac$var$subtleAppearanceStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textDecoration: 'none',
        color: 'color.text.subtle',
        ':hover': {
            color: 'color.text.subtle',
            textDecoration: 'underline'
        },
        ':active': {
            color: 'color.text'
        }
    });
    const $8c4e7f5fe5d003ac$var$inverseAppearanceStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textDecoration: 'underline',
        color: 'color.text.inverse',
        ':hover': {
            color: 'color.text.inverse',
            textDecoration: 'none'
        },
        ':active': {
            color: 'color.text.inverse'
        },
        ':focus': {
            textDecoration: 'underline'
        }
    });
    const $8c4e7f5fe5d003ac$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline',
        whiteSpace: 'nowrap',
        verticalAlign: 'top',
        position: 'relative',
        insetBlockStart: '0.11em'
    });
    const $8c4e7f5fe5d003ac$var$iconStyles = {
        name: "7pys7l",
        styles: "width:0.9em;height:0.9em;margin-inline-start:.3em"
    };
    const $8c4e7f5fe5d003ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, className: preventedClassName, style: preventedStyle, ...htmlAttributes }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhmo0")).default), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: [
                appearance === 'default' && $8c4e7f5fe5d003ac$var$defaultAppearanceStyles,
                appearance === 'subtle' && $8c4e7f5fe5d003ac$var$subtleAppearanceStyles,
                appearance === 'inverse' && $8c4e7f5fe5d003ac$var$inverseAppearanceStyles,
                appearance !== 'inverse' && $8c4e7f5fe5d003ac$var$visitedLinkStyles
            ],
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, target === '_blank' && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $8c4e7f5fe5d003ac$var$iconWrapperStyles,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') ? (0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            css: $8c4e7f5fe5d003ac$var$iconStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })) : (0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            css: $8c4e7f5fe5d003ac$var$iconStyles,
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "currentColor"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
        }))));
    };
    const $8c4e7f5fe5d003ac$var$Link = (0, $5uXOq.forwardRef)($8c4e7f5fe5d003ac$var$LinkWithoutRef);
    var $8c4e7f5fe5d003ac$export$2e2bcd8739ae039 = $8c4e7f5fe5d003ac$var$Link;
});
parcelRegister("jhmo0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10692011b199b6c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3joPi = parcelRequire("3joPi");
    var $6QvkM;
    var $7a0yc;
    var $eGmKJ;
    var $9KnKW;
    var $6wxJn;
    var $jldZL;
    var $55sHU;
    var $8CUq3;
    function $10692011b199b6c5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $10692011b199b6c5$var$focusRingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus, &:focus-visible': {
            outlineColor: (0, (0, parcelRequire("55sHU")).borderColorMap)['color.border.focused'],
            outlineOffset: (0, (0, parcelRequire("55sHU")).positiveSpaceMap)['space.025'],
            outlineStyle: 'solid',
            outlineWidth: (0, (0, parcelRequire("55sHU")).borderWidthMap)['border.width.outline']
        },
        '&:focus:not(:focus-visible)': {
            outline: 'none'
        },
        '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
            '&:focus-visible': {
                outline: '1px solid'
            }
        }
    });
    const $10692011b199b6c5$var$baseStyles = {
        name: "9ge06c",
        styles: "box-sizing:border-box;text-decoration:underline"
    };
    const $10692011b199b6c5$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
    const $10692011b199b6c5$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
    const $10692011b199b6c5$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
    const $10692011b199b6c5$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, (0, parcelRequire("eGmKJ")).default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("6wxJn")).default));
        const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
            providedOnClick(e, analyticsEvent);
        }, [
            providedOnClick,
            interactionContext,
            interactionName
        ]);
        const opensNewWindowLabelId = (0, (0, parcelRequire("9KnKW")).useId)();
        const onClick = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: handleClick,
            action: 'clicked',
            componentName: componentName || 'Anchor',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            analyticsData: analyticsContext,
            actionSubject: 'link'
        });
        const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        const RouterLink = (0, (0, parcelRequire("7a0yc")).default)();
        const isExternal = typeof href === 'string' && $10692011b199b6c5$var$IS_EXTERNAL_LINK_REGEX.test(href);
        const isNonHttpBased = typeof href === 'string' && $10692011b199b6c5$var$IS_NON_HTTP_BASED.test(href);
        const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
        const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
        (0, $3joPi.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
        const Component = isRouterLink ? RouterLink : 'a';
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            style: style,
            ref: ref,
            className: resolvedStyles.static,
            ...safeHtmlAttributes,
            href: !isRouterLink && typeof href !== 'string' ? undefined : href,
            target: target,
            onClick: onClick,
            "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $10692011b199b6c5$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
            "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
            css: [
                $10692011b199b6c5$var$baseStyles,
                $10692011b199b6c5$var$focusRingStyles,
                backgroundColor && (0, (0, parcelRequire("55sHU")).backgroundColorStylesMap)[backgroundColor],
                padding && (0, (0, parcelRequire("55sHU")).paddingStylesMap).padding[padding],
                paddingBlock && (0, (0, parcelRequire("55sHU")).paddingStylesMap).paddingBlock[paddingBlock],
                paddingBlockStart && (0, (0, parcelRequire("55sHU")).paddingStylesMap).paddingBlockStart[paddingBlockStart],
                paddingBlockEnd && (0, (0, parcelRequire("55sHU")).paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
                paddingInline && (0, (0, parcelRequire("55sHU")).paddingStylesMap).paddingInline[paddingInline],
                paddingInlineStart && (0, (0, parcelRequire("55sHU")).paddingStylesMap).paddingInlineStart[paddingInlineStart],
                paddingInlineEnd && (0, (0, parcelRequire("55sHU")).paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
                resolvedStyles.emotion
            ],
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
        }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            id: opensNewWindowLabelId
        }, `, ${newWindowLabel ? newWindowLabel : $10692011b199b6c5$var$OPENS_NEW_WINDOW_LABEL}`));
    };
    const $10692011b199b6c5$var$Anchor = (0, $5uXOq.forwardRef)($10692011b199b6c5$var$AnchorNoRef);
    var $10692011b199b6c5$export$2e2bcd8739ae039 = $10692011b199b6c5$var$Anchor;
});
parcelRegister("7a0yc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f05306b0a621838$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $grjRA;
    const $1f05306b0a621838$var$useRouterLink = ()=>{
        const { routerLinkComponent: routerLinkComponent } = (0, $5uXOq.useContext)((0, (0, parcelRequire("grjRA")).RouterLinkProviderContext));
        if (routerLinkComponent) return routerLinkComponent;
    };
    var $1f05306b0a621838$export$2e2bcd8739ae039 = $1f05306b0a621838$var$useRouterLink;
});
parcelRegister("grjRA", function(module, exports) {
    $parcel$export(module.exports, "RouterLinkProviderContext", ()=>$e2ad785297db7cde$export$2931e0ee690eee88);
    $parcel$export(module.exports, "default", ()=>$e2ad785297db7cde$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $e2ad785297db7cde$export$2931e0ee690eee88 = (0, $5uXOq.createContext)({});
    const $e2ad785297db7cde$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e2ad785297db7cde$export$2931e0ee690eee88.Provider, {
            value: {
                routerLinkComponent: routerLinkComponent
            }
        }, children);
    };
    var $e2ad785297db7cde$export$2e2bcd8739ae039 = $e2ad785297db7cde$var$RouterLinkProvider;
});
parcelRegister("lkmWu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$846af68bcfd2a415$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    const $846af68bcfd2a415$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
    const $846af68bcfd2a415$var$inlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '0'
    });
    const $846af68bcfd2a415$var$textStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(${$846af68bcfd2a415$var$CSS_VAR_TEXT_COLOR})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        'a, a:visited, a:hover, a:focus, a:active': {
            color: 'currentColor',
            textDecoration: 'underline'
        }
    });
    const $846af68bcfd2a415$var$backgroundColors = {
        warning: 'color.background.warning.bold',
        error: 'color.background.danger.bold',
        announcement: 'color.background.neutral.bold'
    };
    const $846af68bcfd2a415$var$tokenBackgroundColors = {
        warning: `var(--ds-background-warning-bold, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
        error: `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        announcement: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
    };
    const $846af68bcfd2a415$var$tokenTextColors = {
        warning: `var(--ds-text-warning-inverse, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
        error: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        announcement: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    };
    const $846af68bcfd2a415$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '3rem',
        alignItems: 'center',
        display: 'flex'
    });
    const $846af68bcfd2a415$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '1.5rem',
        height: '1.5rem',
        flexShrink: '0'
    });
    const $846af68bcfd2a415$var$Banner = (0, $5uXOq.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
        const appearanceType = appearance in $846af68bcfd2a415$var$backgroundColors ? appearance : 'warning';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $846af68bcfd2a415$var$containerStyles,
            backgroundColor: $846af68bcfd2a415$var$backgroundColors[appearanceType],
            padding: "space.150",
            testId: testId,
            ref: ref,
            role: "alert"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $846af68bcfd2a415$var$inlineStyles
        }, icon ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: $846af68bcfd2a415$var$iconWrapperStyles,
            style: {
                fill: $846af68bcfd2a415$var$tokenBackgroundColors[appearanceType],
                color: $846af68bcfd2a415$var$tokenTextColors[appearanceType]
            }
        }, icon) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            style: {
                [$846af68bcfd2a415$var$CSS_VAR_TEXT_COLOR]: $846af68bcfd2a415$var$tokenTextColors[appearanceType]
            },
            css: $846af68bcfd2a415$var$textStyles
        }, children)));
    });
    var $846af68bcfd2a415$export$2e2bcd8739ae039 = $846af68bcfd2a415$var$Banner;
});
parcelRegister("ctg8C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a31fb25f1b05491f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $6QvkM;
    var $eGmKJ;
    var $9MHPe;
    var $fxUuP;
    var $VSDnB;
    var $gkD4s;
    var $4oNEb;
    var $1V7PR;
    var $68kvT;
    var $94LdA;
    const $a31fb25f1b05491f$var$checkIsChildOfPortal = (node)=>{
        if (!node) return false;
        return node.classList && node.classList.contains('atlaskit-portal-container') || $a31fb25f1b05491f$var$checkIsChildOfPortal(node.parentElement);
    };
    const $a31fb25f1b05491f$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
        (0, (0, parcelRequire("fxUuP")).useCloseOnEscapePress)({
            onClose: handleEscapeClose
        });
        const { isLayerDisabled: isLayerDisabled } = (0, (0, parcelRequire("fxUuP")).useLayering)();
        (0, $5uXOq.useEffect)(()=>{
            return (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: (e)=>{
                    if (isLayerDisabled()) return;
                    handleClick(e);
                },
                options: {
                    capture: true
                }
            });
        }, [
            handleClick,
            isLayerDisabled
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", null);
    };
    const $a31fb25f1b05491f$var$InlineDialog = (0, $5uXOq.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, (0, parcelRequire("eGmKJ")).default), onContentClick: onContentClick = (0, (0, parcelRequire("eGmKJ")).default), onContentFocus: onContentFocus = (0, (0, parcelRequire("eGmKJ")).default), onClose: providedOnClose = (0, (0, parcelRequire("eGmKJ")).default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
        const containerRef = (0, $5uXOq.useRef)(null);
        const triggerRef = (0, $5uXOq.useRef)(null);
        const onClose = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>providedOnClose(event),
            action: 'closed',
            componentName: 'inlineDialog',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onCloseRef = (0, $5uXOq.useRef)(onClose);
        (0, $5uXOq.useEffect)(()=>{
            onCloseRef.current = onClose;
        });
        const handleCloseRequest = (0, $5uXOq.useCallback)((event)=>{
            const { target: target } = event;
            if (!(target instanceof HTMLElement)) return;
            if (!document.body.contains(target)) return;
            if (isOpen) {
                onCloseRef.current?.({
                    isOpen: false,
                    event: event
                });
                return;
            }
            if ($a31fb25f1b05491f$var$checkIsChildOfPortal(target)) return;
            if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
                isOpen: false,
                event: event
            });
        }, [
            isOpen
        ]);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (triggerRef.current && triggerRef.current.contains(event.target)) return;
            if (containerRef.current?.contains(event.target)) return;
            handleCloseRequest(event);
        }, [
            handleCloseRequest,
            containerRef,
            triggerRef
        ]);
        const popper = isOpen ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4oNEb")).Popper), {
            placement: placement,
            strategy: strategy
        }, ({ ref: ref, style: style })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("94LdA")).Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                style: style,
                testId: testId
            }, typeof content === 'function' ? content() : content)) : null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gkD4s")).Manager), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1V7PR")).Reference), null, ({ ref: ref })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("68kvT")).default), {
                innerRef: (node)=>{
                    triggerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                },
                hasNodeResolver: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_portal_logic_r18_fix')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children))), isOpen ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, popper, (0, (0, parcelRequire("f8Sb3")).jsx)($a31fb25f1b05491f$var$CloseManager, {
            handleEscapeClose: handleCloseRequest,
            handleClick: handleClick
        })) : popper);
    });
    var $a31fb25f1b05491f$export$2e2bcd8739ae039 = $a31fb25f1b05491f$var$InlineDialog;
});
parcelRegister("9MHPe", function(module, exports) {
    $parcel$export(module.exports, "LevelContext", ()=>$13009cd54ca6fd25$export$650d12d3c2ddb8fc);
    $parcel$export(module.exports, "TopLevelContext", ()=>$13009cd54ca6fd25$export$48b383b280e20440);
    $parcel$export(module.exports, "Layering", ()=>$13009cd54ca6fd25$export$7c885f891c940977);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $13009cd54ca6fd25$export$650d12d3c2ddb8fc = (0, $5uXOq.createContext)(0);
    const $13009cd54ca6fd25$export$48b383b280e20440 = (0, $5uXOq.createContext)({
        topLevelRef: {
            current: null
        },
        setTopLevel: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $13009cd54ca6fd25$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
        const { setTopLevel: setTopLevel, topLevelRef: topLevelRef } = (0, $5uXOq.useContext)($13009cd54ca6fd25$export$48b383b280e20440);
        if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                setTopLevel(currentLevel - 1);
            };
        }, [
            setTopLevel,
            currentLevel
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($13009cd54ca6fd25$export$650d12d3c2ddb8fc.Provider, {
            value: currentLevel
        }, children);
    };
    const $13009cd54ca6fd25$var$LayeringProvider = ({ children: children })=>{
        const topLevelRef = (0, $5uXOq.useRef)(0);
        const value = (0, $5uXOq.useMemo)(()=>({
                topLevelRef: topLevelRef,
                setTopLevel: (level)=>{
                    topLevelRef.current = level;
                }
            }), [
            topLevelRef
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($13009cd54ca6fd25$export$48b383b280e20440.Provider, {
            value: value
        }, children);
    };
    const $13009cd54ca6fd25$export$a183686c3f6f4ea8 = ({ children: children, isDisabled: isDisabled = true })=>{
        const currentLevel = (0, $5uXOq.useContext)($13009cd54ca6fd25$export$650d12d3c2ddb8fc);
        if (isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        const isNested = currentLevel > 0;
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement($13009cd54ca6fd25$var$LevelProvider, {
            currentLevel: currentLevel + 1
        }, children);
        return isNested ? content : (0, ($parcel$interopDefault($5uXOq))).createElement($13009cd54ca6fd25$var$LayeringProvider, null, content);
    };
    const $13009cd54ca6fd25$export$7c885f891c940977 = $13009cd54ca6fd25$export$a183686c3f6f4ea8;
});
parcelRegister("fxUuP", function(module, exports) {
    $parcel$export(module.exports, "useCloseOnEscapePress", ()=>$ad9fa941cb83a846$export$4a4bf067ea9e7886);
    $parcel$export(module.exports, "useLayering", ()=>$ad9fa941cb83a846$export$c8b4d54e03dee6ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $9MHPe;
    const $ad9fa941cb83a846$var$ESCAPE = 'Escape';
    function $ad9fa941cb83a846$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
        const escapePressed = (0, $5uXOq.useRef)(false);
        const { isLayerDisabled: isLayerDisabled } = $ad9fa941cb83a846$export$c8b4d54e03dee6ed();
        const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
            const isDisabledLayer = isLayerDisabled();
            if (isDisabled || escapePressed.current || e.key !== $ad9fa941cb83a846$var$ESCAPE || isDisabledLayer) return;
            escapePressed.current = true;
            onClose(e);
        }, [
            onClose,
            isDisabled,
            isLayerDisabled
        ]);
        const onKeyUp = (0, $5uXOq.useCallback)(()=>{
            escapePressed.current = false;
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            return (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'keyup',
                    listener: onKeyUp
                }
            ], {
                capture: false
            });
        }, [
            onKeyDown,
            onKeyUp
        ]);
    }
    function $ad9fa941cb83a846$export$cec37b93989366d4() {
        const currentLevel = (0, $5uXOq.useContext)((0, (0, parcelRequire("9MHPe")).LevelContext));
        const { topLevelRef: topLevelRef } = (0, $5uXOq.useContext)((0, (0, parcelRequire("9MHPe")).TopLevelContext));
        const isLayerDisabled = (0, $5uXOq.useCallback)(()=>{
            return !!topLevelRef.current && currentLevel !== topLevelRef.current;
        }, [
            currentLevel,
            topLevelRef
        ]);
        return {
            currentLevel: currentLevel,
            topLevelRef: topLevelRef,
            isLayerDisabled: isLayerDisabled
        };
    }
    const $ad9fa941cb83a846$export$c8b4d54e03dee6ed = $ad9fa941cb83a846$export$cec37b93989366d4;
});
parcelRegister("68kvT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f26cc8148e40cea2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dI393 = parcelRequire("dI393");
    const $f26cc8148e40cea2$var$NodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
        if (hasNodeResolver) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($dI393))), {
            innerRef: innerRef
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: (node)=>{
                innerRef(node?.firstElementChild);
            }
        }, children);
    };
    var $f26cc8148e40cea2$export$2e2bcd8739ae039 = $f26cc8148e40cea2$var$NodeResolverWrapper;
});
parcelRegister("94LdA", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$ecacbacca9d72f42$export$42a852a2b6b56249);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $k5uoT;
    const $ecacbacca9d72f42$var$CSS_THEME_BACKGROUND = '--theme-background';
    const $ecacbacca9d72f42$var$CSS_THEME_COLOR = '--theme-color';
    const $ecacbacca9d72f42$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
    const $ecacbacca9d72f42$var$containerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'content-box',
        maxWidth: `${448}px`,
        maxHeight: `${448}px`,
        padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog(),
        background: `var(${$ecacbacca9d72f42$var$CSS_THEME_BACKGROUND})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(${$ecacbacca9d72f42$var$CSS_THEME_BOX_SHADOW})`,
        color: `var(${$ecacbacca9d72f42$var$CSS_THEME_COLOR})`,
        '&:focus': {
            outline: 'none'
        }
    });
    const $ecacbacca9d72f42$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $ecacbacca9d72f42$var$containerStyles,
            "data-testid": testId,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            ref: ref,
            style: {
                [$ecacbacca9d72f42$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                [$ecacbacca9d72f42$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
                [$ecacbacca9d72f42$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
                ...style
            }
        }, typeof children === 'function' ? children() : children));
    });
});
parcelRegister("1R1Ge", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ffd0023e007d9cb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ao4Ml = parcelRequire("ao4Ml");
    var $2alJM = parcelRequire("2alJM");
    var $6QvkM;
    var $j55bS;
    var $eGmKJ;
    var $9MHPe;
    var $4uxPN;
    var $k8nZq;
    var $k5uoT;
    var $is0E3;
    var $7tnMN;
    var $9XIqZ;
    function $7ffd0023e007d9cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7ffd0023e007d9cb$var$fillScreenStyles = {
        name: "1yerbni",
        styles: "width:100vw;height:100vh;position:fixed;inset-block-start:var(--ds-space-0, 0);inset-inline-start:var(--ds-space-0, 0);overflow-y:auto;-webkit-overflow-scrolling:touch"
    };
    const $7ffd0023e007d9cb$var$allowlistElements = (element, callback)=>{
        if (element.hasAttribute('data-atlas-extension')) return false;
        if (typeof callback === 'function') return callback(element);
        return true;
    };
    const $7ffd0023e007d9cb$var$ModalWrapper = (props)=>{
        const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: onClose = (0, (0, parcelRequire("eGmKJ")).default), onStackChange: onStackChange = (0, (0, parcelRequire("eGmKJ")).default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId } = props;
        const calculatedStackIndex = (0, (0, parcelRequire("7tnMN")).default)({
            onStackChange: onStackChange
        });
        const stackIndex = stackIndexOverride || calculatedStackIndex;
        const isForeground = stackIndex === 0;
        const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
        const onCloseHandler = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onClose,
            action: 'closed',
            componentName: 'modalDialog',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const onBlanketClicked = (0, $5uXOq.useCallback)((e)=>{
            if (shouldCloseOnOverlayClick) onCloseHandler(e);
        }, [
            shouldCloseOnOverlayClick,
            onCloseHandler
        ]);
        const allowListCallback = (0, $5uXOq.useCallback)((element)=>$7ffd0023e007d9cb$var$allowlistElements(element, focusLockAllowlist), [
            focusLockAllowlist
        ]);
        (0, (0, parcelRequire("9XIqZ")).default)();
        const modalDialogWithBlanket = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j55bS")).default), {
            isTinted: !isBlanketHidden,
            onBlanketClicked: onBlanketClicked,
            testId: testId && `${testId}--blanket`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("is0E3")).default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete
        }, children));
        let returnFocus = true;
        let onDeactivation;
        if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
        else onDeactivation = ()=>{
            window.setTimeout(()=>{
                shouldReturnFocus.current?.focus();
            }, 0);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k8nZq")).default), {
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal()
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4uxPN")).default), null, (fadeInProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...fadeInProps,
                css: $7ffd0023e007d9cb$var$fillScreenStyles,
                "aria-hidden": !isForeground
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $ao4Ml.default), {
                autoFocus: autoFocusLock,
                returnFocus: returnFocus,
                onDeactivation: onDeactivation,
                whiteList: allowListCallback
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($2alJM))), null), shouldScrollInViewport ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, $2alJM.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket)))));
    };
    var $7ffd0023e007d9cb$export$2e2bcd8739ae039 = $7ffd0023e007d9cb$var$ModalWrapper;
});
parcelRegister("j55bS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dca3d7b20962bd7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $k5uoT;
    function $3dca3d7b20962bd7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3dca3d7b20962bd7$var$packageName = "platform-pkg";
    const $3dca3d7b20962bd7$var$packageVersion = "0.0.0-use.local";
    const $3dca3d7b20962bd7$var$analyticsAttributes = {
        componentName: 'blanket',
        packageName: $3dca3d7b20962bd7$var$packageName,
        packageVersion: $3dca3d7b20962bd7$var$packageVersion
    };
    const $3dca3d7b20962bd7$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'fixed',
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).blanket(),
        inset: 0,
        backgroundColor: `var(--ds-blanket, ${(0, $829f609a65d26a98$export$486ab785e4bac3c6)})`,
        overflowY: 'auto',
        pointerEvents: 'initial'
    });
    const $3dca3d7b20962bd7$var$shouldAllowClickThroughStyles = {
        name: "je8g23",
        styles: "pointer-events:none"
    };
    const $3dca3d7b20962bd7$var$invisibleStyles = {
        name: "1peqg37",
        styles: "background-color:transparent"
    };
    const $3dca3d7b20962bd7$var$Blanket = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, (0, parcelRequire("eGmKJ")).default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
        const mouseDownTarget = (0, $5uXOq.useRef)(null);
        const onBlanketClickedWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onBlanketClicked,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$3dca3d7b20962bd7$var$analyticsAttributes
        });
        const blanketClickOutsideChildren = (0, $5uXOq.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
            onBlanketClickedWithAnalytics
        ]);
        const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
        const onMouseDown = (0, $5uXOq.useCallback)((e)=>{
            mouseDownTarget.current = e.target;
        }, []);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            css: [
                $3dca3d7b20962bd7$var$baseStyles,
                shouldAllowClickThrough && $3dca3d7b20962bd7$var$shouldAllowClickThroughStyles,
                !isTinted && $3dca3d7b20962bd7$var$invisibleStyles
            ],
            onClick: onClick,
            onMouseDown: onMouseDown,
            "data-testid": testId,
            ref: ref
        }, children));
    }));
    $3dca3d7b20962bd7$var$Blanket.displayName = 'Blanket';
    var $3dca3d7b20962bd7$export$2e2bcd8739ae039 = $3dca3d7b20962bd7$var$Blanket;
});
parcelRegister("is0E3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e86ab6183d35f3a4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5JjdN;
    var $SliG5;
    var $9KnKW;
    var $jhVLw;
    var $fxUuP;
    var $4uxPN;
    var $4hDdm = parcelRequire("4hDdm");
    var $h9kUS;
    var $f8twK;
    var $cUyQo;
    var $fYbIt;
    var $8DdLp;
    var $klFzX;
    var $gErrX;
    var $9vYhy;
    var $ator5;
    var $1vCNB;
    const $e86ab6183d35f3a4$var$dialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '100%',
        maxWidth: '100vw',
        height: '100%',
        minHeight: 0,
        maxHeight: '100vh',
        flex: '0 1 auto',
        flexDirection: 'column',
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        color: (0, (0, parcelRequire("cUyQo")).textColor),
        [(0, (0, parcelRequire("f8twK")).CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        pointerEvents: 'auto',
        [(0, (0, parcelRequire("h9kUS")).media).above.xs]: {
            width: 'var(--modal-dialog-width)',
            maxWidth: 'inherit',
            borderRadius: (0, (0, parcelRequire("cUyQo")).borderRadius),
            boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 0 20px -6px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
            marginInlineEnd: 'inherit',
            marginInlineStart: 'inherit'
        },
        '& > form:only-child': {
            display: 'inherit',
            maxHeight: 'inherit',
            flexDirection: 'inherit'
        }
    });
    const $e86ab6183d35f3a4$var$viewportScrollStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minHeight: '100vh',
        maxHeight: 'none',
        [(0, (0, parcelRequire("h9kUS")).media).above.xs]: {
            minHeight: 'var(--modal-dialog-height)'
        }
    });
    const $e86ab6183d35f3a4$var$bodyScrollStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).media).above.xs]: {
            height: 'var(--modal-dialog-height)',
            maxHeight: 'inherit'
        }
    });
    const $e86ab6183d35f3a4$var$ModalDialog = (props)=>{
        const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, children: children, label: label, testId: testId } = props;
        const id = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `modal-dialog-title-${id}`;
        (0, $5uXOq.useEffect)(()=>{
            return (0, $4hDdm.combine)((0, (0, parcelRequire("klFzX")).disableDraggingToCrossOriginIFramesForElement)(), (0, (0, parcelRequire("9vYhy")).disableDraggingToCrossOriginIFramesForTextSelection)(), (0, (0, parcelRequire("gErrX")).disableDraggingToCrossOriginIFramesForExternal)());
        }, []);
        (0, (0, parcelRequire("SliG5")).default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object');
        const [motionRef, onMotionFinish] = (0, (0, parcelRequire("8DdLp")).default)({
            onOpenComplete: onOpenComplete,
            onCloseComplete: onCloseComplete
        });
        const modalDialogContext = (0, $5uXOq.useMemo)(()=>({
                testId: testId,
                titleId: titleId,
                onClose: onClose
            }), [
            testId,
            titleId,
            onClose
        ]);
        (0, (0, parcelRequire("fxUuP")).useCloseOnEscapePress)({
            onClose: onClose,
            isDisabled: !shouldCloseOnEscapePress
        });
        const { currentLevel: currentLevel } = (0, (0, parcelRequire("fxUuP")).useLayering)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1vCNB")).default), {
            stackIndex: stackIndex,
            shouldScrollInViewport: shouldScrollInViewport,
            testId: testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fYbIt")).ModalContext).Provider, {
            value: modalDialogContext
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fYbIt")).ScrollContext).Provider, {
            value: shouldScrollInViewport
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4uxPN")).default), {
            entranceDirection: "bottom",
            onFinish: onMotionFinish
        }, (bottomFadeInProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)("section", {
                ...bottomFadeInProps,
                "aria-label": label,
                ref: (0, (0, parcelRequire("5JjdN")).default)([
                    bottomFadeInProps.ref,
                    motionRef
                ]),
                style: {
                    '--modal-dialog-width': (0, (0, parcelRequire("ator5")).dialogWidth)(width),
                    '--modal-dialog-height': (0, (0, parcelRequire("ator5")).dialogHeight)(height)
                },
                css: [
                    $e86ab6183d35f3a4$var$dialogStyles,
                    shouldScrollInViewport ? $e86ab6183d35f3a4$var$viewportScrollStyles : $e86ab6183d35f3a4$var$bodyScrollStyles
                ],
                role: "dialog",
                "aria-labelledby": label ? undefined : titleId,
                "data-testid": testId,
                "data-modal-stack": stackIndex,
                tabIndex: -1,
                "aria-modal": true,
                "data-ds--level": currentLevel
            }, children))))));
    };
    var $e86ab6183d35f3a4$export$2e2bcd8739ae039 = $e86ab6183d35f3a4$var$ModalDialog;
});
parcelRegister("8DdLp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4317034ec2e3d5b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $c4317034ec2e3d5b$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
        const motionRef = (0, $5uXOq.useRef)(null);
        const onMotionFinish = (0, $5uXOq.useCallback)((state)=>{
            if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
            if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
        }, [
            onOpenComplete,
            onCloseComplete
        ]);
        return [
            motionRef,
            onMotionFinish
        ];
    }
});
parcelRegister("klFzX", function(module, exports) {
    $parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", ()=>$5e7c041a1fb152f5$export$ec28e97c7d8b1b35);
    var $cBeZP;
    var $4hDdm = parcelRequire("4hDdm");
    var $7gWdR = parcelRequire("7gWdR");
    var $gBukj;
    function $5e7c041a1fb152f5$var$watchForInteractionEnd({ stop: stop }) {
        let isDragging = false;
        function stopIfNotDragging() {
            if (isDragging) return;
            stop();
        }
        const unbindEvents = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'pointerdown',
                listener: stop
            },
            {
                type: 'pointerup',
                listener: stopIfNotDragging
            },
            {
                type: 'dragstart',
                listener: stopIfNotDragging,
                options: {
                    capture: false
                }
            }
        ], {
            capture: true,
            once: true
        });
        const unbindMonitor = (0, $7gWdR.monitorForElements)({
            onGenerateDragPreview () {
                isDragging = true;
            },
            onDrop () {
                isDragging = false;
                stop();
            }
        });
        return (0, $4hDdm.combine)(unbindEvents, unbindMonitor);
    }
    function $5e7c041a1fb152f5$var$watchForInteractionStart({ start: start }) {
        return (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'mousedown',
            listener (event) {
                if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
            }
        });
    }
    const $5e7c041a1fb152f5$var$api = (0, (0, parcelRequire("gBukj")).makeFixForAdapter)({
        watchForInteractionStart: $5e7c041a1fb152f5$var$watchForInteractionStart,
        watchForInteractionEnd: $5e7c041a1fb152f5$var$watchForInteractionEnd
    });
    function $5e7c041a1fb152f5$export$ec28e97c7d8b1b35() {
        return $5e7c041a1fb152f5$var$api.registerUsage();
    }
});
parcelRegister("gBukj", function(module, exports) {
    $parcel$export(module.exports, "makeFixForAdapter", ()=>$35c5518f4a7d5d30$export$a74bff2507e6126b);
    var $4hDdm = parcelRequire("4hDdm");
    function $35c5518f4a7d5d30$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
        const originalValue = el.style.getPropertyValue(property);
        const originalPriority = el.style.getPropertyPriority(property);
        el.style.setProperty(property, rule, priority);
        return function cleanup() {
            el.style.setProperty(property, originalValue, originalPriority);
        };
    }
    function $35c5518f4a7d5d30$var$hasSameOrigin(href1, href2) {
        let url1;
        let url2;
        try {
            url1 = new URL(href1);
            url2 = new URL(href2);
        } catch (error) {
            return false;
        }
        return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
    }
    function $35c5518f4a7d5d30$var$isIframeOnAnotherDomain(iframe) {
        if (iframe.srcdoc) return false;
        if (iframe.src.startsWith('data:')) return false;
        return !$35c5518f4a7d5d30$var$hasSameOrigin(window.location.href, iframe.src);
    }
    const $35c5518f4a7d5d30$var$registry = new Map();
    function $35c5518f4a7d5d30$var$applyFix(watchForEndOfInteraction) {
        const iframes = Array.from(document.querySelectorAll('iframe')).filter($35c5518f4a7d5d30$var$isIframeOnAnotherDomain);
        const cleanups = iframes.map((iframe)=>{
            let entry = $35c5518f4a7d5d30$var$registry.get(iframe);
            if (!entry) {
                entry = {
                    reset: $35c5518f4a7d5d30$var$setStyle(iframe, {
                        property: 'pointer-events',
                        rule: 'none',
                        priority: 'important'
                    }),
                    count: 1
                };
                $35c5518f4a7d5d30$var$registry.set(iframe, entry);
            } else entry.count++;
            return function cleanup() {
                entry.count--;
                if (entry.count < 1) {
                    entry.reset();
                    $35c5518f4a7d5d30$var$registry.delete(iframe);
                }
            };
        });
        function stop() {
            cleanupWatcher();
            (0, $4hDdm.combine)(...cleanups)();
        }
        const cleanupWatcher = watchForEndOfInteraction({
            stop: stop
        });
    }
    function $35c5518f4a7d5d30$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
        let registrationCount = 0;
        let stopWatchingInteractionStart = null;
        function start() {
            $35c5518f4a7d5d30$var$applyFix(watchForInteractionEnd);
        }
        function registerUsage() {
            if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
                start: start
            });
            registrationCount++;
            return function unregisterUsage() {
                registrationCount--;
                if (registrationCount !== 0) return;
                stopWatchingInteractionStart?.();
                stopWatchingInteractionStart = null;
            };
        }
        return {
            registerUsage: registerUsage
        };
    }
});
parcelRegister("gErrX", function(module, exports) {
    $parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", ()=>$e219e1274c4fc374$export$27d79116d3a4e7d5);
    var $61IPU = parcelRequire("61IPU");
    var $gBukj;
    function $e219e1274c4fc374$var$watchForInteractionStart({ start: start }) {
        return (0, $61IPU.monitorForExternal)({
            onDragStart () {
                start();
            }
        });
    }
    function $e219e1274c4fc374$var$watchForInteractionEnd({ stop: stop }) {
        return (0, $61IPU.monitorForExternal)({
            onDrop () {
                stop();
            }
        });
    }
    const $e219e1274c4fc374$var$api = (0, (0, parcelRequire("gBukj")).makeFixForAdapter)({
        watchForInteractionStart: $e219e1274c4fc374$var$watchForInteractionStart,
        watchForInteractionEnd: $e219e1274c4fc374$var$watchForInteractionEnd
    });
    function $e219e1274c4fc374$export$27d79116d3a4e7d5() {
        return $e219e1274c4fc374$var$api.registerUsage();
    }
});
parcelRegister("9vYhy", function(module, exports) {
    $parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", ()=>$aa69f8f5bffdc1a7$export$9c0606fcefb5d1e2);
    var $cBeZP;
    var $4hDdm = parcelRequire("4hDdm");
    var $dOXu7 = parcelRequire("dOXu7");
    var $gBukj;
    function $aa69f8f5bffdc1a7$var$watchForInteractionEnd({ stop: stop }) {
        let isDragging = false;
        function stopIfNotDragging() {
            if (isDragging) return;
            stop();
        }
        let frameId = null;
        const unbindEvents = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
            {
                type: 'pointerdown',
                listener: stop
            },
            {
                type: 'pointerup',
                listener: stopIfNotDragging
            },
            {
                type: 'dragstart',
                listener () {
                    frameId = requestAnimationFrame(()=>{
                        frameId = null;
                        stopIfNotDragging();
                    });
                },
                options: {
                    capture: false
                }
            }
        ], {
            capture: true,
            once: true
        });
        const unbindMonitor = (0, $dOXu7.monitorForTextSelection)({
            onDragStart () {
                isDragging = true;
            },
            onDrop () {
                isDragging = false;
                stop();
            }
        });
        return (0, $4hDdm.combine)(unbindEvents, unbindMonitor, function abortFrame() {
            if (frameId != null) cancelAnimationFrame(frameId);
        });
    }
    function $aa69f8f5bffdc1a7$var$watchForInteractionStart({ start: start }) {
        return (0, (0, parcelRequire("cBeZP")).bind)(window, {
            type: 'mousedown',
            listener () {
                const selection = window.getSelection();
                if (!selection) return;
                if (selection.isCollapsed) return;
                start();
            }
        });
    }
    const $aa69f8f5bffdc1a7$var$api = (0, (0, parcelRequire("gBukj")).makeFixForAdapter)({
        watchForInteractionStart: $aa69f8f5bffdc1a7$var$watchForInteractionStart,
        watchForInteractionEnd: $aa69f8f5bffdc1a7$var$watchForInteractionEnd
    });
    function $aa69f8f5bffdc1a7$export$9c0606fcefb5d1e2() {
        return $aa69f8f5bffdc1a7$var$api.registerUsage();
    }
});
parcelRegister("ator5", function(module, exports) {
    $parcel$export(module.exports, "dialogWidth", ()=>$72ba27e5976b9c16$export$a3da89b899389ed8);
    $parcel$export(module.exports, "dialogHeight", ()=>$72ba27e5976b9c16$export$ceba93bf0bdd16f2);
    var $cUyQo;
    const $72ba27e5976b9c16$export$a3da89b899389ed8 = (input)=>{
        if (!input) return 'auto';
        const isWidthName = (0, (0, parcelRequire("cUyQo")).width).values.indexOf(input.toString()) !== -1;
        const widthName = isWidthName && input;
        if (widthName) return `${(0, (0, parcelRequire("cUyQo")).width).widths[widthName]}px`;
        return typeof input === 'number' ? `${input}px` : input;
    };
    const $72ba27e5976b9c16$export$ceba93bf0bdd16f2 = (input)=>{
        if (!input) return 'auto';
        return typeof input === 'number' ? `${input}px` : input;
    };
});
parcelRegister("1vCNB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f543e674b5c19d9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $lObw7;
    var $h9kUS;
    var $k5uoT;
    var $cUyQo;
    function $8f543e674b5c19d9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8f543e674b5c19d9$var$maxWidthDimensions = `calc(100vw - ${(0, (0, parcelRequire("cUyQo")).gutter) * 2}px)`;
    const $8f543e674b5c19d9$var$maxHeightDimensions = `calc(100vh - ${(0, (0, parcelRequire("cUyQo")).gutter) * 2 - 1}px)`;
    const $8f543e674b5c19d9$var$positionerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        position: 'fixed',
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        flexDirection: 'column',
        insetBlockStart: 0,
        insetInlineStart: 0
    });
    const $8f543e674b5c19d9$var$viewportScrollStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: 'auto',
        position: 'relative',
        [(0, (0, parcelRequire("h9kUS")).media).above.xs]: {
            margin: `${(0, (0, parcelRequire("cUyQo")).gutter)}px auto`,
            pointerEvents: 'none'
        }
    });
    const $8f543e674b5c19d9$var$bodyScrollStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).media).above.xs]: {
            maxWidth: $8f543e674b5c19d9$var$maxWidthDimensions,
            maxHeight: $8f543e674b5c19d9$var$maxHeightDimensions,
            position: 'absolute',
            insetBlockStart: `${(0, (0, parcelRequire("cUyQo")).gutter)}px`,
            insetInlineEnd: 0,
            insetInlineStart: 0,
            marginInlineEnd: 'auto',
            marginInlineStart: 'auto',
            pointerEvents: 'none'
        }
    });
    const $8f543e674b5c19d9$var$stackTransitionStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        transitionDuration: `${(0, (0, parcelRequire("lObw7")).mediumDurationMs)}ms`,
        transitionProperty: 'transform',
        transitionTimingFunction: (0, $eba99f58997c09b3$export$c07234257a03d5e9),
        '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
            transition: 'none'
        }
    });
    const $8f543e674b5c19d9$var$stackTransformStyles = {
        name: "937ak9",
        styles: "transform:translateY(var(--modal-dialog-translate-y))"
    };
    const $8f543e674b5c19d9$var$stackIdleStyles = {
        name: "179q9ic",
        styles: "transform:none"
    };
    const $8f543e674b5c19d9$var$Positioner = (props)=>{
        const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                '--modal-dialog-translate-y': `${stackIndex * ((0, (0, parcelRequire("cUyQo")).verticalOffset) / 2)}px`
            },
            css: [
                $8f543e674b5c19d9$var$positionerStyles,
                $8f543e674b5c19d9$var$stackTransitionStyles,
                stackIndex > 0 ? $8f543e674b5c19d9$var$stackTransformStyles : $8f543e674b5c19d9$var$stackIdleStyles,
                shouldScrollInViewport ? $8f543e674b5c19d9$var$viewportScrollStyles : $8f543e674b5c19d9$var$bodyScrollStyles
            ],
            "data-testid": testId && `${testId}--positioner`
        }, children);
    };
    var $8f543e674b5c19d9$export$2e2bcd8739ae039 = $8f543e674b5c19d9$var$Positioner;
});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("7tnMN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e81b0e5cdef75b43$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i65Nq;
    var $lp9re;
    var $kdxL3;
    var $35XSW;
    const $e81b0e5cdef75b43$var$modalStackRegister = [];
    function $e81b0e5cdef75b43$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
        const { isExiting: isExiting } = (0, (0, parcelRequire("35XSW")).useExitingPersistence)();
        const [stackIndexRef, setStackIndex] = (0, (0, parcelRequire("kdxL3")).default)(0);
        const currentStackIndex = stackIndexRef.current;
        const previousStackIndex = (0, (0, parcelRequire("lp9re")).default)(stackIndexRef.current);
        const updateStack = (0, (0, parcelRequire("i65Nq")).default)(()=>{
            const newStackIndex = $e81b0e5cdef75b43$var$modalStackRegister.indexOf(updateStack);
            if (stackIndexRef.current !== newStackIndex) {
                setStackIndex(newStackIndex);
                stackIndexRef.current = newStackIndex;
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            const currentStackIndex = $e81b0e5cdef75b43$var$modalStackRegister.indexOf(updateStack);
            if (!isExiting && currentStackIndex === -1) $e81b0e5cdef75b43$var$modalStackRegister.unshift(updateStack);
            if (isExiting && currentStackIndex !== -1) $e81b0e5cdef75b43$var$modalStackRegister.splice(currentStackIndex, 1);
            $e81b0e5cdef75b43$var$modalStackRegister.forEach((cb)=>cb());
        }, [
            updateStack,
            isExiting
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                const currentStackIndex = $e81b0e5cdef75b43$var$modalStackRegister.indexOf(updateStack);
                if (currentStackIndex !== -1) {
                    $e81b0e5cdef75b43$var$modalStackRegister.splice(currentStackIndex, 1);
                    $e81b0e5cdef75b43$var$modalStackRegister.forEach((cb)=>cb());
                }
            }, [
            updateStack
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (previousStackIndex === undefined) return;
            if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
        }, [
            onStackChange,
            previousStackIndex,
            currentStackIndex
        ]);
        return currentStackIndex;
    }
});
parcelRegister("lp9re", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06a256e02abd1f05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $06a256e02abd1f05$export$2e2bcd8739ae039(value) {
        const ref = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    }
});
parcelRegister("kdxL3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92f67363697749cb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $92f67363697749cb$export$2e2bcd8739ae039(initialState) {
        const [value, setValue] = (0, $5uXOq.useState)(initialState);
        const valueRef = (0, $5uXOq.useRef)(value);
        valueRef.current = value;
        return [
            valueRef,
            setValue
        ];
    }
});
parcelRegister("9XIqZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59a91aea5a2a8a28$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    function $59a91aea5a2a8a28$var$getScrollDistance() {
        return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
    }
    function $59a91aea5a2a8a28$export$2e2bcd8739ae039() {
        const [scrollTopOffset, setScrollTopOffset] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setScrollTopOffset($59a91aea5a2a8a28$var$getScrollDistance());
        }, []);
        const onWindowScroll = (0, $5uXOq.useCallback)(()=>{
            if ($59a91aea5a2a8a28$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
        }, [
            scrollTopOffset
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'scroll',
                listener: onWindowScroll
            });
        }, [
            onWindowScroll
        ]);
        return scrollTopOffset;
    }
});
parcelRegister("1I7E8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30a8e47dcc753634$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "Popup", ()=>(parcelRequire("ed37w")).Popup);
    var $ed37w;
    var $30a8e47dcc753634$export$2e2bcd8739ae039 = (0, (0, parcelRequire("ed37w")).Popup);
});
parcelRegister("ed37w", function(module, exports) {
    $parcel$export(module.exports, "Popup", ()=>$8d10e877eee410d3$export$129a32eedafa97c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9KnKW;
    var $9MHPe;
    var $9Mkr0;
    var $VSDnB;
    var $gkD4s;
    var $1V7PR;
    var $k8nZq;
    var $dC5iT;
    var $8CUq3;
    var $k5uoT;
    var $jIMB4;
    var $hdHM8;
    var $jLapR;
    var $9Qtvo;
    const $8d10e877eee410d3$var$defaultLayer = (0, (0, parcelRequire("k5uoT")).layers).layer();
    const $8d10e877eee410d3$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
    const $8d10e877eee410d3$export$129a32eedafa97c5 = (0, $5uXOq.memo)(({ xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $8d10e877eee410d3$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport })=>{
        const [triggerRef, setTriggerRef] = (0, $5uXOq.useState)(null);
        const getMergedTriggerRef = (0, (0, parcelRequire("jLapR")).useGetMemoizedMergedTriggerRef)();
        const getMergedTriggerRefNew = (0, (0, parcelRequire("9Qtvo")).useGetMemoizedMergedTriggerRefNew)();
        const generatedId = (0, (0, parcelRequire("9KnKW")).useId)();
        const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, (0, parcelRequire("hdHM8")).usePopupAppearance)({
            appearance: inAppearance,
            shouldRenderToParent: inShouldRenderToParent
        });
        const id = providedId || generatedId;
        (0, (0, parcelRequire("9Mkr0")).useNotifyOpenLayerObserver)({
            isOpen: isOpen
        });
        const renderPopperWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jIMB4")).default), {
            xcss: xcss,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        }));
        const popupContent = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gkD4s")).Manager), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1V7PR")).Reference), null, ({ ref: ref })=>{
            return trigger({
                ref: !(0, (0, parcelRequire("VSDnB")).fg)('platform-design-system-dsp-20476-dropdown-menu') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                'aria-controls': isOpen ? id : undefined,
                'aria-expanded': isOpen,
                'aria-haspopup': role === 'dialog' && (0, (0, parcelRequire("VSDnB")).fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
            });
        }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k8nZq")).default), {
            zIndex: zIndex
        }, renderPopperWrapper)));
        if (shouldFitContainer) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $8d10e877eee410d3$var$wrapperStyles
        }, popupContent);
        return popupContent;
    });
    var $8d10e877eee410d3$export$2e2bcd8739ae039 = $8d10e877eee410d3$export$129a32eedafa97c5;
});
parcelRegister("jIMB4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9858401ca27a71a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jhVLw;
    var $fxUuP;
    var $VSDnB;
    var $4oNEb;
    var $k5uoT;
    var $f8twK;
    var $kwAGY;
    var $cLdxp;
    var $f9bw2;
    function $9858401ca27a71a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9858401ca27a71a5$var$fullWidthStyles = {
        name: "1d3w5wq",
        styles: "width:100%"
    };
    const $9858401ca27a71a5$var$rootStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        boxSizing: 'border-box',
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).layer(),
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        color: "var(--ds-text, #172B4D)",
        [(0, (0, parcelRequire("f8twK")).CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        '&:focus': {
            outline: 'none'
        }
    });
    const $9858401ca27a71a5$var$scrollableStyles = {
        name: "1qmr6ab",
        styles: "overflow:auto"
    };
    const $9858401ca27a71a5$var$blanketStyles = {
        name: "nsh9jl",
        styles: "position:fixed;inset:0;background-color:var(--ds-blanket, #091E427D)"
    };
    const $9858401ca27a71a5$var$modalStyles = {
        name: "1rni9zo",
        styles: "max-height:50vh;position:fixed;inset-block-start:var(--ds-space-050, 4px);inset-inline:var(--ds-space-050, 4px)"
    };
    const $9858401ca27a71a5$var$DefaultPopupComponent = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, xcss: xcss, ...htmlAttributes } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: xcss,
            css: [
                $9858401ca27a71a5$var$rootStyles,
                appearance === 'UNSAFE_modal-below-sm' && $9858401ca27a71a5$var$modalStyles,
                !shouldRenderToParent && $9858401ca27a71a5$var$scrollableStyles,
                shouldFitContainer && $9858401ca27a71a5$var$fullWidthStyles
            ],
            ...htmlAttributes,
            ref: ref
        }, children);
    });
    function $9858401ca27a71a5$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', popupComponent: PopupContainer = $9858401ca27a71a5$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default' }) {
        const [popupRef, setPopupRef] = (0, $5uXOq.useState)(null);
        const [initialFocusRef, setInitialFocusRef] = (0, $5uXOq.useState)(null);
        const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
        const shouldDisableFocusTrap = role !== 'dialog';
        (0, (0, parcelRequire("f9bw2")).useFocusManager)({
            initialFocusRef: initialFocusRef,
            popupRef: popupRef,
            shouldCloseOnTab: shouldCloseOnTab,
            triggerRef: triggerRef,
            autoFocus: autoFocus,
            shouldDisableFocusTrap: shouldDisableFocusTrap,
            shouldReturnFocus: shouldReturnFocus
        });
        (0, (0, parcelRequire("cLdxp")).useCloseManager)({
            isOpen: isOpen,
            onClose: onClose,
            popupRef: popupRef,
            triggerRef: triggerRef,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldCloseOnTab: shouldCloseOnTab,
            autoFocus: autoFocus,
            shouldDisableFocusTrap: shouldDisableFocusTrap,
            shouldRenderToParent: shouldRenderToParent
        });
        const { currentLevel: currentLevel } = (0, (0, parcelRequire("fxUuP")).useLayering)();
        const mergedModifiers = (0, $5uXOq.useMemo)(()=>[
                {
                    name: 'flip',
                    enabled: shouldFlip,
                    options: {
                        rootBoundary: rootBoundary,
                        boundary: boundary,
                        fallbackPlacements: fallbackPlacements
                    }
                },
                ...modifiers || []
            ], [
            shouldFlip,
            rootBoundary,
            boundary,
            fallbackPlacements,
            modifiers
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4oNEb")).Popper), {
            placement: placement,
            offset: offset,
            modifiers: mergedModifiers,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport
        }, ({ ref: ref, style: style, placement: placement, update: update })=>{
            const popupContainer = (0, (0, parcelRequire("f8Sb3")).jsx)(PopupContainer, {
                xcss: xcss,
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kwAGY")).RepositionOnUpdate), {
                update: update
            }, content({
                update: update,
                isOpen: isOpen,
                onClose: onClose,
                setInitialFocusRef: setInitialFocusRef
            })));
            return !initialFocusRef && (0, (0, parcelRequire("VSDnB")).fg)('platform-design-system-apply-popup-wrapper-focus') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), null, popupContainer), appearance === 'UNSAFE_modal-below-sm' && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $9858401ca27a71a5$var$blanketStyles
            })) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $9858401ca27a71a5$var$blanketStyles
            }));
        });
    }
    var $9858401ca27a71a5$export$2e2bcd8739ae039 = $9858401ca27a71a5$var$PopperWrapper;
});
parcelRegister("kwAGY", function(module, exports) {
    $parcel$export(module.exports, "RepositionOnUpdate", ()=>$7c4d306c23f4e590$export$51eddd7655ca235a);
    var $5uXOq = parcelRequire("5uXOq");
    const $7c4d306c23f4e590$export$51eddd7655ca235a = ({ children: children, update: update })=>{
        const isFirstRenderRef = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (isFirstRenderRef.current) {
                isFirstRenderRef.current = false;
                return;
            }
            update();
        }, [
            update
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, children);
    };
});
parcelRegister("cLdxp", function(module, exports) {
    $parcel$export(module.exports, "useCloseManager", ()=>$83624aa7913be40b$export$92dae2778ae88f9d);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $eGmKJ;
    var $fxUuP;
    var $VSDnB;
    var $3DdHF;
    var $baX5J;
    const $83624aa7913be40b$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
        const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, (0, parcelRequire("fxUuP")).useLayering)();
        const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, (0, parcelRequire("baX5J")).useAnimationFrame)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isOpen || !popupRef) return 0, (0, parcelRequire("eGmKJ")).default;
            const closePopup = (event)=>{
                if (onClose) {
                    if ((0, (0, parcelRequire("VSDnB")).fg)('sibling-dropdown-close-issue')) {
                        let currentLevel = null;
                        if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level');
                        currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
                    } else onClose(event);
                }
                if (shouldDisableFocusTrap && (0, (0, parcelRequire("VSDnB")).fg)('platform_dst_popup-disable-focuslock')) requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '0');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
                });
            };
            const onClick = (event)=>{
                const { target: target } = event;
                const doesDomNodeExist = document.body.contains(target);
                if (!doesDomNodeExist) return;
                if (isLayerDisabled()) {
                    if ((0, (0, parcelRequire("VSDnB")).fg)('design-system-closed-all-when-click-outside')) {
                        if (target instanceof HTMLElement) {
                            const layeredElement = target.closest?.(`[data-ds--level]`);
                            if (!layeredElement) return;
                            const closeType = layeredElement.getAttribute('[data-ds--close--type]');
                            if (closeType === 'single') return;
                            const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) return;
                        }
                    } else return;
                }
                const isClickOnPopup = popupRef && popupRef.contains(target);
                const isClickOnTrigger = triggerRef && triggerRef.contains(target);
                if (!isClickOnPopup && !isClickOnTrigger) {
                    closePopup(event);
                    if (document.activeElement && !(0, (0, parcelRequire("3DdHF")).isInteractiveElement)(document.activeElement) && (0, (0, parcelRequire("VSDnB")).fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
                }
            };
            const onKeyDown = (event)=>{
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_dst_popup-disable-focuslock')) {
                    const { key: key, shiftKey: shiftKey } = event;
                    if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                        if (isLayerDisabled()) return;
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) {
                                closePopup(event);
                                if (currentLevel === 1) triggerRef?.focus();
                            }
                        });
                        return;
                    }
                    if (key === 'Tab') {
                        if (shouldCloseOnTab) {
                            if (isLayerDisabled()) return;
                            closePopup(event);
                            return;
                        }
                        if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                        if (shouldDisableFocusTrap) {
                            if (shouldRenderToParent) requestFrame(()=>{
                                const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                                if (isPopupFocusOut) closePopup(event);
                            });
                            else requestFrame(()=>{
                                if (!document.hasFocus()) closePopup(event);
                            });
                            return;
                        }
                    }
                    if (isLayerDisabled()) return;
                    if (key === 'Escape' || key === 'Esc') {
                        if (triggerRef && autoFocus) triggerRef.focus();
                        closePopup(event);
                    }
                } else {
                    if (isLayerDisabled()) return;
                    const { key: key } = event;
                    if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
                }
            };
            const unbind = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
            let unbindBlur = (0, (0, parcelRequire("eGmKJ")).default);
            unbindBlur = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'blur',
                listener: function onBlur(e) {
                    if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                    closePopup(e);
                }
            });
            return ()=>{
                cancelAllFrames();
                unbind();
                unbindBlur();
            };
        }, [
            isOpen,
            onClose,
            popupRef,
            triggerRef,
            autoFocus,
            shouldDisableFocusTrap,
            capture,
            isLayerDisabled,
            shouldCloseOnTab,
            currentLevel,
            shouldRenderToParent,
            requestFrame,
            cancelAllFrames
        ]);
    };
});
parcelRegister("3DdHF", function(module, exports) {
    $parcel$export(module.exports, "isInteractiveElement", ()=>$7d7e1fccd0afde1a$export$3dee5e4542c672d9);
    const $7d7e1fccd0afde1a$var$interactiveTags = [
        'button',
        'a',
        'input',
        'select',
        'textarea'
    ];
    const $7d7e1fccd0afde1a$export$3dee5e4542c672d9 = (element)=>{
        if ($7d7e1fccd0afde1a$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
        if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
        return false;
    };
});
parcelRegister("baX5J", function(module, exports) {
    $parcel$export(module.exports, "useAnimationFrame", ()=>$599fc9184c33a338$export$641fa9c94086b46e);
    var $5uXOq = parcelRequire("5uXOq");
    const $599fc9184c33a338$export$641fa9c94086b46e = ()=>{
        const animationsRef = (0, $5uXOq.useRef)([]);
        const requestFrame = (0, $5uXOq.useCallback)((callback)=>{
            const id = requestAnimationFrame(callback);
            animationsRef.current.push(id);
            return id;
        }, []);
        const cancelFrame = (0, $5uXOq.useCallback)((id)=>{
            cancelAnimationFrame(id);
            animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
        }, []);
        const cancelAllFrames = (0, $5uXOq.useCallback)(()=>{
            animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
            animationsRef.current = [];
        }, []);
        return {
            requestFrame: requestFrame,
            cancelFrame: cancelFrame,
            cancelAllFrames: cancelAllFrames
        };
    };
});
parcelRegister("f9bw2", function(module, exports) {
    $parcel$export(module.exports, "useFocusManager", ()=>$5cfd1123aa183e54$export$10c5169755ce7bd7);
    var $5uXOq = parcelRequire("5uXOq");
    var $fGOj2 = parcelRequire("fGOj2");
    var $eGmKJ;
    var $fxUuP;
    var $VSDnB;
    var $baX5J;
    const $5cfd1123aa183e54$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
        const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, (0, parcelRequire("baX5J")).useAnimationFrame)();
        const { currentLevel: currentLevel } = (0, (0, parcelRequire("fxUuP")).useLayering)();
        (0, $5uXOq.useEffect)(()=>{
            if (!popupRef || shouldCloseOnTab) return 0, (0, parcelRequire("eGmKJ")).default;
            if (shouldDisableFocusTrap && (0, (0, parcelRequire("VSDnB")).fg)('platform_dst_popup-disable-focuslock')) {
                const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
                const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
                if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                    requestFrame(()=>{
                        triggerRef?.setAttribute('tabindex', '-1');
                        if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                        (initialFocusRef || popupRef).focus();
                    });
                    return 0, (0, parcelRequire("eGmKJ")).default;
                }
            }
            const trapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: initialFocusRef || popupRef,
                fallbackFocus: popupRef,
                returnFocusOnDeactivate: shouldReturnFocus
            };
            const focusTrap = (0, ($parcel$interopDefault($fGOj2)))(popupRef, trapConfig);
            requestFrame(()=>{
                focusTrap.activate();
            });
            return ()=>{
                cancelAllFrames();
                focusTrap.deactivate();
            };
        }, [
            popupRef,
            triggerRef,
            autoFocus,
            initialFocusRef,
            shouldCloseOnTab,
            shouldDisableFocusTrap,
            requestFrame,
            cancelAllFrames,
            shouldReturnFocus,
            shouldRenderToParent,
            currentLevel
        ]);
    };
});
parcelRegister("hdHM8", function(module, exports) {
    $parcel$export(module.exports, "usePopupAppearance", ()=>$9a30ae17eff5ab49$export$4065aef1d79a5730);
    var $5uXOq = parcelRequire("5uXOq");
    var $oGXFy;
    function $9a30ae17eff5ab49$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
        const mq = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)('below.sm', (e)=>{
            setIsSmallViewport(!!e.matches);
        });
        const [isSmallViewport, setIsSmallViewport] = (0, $5uXOq.useState)(!!mq?.matches);
        const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
        const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
        return {
            appearance: appearance,
            shouldRenderToParent: shouldRenderToParent
        };
    }
});
parcelRegister("oGXFy", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_useMediaQuery", ()=>$76ca3f4294719aa5$export$49e55ae2c03d6045);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7yA6J;
    var $h9kUS;
    const $76ca3f4294719aa5$var$queries = {
        'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).above.xxs.replace('@media ', '').trim()),
        'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).above.xs.replace('@media ', '').trim()),
        'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).above.sm.replace('@media ', '').trim()),
        'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).above.md.replace('@media ', '').trim()),
        'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).above.lg.replace('@media ', '').trim()),
        'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).above.xl.replace('@media ', '').trim()),
        'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.xs.replace('@media ', '').trim()),
        'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm.replace('@media ', '').trim()),
        'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.md.replace('@media ', '').trim()),
        'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.lg.replace('@media ', '').trim()),
        'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.xl.replace('@media ', '').trim())
    };
    const $76ca3f4294719aa5$export$49e55ae2c03d6045 = (queryString, listener)=>{
        const listenerRef = (0, $5uXOq.useRef)(listener);
        (0, $5uXOq.useEffect)(()=>{
            listenerRef.current = listener;
        }, [
            listener
        ]);
        const hasListener = !!listener;
        const mq = $76ca3f4294719aa5$var$queries[queryString];
        (0, (0, parcelRequire("7yA6J")).useLayoutEffect)(()=>{
            listenerRef.current = listener;
            if (!mq || !hasListener || !listenerRef.current) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(mq, {
                type: 'change',
                listener: (event)=>{
                    return listenerRef.current(event);
                }
            });
        }, [
            mq,
            hasListener
        ]);
        return mq || null;
    };
});
parcelRegister("7yA6J", function(module, exports) {
    $parcel$export(module.exports, "useLayoutEffect", ()=>$c4a0ca5d002df00b$export$e5c5a5f917a5871c);
    var $5uXOq = parcelRequire("5uXOq");
    const $c4a0ca5d002df00b$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);
});
parcelRegister("jLapR", function(module, exports) {
    $parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", ()=>$511b0ab22a44ec88$export$7cc5c058dd769dff);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    const $511b0ab22a44ec88$export$7cc5c058dd769dff = ()=>{
        const [getMemoizedMergedTriggerRef] = (0, $5uXOq.useState)(()=>(0, (0, parcelRequire("8QpSo")).default)((ref, setTriggerRef, isOpen)=>{
                return (node)=>{
                    if (node && isOpen) {
                        if (typeof ref === 'function') ref(node);
                        else if (ref) ref.current = node;
                        setTriggerRef(node);
                    }
                };
            }));
        return getMemoizedMergedTriggerRef;
    };
});
parcelRegister("9Qtvo", function(module, exports) {
    $parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", ()=>$22af45ce662ac8e0$export$5d3a2de79e07b376);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    const $22af45ce662ac8e0$export$5d3a2de79e07b376 = ()=>{
        const [getMemoizedMergedTriggerRefNew] = (0, $5uXOq.useState)(()=>(0, (0, parcelRequire("8QpSo")).default)((ref, setTriggerRef)=>{
                return (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else if (ref) ref.current = node;
                        setTriggerRef(node);
                    }
                };
            }));
        return getMemoizedMergedTriggerRefNew;
    };
});
parcelRegister("7gs1W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bbff6f33edc9e742$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $SWIxc;
    var $imZsD;
    const $bbff6f33edc9e742$var$Spotlight = ({ actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth = 400, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label, pulse: pulse = true, scrollPositionBlock: scrollPositionBlock, shouldWatchTarget: shouldWatchTarget = false, target: target, targetBgColor: targetBgColor, targetNode: targetNode, targetOnClick: targetOnClick, targetRadius: targetRadius, targetReplacement: targetReplacement, testId: testId = 'spotlight', titleId: titleId, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).SpotlightConsumer), null, ({ opened: opened, closed: closed, targets: targets })=>{
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("SWIxc")).default), {
                ...rest,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                children: children,
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                footer: footer,
                header: header,
                heading: heading,
                headingAfterElement: headingAfterElement,
                image: image,
                label: label,
                onClosed: closed,
                onOpened: opened,
                pulse: pulse,
                scrollPositionBlock: scrollPositionBlock,
                shouldWatchTarget: shouldWatchTarget,
                target: target,
                targetBgColor: targetBgColor,
                targetNode: actualTargetNode,
                targetOnClick: targetOnClick,
                targetRadius: targetRadius,
                targetReplacement: targetReplacement,
                testId: testId,
                titleId: titleId
            }) : null;
        });
    var $bbff6f33edc9e742$export$2e2bcd8739ae039 = $bbff6f33edc9e742$var$Spotlight;
});
parcelRegister("SWIxc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$150cbc32a362a4e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lv4Ny = parcelRequire("lv4Ny");
    var $2alJM = parcelRequire("2alJM");
    var $k9tnV;
    var $9MHPe;
    var $VSDnB;
    var $k8nZq;
    var $k5uoT;
    var $18JP0;
    var $YYGxJ;
    var $7SX8k;
    var $ekHpI;
    var $e4PSc;
    var $1QiBP;
    class $150cbc32a362a4e3$var$SpotlightInner extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                dialogWidth: 400,
                pulse: true
            };
        }
        componentDidUpdate(prevProps) {
            if (prevProps.targetNode !== this.props.targetNode) (0, (0, parcelRequire("k9tnV")).default)(this.props.targetNode, {
                scrollMode: 'if-needed',
                block: this.props.scrollPositionBlock
            });
        }
        componentDidMount() {
            (0, (0, parcelRequire("k9tnV")).default)(this.props.targetNode, {
                scrollMode: 'if-needed',
                block: this.props.scrollPositionBlock
            });
            this.props.onOpened();
        }
        componentWillUnmount() {
            this.props.onClosed();
        }
        render() {
            const { pulse: pulse, shouldWatchTarget: shouldWatchTarget, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
            const { replacementElement: replacementElement } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QiBP")).SpotlightTransitionConsumer), null, ({ isOpen: isOpen, onExited: onExited })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8nZq")).default), {
                    zIndex: (0, (0, parcelRequire("k5uoT")).layers).spotlight() + 1
                }, TargetReplacement ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ekHpI")).default), {
                    hasNodeResolver: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_onboarding_noderesolve'),
                    innerRef: (elem)=>this.setState({
                            replacementElement: elem
                        })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("18JP0")).ElementBox), {
                    element: targetNode,
                    resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined
                }, (box)=>(0, ($parcel$interopDefault($5uXOq))).createElement(TargetReplacement, {
                        "data-testid": `${testId}--target`,
                        ...this.getTargetNodeStyle(box)
                    }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("18JP0")).ElementBox), {
                    element: targetNode,
                    resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined
                }, (box)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7SX8k")).default), {
                        shouldWatch: shouldWatchTarget,
                        testId: `${testId}--target`,
                        pulse: pulse,
                        target: target,
                        style: this.getTargetNodeStyle(box),
                        targetBgColor: targetBgColor,
                        targetNode: targetNode,
                        targetOnClick: targetOnClick,
                        targetRadius: targetRadius
                    })), TargetReplacement && !replacementElement ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YYGxJ")).Fade), {
                    hasEntered: isOpen,
                    onExited: onExited
                }, (animationStyles)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MHPe")).Layering), {
                        isDisabled: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_spotlight_layering') ? false : true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4PSc")).default), {
                        testId: `${testId}--dialog`,
                        actions: this.props.actions,
                        actionsBeforeElement: this.props.actionsBeforeElement,
                        children: this.props.children,
                        dialogPlacement: this.props.dialogPlacement,
                        dialogWidth: this.props.dialogWidth,
                        footer: this.props.footer,
                        header: this.props.header,
                        heading: this.props.heading,
                        titleId: this.props.titleId,
                        label: this.props.label,
                        headingAfterElement: this.props.headingAfterElement,
                        image: this.props.image,
                        targetNode: replacementElement || targetNode,
                        animationStyles: animationStyles
                    }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($2alJM))), null)));
        }
        constructor(...args){
            super(...args), this.state = {
                replacementElement: null
            }, this.getTargetNodeStyle = (box)=>{
                if (!(0, $lv4Ny.canUseDOM)) return {};
                const { height: height, left: left, top: top, width: width, ...rest } = box;
                return {
                    ...rest,
                    height: height,
                    left: left,
                    top: top,
                    width: width,
                    position: 'fixed'
                };
            };
        }
    }
    var $150cbc32a362a4e3$export$2e2bcd8739ae039 = $150cbc32a362a4e3$var$SpotlightInner;
});
parcelRegister("18JP0", function(module, exports) {
    $parcel$export(module.exports, "ElementBox", ()=>$a258af1780b88209$export$1b6719bd7aff3c00);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $VSDnB;
    const $a258af1780b88209$var$POSITION_UPDATE_INTERVAL = 200;
    const $a258af1780b88209$var$getElementRect = (element)=>{
        const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
        return {
            height: height,
            left: left,
            top: top,
            width: width
        };
    };
    const $a258af1780b88209$var$useResizeAwareElementBox = (element, updateMethod)=>{
        const [box, setBox] = (0, $5uXOq.useState)({
            width: 0,
            height: 0,
            left: 0,
            top: 0
        });
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (updateMethod === 'resizeListener') setBox($a258af1780b88209$var$getElementRect(element));
        }, [
            element,
            updateMethod
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onResize = ()=>{
                requestAnimationFrame(()=>{
                    setBox($a258af1780b88209$var$getElementRect(element));
                });
            };
            if (updateMethod === 'resizeListener') return (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'resize',
                listener: onResize
            });
        }, [
            element,
            updateMethod
        ]);
        return box;
    };
    const $a258af1780b88209$var$usePollingElementBox = (element, updateMethod)=>{
        const [width, setWidth] = (0, $5uXOq.useState)(0);
        const [height, setHeight] = (0, $5uXOq.useState)(0);
        const [left, setLeft] = (0, $5uXOq.useState)(0);
        const [top, setTop] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (updateMethod === 'polling') {
                const newBox = $a258af1780b88209$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
            }
        }, [
            element,
            updateMethod
        ]);
        const requestRef = (0, $5uXOq.useRef)();
        const previousUpdateTimeRef = (0, $5uXOq.useRef)();
        const animate = (0, $5uXOq.useCallback)((time)=>{
            if (previousUpdateTimeRef.current !== undefined) {
                const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
                if (timeSinceLastUpdate > $a258af1780b88209$var$POSITION_UPDATE_INTERVAL) {
                    const newBox = $a258af1780b88209$var$getElementRect(element);
                    setWidth(newBox.width);
                    setHeight(newBox.height);
                    setLeft(newBox.left);
                    setTop(newBox.top);
                    previousUpdateTimeRef.current = time;
                }
            } else previousUpdateTimeRef.current = time;
            requestRef.current = requestAnimationFrame(animate);
        }, [
            element
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
            return ()=>{
                if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
            };
        }, [
            animate,
            element,
            updateMethod
        ]);
        const box = (0, $5uXOq.useMemo)(()=>({
                width: width,
                height: height,
                left: left,
                top: top
            }), [
            width,
            height,
            left,
            top
        ]);
        return box;
    };
    const $a258af1780b88209$export$54f449d89c9b029a = (element, resizeUpdateMethod)=>{
        const updateMethod = resizeUpdateMethod || (0, (0, parcelRequire("VSDnB")).getBooleanFF)('platform.design-system.refresh-spotlight-on-interval') ? 'polling' : 'resizeListener';
        const boxViaResizeListener = $a258af1780b88209$var$useResizeAwareElementBox(element, updateMethod);
        const boxViaPolling = $a258af1780b88209$var$usePollingElementBox(element, updateMethod);
        return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
    };
    const $a258af1780b88209$export$1b6719bd7aff3c00 = (props)=>{
        const box = $a258af1780b88209$export$54f449d89c9b029a(props.element, props.resizeUpdateMethod);
        return props.children(box);
    };
});
parcelRegister("YYGxJ", function(module, exports) {
    $parcel$export(module.exports, "Fade", ()=>$d18d88acb014b28d$export$c983850c6c9d8b0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $ahdj0;
    var $VSDnB;
    const $d18d88acb014b28d$var$duration = {
        enter: 0,
        exit: 100
    };
    const $d18d88acb014b28d$export$c983850c6c9d8b0e = ({ hasEntered: hasEntered, children: children, onExited: onExited })=>{
        const nodeRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ahdj0")).default), {
            in: hasEntered,
            timeout: $d18d88acb014b28d$var$duration,
            onExited: onExited,
            unmountOnExit: true,
            appear: true,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_transition_group_r18') && {
                nodeRef: nodeRef
            }
        }, (status)=>{
            const anim = {
                entered: {
                    opacity: 1
                },
                exiting: {
                    opacity: 0
                }
            };
            return children({
                transition: `opacity ${$d18d88acb014b28d$var$duration.exit}ms`,
                opacity: 0,
                ...status in anim ? anim[status] : {}
            });
        });
    };
});
parcelRegister("7SX8k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6f418dd4dd618d4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k6T4f;
    var $1azd9;
    const $b6f418dd4dd618d4$var$computedStyleAttributesToClone = [
        'fontSize',
        'fontWeight',
        'lineHeight',
        'padding',
        'color',
        'textOverflow'
    ];
    function $b6f418dd4dd618d4$var$cloneAndOverrideStyles(node) {
        const shouldCloneChildren = true;
        const clonedNode = node.cloneNode(shouldCloneChildren);
        const computedStyles = getComputedStyle(node);
        $b6f418dd4dd618d4$var$computedStyleAttributesToClone.forEach((attribute)=>{
            clonedNode.style[attribute] = computedStyles[attribute];
        });
        clonedNode.style.margin = '0';
        clonedNode.style.position = 'static';
        clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
        return clonedNode;
    }
    const $b6f418dd4dd618d4$var$Clone = (props)=>{
        const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
        const contentVersion = (0, (0, parcelRequire("1azd9")).useElementObserver)(targetNode, {
            disableWatch: !shouldWatch
        });
        const contentHTML = (0, $5uXOq.useMemo)(()=>$b6f418dd4dd618d4$var$cloneAndOverrideStyles(targetNode).outerHTML, [
            contentVersion,
            targetNode
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6T4f")).TargetInner), {
            "data-testid": testId,
            pulse: pulse,
            bgColor: targetBgColor,
            radius: targetRadius,
            style: style
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: contentHTML
            },
            style: {
                height: '100%',
                pointerEvents: 'none'
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6T4f")).TargetOverlay), {
            onClick: targetOnClick ? (event)=>targetOnClick({
                    event: event,
                    target: target
                }) : undefined
        }));
    };
    var $b6f418dd4dd618d4$export$2e2bcd8739ae039 = $b6f418dd4dd618d4$var$Clone;
});
parcelRegister("k6T4f", function(module, exports) {
    $parcel$export(module.exports, "TargetInner", ()=>$74265a1b3b566a15$export$b1542cc928b93af);
    $parcel$export(module.exports, "TargetOverlay", ()=>$74265a1b3b566a15$export$a28a07e0025d709d);
    $parcel$export(module.exports, "Pulse", ()=>$74265a1b3b566a15$export$927d63e2511364c0);
    var $f8Sb3;
    var $dWt6p;
    function $74265a1b3b566a15$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $74265a1b3b566a15$var$baseShadow = `0 0 0 2px ${`var(--ds-border-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`}`;
    const $74265a1b3b566a15$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
    const $74265a1b3b566a15$var$pulseKeyframes = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 33%': {
            boxShadow: `${$74265a1b3b566a15$var$baseShadow}, 0 0 0 ${"var(--ds-border-discovery, rgba(101, 84, 192, 1))"}`
        },
        '66%, 100%': {
            boxShadow: `${$74265a1b3b566a15$var$baseShadow}, 0 0 0 10px rgba(101, 84, 192, 0.01)`
        }
    });
    const $74265a1b3b566a15$export$9fd1cab52ce14fd5 = $74265a1b3b566a15$var$pulseKeyframes.name;
    const $74265a1b3b566a15$var$animationStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        animation: `${$74265a1b3b566a15$var$pulseKeyframes} 3000ms ${$74265a1b3b566a15$var$easing} infinite`,
        boxShadow: $74265a1b3b566a15$var$baseShadow
    });
    const $74265a1b3b566a15$var$Base = ({ bgColor: bgColor, children: children, className: className, radius: radius, testId: testId, style: style, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            "data-testid": testId,
            style: {
                ...style,
                backgroundColor: bgColor,
                borderRadius: radius ? `${radius}px` : undefined
            },
            ...props
        }, children);
    const $74265a1b3b566a15$export$b1542cc928b93af = ({ bgColor: bgColor, children: children, className: className, pulse: pulse, radius: radius, testId: testId, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)($74265a1b3b566a15$var$Base, {
            bgColor: bgColor,
            className: className,
            radius: radius,
            testId: testId,
            ...props,
            css: [
                pulse && $74265a1b3b566a15$var$animationStyles,
                (0, (0, parcelRequire("dWt6p")).reduceMotionAsPerUserPreference)
            ]
        }, children);
    const $74265a1b3b566a15$var$targetOverlayStyles = {
        name: "8s2nx9",
        styles: "width:100%;height:100%;position:absolute;inset-block-start:var(--ds-space-0, 0);inset-inline-start:var(--ds-space-0, 0)"
    };
    const $74265a1b3b566a15$export$a28a07e0025d709d = ({ onClick: onClick, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: onClick,
            ...props,
            css: $74265a1b3b566a15$var$targetOverlayStyles,
            style: {
                cursor: onClick ? 'pointer' : 'auto'
            }
        });
    const $74265a1b3b566a15$export$927d63e2511364c0 = ({ bgColor: bgColor, children: children, className: className, radius: radius, pulse: pulse = true, testId: testId, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)($74265a1b3b566a15$var$Base, {
            bgColor: bgColor,
            className: className,
            radius: radius,
            testId: testId,
            ...props,
            css: [
                pulse && $74265a1b3b566a15$var$animationStyles,
                (0, (0, parcelRequire("dWt6p")).reduceMotionAsPerUserPreference)
            ]
        }, children);
});
parcelRegister("1azd9", function(module, exports) {
    $parcel$export(module.exports, "useElementObserver", ()=>$0e054e21ef522f23$export$729bafd4e621fba0);
    var $5uXOq = parcelRequire("5uXOq");
    function $0e054e21ef522f23$export$729bafd4e621fba0(element, opts = {}) {
        const { onChange: onChange, disableWatch: disableWatch = false } = opts;
        const [targetContentVersion, setTargetContentVersion] = (0, $5uXOq.useState)(0);
        const mutationObserver = (0, $5uXOq.useRef)(undefined);
        const cancelIdleCallback1 = (0, $5uXOq.useRef)(undefined);
        const disposer = (0, $5uXOq.useCallback)(()=>{
            cancelIdleCallback1.current?.();
            cancelIdleCallback1.current = undefined;
            mutationObserver.current?.disconnect();
            mutationObserver.current = undefined;
        }, []);
        const onMutation = (0, $5uXOq.useCallback)(()=>{
            cancelIdleCallback1.current?.();
            cancelIdleCallback1.current = $0e054e21ef522f23$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                    const version = v + 1;
                    onChange?.(version);
                    return version;
                }));
        }, [
            onChange
        ]);
        (0, $5uXOq.useEffect)(()=>{
            disposer();
            if (!disableWatch && element) {
                mutationObserver.current = new MutationObserver(onMutation);
                mutationObserver.current.observe(element, {
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
            return disposer;
        }, [
            disableWatch,
            disposer,
            element,
            onMutation
        ]);
        return targetContentVersion;
    }
    function $0e054e21ef522f23$export$12e07a2a9f87578a({ element: element, children: children, onChange: onChange, disableWatch: disableWatch }) {
        $0e054e21ef522f23$export$729bafd4e621fba0(element, {
            disableWatch: disableWatch,
            onChange: onChange
        });
        return {
            children: children
        };
    }
    function $0e054e21ef522f23$var$callWhenIdle(callback, opts = {}) {
        const { timeout: timeout = 100 } = opts;
        if (typeof window.requestIdleCallback === 'function') {
            const idleHandle = window.requestIdleCallback(callback, {
                timeout: timeout
            });
            return ()=>cancelIdleCallback(idleHandle);
        }
        const timeoutHandle = setTimeout(callback, timeout);
        return ()=>clearTimeout(timeoutHandle);
    }
});
parcelRegister("ekHpI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37a1a812aa8f24aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dI393 = parcelRequire("dI393");
    const $37a1a812aa8f24aa$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
        const divRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
        }, [
            hasNodeResolver
        ]);
        if (hasNodeResolver) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($dI393))), {
            innerRef: innerRef
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: divRef
        }, children);
    };
    var $37a1a812aa8f24aa$export$2e2bcd8739ae039 = $37a1a812aa8f24aa$var$NodeResolverSpotlightInner;
});
parcelRegister("e4PSc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$789e05520a01dfea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $4oNEb;
    var $dC5iT;
    var $jdzOc;
    var $5ujeO;
    var $4XGH5;
    class $789e05520a01dfea$var$SpotlightDialogComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.focusLockTimeoutId = window.setTimeout(()=>{
                this.setState({
                    focusLockDisabled: false
                });
            }, 200);
        }
        componentWillUnmount() {
            window.clearTimeout(this.focusLockTimeoutId);
        }
        render() {
            const { actions: actions, actionsBeforeElement: actionsBeforeElement, animationStyles: animationStyles, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label = 'Introducing new feature', titleId: titleId, targetNode: targetNode, testId: testId } = this.props;
            const { focusLockDisabled: focusLockDisabled } = this.state;
            const dialogLabel = !heading && !titleId ? label : undefined;
            const dialogLabelledBy = titleId || (heading ? 'spotlight-dialog-label' : undefined);
            const translatedPlacement = dialogPlacement ? ({
                'top left': 'top-start',
                'top center': 'top',
                'top right': 'top-end',
                'right top': 'right-start',
                'right middle': 'right',
                'right bottom': 'right-end',
                'bottom left': 'bottom-start',
                'bottom center': 'bottom',
                'bottom right': 'bottom-end',
                'left top': 'left-start',
                'left middle': 'left',
                'left bottom': 'left-end'
            })[dialogPlacement] : undefined;
            const modifiers = [
                {
                    name: 'preventOverflow',
                    options: {
                        padding: 5,
                        rootBoundary: 'document',
                        altAxis: true,
                        tether: false
                    }
                }
            ];
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), {
                modifiers: modifiers,
                referenceElement: targetNode,
                placement: translatedPlacement
            }, ({ ref: ref, style: style, update: update })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4XGH5")).default), {
                    value: dialogWidth,
                    onChange: update
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
                    disabled: focusLockDisabled,
                    returnFocus: false,
                    autoFocus: true
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    style: {
                        ...style,
                        ...animationStyles
                    },
                    ref: ref,
                    "aria-modal": true,
                    role: "dialog",
                    "aria-label": dialogLabel,
                    "aria-labelledby": dialogLabelledBy,
                    testId: `${testId}-container`
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ujeO")).default), {
                    testId: testId,
                    width: dialogWidth,
                    actions: actions,
                    actionsBeforeElement: actionsBeforeElement,
                    image: image && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdzOc")).DialogImage), {
                        alt: heading,
                        src: image
                    }),
                    components: {
                        Header: header,
                        Footer: footer
                    },
                    heading: heading,
                    headingId: "spotlight-dialog-label",
                    headingAfterElement: headingAfterElement,
                    headingLevel: 2
                }, children)))));
        }
        constructor(...args){
            super(...args), this.state = {
                focusLockDisabled: true
            };
        }
    }
    var $789e05520a01dfea$export$2e2bcd8739ae039 = $789e05520a01dfea$var$SpotlightDialogComponent;
});
parcelRegister("jdzOc", function(module, exports) {
    $parcel$export(module.exports, "DialogImage", ()=>$701e8b2a5a3a9de9$export$855e1a47874d6b81);
    $parcel$export(module.exports, "DialogActionItemContainer", ()=>$701e8b2a5a3a9de9$export$ed9b6b50bbed5f27);
    $parcel$export(module.exports, "DialogActionItem", ()=>$701e8b2a5a3a9de9$export$6ae54e00f59e1f33);
    var $f8Sb3;
    function $701e8b2a5a3a9de9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $701e8b2a5a3a9de9$var$imageStyles = {
        name: "1hyxgad",
        styles: "max-width:100%;height:auto"
    };
    const $701e8b2a5a3a9de9$var$actionItemContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: `${"var(--ds-space-0, 0px)"} -4px`,
        flexDirection: 'row-reverse'
    });
    const $701e8b2a5a3a9de9$var$actionItemStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $701e8b2a5a3a9de9$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            css: $701e8b2a5a3a9de9$var$imageStyles,
            alt: alt,
            ...props
        });
    const $701e8b2a5a3a9de9$export$ed9b6b50bbed5f27 = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $701e8b2a5a3a9de9$var$actionItemContainerStyles
        }, children);
    const $701e8b2a5a3a9de9$export$6ae54e00f59e1f33 = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $701e8b2a5a3a9de9$var$actionItemStyles
        }, children);
});
parcelRegister("5ujeO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c733b7879a85e4b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9yOBd;
    var $dkK4L;
    var $l1N8i;
    var $fxUuP;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $jdzOc;
    var $lPfex;
    function $c733b7879a85e4b1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c733b7879a85e4b1$var$bodyStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`,
        flexDirection: 'column'
    });
    const $c733b7879a85e4b1$var$imageStyles = {
        name: "4zleql",
        styles: "display:block"
    };
    const $c733b7879a85e4b1$var$defaultHeaderStyles = {
        name: "8dfjp9",
        styles: "display:flex;align-items:baseline;justify-content:space-between;padding-block-end:var(--ds-space-100, 8px)"
    };
    const $c733b7879a85e4b1$var$DefaultHeader = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c733b7879a85e4b1$var$defaultHeaderStyles
        }, children);
    const $c733b7879a85e4b1$var$defaultFooterStyles = {
        name: "1xj74a2",
        styles: "display:flex;align-items:center;justify-content:space-between;padding-block-start:var(--ds-space-100, 8px)"
    };
    const $c733b7879a85e4b1$var$DefaultFooter = ({ children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c733b7879a85e4b1$var$defaultFooterStyles
        }, children);
    const $c733b7879a85e4b1$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: 'fit-content',
        zIndex: 'spotlight',
        borderRadius: 'border.radius',
        color: 'color.text.inverse',
        overflow: 'auto',
        minWidth: '160px',
        maxWidth: '600px'
    });
    const $c733b7879a85e4b1$var$containerShadowStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        boxShadow: 'elevation.shadow.raised'
    });
    const $c733b7879a85e4b1$var$SpotlightCard = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
        const { Header: Header = $c733b7879a85e4b1$var$DefaultHeader, Footer: Footer = $c733b7879a85e4b1$var$DefaultFooter } = components;
        const { currentLevel: currentLevel } = (0, (0, parcelRequire("fxUuP")).useLayering)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dkK4L")).default).Provider, {
            value: (0, (0, parcelRequire("lPfex")).spotlightButtonTheme)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            backgroundColor: "color.background.discovery.bold",
            xcss: [
                $c733b7879a85e4b1$var$containerStyles,
                !isFlat && $c733b7879a85e4b1$var$containerShadowStyles
            ],
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId,
            "data-ds--level": currentLevel,
            "data-ds--close--type": "single"
        }, typeof image === 'string' ? (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            css: $c733b7879a85e4b1$var$imageStyles,
            src: image,
            alt: ""
        }) : image, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c733b7879a85e4b1$var$bodyStyles
        }, heading || headingAfterElement ? (0, (0, parcelRequire("f8Sb3")).jsx)(Header, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1N8i")).default), {
            id: headingId,
            size: "medium",
            as: `h${headingLevel}`,
            color: "color.text.inverse"
        }, heading), headingAfterElement) : null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), null, children), actions.length > 0 || actionsBeforeElement ? (0, (0, parcelRequire("f8Sb3")).jsx)(Footer, null, actionsBeforeElement || (0, (0, parcelRequire("f8Sb3")).jsx)("span", null), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jdzOc")).DialogActionItemContainer), null, actions.map(({ text: text, key: key, ...rest }, idx)=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jdzOc")).DialogActionItem), {
                key: key || (typeof text === 'string' ? text : `${idx}`)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), rest, text));
        }))) : null)));
    });
    $c733b7879a85e4b1$var$SpotlightCard.displayName = 'SpotlightCard';
    var $c733b7879a85e4b1$export$2e2bcd8739ae039 = $c733b7879a85e4b1$var$SpotlightCard;
});
parcelRegister("lPfex", function(module, exports) {
    $parcel$export(module.exports, "spotlightButtonTheme", ()=>$8aced0e496744c93$export$39a36121076ca24);
    $parcel$export(module.exports, "modalButtonTheme", ()=>$8aced0e496744c93$export$d131eb21ba4cbd16);
    const $8aced0e496744c93$var$spotlightTheme = {
        default: {
            background: {
                default: `var(--ds-background-inverse-subtle, ${$829f609a65d26a98$export$147899de772240ec})`,
                hover: `var(--ds-background-inverse-subtle-hovered, ${$829f609a65d26a98$export$a7175d4e9206bc80})`,
                active: `var(--ds-background-inverse-subtle-pressed, ${$829f609a65d26a98$export$147899de772240ec})`,
                disabled: `var(--ds-background-disabled, ${$829f609a65d26a98$export$c71e4279dd54a18d})`,
                selected: `var(--ds-background-inverse-subtle-pressed, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
                focus: `var(--ds-background-inverse-subtle, ${$829f609a65d26a98$export$147899de772240ec})`
            },
            color: {
                default: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                hover: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                active: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                disabled: {
                    light: `var(--ds-text-disabled, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                    dark: `var(--ds-text-disabled, ${$829f609a65d26a98$export$633847cf062b69e0})`
                },
                selected: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                focus: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`
            }
        },
        subtle: {
            background: {
                default: 'none',
                hover: `var(--ds-background-inverse-subtle-hovered, ${$829f609a65d26a98$export$a7175d4e9206bc80})`,
                active: `var(--ds-background-inverse-subtle-pressed, ${$829f609a65d26a98$export$147899de772240ec})`,
                disabled: 'none',
                selected: {
                    light: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                    dark: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$3d4f271a500072a})`
                },
                focusSelected: {
                    light: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                    dark: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$3d4f271a500072a})`
                }
            },
            color: {
                default: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                hover: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                active: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                disabled: `var(--ds-text-disabled, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                selected: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                focus: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`
            }
        },
        'subtle-link': {
            textDecoration: {
                hover: `underline ${`var(--ds-text-inverse, ${$829f609a65d26a98$export$4b0a4417ed59760f})`}`
            },
            textDecorationLine: {
                active: 'none'
            },
            color: {
                default: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                hover: `var(--ds-text-inverse, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
                active: `var(--ds-text-inverse, ${$829f609a65d26a98$export$6011520a64d9a187})`,
                disabled: `var(--ds-text-discovery, ${$829f609a65d26a98$export$147899de772240ec})`,
                selected: `var(--ds-text-selected, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                focus: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`
            }
        }
    };
    const $8aced0e496744c93$var$modalTheme = {
        primary: {
            background: {
                default: `var(--ds-background-discovery-bold, ${$829f609a65d26a98$export$c71e4279dd54a18d})`,
                hover: `var(--ds-background-discovery-bold-hovered, ${$829f609a65d26a98$export$a7175d4e9206bc80})`,
                active: `var(--ds-background-discovery-bold-pressed, ${$829f609a65d26a98$export$147899de772240ec})`,
                disabled: {
                    light: `var(--ds-background-disabled, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
                    dark: `var(--ds-background-disabled, ${$829f609a65d26a98$export$d281fbfe3cff2df6})`
                },
                selected: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
                focus: `var(--ds-background-discovery-bold-hovered, ${$829f609a65d26a98$export$c71e4279dd54a18d})`
            },
            color: {
                default: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                disabled: {
                    light: `var(--ds-text-disabled, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                    dark: `var(--ds-text-disabled, ${$829f609a65d26a98$export$633847cf062b69e0})`
                },
                selected: `var(--ds-text-selected, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                focus: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`
            }
        }
    };
    function $8aced0e496744c93$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
        if (!newTheme[appearance]) return undefined;
        const root = newTheme[appearance];
        return Object.keys(root).reduce((acc, val)=>{
            let node = root;
            [
                val,
                state,
                mode
            ].forEach((item)=>{
                if (!node[item]) return undefined;
                if (typeof node[item] !== 'object') {
                    acc[val] = node[item];
                    return undefined;
                }
                node = node[item];
                return undefined;
            });
            return acc;
        }, {});
    }
    const $8aced0e496744c93$export$39a36121076ca24 = (current, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...$8aced0e496744c93$var$extract($8aced0e496744c93$var$spotlightTheme, themeProps)
            },
            ...rest
        };
    };
    const $8aced0e496744c93$export$d131eb21ba4cbd16 = (current, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...$8aced0e496744c93$var$extract($8aced0e496744c93$var$modalTheme, themeProps)
            },
            ...rest
        };
    };
});
parcelRegister("4XGH5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$10a3c5fc6b92d479$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $10a3c5fc6b92d479$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.value !== this.props.value) this.props.onChange();
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("1QiBP", function(module, exports) {
    $parcel$export(module.exports, "SpotlightTransitionConsumer", ()=>$a6b34dff0b441b13$export$7d63b19b854c2fe8);
    $parcel$export(module.exports, "default", ()=>$a6b34dff0b441b13$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $a6b34dff0b441b13$var$SpotlightTransitionContext = (0, $5uXOq.createContext)({
        isOpen: true,
        onExited: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $a6b34dff0b441b13$var$hasChildren = (children)=>(0, ($parcel$interopDefault($5uXOq))).Children.count(children) > 0 && ((0, ($parcel$interopDefault($5uXOq))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
    class $a6b34dff0b441b13$var$SpotlightTransition extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromProps(props, state) {
            const { currentChildren: previousChildren } = state;
            const exiting = $a6b34dff0b441b13$var$hasChildren(previousChildren) && !$a6b34dff0b441b13$var$hasChildren(props.children);
            return {
                currentChildren: exiting ? previousChildren : props.children
            };
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($a6b34dff0b441b13$var$SpotlightTransitionContext.Provider, {
                value: {
                    onExited: this.onExited,
                    isOpen: $a6b34dff0b441b13$var$hasChildren(this.props.children)
                }
            }, this.state.currentChildren);
        }
        constructor(...args){
            super(...args), this.state = {
                currentChildren: undefined
            }, this.onExited = ()=>{
                this.setState({
                    currentChildren: this.props.children
                });
            };
        }
    }
    const $a6b34dff0b441b13$export$7d63b19b854c2fe8 = $a6b34dff0b441b13$var$SpotlightTransitionContext.Consumer;
    var $a6b34dff0b441b13$export$2e2bcd8739ae039 = $a6b34dff0b441b13$var$SpotlightTransition;
});
parcelRegister("imZsD", function(module, exports) {
    $parcel$export(module.exports, "TargetConsumer", ()=>$9612e9b514677162$export$f643dd64c1952cc8);
    $parcel$export(module.exports, "SpotlightContext", ()=>$9612e9b514677162$export$7b5aa0f5b37a336d);
    $parcel$export(module.exports, "SpotlightConsumer", ()=>$9612e9b514677162$export$3503199acd121708);
    $parcel$export(module.exports, "default", ()=>$9612e9b514677162$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $eGmKJ;
    var $k8nZq;
    var $k5uoT;
    var $6b6Qn;
    var $YYGxJ;
    var $6cAn5 = parcelRequire("6cAn5");
    const { Consumer: $9612e9b514677162$export$f643dd64c1952cc8, Provider: $9612e9b514677162$var$TargetProvider } = (0, $5uXOq.createContext)(undefined);
    const $9612e9b514677162$export$7b5aa0f5b37a336d = (0, $5uXOq.createContext)({
        opened: (0, (0, parcelRequire("eGmKJ")).default),
        closed: (0, (0, parcelRequire("eGmKJ")).default),
        targets: {}
    });
    const { Consumer: $9612e9b514677162$export$3503199acd121708, Provider: $9612e9b514677162$var$SpotlightStateProvider } = $9612e9b514677162$export$7b5aa0f5b37a336d;
    const $9612e9b514677162$var$Container = ({ component: Wrapper, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, children);
    class $9612e9b514677162$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                blanketIsTinted: true
            };
        }
        componentDidMount() {
            typeof $6cAn5;
        }
        render() {
            const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($9612e9b514677162$var$SpotlightStateProvider, {
                value: this.getStateProviderValue(this.state.targets)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($9612e9b514677162$var$TargetProvider, {
                value: this.targetRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($9612e9b514677162$var$Container, {
                component: Tag || (0, ($parcel$interopDefault($5uXOq))).Fragment
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YYGxJ")).Fade), {
                hasEntered: this.state.spotlightCount > 0
            }, (animationStyles)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8nZq")).default), {
                    zIndex: (0, (0, parcelRequire("k5uoT")).layers).spotlight()
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6b6Qn")).default), {
                    style: animationStyles,
                    isTinted: blanketIsTinted,
                    onBlanketClicked: onBlanketClicked
                }))), children)));
        }
        constructor(...args){
            super(...args), this.state = {
                spotlightCount: 0,
                targets: {}
            }, this.targetRef = (name)=>(element)=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                }, this.spotlightOpen = ()=>{
                this.setState((state)=>({
                        spotlightCount: state.spotlightCount + 1
                    }));
            }, this.spotlightClose = ()=>{
                this.setState((state)=>({
                        spotlightCount: state.spotlightCount - 1
                    }));
            }, this.getStateProviderValue = (0, (0, parcelRequire("8QpSo")).default)((targets)=>({
                    opened: this.spotlightOpen,
                    closed: this.spotlightClose,
                    targets: targets
                }));
        }
    }
});
parcelRegister("6b6Qn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$518ed4e5e45982af$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $k5uoT;
    const $518ed4e5e45982af$var$blanketStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'fixed',
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).spotlight(),
        inset: 0,
        transition: 'opacity 220ms'
    });
    const $518ed4e5e45982af$var$Blanket = ({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            css: $518ed4e5e45982af$var$blanketStyles,
            style: {
                ...style,
                backgroundColor: isTinted ? `var(--ds-blanket, ${0, $829f609a65d26a98$export$486ab785e4bac3c6})` : 'transparent'
            },
            onClick: onBlanketClicked
        });
    };
    var $518ed4e5e45982af$export$2e2bcd8739ae039 = $518ed4e5e45982af$var$Blanket;
});
parcelRegister("kTHGn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$77295807efde9889$export$2e2bcd8739ae039);
    var $hAKJr;
    var $6cAn5 = parcelRequire("6cAn5");
    function $77295807efde9889$var$getTokenValue(tokenId, fallback = '') {
        let token = (0, (0, parcelRequire("hAKJr")).default)[tokenId];
        let tokenValue = fallback;
        typeof $6cAn5;
        if (typeof window === 'undefined') return tokenValue;
        tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
        tokenValue = tokenValue || fallback;
        return tokenValue;
    }
    var $77295807efde9889$export$2e2bcd8739ae039 = $77295807efde9889$var$getTokenValue;
});
parcelRegister("hAKJr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1064fb07223d4e99$export$2e2bcd8739ae039);
    const $1064fb07223d4e99$var$tokens = {
        'color.text': '--ds-text',
        'color.text.accent.lime': '--ds-text-accent-lime',
        'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
        'color.text.accent.red': '--ds-text-accent-red',
        'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
        'color.text.accent.orange': '--ds-text-accent-orange',
        'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
        'color.text.accent.yellow': '--ds-text-accent-yellow',
        'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
        'color.text.accent.green': '--ds-text-accent-green',
        'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
        'color.text.accent.teal': '--ds-text-accent-teal',
        'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
        'color.text.accent.blue': '--ds-text-accent-blue',
        'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
        'color.text.accent.purple': '--ds-text-accent-purple',
        'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
        'color.text.accent.magenta': '--ds-text-accent-magenta',
        'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
        'color.text.accent.gray': '--ds-text-accent-gray',
        'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
        'color.text.disabled': '--ds-text-disabled',
        'color.text.inverse': '--ds-text-inverse',
        'color.text.selected': '--ds-text-selected',
        'color.text.brand': '--ds-text-brand',
        'color.text.danger': '--ds-text-danger',
        'color.text.warning': '--ds-text-warning',
        'color.text.warning.inverse': '--ds-text-warning-inverse',
        'color.text.success': '--ds-text-success',
        'color.text.discovery': '--ds-text-discovery',
        'color.text.information': '--ds-text-information',
        'color.text.subtlest': '--ds-text-subtlest',
        'color.text.subtle': '--ds-text-subtle',
        'color.link': '--ds-link',
        'color.link.pressed': '--ds-link-pressed',
        'color.link.visited': '--ds-link-visited',
        'color.link.visited.pressed': '--ds-link-visited-pressed',
        'color.icon': '--ds-icon',
        'color.icon.accent.lime': '--ds-icon-accent-lime',
        'color.icon.accent.red': '--ds-icon-accent-red',
        'color.icon.accent.orange': '--ds-icon-accent-orange',
        'color.icon.accent.yellow': '--ds-icon-accent-yellow',
        'color.icon.accent.green': '--ds-icon-accent-green',
        'color.icon.accent.teal': '--ds-icon-accent-teal',
        'color.icon.accent.blue': '--ds-icon-accent-blue',
        'color.icon.accent.purple': '--ds-icon-accent-purple',
        'color.icon.accent.magenta': '--ds-icon-accent-magenta',
        'color.icon.accent.gray': '--ds-icon-accent-gray',
        'color.icon.disabled': '--ds-icon-disabled',
        'color.icon.inverse': '--ds-icon-inverse',
        'color.icon.selected': '--ds-icon-selected',
        'color.icon.brand': '--ds-icon-brand',
        'color.icon.danger': '--ds-icon-danger',
        'color.icon.warning': '--ds-icon-warning',
        'color.icon.warning.inverse': '--ds-icon-warning-inverse',
        'color.icon.success': '--ds-icon-success',
        'color.icon.discovery': '--ds-icon-discovery',
        'color.icon.information': '--ds-icon-information',
        'color.icon.subtlest': '--ds-icon-subtlest',
        'color.icon.subtle': '--ds-icon-subtle',
        'color.border': '--ds-border',
        'color.border.accent.lime': '--ds-border-accent-lime',
        'color.border.accent.red': '--ds-border-accent-red',
        'color.border.accent.orange': '--ds-border-accent-orange',
        'color.border.accent.yellow': '--ds-border-accent-yellow',
        'color.border.accent.green': '--ds-border-accent-green',
        'color.border.accent.teal': '--ds-border-accent-teal',
        'color.border.accent.blue': '--ds-border-accent-blue',
        'color.border.accent.purple': '--ds-border-accent-purple',
        'color.border.accent.magenta': '--ds-border-accent-magenta',
        'color.border.accent.gray': '--ds-border-accent-gray',
        'color.border.disabled': '--ds-border-disabled',
        'color.border.focused': '--ds-border-focused',
        'color.border.input': '--ds-border-input',
        'color.border.inverse': '--ds-border-inverse',
        'color.border.selected': '--ds-border-selected',
        'color.border.brand': '--ds-border-brand',
        'color.border.danger': '--ds-border-danger',
        'color.border.warning': '--ds-border-warning',
        'color.border.success': '--ds-border-success',
        'color.border.discovery': '--ds-border-discovery',
        'color.border.information': '--ds-border-information',
        'color.border.bold': '--ds-border-bold',
        'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
        'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
        'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
        'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
        'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
        'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
        'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
        'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
        'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
        'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
        'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
        'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
        'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
        'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
        'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
        'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
        'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
        'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
        'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
        'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
        'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
        'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
        'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
        'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
        'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
        'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
        'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
        'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
        'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
        'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
        'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
        'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
        'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
        'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
        'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
        'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
        'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
        'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
        'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
        'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
        'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
        'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
        'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
        'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
        'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
        'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
        'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
        'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
        'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
        'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
        'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
        'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
        'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
        'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
        'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
        'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
        'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
        'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
        'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
        'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
        'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
        'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
        'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
        'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
        'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
        'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
        'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
        'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
        'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
        'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
        'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
        'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
        'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
        'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
        'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
        'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
        'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
        'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
        'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
        'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
        'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
        'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
        'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
        'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
        'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
        'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
        'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
        'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
        'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
        'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
        'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
        'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
        'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
        'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
        'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
        'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
        'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
        'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
        'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
        'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
        'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
        'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
        'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
        'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
        'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
        'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
        'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
        'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
        'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
        'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
        'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
        'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
        'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
        'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
        'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
        'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
        'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
        'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
        'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
        'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
        'color.background.disabled': '--ds-background-disabled',
        'color.background.input': '--ds-background-input',
        'color.background.input.hovered': '--ds-background-input-hovered',
        'color.background.input.pressed': '--ds-background-input-pressed',
        'color.background.inverse.subtle': '--ds-background-inverse-subtle',
        'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
        'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
        'color.background.neutral': '--ds-background-neutral',
        'color.background.neutral.hovered': '--ds-background-neutral-hovered',
        'color.background.neutral.pressed': '--ds-background-neutral-pressed',
        'color.background.neutral.subtle': '--ds-background-neutral-subtle',
        'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
        'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
        'color.background.neutral.bold': '--ds-background-neutral-bold',
        'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
        'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
        'color.background.selected': '--ds-background-selected',
        'color.background.selected.hovered': '--ds-background-selected-hovered',
        'color.background.selected.pressed': '--ds-background-selected-pressed',
        'color.background.selected.bold': '--ds-background-selected-bold',
        'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
        'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
        'color.background.brand.subtlest': '--ds-background-brand-subtlest',
        'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
        'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
        'color.background.brand.bold': '--ds-background-brand-bold',
        'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
        'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
        'color.background.brand.boldest': '--ds-background-brand-boldest',
        'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
        'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
        'color.background.danger': '--ds-background-danger',
        'color.background.danger.hovered': '--ds-background-danger-hovered',
        'color.background.danger.pressed': '--ds-background-danger-pressed',
        'color.background.danger.bold': '--ds-background-danger-bold',
        'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
        'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
        'color.background.warning': '--ds-background-warning',
        'color.background.warning.hovered': '--ds-background-warning-hovered',
        'color.background.warning.pressed': '--ds-background-warning-pressed',
        'color.background.warning.bold': '--ds-background-warning-bold',
        'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
        'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
        'color.background.success': '--ds-background-success',
        'color.background.success.hovered': '--ds-background-success-hovered',
        'color.background.success.pressed': '--ds-background-success-pressed',
        'color.background.success.bold': '--ds-background-success-bold',
        'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
        'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
        'color.background.discovery': '--ds-background-discovery',
        'color.background.discovery.hovered': '--ds-background-discovery-hovered',
        'color.background.discovery.pressed': '--ds-background-discovery-pressed',
        'color.background.discovery.bold': '--ds-background-discovery-bold',
        'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
        'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
        'color.background.information': '--ds-background-information',
        'color.background.information.hovered': '--ds-background-information-hovered',
        'color.background.information.pressed': '--ds-background-information-pressed',
        'color.background.information.bold': '--ds-background-information-bold',
        'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
        'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
        'color.blanket': '--ds-blanket',
        'color.blanket.selected': '--ds-blanket-selected',
        'color.blanket.danger': '--ds-blanket-danger',
        'color.interaction.hovered': '--ds-interaction-hovered',
        'color.interaction.pressed': '--ds-interaction-pressed',
        'color.skeleton': '--ds-skeleton',
        'color.skeleton.subtle': '--ds-skeleton-subtle',
        'color.chart.categorical.1': '--ds-chart-categorical-1',
        'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
        'color.chart.categorical.2': '--ds-chart-categorical-2',
        'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
        'color.chart.categorical.3': '--ds-chart-categorical-3',
        'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
        'color.chart.categorical.4': '--ds-chart-categorical-4',
        'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
        'color.chart.categorical.5': '--ds-chart-categorical-5',
        'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
        'color.chart.categorical.6': '--ds-chart-categorical-6',
        'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
        'color.chart.categorical.7': '--ds-chart-categorical-7',
        'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
        'color.chart.categorical.8': '--ds-chart-categorical-8',
        'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
        'color.chart.lime.bold': '--ds-chart-lime-bold',
        'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
        'color.chart.lime.bolder': '--ds-chart-lime-bolder',
        'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
        'color.chart.lime.boldest': '--ds-chart-lime-boldest',
        'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
        'color.chart.neutral': '--ds-chart-neutral',
        'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
        'color.chart.red.bold': '--ds-chart-red-bold',
        'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
        'color.chart.red.bolder': '--ds-chart-red-bolder',
        'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
        'color.chart.red.boldest': '--ds-chart-red-boldest',
        'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
        'color.chart.orange.bold': '--ds-chart-orange-bold',
        'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
        'color.chart.orange.bolder': '--ds-chart-orange-bolder',
        'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
        'color.chart.orange.boldest': '--ds-chart-orange-boldest',
        'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
        'color.chart.yellow.bold': '--ds-chart-yellow-bold',
        'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
        'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
        'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
        'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
        'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
        'color.chart.green.bold': '--ds-chart-green-bold',
        'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
        'color.chart.green.bolder': '--ds-chart-green-bolder',
        'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
        'color.chart.green.boldest': '--ds-chart-green-boldest',
        'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
        'color.chart.teal.bold': '--ds-chart-teal-bold',
        'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
        'color.chart.teal.bolder': '--ds-chart-teal-bolder',
        'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
        'color.chart.teal.boldest': '--ds-chart-teal-boldest',
        'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
        'color.chart.blue.bold': '--ds-chart-blue-bold',
        'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
        'color.chart.blue.bolder': '--ds-chart-blue-bolder',
        'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
        'color.chart.blue.boldest': '--ds-chart-blue-boldest',
        'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
        'color.chart.purple.bold': '--ds-chart-purple-bold',
        'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
        'color.chart.purple.bolder': '--ds-chart-purple-bolder',
        'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
        'color.chart.purple.boldest': '--ds-chart-purple-boldest',
        'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
        'color.chart.magenta.bold': '--ds-chart-magenta-bold',
        'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
        'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
        'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
        'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
        'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
        'color.chart.gray.bold': '--ds-chart-gray-bold',
        'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
        'color.chart.gray.bolder': '--ds-chart-gray-bolder',
        'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
        'color.chart.gray.boldest': '--ds-chart-gray-boldest',
        'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
        'color.chart.brand': '--ds-chart-brand',
        'color.chart.brand.hovered': '--ds-chart-brand-hovered',
        'color.chart.danger': '--ds-chart-danger',
        'color.chart.danger.hovered': '--ds-chart-danger-hovered',
        'color.chart.danger.bold': '--ds-chart-danger-bold',
        'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
        'color.chart.warning': '--ds-chart-warning',
        'color.chart.warning.hovered': '--ds-chart-warning-hovered',
        'color.chart.warning.bold': '--ds-chart-warning-bold',
        'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
        'color.chart.success': '--ds-chart-success',
        'color.chart.success.hovered': '--ds-chart-success-hovered',
        'color.chart.success.bold': '--ds-chart-success-bold',
        'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
        'color.chart.discovery': '--ds-chart-discovery',
        'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
        'color.chart.discovery.bold': '--ds-chart-discovery-bold',
        'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
        'color.chart.information': '--ds-chart-information',
        'color.chart.information.hovered': '--ds-chart-information-hovered',
        'color.chart.information.bold': '--ds-chart-information-bold',
        'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
        'elevation.surface': '--ds-surface',
        'elevation.surface.hovered': '--ds-surface-hovered',
        'elevation.surface.pressed': '--ds-surface-pressed',
        'elevation.surface.overlay': '--ds-surface-overlay',
        'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
        'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
        'elevation.surface.raised': '--ds-surface-raised',
        'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
        'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
        'elevation.surface.sunken': '--ds-surface-sunken',
        'elevation.shadow.overflow': '--ds-shadow-overflow',
        'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
        'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
        'elevation.shadow.overlay': '--ds-shadow-overlay',
        'elevation.shadow.raised': '--ds-shadow-raised',
        'opacity.disabled': '--ds-opacity-disabled',
        'opacity.loading': '--ds-opacity-loading',
        'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
        'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
        'utility.elevation.surface.current': '--ds-elevation-surface-current',
        'border.radius.050': '--ds-border-radius-050',
        'border.radius': '--ds-border-radius',
        'border.radius.100': '--ds-border-radius-100',
        'border.radius.200': '--ds-border-radius-200',
        'border.radius.300': '--ds-border-radius-300',
        'border.radius.400': '--ds-border-radius-400',
        'border.radius.circle': '--ds-border-radius-circle',
        'border.width': '--ds-border-width',
        'border.width.0': '--ds-border-width-0',
        'border.width.indicator': '--ds-border-width-indicator',
        'border.width.outline': '--ds-border-width-outline',
        'space.0': '--ds-space-0',
        'space.025': '--ds-space-025',
        'space.050': '--ds-space-050',
        'space.075': '--ds-space-075',
        'space.100': '--ds-space-100',
        'space.150': '--ds-space-150',
        'space.200': '--ds-space-200',
        'space.250': '--ds-space-250',
        'space.300': '--ds-space-300',
        'space.400': '--ds-space-400',
        'space.500': '--ds-space-500',
        'space.600': '--ds-space-600',
        'space.800': '--ds-space-800',
        'space.1000': '--ds-space-1000',
        'space.negative.025': '--ds-space-negative-025',
        'space.negative.050': '--ds-space-negative-050',
        'space.negative.075': '--ds-space-negative-075',
        'space.negative.100': '--ds-space-negative-100',
        'space.negative.150': '--ds-space-negative-150',
        'space.negative.200': '--ds-space-negative-200',
        'space.negative.250': '--ds-space-negative-250',
        'space.negative.300': '--ds-space-negative-300',
        'space.negative.400': '--ds-space-negative-400',
        'font.letterSpacing.0': '--ds-font-letterSpacing-0',
        'font.letterSpacing.100': '--ds-font-letterSpacing-100',
        'font.letterSpacing.200': '--ds-font-letterSpacing-200',
        'font.letterSpacing.300': '--ds-font-letterSpacing-300',
        'font.letterSpacing.400': '--ds-font-letterSpacing-400',
        'font.heading.xxlarge': '--ds-font-heading-xxlarge',
        'font.heading.xlarge': '--ds-font-heading-xlarge',
        'font.heading.large': '--ds-font-heading-large',
        'font.heading.medium': '--ds-font-heading-medium',
        'font.heading.small': '--ds-font-heading-small',
        'font.heading.xsmall': '--ds-font-heading-xsmall',
        'font.heading.xxsmall': '--ds-font-heading-xxsmall',
        'font.body.large': '--ds-font-body-large',
        'font.body': '--ds-font-body',
        'font.body.small': '--ds-font-body-small',
        'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
        'font.code': '--ds-font-code',
        'font.weight.regular': '--ds-font-weight-regular',
        'font.weight.medium': '--ds-font-weight-medium',
        'font.weight.semibold': '--ds-font-weight-semibold',
        'font.weight.bold': '--ds-font-weight-bold',
        'font.family.heading': '--ds-font-family-heading',
        'font.family.body': '--ds-font-family-body',
        'font.family.code': '--ds-font-family-code',
        'font.family.monospace': '--ds-font-family-monospace',
        'font.family.sans': '--ds-font-family-sans',
        'font.family.brand.heading': '--ds-font-family-brand-heading',
        'font.family.brand.body': '--ds-font-family-brand-body',
        'font.size.050': '--ds-font-size-050',
        'font.size.075': '--ds-font-size-075',
        'font.size.100': '--ds-font-size-100',
        'font.size.200': '--ds-font-size-200',
        'font.size.300': '--ds-font-size-300',
        'font.size.400': '--ds-font-size-400',
        'font.size.500': '--ds-font-size-500',
        'font.size.600': '--ds-font-size-600',
        'font.lineHeight.1': '--ds-font-lineHeight-1',
        'font.lineHeight.100': '--ds-font-lineHeight-100',
        'font.lineHeight.200': '--ds-font-lineHeight-200',
        'font.lineHeight.300': '--ds-font-lineHeight-300',
        'font.lineHeight.400': '--ds-font-lineHeight-400',
        'font.lineHeight.500': '--ds-font-lineHeight-500',
        'font.lineHeight.600': '--ds-font-lineHeight-600'
    };
    var $1064fb07223d4e99$export$2e2bcd8739ae039 = $1064fb07223d4e99$var$tokens;
});
parcelRegister("42CjB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f0bfcbabdc5b5773$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5ILhZ;
    var $3bDjY;
    var $jVkxy;
    const $f0bfcbabdc5b5773$var$IconButton = (0, ($parcel$interopDefault($5uXOq))).memo((0, ($parcel$interopDefault($5uXOq))).forwardRef(function Button({ 'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("jVkxy")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'button',
            icon: icon,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            label: label,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shape: shape,
            spacing: spacing,
            testId: testId
        });
        if (!isTooltipDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip?.content ?? label,
            testId: tooltip?.testId,
            position: tooltip?.position,
            delay: tooltip?.delay,
            onShow: tooltip?.onShow,
            onHide: tooltip?.onHide,
            mousePosition: tooltip?.mousePosition,
            analyticsContext: tooltip?.analyticsContext,
            strategy: tooltip?.strategy,
            tag: tooltip?.tag,
            truncate: tooltip?.truncate,
            component: tooltip?.component,
            hideTooltipOnClick: tooltip?.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents
        }, (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                ...saferRest,
                "aria-labelledby": baseProps['aria-labelledby'],
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                onClick: (event, analyticsEvent)=>{
                    baseProps?.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (ref)=>{
                    baseProps.ref(ref);
                    triggerProps?.ref?.(ref);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }, baseProps.children));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ...saferRest,
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            isDisabled: baseProps.isDisabled,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            type: type,
            testId: testId,
            componentName: "IconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName
        }, baseProps.children);
    }));
    $f0bfcbabdc5b5773$var$IconButton.displayName = 'IconButton';
    var $f0bfcbabdc5b5773$export$2e2bcd8739ae039 = $f0bfcbabdc5b5773$var$IconButton;
});
parcelRegister("jVkxy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24930c14a01f3ecf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jldZL;
    var $4vsgW;
    var $ijDdv;
    var $8vqCH;
    const $24930c14a01f3ecf$var$useIconButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shape: shape, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId })=>{
        const isCircle = shape === 'circle';
        const baseProps = (0, (0, parcelRequire("8vqCH")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            autoFocus: autoFocus,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            buttonType: buttonType,
            children: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4vsgW")).default), {
                type: "icon",
                isLoading: isLoading
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ijDdv")).default), {
                icon: icon
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, label)),
            interactionName: interactionName,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: isCircle,
            onClick: onClick,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return baseProps;
    };
    var $24930c14a01f3ecf$export$2e2bcd8739ae039 = $24930c14a01f3ecf$var$useIconButton;
});
parcelRegister("4vsgW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff38d2b65d8a0d1f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $ff38d2b65d8a0d1f$var$textStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexGrow: 1,
        flexShrink: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $ff38d2b65d8a0d1f$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
    const $ff38d2b65d8a0d1f$var$commonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        transition: 'opacity 0.3s'
    });
    const $ff38d2b65d8a0d1f$var$fadeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ff38d2b65d8a0d1f$var$beforeIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
        '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
    });
    const $ff38d2b65d8a0d1f$var$afterIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
        '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
    });
    const $ff38d2b65d8a0d1f$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: [
                $ff38d2b65d8a0d1f$var$commonStyles,
                ...type === 'text' ? [
                    $ff38d2b65d8a0d1f$var$textStyles
                ] : [
                    $ff38d2b65d8a0d1f$var$iconStyles
                ],
                ...isLoading ? [
                    $ff38d2b65d8a0d1f$var$fadeStyles
                ] : [],
                ...position === 'before' ? [
                    $ff38d2b65d8a0d1f$var$beforeIconStyles
                ] : [],
                ...position === 'after' ? [
                    $ff38d2b65d8a0d1f$var$afterIconStyles
                ] : []
            ]
        }, children);
    };
    var $ff38d2b65d8a0d1f$export$2e2bcd8739ae039 = $ff38d2b65d8a0d1f$var$Content;
});
parcelRegister("ijDdv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1772ea5cb5ed674$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $c1772ea5cb5ed674$var$isIconRenderProp(func) {
        return !func.displayName && !func.render && typeof func === 'function';
    }
    const $c1772ea5cb5ed674$var$IconRenderer = ({ icon: Icon })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, $c1772ea5cb5ed674$var$isIconRenderProp(Icon) ? Icon({
            label: '',
            color: 'currentColor'
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: "",
            color: 'currentColor'
        }));
    };
    var $c1772ea5cb5ed674$export$2e2bcd8739ae039 = $c1772ea5cb5ed674$var$IconRenderer;
});
parcelRegister("8vqCH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$baa0f9b80c3c2b60$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $SliG5;
    var $9KnKW;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $jldZL;
    var $icwyz;
    var $cUzav;
    var $77410;
    const $baa0f9b80c3c2b60$var$buttonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        width: 'auto',
        maxWidth: '100%',
        position: 'relative',
        alignItems: 'baseline',
        justifyContent: 'center',
        columnGap: 'space.050',
        borderRadius: 'border.radius.100',
        borderWidth: 'border.width.0',
        flexShrink: 0,
        height: `${32 / 14}em`,
        font: 'font.body',
        fontWeight: 'font.weight.medium',
        paddingBlock: 'space.075',
        paddingInlineEnd: 'space.150',
        paddingInlineStart: 'space.150',
        textAlign: 'center',
        transition: 'background 0.1s ease-out',
        verticalAlign: 'middle',
        '::after': {
            borderRadius: 'inherit',
            inset: 'space.0',
            borderStyle: 'solid',
            borderWidth: "var(--ds-border-width, 1px)",
            pointerEvents: 'none',
            position: 'absolute'
        }
    });
    const $baa0f9b80c3c2b60$var$defaultInteractiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':hover': {
            background: "var(--ds-background-neutral-hovered, #091e4214)",
            color: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
        },
        ':active': {
            background: `var(--ds-background-neutral-pressed, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
            color: `var(--ds-text, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`
        }
    });
    const $baa0f9b80c3c2b60$var$defaultInteractiveRefreshedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            color: 'color.text.subtle'
        },
        ':active': {
            background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
            color: 'color.text.subtle'
        }
    });
    const $baa0f9b80c3c2b60$var$defaultStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: `var(--ds-background-neutral, ${$829f609a65d26a98$export$8d43898f60b96a82})`,
        color: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        ':visited': {
            color: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
        }
    });
    const $baa0f9b80c3c2b60$var$defaultRefreshedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-neutral-subtle, #00000000)",
        color: 'color.text.subtle',
        '::after': {
            content: '""',
            borderColor: 'color.border'
        },
        ':visited': {
            color: 'color.text.subtle'
        }
    });
    const $baa0f9b80c3c2b60$var$primaryStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-brand-bold, #0052CC)",
        color: "var(--ds-text-inverse, #FFFFFF)",
        ':visited': {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    });
    const $baa0f9b80c3c2b60$var$primaryInteractiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':hover': {
            color: "var(--ds-text-inverse, #FFFFFF)",
            background: "var(--ds-background-brand-bold-hovered, #0065FF)"
        },
        ':active': {
            color: "var(--ds-text-inverse, #FFFFFF)",
            background: "var(--ds-background-brand-bold-pressed, #0747A6)"
        }
    });
    const $baa0f9b80c3c2b60$var$warningStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-warning-bold, #FFAB00)",
        color: "var(--ds-text-warning-inverse, #172B4D)",
        ':visited': {
            color: "var(--ds-text-warning-inverse, #172B4D)"
        }
    });
    const $baa0f9b80c3c2b60$var$warningInteractiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':hover': {
            color: "var(--ds-text-warning-inverse, #172B4D)",
            background: "var(--ds-background-warning-bold-hovered, #FFC400)"
        },
        ':active': {
            color: "var(--ds-text-warning-inverse, #172B4D)",
            background: "var(--ds-background-warning-bold-pressed, #FF991F)"
        }
    });
    const $baa0f9b80c3c2b60$var$dangerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-danger-bold, #DE350B)",
        color: 'color.text.inverse',
        ':visited': {
            color: 'color.text.inverse'
        }
    });
    const $baa0f9b80c3c2b60$var$dangerInteractiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':hover': {
            color: 'color.text.inverse',
            background: "var(--ds-background-danger-bold-hovered, #FF5630)"
        },
        ':active': {
            color: 'color.text.inverse',
            background: "var(--ds-background-danger-bold-pressed, #BF2600)"
        }
    });
    const $baa0f9b80c3c2b60$var$discoveryStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-discovery-bold, #5243AA)",
        color: 'color.text.inverse',
        ':visited': {
            color: 'color.text.inverse'
        }
    });
    const $baa0f9b80c3c2b60$var$discoveryInteractiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':hover': {
            color: 'color.text.inverse',
            background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
        },
        ':active': {
            color: 'color.text.inverse',
            background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
        }
    });
    const $baa0f9b80c3c2b60$var$subtleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-neutral-subtle, transparent)",
        color: "var(--ds-text, #42526E)",
        ':visited': {
            color: "var(--ds-text, #42526E)"
        }
    });
    const $baa0f9b80c3c2b60$var$subtleRefreshedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-neutral-subtle, transparent)",
        color: 'color.text.subtle',
        ':visited': {
            color: 'color.text.subtle'
        }
    });
    const $baa0f9b80c3c2b60$var$subtleInteractiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
            color: "var(--ds-text, #42526E)"
        },
        ':active': {
            background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
            color: "var(--ds-text, #42526E)"
        }
    });
    const $baa0f9b80c3c2b60$var$subtleInteractiveRefreshedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
            color: 'color.text.subtle'
        },
        ':active': {
            background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
            color: 'color.text.subtle'
        }
    });
    const $baa0f9b80c3c2b60$var$linkDecorationUnsetStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textDecoration: 'none',
        ':hover': {
            textDecoration: 'none'
        },
        ':active': {
            textDecoration: 'none'
        },
        ':focus': {
            textDecoration: 'none'
        }
    });
    const $baa0f9b80c3c2b60$var$disabledStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'not-allowed',
        background: `var(--ds-background-disabled, ${$829f609a65d26a98$export$8d43898f60b96a82})`,
        color: "var(--ds-text-disabled, #091E424F)",
        ':hover': {
            background: `var(--ds-background-disabled, ${$829f609a65d26a98$export$8d43898f60b96a82})`,
            color: "var(--ds-text-disabled, #091E424F)"
        },
        ':active': {
            background: `var(--ds-background-disabled, ${$829f609a65d26a98$export$8d43898f60b96a82})`,
            color: "var(--ds-text-disabled, #091E424F)"
        },
        '::after': {
            content: 'none'
        }
    });
    const $baa0f9b80c3c2b60$var$selectedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
        color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        ':visited': {
            color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`
        }
    });
    const $baa0f9b80c3c2b60$var$selectedRefreshedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected',
        '::after': {
            content: '""',
            borderColor: 'color.border.selected'
        },
        ':visited': {
            color: 'color.text.selected'
        }
    });
    const $baa0f9b80c3c2b60$var$selectedInsideSplitButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        zIndex: 2
    });
    const $baa0f9b80c3c2b60$var$selectedInteractiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':hover': {
            color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected-hovered, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`
        },
        ':active': {
            color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected-pressed, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`
        }
    });
    const $baa0f9b80c3c2b60$var$selectedWarningStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: `var(--ds-background-selected, ${$829f609a65d26a98$export$59619663aa6500fb})`,
        color: `var(--ds-text-selected, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        ':hover': {
            color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected, ${$829f609a65d26a98$export$59619663aa6500fb})`
        },
        ':active': {
            color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected, ${$829f609a65d26a98$export$59619663aa6500fb})`
        }
    });
    const $baa0f9b80c3c2b60$var$selectedDangerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: `var(--ds-background-selected, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
        color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        ':hover': {
            color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`
        },
        ':active': {
            color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            background: `var(--ds-background-selected, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`
        }
    });
    const $baa0f9b80c3c2b60$var$selectedDiscoveryStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: "var(--ds-background-selected, #403294)",
        color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        ':hover': {
            color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            background: "var(--ds-background-selected, #403294)"
        },
        ':active': {
            color: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            background: "var(--ds-background-selected, #403294)"
        }
    });
    const $baa0f9b80c3c2b60$var$spacingCompactStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        columnGap: 'space.050',
        height: `${24 / 14}em`,
        paddingBlock: 'space.025',
        paddingInlineEnd: 'space.150',
        paddingInlineStart: 'space.150',
        verticalAlign: 'middle'
    });
    const $baa0f9b80c3c2b60$var$circleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.circle'
    });
    const $baa0f9b80c3c2b60$var$fullWidthStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $baa0f9b80c3c2b60$var$loadingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        cursor: 'progress'
    });
    const $baa0f9b80c3c2b60$var$iconButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: `${32 / 14}em`,
        width: `${32 / 14}em`,
        paddingInlineEnd: 'space.0',
        paddingInlineStart: 'space.0'
    });
    const $baa0f9b80c3c2b60$var$iconButtonCompactStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${24 / 14}em`,
        height: `${24 / 14}em`
    });
    const $baa0f9b80c3c2b60$var$buttonIconBeforeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.100'
    });
    const $baa0f9b80c3c2b60$var$buttonIconAfterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineEnd: 'space.100'
    });
    const $baa0f9b80c3c2b60$var$splitButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        ':focus-visible': {
            zIndex: 'card'
        }
    });
    const $baa0f9b80c3c2b60$var$navigationSplitButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        backgroundColor: 'color.background.neutral.subtle',
        paddingInlineEnd: 'space.075',
        paddingInlineStart: 'space.075'
    });
    const $baa0f9b80c3c2b60$var$loadingOverlayStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        insetBlockEnd: 'space.0',
        insetBlockStart: 'space.0',
        insetInlineEnd: 'space.0',
        insetInlineStart: 'space.0'
    });
    const $baa0f9b80c3c2b60$var$useButtonBase = ({ appearance: propAppearance = 'default', autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, children: children, onClick: onClick, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onTouchStartCapture: onTouchStartCapture, onTouchEndCapture: onTouchEndCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, ref: ref, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', testId: testId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy })=>{
        const localRef = (0, $5uXOq.useRef)(null);
        const splitButtonContext = (0, (0, parcelRequire("icwyz")).useSplitButtonContext)();
        const loadingLabelId = (0, (0, parcelRequire("9KnKW")).useId)();
        const isSplitButton = Boolean(splitButtonContext);
        const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
        const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
        const appearance = isDefaultAppearanceSplitButton && (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? 'subtle' : splitButtonContext?.appearance || propAppearance;
        const spacing = splitButtonContext?.spacing || propSpacing;
        const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
        const isInteractive = !isDisabled && !isLoading;
        const isEffectivelyDisabled = isDisabled || isLoading;
        const isSelected = propIsSelected && !isDisabled;
        (0, (0, parcelRequire("SliG5")).default)(localRef, autoFocus);
        return {
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                localRef,
                ref
            ]),
            xcss: [
                $baa0f9b80c3c2b60$var$buttonStyles,
                appearance === 'default' && ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $baa0f9b80c3c2b60$var$defaultRefreshedStyles : $baa0f9b80c3c2b60$var$defaultStyles),
                appearance === 'default' && isInteractive && ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $baa0f9b80c3c2b60$var$defaultInteractiveRefreshedStyles : $baa0f9b80c3c2b60$var$defaultInteractiveStyles),
                appearance === 'primary' && $baa0f9b80c3c2b60$var$primaryStyles,
                appearance === 'primary' && isInteractive && $baa0f9b80c3c2b60$var$primaryInteractiveStyles,
                appearance === 'warning' && $baa0f9b80c3c2b60$var$warningStyles,
                appearance === 'warning' && isInteractive && $baa0f9b80c3c2b60$var$warningInteractiveStyles,
                appearance === 'danger' && $baa0f9b80c3c2b60$var$dangerStyles,
                appearance === 'danger' && isInteractive && $baa0f9b80c3c2b60$var$dangerInteractiveStyles,
                appearance === 'discovery' && $baa0f9b80c3c2b60$var$discoveryStyles,
                appearance === 'discovery' && isInteractive && $baa0f9b80c3c2b60$var$discoveryInteractiveStyles,
                appearance === 'subtle' && ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $baa0f9b80c3c2b60$var$subtleRefreshedStyles : $baa0f9b80c3c2b60$var$subtleStyles),
                appearance === 'subtle' && isInteractive && ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $baa0f9b80c3c2b60$var$subtleInteractiveRefreshedStyles : $baa0f9b80c3c2b60$var$subtleInteractiveStyles),
                $baa0f9b80c3c2b60$var$linkDecorationUnsetStyles,
                isSelected && ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $baa0f9b80c3c2b60$var$selectedRefreshedStyles : $baa0f9b80c3c2b60$var$selectedStyles),
                isSelected && isSplitButton && $baa0f9b80c3c2b60$var$selectedInsideSplitButtonStyles,
                isSelected && isInteractive && $baa0f9b80c3c2b60$var$selectedInteractiveStyles,
                isSelected && appearance === 'danger' && $baa0f9b80c3c2b60$var$selectedDangerStyles,
                isSelected && appearance === 'warning' && $baa0f9b80c3c2b60$var$selectedWarningStyles,
                isSelected && appearance === 'discovery' && $baa0f9b80c3c2b60$var$selectedDiscoveryStyles,
                isDisabled && $baa0f9b80c3c2b60$var$disabledStyles,
                isCircle && !isSplitButton && $baa0f9b80c3c2b60$var$circleStyles,
                spacing === 'compact' && $baa0f9b80c3c2b60$var$spacingCompactStyles,
                hasIconBefore && $baa0f9b80c3c2b60$var$buttonIconBeforeStyles,
                hasIconAfter && $baa0f9b80c3c2b60$var$buttonIconAfterStyles,
                isIconButton && $baa0f9b80c3c2b60$var$iconButtonStyles,
                isIconButton && spacing === 'compact' && $baa0f9b80c3c2b60$var$iconButtonCompactStyles,
                shouldFitContainer && $baa0f9b80c3c2b60$var$fullWidthStyles,
                isLoading && $baa0f9b80c3c2b60$var$loadingStyles,
                isSplitButton && $baa0f9b80c3c2b60$var$splitButtonStyles,
                isNavigationSplitButton && $baa0f9b80c3c2b60$var$navigationSplitButtonStyles
            ],
            isDisabled: isEffectivelyDisabled,
            children: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, children, isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                as: "span",
                xcss: $baa0f9b80c3c2b60$var$loadingOverlayStyles
            }, (0, (0, parcelRequire("77410")).default)({
                spacing: spacing,
                appearance: appearance,
                isDisabled: isDisabled,
                isSelected: isSelected,
                testId: testId
            })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), {
                id: loadingLabelId
            }, (0, $08da727ccd44b71d$export$d4c5499dc806c969))),
            'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${0, $08da727ccd44b71d$export$d4c5499dc806c969}` : ariaLabel,
            'aria-labelledby': isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
            ...(0, (0, parcelRequire("cUzav")).default)(isEffectivelyDisabled, {
                onClick: onClick,
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture
            })
        };
    };
    var $baa0f9b80c3c2b60$export$2e2bcd8739ae039 = $baa0f9b80c3c2b60$var$useButtonBase;
});
parcelRegister("icwyz", function(module, exports) {
    $parcel$export(module.exports, "SplitButtonContext", ()=>$c9c095971b0e7001$export$4b86304b2c0d7e71);
    $parcel$export(module.exports, "useSplitButtonContext", ()=>$c9c095971b0e7001$export$47e2c6fdb142d947);
    var $5uXOq = parcelRequire("5uXOq");
    const $c9c095971b0e7001$export$4b86304b2c0d7e71 = (0, $5uXOq.createContext)(undefined);
    const $c9c095971b0e7001$export$47e2c6fdb142d947 = ()=>{
        const context = (0, $5uXOq.useContext)($c9c095971b0e7001$export$4b86304b2c0d7e71);
        if (!context) return undefined;
        if (context.appearance === 'navigation') {
            const newContext = {
                spacing: 'default',
                appearance: 'subtle',
                isDisabled: false,
                isActiveOverSelected: false,
                isNavigationSplitButton: true,
                isHighlighted: context.isHighlighted
            };
            return newContext;
        }
        const splitButtonContext = {
            spacing: context.spacing,
            appearance: context.appearance,
            isDisabled: context.isDisabled,
            isActiveOverSelected: true,
            isNavigationSplitButton: false,
            isHighlighted: false
        };
        return splitButtonContext;
    };
});
parcelRegister("cUzav", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$084bad2e87cd222d$export$2e2bcd8739ae039);
    function $084bad2e87cd222d$var$abort(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    const $084bad2e87cd222d$var$tabKeyCode = 9;
    function $084bad2e87cd222d$var$onKey(event) {
        if (event.keyCode === $084bad2e87cd222d$var$tabKeyCode) return;
        $084bad2e87cd222d$var$abort(event);
    }
    function $084bad2e87cd222d$export$2e2bcd8739ae039(shouldBlockEvents, events) {
        return shouldBlockEvents ? {
            onMouseDownCapture: $084bad2e87cd222d$var$abort,
            onMouseUpCapture: $084bad2e87cd222d$var$abort,
            onKeyDownCapture: $084bad2e87cd222d$var$onKey,
            onKeyUpCapture: $084bad2e87cd222d$var$onKey,
            onTouchStartCapture: $084bad2e87cd222d$var$abort,
            onTouchEndCapture: $084bad2e87cd222d$var$abort,
            onPointerDownCapture: $084bad2e87cd222d$var$abort,
            onPointerUpCapture: $084bad2e87cd222d$var$abort,
            onClickCapture: $084bad2e87cd222d$var$abort,
            onClick: $084bad2e87cd222d$var$abort
        } : events;
    }
});
const $08da727ccd44b71d$export$d4c5499dc806c969 = ', Loading';
parcelRegister("77410", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8751b8327b6d3f9f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    function $8751b8327b6d3f9f$var$getIconSpacing(spacing) {
        switch(spacing){
            case 'compact':
                return 'small';
            default:
                return 'medium';
        }
    }
    function $8751b8327b6d3f9f$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
        if (isDisabled || isSelected) return 'inherit';
        if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
        return 'inherit';
    }
    function $8751b8327b6d3f9f$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            size: $8751b8327b6d3f9f$var$getIconSpacing(spacing),
            appearance: $8751b8327b6d3f9f$var$getSpinnerAppearance({
                appearance: appearance,
                isDisabled: isDisabled,
                isSelected: isSelected
            }),
            testId: testId ? `${testId}--loading-spinner` : undefined
        });
    }
});
parcelRegister("22jFS", function(module, exports) {
    $parcel$export(module.exports, "VAR_LEFT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$cbfb0f5b2869b17b);
    $parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$a30f2e00489a8957);
    $parcel$export(module.exports, "VAR_RIGHT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$c103b605cd368aed);
    $parcel$export(module.exports, "VAR_RIGHT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$fa34f417972d6341);
    $parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", ()=>$565cb8192fc4e070$export$3a6a779d9181047c);
    $parcel$export(module.exports, "VAR_BANNER_HEIGHT", ()=>$565cb8192fc4e070$export$bcd94a6a792e7f96);
    $parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", ()=>$565cb8192fc4e070$export$b6744d31294864fd);
    $parcel$export(module.exports, "DIMENSIONS", ()=>$565cb8192fc4e070$export$d67ac355184b7646);
    $parcel$export(module.exports, "LEFT_PANEL", ()=>$565cb8192fc4e070$export$344062f7cfc9528e);
    $parcel$export(module.exports, "RIGHT_PANEL", ()=>$565cb8192fc4e070$export$c7139cc2d6110b5f);
    $parcel$export(module.exports, "BANNER", ()=>$565cb8192fc4e070$export$238d30785c4bca84);
    $parcel$export(module.exports, "TOP_NAVIGATION", ()=>$565cb8192fc4e070$export$bec6dca2e63de4ae);
    $parcel$export(module.exports, "CONTENT", ()=>$565cb8192fc4e070$export$d1213e82613ff4df);
    $parcel$export(module.exports, "DEFAULT_BANNER_HEIGHT", ()=>$565cb8192fc4e070$export$be83e7118304b28e);
    $parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", ()=>$565cb8192fc4e070$export$4a98ee0bd1ae362);
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$539e68c09584883a);
    $parcel$export(module.exports, "DEFAULT_RIGHT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$b92df8810d2fcd01);
    $parcel$export(module.exports, "DEFAULT_RIGHT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$c3e41153b9288bcf);
    $parcel$export(module.exports, "DEFAULT_LEFT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$c4d6152f86ea28f6);
    $parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$46acf8758e9e2636);
    $parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$70740f5ad8360a78);
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", ()=>$565cb8192fc4e070$export$991d5285ad765a3d);
    $parcel$export(module.exports, "MIN_LEFT_SIDEBAR_DRAG_THRESHOLD", ()=>$565cb8192fc4e070$export$6949d4f32b161684);
    $parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", ()=>$565cb8192fc4e070$export$d6e7e8af042815bb);
    $parcel$export(module.exports, "TRANSITION_DURATION", ()=>$565cb8192fc4e070$export$3749e1104328fde4);
    $parcel$export(module.exports, "FLYOUT_DELAY", ()=>$565cb8192fc4e070$export$1074d925b0b82be5);
    $parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", ()=>$565cb8192fc4e070$export$451e84a45a9e4a75);
    $parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", ()=>$565cb8192fc4e070$export$802bb2c050f3db5c);
    $parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", ()=>$565cb8192fc4e070$export$5e5e1875c3fd8f4f);
    $parcel$export(module.exports, "GRAB_AREA_LINE_SELECTOR", ()=>$565cb8192fc4e070$export$70c702a8c5895f03);
    $parcel$export(module.exports, "GRAB_AREA_SELECTOR", ()=>$565cb8192fc4e070$export$48a43f91e4becf4e);
    $parcel$export(module.exports, "RESIZE_BUTTON_SELECTOR", ()=>$565cb8192fc4e070$export$dac2fb31a9f6844d);
    $parcel$export(module.exports, "RESIZE_CONTROL_SELECTOR", ()=>$565cb8192fc4e070$export$9ecd22db14e6c70e);
    $parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", ()=>$565cb8192fc4e070$export$5253dd9707b8c3ba);
    $parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", ()=>$565cb8192fc4e070$export$206a08f7f8beb554);
    $parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", ()=>$565cb8192fc4e070$export$659ee746b31b360d);
    $parcel$export(module.exports, "LEFT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$f963aecf2d4465bd);
    $parcel$export(module.exports, "RIGHT_PANEL_WIDTH", ()=>$565cb8192fc4e070$export$750459958906793);
    $parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$f897e1ed9f8ed251);
    $parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", ()=>$565cb8192fc4e070$export$b44ab66843c05a69);
    $parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", ()=>$565cb8192fc4e070$export$aeff86a16f13529);
    $parcel$export(module.exports, "BANNER_HEIGHT", ()=>$565cb8192fc4e070$export$ed7cc0d417ee89e);
    $parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", ()=>$565cb8192fc4e070$export$d2fa14f05b61e66);
    const $565cb8192fc4e070$export$cbfb0f5b2869b17b = 'leftPanelWidth';
    const $565cb8192fc4e070$export$a30f2e00489a8957 = 'leftSidebarWidth';
    const $565cb8192fc4e070$export$c103b605cd368aed = 'rightSidebarWidth';
    const $565cb8192fc4e070$export$fa34f417972d6341 = 'rightPanelWidth';
    const $565cb8192fc4e070$export$3a6a779d9181047c = 'topNavigationHeight';
    const $565cb8192fc4e070$export$bcd94a6a792e7f96 = 'bannerHeight';
    const $565cb8192fc4e070$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
    const $565cb8192fc4e070$export$d67ac355184b7646 = [
        $565cb8192fc4e070$export$cbfb0f5b2869b17b,
        $565cb8192fc4e070$export$fa34f417972d6341,
        $565cb8192fc4e070$export$bcd94a6a792e7f96,
        $565cb8192fc4e070$export$3a6a779d9181047c,
        $565cb8192fc4e070$export$a30f2e00489a8957,
        $565cb8192fc4e070$export$c103b605cd368aed
    ];
    const $565cb8192fc4e070$export$344062f7cfc9528e = 'left-panel';
    const $565cb8192fc4e070$export$c7139cc2d6110b5f = 'right-panel';
    const $565cb8192fc4e070$export$238d30785c4bca84 = 'banner';
    const $565cb8192fc4e070$export$bec6dca2e63de4ae = 'top-navigation';
    const $565cb8192fc4e070$export$d1213e82613ff4df = 'content';
    const $565cb8192fc4e070$export$2d8180803f50fc5 = 'main';
    const $565cb8192fc4e070$export$50ea883ba6f28ff5 = 'left-sidebar';
    const $565cb8192fc4e070$export$7bf43119a6b49ddb = 'right-sidebar';
    const $565cb8192fc4e070$export$be83e7118304b28e = 56;
    const $565cb8192fc4e070$export$4a98ee0bd1ae362 = 56;
    const $565cb8192fc4e070$export$539e68c09584883a = 240;
    const $565cb8192fc4e070$export$b92df8810d2fcd01 = 280;
    const $565cb8192fc4e070$export$c3e41153b9288bcf = 368;
    const $565cb8192fc4e070$export$c4d6152f86ea28f6 = 368;
    const $565cb8192fc4e070$export$46acf8758e9e2636 = 20;
    const $565cb8192fc4e070$export$70740f5ad8360a78 = 16;
    const $565cb8192fc4e070$export$f562af313cda0684 = 80;
    const $565cb8192fc4e070$export$991d5285ad765a3d = 240;
    const $565cb8192fc4e070$export$6949d4f32b161684 = 200;
    const $565cb8192fc4e070$export$d6e7e8af042815bb = 350;
    const $565cb8192fc4e070$export$3749e1104328fde4 = 300;
    const $565cb8192fc4e070$export$1074d925b0b82be5 = 200;
    const $565cb8192fc4e070$export$24d54fc362d78805 = 'expandedLeftSidebarWidth';
    const $565cb8192fc4e070$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
    const $565cb8192fc4e070$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
    const $565cb8192fc4e070$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
    const $565cb8192fc4e070$export$60b3bc5d4ac00d5e = 'data-is-flyout-open';
    const $565cb8192fc4e070$export$70c702a8c5895f03 = 'data-grab-area-line';
    const $565cb8192fc4e070$export$48a43f91e4becf4e = 'data-grab-area';
    const $565cb8192fc4e070$export$dac2fb31a9f6844d = 'data-resize-button';
    const $565cb8192fc4e070$export$9ecd22db14e6c70e = 'data-resize-control';
    const $565cb8192fc4e070$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
    const $565cb8192fc4e070$export$206a08f7f8beb554 = 'Skip to:';
    const $565cb8192fc4e070$export$659ee746b31b360d = 'data-layout-container';
    const $565cb8192fc4e070$export$f963aecf2d4465bd = `var(--${$565cb8192fc4e070$export$cbfb0f5b2869b17b}, 0px)`;
    const $565cb8192fc4e070$export$750459958906793 = `var(--${$565cb8192fc4e070$export$fa34f417972d6341}, 0px)`;
    const $565cb8192fc4e070$export$f897e1ed9f8ed251 = `var(--${$565cb8192fc4e070$export$a30f2e00489a8957}, 0px)`;
    const $565cb8192fc4e070$export$b44ab66843c05a69 = `var(--${$565cb8192fc4e070$export$c103b605cd368aed}, 0px)`;
    const $565cb8192fc4e070$export$aeff86a16f13529 = `var(--${$565cb8192fc4e070$export$3a6a779d9181047c}, 0px)`;
    const $565cb8192fc4e070$export$ed7cc0d417ee89e = `var(--${$565cb8192fc4e070$export$bcd94a6a792e7f96}, 0px)`;
    const $565cb8192fc4e070$export$d2fa14f05b61e66 = `var(--${$565cb8192fc4e070$export$b6744d31294864fd}, ${$565cb8192fc4e070$export$991d5285ad765a3d}px)`;
});
parcelRegister("84THj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5e19e6ceaf4184b5$var$_react = $5e19e6ceaf4184b5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5e19e6ceaf4184b5$var$_close = $5e19e6ceaf4184b5$var$_interopRequireDefault((parcelRequire("i28qQ")));
    var $5e19e6ceaf4184b5$var$_cross = $5e19e6ceaf4184b5$var$_interopRequireDefault((parcelRequire("lLLkM")));
    function $5e19e6ceaf4184b5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5e19e6ceaf4184b5$var$CloseIcon = (props)=>$5e19e6ceaf4184b5$var$_react.default.createElement($5e19e6ceaf4184b5$var$_close.default, Object.assign({
            LEGACY_fallbackIcon: $5e19e6ceaf4184b5$var$_cross.default
        }, props));
    $5e19e6ceaf4184b5$var$CloseIcon.Name = 'CloseIconMigration';
    var $5e19e6ceaf4184b5$var$_default = module.exports.default = $5e19e6ceaf4184b5$var$CloseIcon;
});
parcelRegister("dV6Te", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c98cdffddc81709c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cxNi9;
    var $bxFwL;
    const $c98cdffddc81709c$var$svgStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("bxFwL")).commonSVGStyles));
    const $c98cdffddc81709c$var$SVG = (0, $5uXOq.memo)(function SVG({ size: size = 'medium', label: label, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, testId: testId, children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            viewBox: "0 0 24 24",
            style: {
                color: primaryColor,
                fill: secondaryColor || (0, (0, parcelRequire("cxNi9")).getBackground)()
            },
            css: [
                $c98cdffddc81709c$var$svgStyles,
                (0, (0, parcelRequire("bxFwL")).sizeStyleMap)[size]
            ],
            "data-testid": testId,
            "aria-label": label || undefined,
            role: label ? 'img' : 'presentation'
        }, children);
    });
    var $c98cdffddc81709c$export$2e2bcd8739ae039 = $c98cdffddc81709c$var$SVG;
});
parcelRegister("vIiRg", function(module, exports) {
    $parcel$export(module.exports, "AVATAR_SIZES", ()=>$32eb610dda6e4a8d$export$9a270941bcff7e77);
    $parcel$export(module.exports, "AVATAR_RADIUS", ()=>$32eb610dda6e4a8d$export$e6da6efe4d1a5c9b);
    $parcel$export(module.exports, "BORDER_WIDTH", ()=>$32eb610dda6e4a8d$export$e2bd4c1faded7921);
    $parcel$export(module.exports, "ACTIVE_SCALE_FACTOR", ()=>$32eb610dda6e4a8d$export$89a980dfdf90df51);
    $parcel$export(module.exports, "CSS_VAR_AVATAR_BGCOLOR", ()=>$32eb610dda6e4a8d$export$3c061e31594ebabe);
    $parcel$export(module.exports, "ICON_SIZES", ()=>$32eb610dda6e4a8d$export$fdc820179f1f9be4);
    $parcel$export(module.exports, "ICON_OFFSET", ()=>$32eb610dda6e4a8d$export$382610e783aa2ae8);
    var $k5uoT;
    const $32eb610dda6e4a8d$export$9a270941bcff7e77 = {
        xsmall: (0, (0, parcelRequire("k5uoT")).gridSize)() * 2,
        small: (0, (0, parcelRequire("k5uoT")).gridSize)() * 3,
        medium: (0, (0, parcelRequire("k5uoT")).gridSize)() * 4,
        large: (0, (0, parcelRequire("k5uoT")).gridSize)() * 5,
        xlarge: (0, (0, parcelRequire("k5uoT")).gridSize)() * 12,
        xxlarge: (0, (0, parcelRequire("k5uoT")).gridSize)() * 16
    };
    const $32eb610dda6e4a8d$export$e6da6efe4d1a5c9b = {
        xsmall: 2,
        small: 2,
        medium: 3,
        large: 3,
        xlarge: 6,
        xxlarge: 12
    };
    const $32eb610dda6e4a8d$export$e2bd4c1faded7921 = 2;
    const $32eb610dda6e4a8d$export$89a980dfdf90df51 = 0.9;
    const $32eb610dda6e4a8d$export$3c061e31594ebabe = '--avatar-background-color';
    const $32eb610dda6e4a8d$export$fdc820179f1f9be4 = {
        small: 12,
        medium: 14,
        large: 15,
        xlarge: 18
    };
    const $32eb610dda6e4a8d$export$382610e783aa2ae8 = {
        small: 0,
        medium: 0,
        large: 1,
        xlarge: 7
    };
});
parcelRegister("hqZzc", function(module, exports) {
    $parcel$export(module.exports, "RovoIcon", ()=>$1a00d6c2ebe03e6f$export$e23ae35269442b4f);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $1a00d6c2ebe03e6f$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
    };
    const $1a00d6c2ebe03e6f$export$e23ae35269442b4f = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            svg: $1a00d6c2ebe03e6f$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            label: label,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("1Cvrw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $12e1baef6b49aa95$var$_react = $12e1baef6b49aa95$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $12e1baef6b49aa95$var$_UNSAFE_baseNew = $12e1baef6b49aa95$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $12e1baef6b49aa95$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $12e1baef6b49aa95$var$StarUnstarredIcon = (props)=>$12e1baef6b49aa95$var$_react.default.createElement($12e1baef6b49aa95$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m6 8.917.424-.619L6 8.008l-.424.29zM2.597 11.25l-.724-.194a.75.75 0 0 0 1.148.813zm1.07-3.986.724.194.124-.463-.368-.307zM.75 4.834l-.058-.748A.75.75 0 0 0 .27 5.41zm3.792-.292.057.747.473-.036.17-.442zM6 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.458 3.792-.7.269.17.442.473.036zm3.792.291.48.577a.75.75 0 0 0-.423-1.324zm-2.917 2.43-.48-.575-.368.307.124.463zm1.07 3.987-.424.618a.75.75 0 0 0 1.148-.812zM5.576 8.298l-3.403 2.334.848 1.236 3.403-2.333zm-2.254 3.146L4.39 7.458 2.942 7.07l-1.07 3.986zm.825-4.756L1.23 4.258.27 5.41l2.917 2.43zM.807 5.58 4.6 5.29l-.115-1.495-3.792.292zm4.435-.77L6.7 1.019 5.3.481 3.842 4.272zM5.3 1.019l1.458 3.792 1.4-.539L6.7.481zm2.1 4.27 3.793.292.114-1.495-3.791-.292zm3.37-1.032-2.917 2.43.96 1.153 2.917-2.43zM7.609 7.458l1.07 3.986 1.448-.388-1.07-3.986zm2.218 3.174L6.424 8.298l-.848 1.237 3.403 2.333z"/>`,
            type: 'utility'
        }, props));
    $12e1baef6b49aa95$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
    var $12e1baef6b49aa95$var$_default = module.exports.default = $12e1baef6b49aa95$var$StarUnstarredIcon;
});
parcelRegister("eCeGD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31e0e6ab408159ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5ILhZ;
    var $fuBHX;
    const $31e0e6ab408159ad$var$Button = (0, ($parcel$interopDefault($5uXOq))).memo((0, ($parcel$interopDefault($5uXOq))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("fuBHX")).default)({
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            analyticsContext: analyticsContext,
            appearance: appearance,
            autoFocus: autoFocus,
            buttonType: 'button',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            isDisabled: baseProps.isDisabled,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "Button"
        }, baseProps.children);
    }));
    $31e0e6ab408159ad$var$Button.displayName = 'Button';
    var $31e0e6ab408159ad$export$2e2bcd8739ae039 = $31e0e6ab408159ad$var$Button;
});
parcelRegister("fuBHX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b21f84137d62379$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4vsgW;
    var $ijDdv;
    var $8vqCH;
    const $8b21f84137d62379$var$useDefaultButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId })=>{
        const baseProps = (0, (0, parcelRequire("8vqCH")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            autoFocus: autoFocus,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            buttonType: buttonType,
            children: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, iconBefore && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4vsgW")).default), {
                type: "icon",
                position: "before",
                isLoading: isLoading
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ijDdv")).default), {
                icon: iconBefore
            })), children && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4vsgW")).default), {
                isLoading: isLoading
            }, children), iconAfter && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4vsgW")).default), {
                type: "icon",
                position: "after",
                isLoading: isLoading
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ijDdv")).default), {
                icon: iconAfter
            }))),
            interactionName: interactionName,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            onClick: onClick,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId,
            hasIconBefore: Boolean(iconBefore),
            hasIconAfter: Boolean(iconAfter)
        });
        return baseProps;
    };
    var $8b21f84137d62379$export$2e2bcd8739ae039 = $8b21f84137d62379$var$useDefaultButton;
});
parcelRegister("BLPHT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c58d48a2d2ab0e8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $eCeGD;
    var $5JjdN;
    var $eGmKJ;
    var $33etG;
    var $fsuMn;
    var $c8Oei;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $aFqyR;
    var $5CZpS;
    var $fL28e;
    var $iY6id;
    var $l7Q0F;
    var $gsxsp;
    const $5c58d48a2d2ab0e8$var$gridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $5c58d48a2d2ab0e8$var$MAX_HEIGHT = `calc(100vh - ${$5c58d48a2d2ab0e8$var$gridSize * 2}px)`;
    const $5c58d48a2d2ab0e8$var$opposites = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left',
        start: 'end',
        auto: 'auto',
        end: 'start'
    };
    const $5c58d48a2d2ab0e8$var$getFallbackPlacements = (placement)=>{
        const placementPieces = placement.split('-');
        const mainAxis = placementPieces[0];
        if (![
            'top',
            'bottom'
        ].includes(mainAxis)) return undefined;
        else if (placementPieces.length === 2 && [
            'start',
            'end'
        ].includes(placementPieces[1])) {
            const crossAxis = placementPieces[1];
            return [
                `${mainAxis}`,
                `${mainAxis}-${$5c58d48a2d2ab0e8$var$opposites[crossAxis]}`,
                `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}-${crossAxis}`,
                `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}`,
                `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}-${$5c58d48a2d2ab0e8$var$opposites[crossAxis]}`,
                'auto'
            ];
        } else return [
            `${mainAxis}-start`,
            `${mainAxis}-end`,
            `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}`,
            `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}-start`,
            `${$5c58d48a2d2ab0e8$var$opposites[mainAxis]}-end`,
            `auto`
        ];
    };
    const $5c58d48a2d2ab0e8$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, (0, parcelRequire("eGmKJ")).default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, (0, parcelRequire("k5uoT")).layers).modal(), label: label, interactionName: interactionName, strategy: strategy })=>{
        const [isLocalOpen, setLocalIsOpen] = (0, (0, parcelRequire("33etG")).default)(isOpen, ()=>defaultOpen);
        const triggerRef = (0, $5uXOq.useRef)(null);
        const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
        const id = (0, (0, parcelRequire("gsxsp")).default)();
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const fallbackPlacements = (0, $5uXOq.useMemo)(()=>$5c58d48a2d2ab0e8$var$getFallbackPlacements(placement), [
            placement
        ]);
        const handleTriggerClicked = (0, $5uXOq.useCallback)((event)=>{
            const newValue = !isLocalOpen;
            const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
            if (type === 'keydown') setTriggeredUsingKeyboard(true);
            else if (clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
            else if (detail === 0) setTriggeredUsingKeyboard(true);
            else {
                itemRef?.current?.focus();
                setTriggeredUsingKeyboard(false);
            }
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        }, [
            isLocalOpen,
            setLocalIsOpen,
            onOpenChange,
            itemRef
        ]);
        const handleOnClose = (0, $5uXOq.useCallback)((event, currentLevel)=>{
            if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, (0, parcelRequire("gsxsp")).PREFIX)}] [aria-haspopup]`)) {
                if (!currentLevel) return;
                const toCloseLevel = itemRef.current?.dataset['ds-Level'];
                if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
            }
            if (returnFocusRef) requestAnimationFrame(()=>{
                returnFocusRef.current?.focus();
            });
            else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
                itemRef.current?.focus();
            });
            else if (triggerRef.current) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
            const newValue = false;
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        }, [
            itemRef,
            onOpenChange,
            returnFocusRef,
            setLocalIsOpen
        ]);
        const { isFocused: isFocused, bindFocus: bindFocus } = (0, (0, parcelRequire("fsuMn")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isFocused) return 0, (0, parcelRequire("eGmKJ")).default;
            if (isLocalOpen) return 0, (0, parcelRequire("eGmKJ")).default;
            return (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    let isNestedTriggerButton;
                    if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, (0, parcelRequire("gsxsp")).PREFIX)}] [aria-haspopup]`);
                    if (e.key === (0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    } else if ((e.code === (0, $5e71d9a7b5ef77ee$export$e51a3576c045c8d5) || e.key === (0, $5e71d9a7b5ef77ee$export$8152f929a25a0ff4)) && e.detail === 0) setTriggeredUsingKeyboard(true);
                    else if (e.key === (0, $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b) && isNestedTriggerButton) handleOnClose(e);
                }
            });
        }, [
            isFocused,
            isLocalOpen,
            handleTriggerClicked,
            handleOnClose
        ]);
        const conditionalProps = shouldFitContainer ? {
            shouldFitContainer: shouldFitContainer,
            strategy: strategy !== 'fixed' ? strategy : undefined
        } : {
            shouldRenderToParent: shouldRenderToParent,
            strategy: strategy
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iY6id")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fL28e")).DropdownMenuProvider), {
            value: {
                returnFocusRef: triggerRef
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, (0, parcelRequire("5JjdN")).default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                    ...bindFocus,
                    ref: (0, (0, parcelRequire("5JjdN")).default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                        interactionName: interactionName
                    }
                }, trigger);
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aFqyR")).default), {
                    onClose: handleOnClose
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5CZpS")).default), {
                    spacing: spacing,
                    maxHeight: $5c58d48a2d2ab0e8$var$MAX_HEIGHT,
                    maxWidth: shouldFitContainer ? undefined : 800,
                    onClose: handleOnClose,
                    onUpdate: update,
                    isLoading: isLoading,
                    statusLabel: statusLabel,
                    setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                    shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                    isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                    autoFocus: autoFocus,
                    testId: testId && `${testId}--menu-wrapper`
                }, children))
        })));
    };
    var $5c58d48a2d2ab0e8$export$2e2bcd8739ae039 = $5c58d48a2d2ab0e8$var$DropdownMenu;
});
parcelRegister("33etG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d76037f5e9b3123$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $9d76037f5e9b3123$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
        const isControlled = propValue !== undefined;
        const [valueState, setValue] = (0, $5uXOq.useState)(getDefaultPropValue);
        const isControlledRef = (0, $5uXOq.useRef)(isControlled);
        (0, $5uXOq.useEffect)(()=>{
            isControlledRef.current = isControlled;
        }, [
            isControlled
        ]);
        const value = isControlled ? propValue : valueState;
        const setValueIfUncontrolled = (0, $5uXOq.useCallback)((newValue)=>{
            if (!isControlledRef.current) setValue(newValue);
        }, []);
        return [
            value,
            setValueIfUncontrolled
        ];
    }
});
parcelRegister("fsuMn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb649bf26e54ce35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $cb649bf26e54ce35$export$2e2bcd8739ae039() {
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const bindFocus = (0, $5uXOq.useRef)({
            onFocus: ()=>setIsFocused(true),
            onBlur: ()=>setIsFocused(false)
        });
        (0, $5uXOq.useEffect)(()=>{
            return ()=>setIsFocused(false);
        }, []);
        return {
            isFocused: isFocused,
            bindFocus: bindFocus.current
        };
    }
});
parcelRegister("c8Oei", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8d6d31f6a6431b53$var$_react = $8d6d31f6a6431b53$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8d6d31f6a6431b53$var$_chevronDown = $8d6d31f6a6431b53$var$_interopRequireDefault((parcelRequire("hORKG")));
    var $8d6d31f6a6431b53$var$_chevronDown2 = $8d6d31f6a6431b53$var$_interopRequireDefault((parcelRequire("6Ingq")));
    function $8d6d31f6a6431b53$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8d6d31f6a6431b53$var$ChevronDownIcon = (props)=>$8d6d31f6a6431b53$var$_react.default.createElement($8d6d31f6a6431b53$var$_chevronDown.default, Object.assign({
            LEGACY_fallbackIcon: $8d6d31f6a6431b53$var$_chevronDown2.default
        }, props));
    $8d6d31f6a6431b53$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
    var $8d6d31f6a6431b53$var$_default = module.exports.default = $8d6d31f6a6431b53$var$ChevronDownIcon;
});
parcelRegister("aFqyR", function(module, exports) {
    $parcel$export(module.exports, "FocusManagerContext", ()=>$974fa4bbe12da3a6$export$f18c1d4fc7326096);
    $parcel$export(module.exports, "default", ()=>$974fa4bbe12da3a6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $eGmKJ;
    var $fxUuP;
    var $c7zut;
    const $974fa4bbe12da3a6$export$f18c1d4fc7326096 = (0, $5uXOq.createContext)({
        menuItemRefs: [],
        registerRef: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $974fa4bbe12da3a6$var$FocusManager = ({ children: children, onClose: onClose })=>{
        const menuItemRefs = (0, $5uXOq.useRef)([]);
        const [refresh, setRefresh] = (0, $5uXOq.useState)(0);
        const registerMode = (0, $5uXOq.useRef)('ordered');
        registerMode.current = 'ordered';
        const registerRef = (0, $5uXOq.useCallback)((ref)=>{
            if (menuItemRefs.current.includes(ref)) return;
            switch(registerMode.current){
                case 'ordered':
                    menuItemRefs.current.push(ref);
                    break;
                case 'unordered':
                    registerMode.current = 'regenerate';
                    menuItemRefs.current = [];
                    setRefresh(refresh + 1);
                    break;
                case 'regenerate':
                    break;
                default:
                    throw new Error(`Unexpected case of ${registerMode.current}`);
            }
        }, [
            refresh
        ]);
        const { isLayerDisabled: isLayerDisabled } = (0, (0, parcelRequire("fxUuP")).useLayering)();
        (0, $5uXOq.useEffect)(()=>{
            if (registerMode.current === 'ordered') registerMode.current = 'unordered';
        });
        (0, $5uXOq.useEffect)(()=>(0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'keydown',
                listener: (0, (0, parcelRequire("c7zut")).default)(menuItemRefs, isLayerDisabled, onClose)
            }), [
            isLayerDisabled,
            onClose
        ]);
        const contextValue = {
            menuItemRefs: menuItemRefs.current,
            registerRef: registerRef
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($974fa4bbe12da3a6$export$f18c1d4fc7326096.Provider, {
            value: contextValue
        }, children);
    };
    var $974fa4bbe12da3a6$export$2e2bcd8739ae039 = $974fa4bbe12da3a6$var$FocusManager;
});
parcelRegister("c7zut", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8063bd9a2f17da3b$export$2e2bcd8739ae039);
    var $VSDnB;
    var $gsxsp;
    const $8063bd9a2f17da3b$var$actionMap = {
        [(0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)]: 'next',
        [(0, $5e71d9a7b5ef77ee$export$390330c10ff2b9a1)]: 'prev',
        [(0, $5e71d9a7b5ef77ee$export$4af703091671bc)]: 'first',
        [(0, $5e71d9a7b5ef77ee$export$e2bc30913faa5db7)]: 'last'
    };
    const $8063bd9a2f17da3b$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
        while(currentFocusedIdx + 1 < refs.length){
            const { current: element } = refs[++currentFocusedIdx];
            const isValid = !!element && !element.hasAttribute('disabled');
            if (isValid) return element;
        }
    };
    const $8063bd9a2f17da3b$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
        while(currentFocusedIdx > 0){
            const { current: element } = refs[--currentFocusedIdx];
            const isValid = !!element && !element.hasAttribute('disabled');
            if (isValid) return element;
        }
    };
    function $8063bd9a2f17da3b$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
        return (e)=>{
            const currentRefs = refs.current ?? [];
            const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_dst_popup-disable-focuslock')) {
                const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, (0, parcelRequire("gsxsp")).PREFIX)}]`);
                if (isLayerDisabled() && isNestedDropdown) {
                    if (e.key === (0, $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                    return;
                }
            } else if (isLayerDisabled()) {
                if (e.key === (0, $5e71d9a7b5ef77ee$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                return;
            }
            const action = $8063bd9a2f17da3b$var$actionMap[e.key];
            switch(action){
                case 'next':
                    e.preventDefault();
                    if (currentFocusedIdx < currentRefs.length - 1) {
                        const nextFocusableElement = $8063bd9a2f17da3b$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                        nextFocusableElement?.focus();
                    } else {
                        const firstFocusableElement = $8063bd9a2f17da3b$var$getNextFocusableElement(currentRefs, -1);
                        firstFocusableElement?.focus();
                    }
                    break;
                case 'prev':
                    e.preventDefault();
                    if (currentFocusedIdx > 0) {
                        const prevFocusableElement = $8063bd9a2f17da3b$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                        prevFocusableElement?.focus();
                    } else {
                        const lastFocusableElement = $8063bd9a2f17da3b$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                        lastFocusableElement?.focus();
                    }
                    break;
                case 'first':
                    e.preventDefault();
                    const nextFocusableElement = $8063bd9a2f17da3b$var$getNextFocusableElement(currentRefs, -1);
                    nextFocusableElement?.focus();
                    break;
                case 'last':
                    e.preventDefault();
                    const prevFocusableElement = $8063bd9a2f17da3b$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                    prevFocusableElement?.focus();
                    break;
                default:
                    return;
            }
        };
    }
});
parcelRegister("gsxsp", function(module, exports) {
    $parcel$export(module.exports, "PREFIX", ()=>$53348102ac8cc8b7$export$8a682ae47622dbb9);
    $parcel$export(module.exports, "default", ()=>$53348102ac8cc8b7$export$2e2bcd8739ae039);
    var $9KnKW;
    const $53348102ac8cc8b7$export$8a682ae47622dbb9 = 'ds--dropdown--';
    function $53348102ac8cc8b7$export$2e2bcd8739ae039() {
        const id = (0, (0, parcelRequire("9KnKW")).useId)();
        return `${$53348102ac8cc8b7$export$8a682ae47622dbb9}${id}`;
    }
});
parcelRegister("5CZpS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6165a25e5ac52753$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eZUJu;
    var $dC5iT;
    var $8CUq3;
    var $eZJjh;
    var $1yOpY;
    var $enuC5;
    var $aFqyR;
    const $6165a25e5ac52753$var$spinnerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        minWidth: '160px',
        padding: 'space.250',
        justifyContent: 'center'
    });
    const $6165a25e5ac52753$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $6165a25e5ac52753$var$spinnerContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small",
            label: statusLabel,
            testId: testId
        }));
    const $6165a25e5ac52753$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
        const { menuItemRefs: menuItemRefs } = (0, $5uXOq.useContext)((0, (0, parcelRequire("aFqyR")).FocusManagerContext));
        const closeOnMenuItemClick = (e)=>{
            const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
                const { current: menuItem } = menuItemRef;
                if (!menuItem) return false;
                const isCheckboxOrRadio = (0, (0, parcelRequire("1yOpY")).default)(menuItem) || (0, (0, parcelRequire("enuC5")).default)(menuItem);
                return menuItem.contains(e.target) && !isCheckboxOrRadio;
            });
            if (isTargetMenuItemOrDescendant && onClose) onClose(e);
        };
        (0, $5uXOq.useLayoutEffect)(()=>{
            onUpdate();
        }, [
            isLoading,
            onUpdate
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
            if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
            setInitialFocusRef?.(firstFocusableRef);
        }, [
            menuItemRefs,
            setInitialFocusRef,
            autoFocus,
            shouldRenderToParent,
            isTriggeredUsingKeyboard
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZUJu")).default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            onClick: closeOnMenuItemClick,
            role: "menu",
            spacing: spacing,
            testId: testId && `${testId}--menu-group`
        }, isLoading ? (0, (0, parcelRequire("f8Sb3")).jsx)($6165a25e5ac52753$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children);
    };
    var $6165a25e5ac52753$export$2e2bcd8739ae039 = $6165a25e5ac52753$var$MenuWrapper;
});
parcelRegister("eZUJu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19b901a90a69a2f9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $j7LBE;
    function $19b901a90a69a2f9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $19b901a90a69a2f9$var$baseStyles = {
        name: "1u0qf12",
        styles: "display:flex;position:static;flex-direction:column;overflow:auto"
    };
    const $19b901a90a69a2f9$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', className: UNSAFE_className, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j7LBE")).SpacingContext).Provider, {
            value: spacing
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j7LBE")).SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-busy": isLoading,
            style: {
                minWidth: minWidth,
                maxWidth: maxWidth,
                minHeight: minHeight,
                maxHeight: maxHeight
            },
            css: $19b901a90a69a2f9$var$baseStyles,
            "data-testid": testId,
            role: role,
            className: UNSAFE_className,
            ...rest
        })));
    var $19b901a90a69a2f9$export$2e2bcd8739ae039 = $19b901a90a69a2f9$var$MenuGroup;
});
parcelRegister("j7LBE", function(module, exports) {
    $parcel$export(module.exports, "SpacingContext", ()=>$05612b3235137344$export$443076ec7ebce042);
    $parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", ()=>$05612b3235137344$export$9ca534b70725964d);
    var $5uXOq = parcelRequire("5uXOq");
    const $05612b3235137344$export$443076ec7ebce042 = (0, $5uXOq.createContext)('cozy');
    const $05612b3235137344$export$9ca534b70725964d = (0, $5uXOq.createContext)('border');
});
parcelRegister("1yOpY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$11f2429108c8dfd0$export$2e2bcd8739ae039);
    function $11f2429108c8dfd0$export$2e2bcd8739ae039(element) {
        const role = element.getAttribute('role');
        return role === 'checkbox' || role === 'menuitemcheckbox';
    }
});
parcelRegister("enuC5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bf55b1b2e2bb5e7$export$2e2bcd8739ae039);
    function $1bf55b1b2e2bb5e7$export$2e2bcd8739ae039(element) {
        const role = element.getAttribute('role');
        return role === 'radio' || role === 'menuitemradio';
    }
});
parcelRegister("fL28e", function(module, exports) {
    $parcel$export(module.exports, "DropdownMenuProvider", ()=>$0fa8ed7350d4e91e$export$9357e33608f1035a);
    var $5uXOq = parcelRequire("5uXOq");
    const $0fa8ed7350d4e91e$var$DropdownMenuContext = (0, $5uXOq.createContext)(undefined);
    const $0fa8ed7350d4e91e$export$9357e33608f1035a = $0fa8ed7350d4e91e$var$DropdownMenuContext.Provider;
});
parcelRegister("iY6id", function(module, exports) {
    $parcel$export(module.exports, "SelectionStoreContext", ()=>$bab2af36b28b0b77$export$756f795847463ebd);
    $parcel$export(module.exports, "default", ()=>$bab2af36b28b0b77$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $bab2af36b28b0b77$export$756f795847463ebd = (0, $5uXOq.createContext)({
        setItemState: (0, (0, parcelRequire("eGmKJ")).default),
        getItemState: ()=>undefined,
        setGroupState: (0, (0, parcelRequire("eGmKJ")).default),
        getGroupState: ()=>({})
    });
    const $bab2af36b28b0b77$var$SelectionStore = (props)=>{
        const { children: children } = props;
        const store = (0, $5uXOq.useRef)({});
        const context = (0, $5uXOq.useMemo)(()=>({
                setItemState: (group, id, value)=>{
                    if (!store.current[group]) store.current[group] = {};
                    store.current[group][id] = value;
                },
                getItemState: (group, id)=>{
                    if (!store.current[group]) return undefined;
                    return store.current[group][id];
                },
                setGroupState: (group, value)=>{
                    store.current[group] = value;
                },
                getGroupState: (group)=>{
                    return store.current[group] || {};
                }
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($bab2af36b28b0b77$export$756f795847463ebd.Provider, {
            value: context
        }, children);
    };
    var $bab2af36b28b0b77$export$2e2bcd8739ae039 = $bab2af36b28b0b77$var$SelectionStore;
});
parcelRegister("l7Q0F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70536c1d6eed3410$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aFqyR;
    function $70536c1d6eed3410$var$useRegisterItemWithFocusManager() {
        const { registerRef: registerRef } = (0, $5uXOq.useContext)((0, (0, parcelRequire("aFqyR")).FocusManagerContext));
        const itemRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>registerRef(itemRef), [
            registerRef
        ]);
        return itemRef;
    }
    var $70536c1d6eed3410$export$2e2bcd8739ae039 = $70536c1d6eed3410$var$useRegisterItemWithFocusManager;
});
parcelRegister("kJpBP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$935f4004e63fbbc2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cYuZM;
    var $eGmKJ;
    var $6wxJn;
    var $VSDnB;
    var $bDaWv;
    const $935f4004e63fbbc2$var$ButtonItem = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, cssFn: cssFn = (0, (0, parcelRequire("eGmKJ")).default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
        const onMouseDownHandler = onMouseDown;
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("6wxJn")).default));
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            interactionContext?.tracePress(interactionName, e.timeStamp);
            onClick?.(e);
        }, [
            onClick,
            interactionContext,
            interactionName
        ]);
        if (!children) return null;
        (0, (0, parcelRequire("cYuZM")).propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, (0, parcelRequire("eGmKJ")).default), '');
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bDaWv")).default), {
            className: UNSAFE_className,
            ...rest,
            overrides: overrides,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isDisabled: isDisabled,
            isSelected: isSelected,
            description: description,
            title: children,
            shouldTitleWrap: shouldTitleWrap,
            shouldDescriptionWrap: shouldDescriptionWrap,
            css: cssFn({
                isSelected: isSelected,
                isDisabled: isDisabled
            }),
            testId: testId && `${testId}--primitive`
        }, ({ children: children, className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("button", {
                "data-testid": testId,
                ...rest,
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: (0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
                onMouseDown: onMouseDownHandler,
                type: "button"
            }, children));
    }));
    var $935f4004e63fbbc2$export$2e2bcd8739ae039 = $935f4004e63fbbc2$var$ButtonItem;
});
parcelRegister("bDaWv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24aefab920b5a8fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cYuZM;
    var $jhVLw;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $j7LBE;
    function $24aefab920b5a8fa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $24aefab920b5a8fa$var$defaultRender = (Component, props)=>(0, (0, parcelRequire("f8Sb3")).jsx)(Component, props);
    const $24aefab920b5a8fa$var$beforeAfterElementStyles = {
        name: "sjfyf",
        styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
    };
    const $24aefab920b5a8fa$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        outline: 'none',
        overflow: 'hidden',
        textAlign: 'left'
    });
    const $24aefab920b5a8fa$var$truncateStyles = {
        name: "hdknak",
        styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $24aefab920b5a8fa$var$titleStyles = {
        name: "183yev2",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $24aefab920b5a8fa$var$wordBreakStyles = {
        name: "1sdjnkx",
        styles: "word-break:break-word"
    };
    const $24aefab920b5a8fa$var$descriptionStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $24aefab920b5a8fa$var$disabledDescriptionStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    });
    const $24aefab920b5a8fa$var$positionRelativeStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $24aefab920b5a8fa$var$primitiveStyles = {
        name: "vfenhj",
        styles: "display:flex;box-sizing:border-box;width:100%;min-height:40px;margin:var(--ds-space-0, 0px);align-items:center;border:0;outline:0;text-decoration:none;user-select:none;&::-moz-focus-inner{border:0;}&:hover{text-decoration:none;}"
    };
    const $24aefab920b5a8fa$var$spacingMapStyles = {
        cozy: {
            name: "1x13z0k",
            styles: "padding-block:var(--ds-space-100, 8px);padding-inline:var(--ds-space-200, 16px)"
        },
        compact: {
            name: "1xdhs5i",
            styles: "min-height:32px;padding-block:var(--ds-space-050, 4px);padding-inline:var(--ds-space-150, 12px)"
        }
    };
    const $24aefab920b5a8fa$var$interactiveStyles = {
        name: "e0dnmk",
        styles: "cursor:pointer"
    };
    const $24aefab920b5a8fa$var$unselectedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
        color: 'currentColor',
        '&:visited': {
            color: 'currentColor'
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            color: 'currentColor'
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            boxShadow: 'none',
            color: 'currentColor'
        }
    });
    const $24aefab920b5a8fa$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        cursor: 'not-allowed',
        '&, :hover, :active': {
            backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
            color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
        }
    });
    const $24aefab920b5a8fa$var$selectedBorderStyles = {
        name: "1dgy7ry",
        styles: "&::before{width:2px;position:absolute;background:var(--ds-border-selected, transparent);content:\"\";inset-block-end:0;inset-block-start:0;inset-inline-start:0;}"
    };
    const $24aefab920b5a8fa$var$selectedNotchStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::before': {
            width: 4,
            position: 'absolute',
            background: "var(--ds-border-selected, transparent)",
            borderRadius: `0 ${"var(--ds-border-radius, 4px)"} ${"var(--ds-border-radius, 4px)"} 0`,
            content: '""',
            insetBlockEnd: "var(--ds-space-150, 12px)",
            insetBlockStart: "var(--ds-space-150, 12px)",
            insetInlineStart: 0
        }
    });
    const $24aefab920b5a8fa$var$selectedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        color: "var(--ds-text-selected, currentColor)",
        '&:visited': {
            color: "var(--ds-text-selected, currentColor)"
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            color: "var(--ds-text-selected, currentColor)"
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            color: "var(--ds-text-selected, currentColor)"
        }
    });
    const $24aefab920b5a8fa$var$gapMap = {
        compact: 'space.100',
        cozy: 'space.150'
    };
    const $24aefab920b5a8fa$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, testId: testId })=>{
        (0, (0, parcelRequire("cYuZM")).propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '');
        const spacing = (0, $5uXOq.useContext)((0, (0, parcelRequire("j7LBE")).SpacingContext));
        const selectionStyle = (0, $5uXOq.useContext)((0, (0, parcelRequire("j7LBE")).SELECTION_STYLE_CONTEXT_DO_NOT_USE));
        const renderTitle = overrides && overrides.Title && overrides.Title.render || $24aefab920b5a8fa$var$defaultRender;
        const UNSAFE_className = UNSAFE_externalClassName;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: cn, cx: cx })=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), {
                isInset: true
            }, children({
                className: cx([
                    cn([
                        $24aefab920b5a8fa$var$positionRelativeStyles,
                        $24aefab920b5a8fa$var$primitiveStyles,
                        $24aefab920b5a8fa$var$spacingMapStyles[spacing],
                        !isDisabled && !isSelected && $24aefab920b5a8fa$var$unselectedStyles,
                        !isDisabled && isSelected && [
                            $24aefab920b5a8fa$var$selectedStyles,
                            [
                                selectionStyle === 'border' && $24aefab920b5a8fa$var$selectedBorderStyles,
                                selectionStyle === 'notch' && $24aefab920b5a8fa$var$selectedNotchStyles
                            ]
                        ],
                        isDisabled ? $24aefab920b5a8fa$var$disabledStyles : $24aefab920b5a8fa$var$interactiveStyles
                    ]),
                    UNSAFE_className
                ]),
                children: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                    as: "span",
                    spread: "space-between",
                    alignBlock: "center",
                    space: $24aefab920b5a8fa$var$gapMap[spacing],
                    grow: "fill",
                    testId: testId && `${testId}--container`
                }, iconBefore && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    "data-item-elem-before": true,
                    css: $24aefab920b5a8fa$var$beforeAfterElementStyles,
                    "data-testid": testId && `${testId}--icon-before`
                }, iconBefore), title && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
                    alignBlock: "center",
                    grow: "fill",
                    xcss: $24aefab920b5a8fa$var$contentStyles
                }, renderTitle('span', {
                    children: title,
                    className: cn($24aefab920b5a8fa$var$titleStyles, shouldTitleWrap ? $24aefab920b5a8fa$var$wordBreakStyles : $24aefab920b5a8fa$var$truncateStyles),
                    'data-item-title': true
                }), description && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    "data-item-description": true,
                    css: [
                        $24aefab920b5a8fa$var$descriptionStyles,
                        isDisabled && $24aefab920b5a8fa$var$disabledDescriptionStyles,
                        shouldDescriptionWrap ? $24aefab920b5a8fa$var$wordBreakStyles : $24aefab920b5a8fa$var$truncateStyles
                    ]
                }, description)), iconAfter && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    "data-item-elem-after": true,
                    css: $24aefab920b5a8fa$var$beforeAfterElementStyles,
                    "data-testid": testId && `${testId}--icon-after`
                }, iconAfter))
            }));
        });
    };
    var $24aefab920b5a8fa$export$2e2bcd8739ae039 = $24aefab920b5a8fa$var$MenuItemPrimitive;
});
parcelRegister("1aogK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c4cb74e8151525f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cYuZM;
    var $eGmKJ;
    var $6wxJn;
    var $VSDnB;
    var $bDaWv;
    const $0c4cb74e8151525f$var$preventEvent = (e)=>{
        e.preventDefault();
    };
    const $0c4cb74e8151525f$var$CustomItem = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ component: Component, cssFn: cssFn = (0, (0, parcelRequire("eGmKJ")).default), isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
        const onMouseDownHandler = onMouseDown;
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("6wxJn")).default));
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            interactionContext?.tracePress(interactionName, e.timeStamp);
            onClick?.(e);
        }, [
            onClick,
            interactionContext,
            interactionName
        ]);
        if (!Component) return null;
        (0, (0, parcelRequire("cYuZM")).propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, (0, parcelRequire("eGmKJ")).default), '');
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bDaWv")).default), {
            className: UNSAFE_className,
            ...rest,
            overrides: overrides,
            description: description,
            iconAfter: iconAfter,
            title: children,
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            shouldTitleWrap: shouldTitleWrap,
            shouldDescriptionWrap: shouldDescriptionWrap,
            css: (0, (0, parcelRequire("f8Sb3")).css)(cssFn({
                isDisabled: isDisabled,
                isSelected: isSelected
            })),
            testId: testId && `${testId}--primitive`
        }, ({ children: children, className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
                "data-testid": testId,
                ...rest,
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $0c4cb74e8151525f$var$preventEvent
                },
                onMouseDown: isDisabled ? $0c4cb74e8151525f$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $0c4cb74e8151525f$var$preventEvent : (0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled
            }, children));
    }));
    var $0c4cb74e8151525f$export$2e2bcd8739ae039 = $0c4cb74e8151525f$var$CustomItem;
});
parcelRegister("3Z96c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0cddba17323f139b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7a0yc;
    var $cYuZM;
    var $eGmKJ;
    var $6wxJn;
    var $VSDnB;
    var $bDaWv;
    const $0cddba17323f139b$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
    const $0cddba17323f139b$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
    const $0cddba17323f139b$var$preventEvent = (e)=>{
        e.preventDefault();
    };
    const $0cddba17323f139b$var$LinkItem = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, href: href, cssFn: cssFn = (0, (0, parcelRequire("eGmKJ")).default), description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, overrides: overrides, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
        const onMouseDownHandler = onMouseDown;
        const RouterLink = (0, (0, parcelRequire("7a0yc")).default)();
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("6wxJn")).default));
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            interactionContext?.tracePress(interactionName, e.timeStamp);
            onClick?.(e);
        }, [
            onClick,
            interactionContext,
            interactionName
        ]);
        if (!children) return null;
        const isExternal = typeof href === 'string' && $0cddba17323f139b$var$IS_EXTERNAL_LINK_REGEX.test(href);
        const isNonHttpBased = typeof href === 'string' && $0cddba17323f139b$var$IS_NON_HTTP_BASED.test(href);
        const isEmptyHref = href == null || href === '';
        const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
        const Component = isRouterLink ? RouterLink : 'a';
        (0, (0, parcelRequire("cYuZM")).propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, (0, parcelRequire("eGmKJ")).default), '');
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bDaWv")).default), {
            ...rest,
            className: UNSAFE_className,
            overrides: overrides,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            isSelected: isSelected,
            isDisabled: isDisabled,
            description: description,
            shouldTitleWrap: shouldTitleWrap,
            shouldDescriptionWrap: shouldDescriptionWrap,
            css: cssFn({
                isSelected: isSelected,
                isDisabled: isDisabled
            }),
            title: children,
            testId: testId && `${testId}--primitive`
        }, ({ children: children, className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                className: className,
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $0cddba17323f139b$var$preventEvent
                },
                onMouseDown: isDisabled ? $0cddba17323f139b$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $0cddba17323f139b$var$preventEvent : (0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') ? handleClick : onClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled,
                ref: ref
            }, children));
    }));
    var $0cddba17323f139b$export$2e2bcd8739ae039 = $0cddba17323f139b$var$LinkItem;
});
parcelRegister("9UCCQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce4b68b55e2d295e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cYuZM;
    var $k5uoT;
    var $3RZIb;
    var $4mNf3;
    function $ce4b68b55e2d295e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce4b68b55e2d295e$var$gridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $ce4b68b55e2d295e$var$itemHeadingTopMargin = $ce4b68b55e2d295e$var$gridSize * 2.5;
    const $ce4b68b55e2d295e$var$itemHeadingBottomMargin = $ce4b68b55e2d295e$var$gridSize * 0.75;
    const $ce4b68b55e2d295e$var$itemHeadingContentHeight = (0, (0, parcelRequire("3RZIb")).headingSizes).h100.lineHeight;
    const $ce4b68b55e2d295e$var$skeletonHeadingHeight = $ce4b68b55e2d295e$var$gridSize;
    const $ce4b68b55e2d295e$var$skeletonHeadingMarginOffset = 3;
    const $ce4b68b55e2d295e$var$skeletonHeadingTopMargin = $ce4b68b55e2d295e$var$itemHeadingTopMargin + ($ce4b68b55e2d295e$var$itemHeadingContentHeight - $ce4b68b55e2d295e$var$skeletonHeadingHeight) - $ce4b68b55e2d295e$var$skeletonHeadingMarginOffset;
    const $ce4b68b55e2d295e$var$skeletonHeadingBottomMargin = $ce4b68b55e2d295e$var$itemHeadingBottomMargin + $ce4b68b55e2d295e$var$skeletonHeadingMarginOffset;
    const $ce4b68b55e2d295e$var$sectionPaddingTopBottom = $ce4b68b55e2d295e$var$gridSize * 0.75;
    const $ce4b68b55e2d295e$var$VAR_SEPARATOR_COLOR = '--ds-menu-seperator-color';
    const $ce4b68b55e2d295e$var$sectionStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::before, &::after': {
            display: 'block',
            height: $ce4b68b55e2d295e$var$sectionPaddingTopBottom,
            content: '""'
        },
        '& [data-ds--menu--heading-item]': {
            marginBlockEnd: $ce4b68b55e2d295e$var$itemHeadingBottomMargin,
            marginBlockStart: $ce4b68b55e2d295e$var$itemHeadingTopMargin,
            '&:first-of-type': {
                marginBlockStart: $ce4b68b55e2d295e$var$itemHeadingTopMargin - $ce4b68b55e2d295e$var$sectionPaddingTopBottom
            }
        },
        '& [data-ds--menu--skeleton-heading-item]': {
            marginBlockEnd: $ce4b68b55e2d295e$var$skeletonHeadingBottomMargin,
            marginBlockStart: $ce4b68b55e2d295e$var$skeletonHeadingTopMargin,
            '&:first-of-type': {
                marginBlockStart: $ce4b68b55e2d295e$var$skeletonHeadingTopMargin - $ce4b68b55e2d295e$var$sectionPaddingTopBottom
            }
        },
        '&:focus': {
            outlineOffset: -1
        }
    });
    const $ce4b68b55e2d295e$var$scrollableStyles = {
        name: "qji62u",
        styles: "flex-shrink:1;overflow:auto"
    };
    const $ce4b68b55e2d295e$var$unscrollableStyles = {
        name: "ozd7xs",
        styles: "flex-shrink:0"
    };
    const $ce4b68b55e2d295e$var$thinSeparatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderBlockStart: `1px solid var(${$ce4b68b55e2d295e$var$VAR_SEPARATOR_COLOR}, ${`var(--ds-border, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`})`
    });
    const $ce4b68b55e2d295e$var$noSeparatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '[data-section] + &': {
            marginBlockStart: -6
        }
    });
    const $ce4b68b55e2d295e$var$Section = (0, $5uXOq.forwardRef)(({ children: children, overrides: overrides, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, className: UNSAFE_className, ...rest }, ref)=>{
        (0, (0, parcelRequire("cYuZM")).propDeprecationWarning)("platform-pkg", 'overrides', overrides !== undefined, '');
        const UNSAFE_headingOverrides = overrides && overrides.HeadingItem && overrides.HeadingItem.cssFn;
        const content = isList ? (0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
            style: {
                margin: 0,
                padding: 0
            }
        }, (0, $5uXOq.Children).map((0, $5uXOq.Children).toArray(children), (child, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)("li", {
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                key: index
            }, child))) : children;
        const childrenMarkup = title !== undefined ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4mNf3")).default), {
            cssFn: UNSAFE_headingOverrides,
            testId: testId && `${testId}--heading`,
            "aria-hidden": true
        }, title), content) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, content);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...rest,
            className: UNSAFE_className,
            id: id,
            css: [
                $ce4b68b55e2d295e$var$sectionStyles,
                isScrollable ? $ce4b68b55e2d295e$var$scrollableStyles : $ce4b68b55e2d295e$var$unscrollableStyles,
                hasSeparator ? $ce4b68b55e2d295e$var$thinSeparatorStyles : $ce4b68b55e2d295e$var$noSeparatorStyles
            ],
            "aria-label": title,
            "aria-labelledby": titleId,
            "data-testid": testId,
            role: "group",
            "data-section": true,
            ref: ref
        }, childrenMarkup);
    });
    var $ce4b68b55e2d295e$export$2e2bcd8739ae039 = $ce4b68b55e2d295e$var$Section;
});
parcelRegister("4mNf3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cad2c1a6550a739b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cYuZM;
    var $eGmKJ;
    const $cad2c1a6550a739b$var$headingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingBlock: "var(--ds-space-0, 0px)",
        paddingInline: "var(--ds-space-200, 16px)"
    });
    const $cad2c1a6550a739b$var$HeadingItem = (0, $5uXOq.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, cssFn: cssFn = (0, (0, parcelRequire("eGmKJ")).default), className: UNSAFE_className, ...rest })=>{
        (0, (0, parcelRequire("cYuZM")).propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, (0, parcelRequire("eGmKJ")).default), '');
        const UNSAFE_overrides = (0, (0, parcelRequire("f8Sb3")).css)(cssFn(undefined));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $cad2c1a6550a739b$var$headingStyles,
                UNSAFE_overrides
            ],
            role: "heading",
            "aria-level": headingLevel,
            "data-testid": testId,
            "data-ds--menu--heading-item": true,
            id: id,
            className: UNSAFE_className,
            ...rest
        }, children);
    });
    var $cad2c1a6550a739b$export$2e2bcd8739ae039 = $cad2c1a6550a739b$var$HeadingItem;
});
parcelRegister("k20lf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f0173d5b95091e18$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $f0173d5b95091e18$var$headingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtle',
        font: 'font.heading.xxsmall',
        paddingBlock: 'space.0',
        paddingInline: 'space.200'
    });
    const $f0173d5b95091e18$var$GroupTitle = ({ id: id, title: title })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            "data-ds--menu--heading-item": true,
            role: "menuitem",
            id: id,
            "aria-hidden": "true",
            xcss: $f0173d5b95091e18$var$headingStyles
        }, title);
    var $f0173d5b95091e18$export$2e2bcd8739ae039 = $f0173d5b95091e18$var$GroupTitle;
});
parcelRegister("9kPzn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$016202b51d00a16b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lv4Ny = parcelRequire("lv4Ny");
    var $6QvkM;
    var $9MHPe;
    var $fxUuP;
    var $k8nZq;
    var $bWj5A;
    var $k7EKU;
    const $016202b51d00a16b$var$EscapeCloseManager = ({ onClose: onClose })=>{
        const handleClose = (0, $5uXOq.useCallback)((evt)=>{
            onClose && onClose(evt);
        }, [
            onClose
        ]);
        (0, (0, parcelRequire("fxUuP")).useCloseOnEscapePress)({
            onClose: handleClose
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null);
    };
    const $016202b51d00a16b$export$4071300121a182f5 = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, onClose: onClose, testId: testId, children: children, icon: icon, closeLabel: closeLabel, scrollContentLabel: scrollContentLabel, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, overrides: overrides, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
        const body = (0, $lv4Ny.canUseDOM) ? document.querySelector('body') : undefined;
        const handleClose = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (evt, analyticsEvent)=>onClose && onClose(evt, analyticsEvent),
            action: 'dismissed',
            componentName: 'drawer',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            analyticsData: {
                trigger: 'escKey'
            }
        });
        const handleKeyDown = (0, $5uXOq.useCallback)((evt)=>{
            onKeyDown && onKeyDown(evt);
        }, [
            onKeyDown
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen) window.addEventListener('keydown', handleKeyDown);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDown);
            };
        }, [
            handleKeyDown,
            isOpen
        ]);
        const handleBlanketClick = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (evt, analyticsEvent)=>onClose && onClose(evt, analyticsEvent),
            action: 'dismissed',
            componentName: 'drawer',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            analyticsData: {
                trigger: 'blanket'
            }
        });
        const handleBackButtonClick = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (evt, analyticsEvent)=>onClose && onClose(evt, analyticsEvent),
            action: 'dismissed',
            componentName: 'drawer',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            analyticsData: {
                trigger: 'backButton'
            }
        });
        if (!body) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8nZq")).default), {
            zIndex: zIndex
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bWj5A")).default), {
            isOpen: isOpen,
            onBlanketClicked: handleBlanketClick,
            testId: testId && `${testId}--blanket`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k7EKU")).default), {
            testId: testId,
            icon: icon,
            closeLabel: closeLabel,
            in: isOpen,
            onClose: handleBackButtonClick,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            width: width,
            enterFrom: enterFrom,
            label: label,
            titleId: titleId,
            overrides: overrides,
            autoFocusFirstElem: autoFocusFirstElem,
            isFocusLockEnabled: isFocusLockEnabled,
            shouldReturnFocus: shouldReturnFocus,
            scrollContentLabel: scrollContentLabel
        }, isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($016202b51d00a16b$var$EscapeCloseManager, {
            onClose: handleClose
        })) : children));
    };
    var $016202b51d00a16b$export$2e2bcd8739ae039 = $016202b51d00a16b$export$4071300121a182f5;
});
parcelRegister("bWj5A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f7b58226b6ad1e6$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $j55bS;
    var $35XSW;
    var $4uxPN;
    var $hSmJH;
    function $4f7b58226b6ad1e6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4f7b58226b6ad1e6$var$blanketStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $4f7b58226b6ad1e6$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("35XSW")).default), {
            appear: true
        }, isOpen && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4uxPN")).default), {
            duration: (0, (0, parcelRequire("hSmJH")).transitionDurationMs) * 2,
            animationTimingFunction: (0, (0, parcelRequire("hSmJH")).animationTimingFunction)
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $4f7b58226b6ad1e6$var$blanketStyles,
                className: className
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j55bS")).default), {
                isTinted: true,
                onBlanketClicked: onBlanketClicked,
                testId: testId && testId
            }))));
    };
    var $4f7b58226b6ad1e6$export$2e2bcd8739ae039 = $4f7b58226b6ad1e6$var$Blanket;
});
parcelRegister("hSmJH", function(module, exports) {
    $parcel$export(module.exports, "transitionDurationMs", ()=>$4246f58ff00a79cd$export$614e920ab938d7a6);
    $parcel$export(module.exports, "animationTimingFunction", ()=>$4246f58ff00a79cd$export$aa1acbd7fbaf45a2);
    const $4246f58ff00a79cd$export$3105270315df0e7 = '0.22s';
    const $4246f58ff00a79cd$export$614e920ab938d7a6 = 220;
    const $4246f58ff00a79cd$export$5cc90842f5a0bf76 = (0, $eba99f58997c09b3$export$57636bb43b1ccbb0);
    const $4246f58ff00a79cd$export$790206ddaae8bb6a = [
        'narrow',
        'medium',
        'wide',
        'extended',
        'full'
    ];
    const $4246f58ff00a79cd$export$8fc1e0a9d795944b = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $4246f58ff00a79cd$export$aa1acbd7fbaf45a2 = ()=>(0, $eba99f58997c09b3$export$57636bb43b1ccbb0);
    const $4246f58ff00a79cd$export$95a69bf7d3b83292 = {
        isFocusLockEnabled: true,
        shouldReturnFocus: true,
        autoFocusFirstElem: true
    };
});
parcelRegister("k7EKU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df1fe562af663c68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $42CjB;
    var $bu8Mq;
    var $3gt3f;
    var $35XSW;
    var $8Sbj3;
    var $VSDnB;
    var $hSmJH;
    var $3WobP;
    var $kBZyj;
    var $jGFwU;
    var $48IQt;
    var $c2VLg;
    const $df1fe562af663c68$var$defaults = {
        Sidebar: (0, (0, parcelRequire("c2VLg")).default),
        Content: (0, (0, parcelRequire("kBZyj")).default)
    };
    const $df1fe562af663c68$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
        const { isExiting: isExiting } = (0, (0, parcelRequire("35XSW")).useExitingPersistence)();
        const duration = isExiting ? (0, (0, parcelRequire("hSmJH")).transitionDurationMs) * 2 : (0, (0, parcelRequire("hSmJH")).transitionDurationMs);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8Sbj3")).default), {
            animationTimingFunction: (0, (0, parcelRequire("hSmJH")).animationTimingFunction),
            duration: duration,
            enterFrom: enterFrom,
            exitTo: enterFrom,
            fade: "none",
            onFinish: onFinish
        }, children);
    };
    const $df1fe562af663c68$var$DrawerPrimitive = ({ children: children, icon: Icon, closeLabel: closeLabel = 'Close drawer', scrollContentLabel: scrollContentLabel, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, overrides: overrides, testId: testId, in: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width, label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
        const getOverrides = (0, (0, parcelRequire("3WobP")).createExtender)($df1fe562af663c68$var$defaults, overrides);
        const { component: Sidebar, ...sideBarOverrides } = getOverrides('Sidebar');
        const { component: Content, ...contentOverrides } = getOverrides('Content');
        const drawerRef = (0, $5uXOq.useRef)(null);
        const onFinish = (0, $5uXOq.useCallback)((state)=>{
            if (state === 'entering') onOpenComplete?.(drawerRef.current);
            else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
        }, [
            onCloseComplete,
            onOpenComplete
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("35XSW")).default), {
            appear: true
        }, isOpen && (0, (0, parcelRequire("f8Sb3")).jsx)($df1fe562af663c68$var$CustomSlideIn, {
            onFinish: onFinish,
            enterFrom: enterFrom
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("48IQt")).default), {
                autoFocusFirstElem: autoFocusFirstElem,
                isFocusLockEnabled: isFocusLockEnabled,
                shouldReturnFocus: shouldReturnFocus
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jGFwU")).default), {
                className: className,
                width: width,
                testId: testId,
                drawerRef: drawerRef,
                label: label,
                titleId: titleId
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Sidebar, sideBarOverrides, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
                onClick: onClose,
                testId: testId && 'DrawerPrimitiveSidebarCloseButton',
                icon: Icon ? (iconProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
                        ...iconProps,
                        size: "large",
                        ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                            LEGACY_size: 'large'
                        } : {}
                    }) : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("bu8Mq"))))) : (0, ($parcel$interopDefault((0, parcelRequire("3gt3f"))))),
                label: closeLabel,
                shape: "circle",
                appearance: "subtle"
            })), (0, (0, parcelRequire("f8Sb3")).jsx)(Content, {
                scrollContentLabel: scrollContentLabel,
                ...contentOverrides
            }, children)))));
    };
    var $df1fe562af663c68$export$2e2bcd8739ae039 = $df1fe562af663c68$var$DrawerPrimitive;
});
parcelRegister("bu8Mq", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $85c94e946798d101$var$_react = $85c94e946798d101$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $85c94e946798d101$var$_arrowLeft = $85c94e946798d101$var$_interopRequireDefault((parcelRequire("ctqwA")));
    var $85c94e946798d101$var$_arrowLeft2 = $85c94e946798d101$var$_interopRequireDefault((parcelRequire("3gt3f")));
    function $85c94e946798d101$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $85c94e946798d101$var$ArrowLeftIcon = (props)=>$85c94e946798d101$var$_react.default.createElement($85c94e946798d101$var$_arrowLeft.default, Object.assign({
            LEGACY_fallbackIcon: $85c94e946798d101$var$_arrowLeft2.default
        }, props));
    $85c94e946798d101$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
    var $85c94e946798d101$var$_default = module.exports.default = $85c94e946798d101$var$ArrowLeftIcon;
});
parcelRegister("3WobP", function(module, exports) {
    $parcel$export(module.exports, "createExtender", ()=>$f9e827249ded690c$export$3f052dbd10b2d4da);
    const $f9e827249ded690c$export$3f052dbd10b2d4da = function createExtender(defaults, overrides = Object.create(Object.prototype)) {
        if (!defaults) throw new Error('a default set of overrides *must* be passed in as the first argument');
        return function getOverrides(key) {
            const { cssFn: defaultCssFn, component: defaultComponent } = defaults[key];
            if (!overrides[key]) return {
                cssFn: defaultCssFn,
                component: defaultComponent
            };
            const { cssFn: customCssFn, component: customComponent } = overrides[key];
            const composedCssFn = (state)=>{
                return customCssFn(defaultCssFn(state), state);
            };
            return {
                cssFn: customCssFn ? composedCssFn : defaultCssFn,
                component: customComponent || defaultComponent
            };
        };
    };
});
parcelRegister("kBZyj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdfc5af274530ef7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    const $bdfc5af274530ef7$var$defaultStyles = {
        flex: 1,
        overflow: 'auto',
        marginTop: "var(--ds-space-300, 24px)"
    };
    const $bdfc5af274530ef7$var$contentCSS = ()=>$bdfc5af274530ef7$var$defaultStyles;
    const $bdfc5af274530ef7$var$Content = ({ cssFn: cssFn, scrollContentLabel: scrollContentLabel = 'Scrollable content', ...props })=>{
        const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
        const scrollableRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const setLazyContentFocus = ()=>{
                const target = scrollableRef.current;
                target && setContentFocus(target.scrollHeight > target.clientHeight);
            };
            setLazyContentFocus();
        }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("f8Sb3")).css)(cssFn($bdfc5af274530ef7$var$defaultStyles)),
            ref: scrollableRef,
            tabIndex: showContentFocus ? 0 : undefined,
            role: showContentFocus ? 'region' : undefined,
            "aria-label": showContentFocus ? scrollContentLabel : undefined,
            "data-testid": "drawer-contents",
            ...props
        });
    };
    const $bdfc5af274530ef7$var$contentDefaults = {
        component: $bdfc5af274530ef7$var$Content,
        cssFn: $bdfc5af274530ef7$var$contentCSS
    };
    var $bdfc5af274530ef7$export$2e2bcd8739ae039 = $bdfc5af274530ef7$var$contentDefaults;
});
parcelRegister("jGFwU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54ba1e1bfd9baa64$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3Du7S;
    var $f8twK;
    var $7QPC8;
    const $54ba1e1bfd9baa64$export$f693ac40d0904cc2 = {
        full: {
            width: '100vw'
        },
        extended: {
            width: '95vw'
        },
        narrow: {
            width: 360
        },
        medium: {
            width: 480
        },
        wide: {
            width: 600
        }
    };
    const $54ba1e1bfd9baa64$var$wrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100vh',
        position: 'fixed',
        zIndex: 500,
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        [(0, (0, parcelRequire("f8twK")).CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        insetBlockStart: 0,
        insetInlineStart: 0,
        overflow: 'hidden'
    });
    const $54ba1e1bfd9baa64$var$DrawerWrapper = (0, $5uXOq.forwardRef)(({ children: children, className: className, width: width = 'narrow', testId: testId, drawerRef: drawerRef, label: label, titleId: titleId }, scrollRef)=>{
        const assignSecondChildRef = (0, $5uXOq.useCallback)((node)=>{
            if (node?.children?.length && typeof scrollRef === 'function') scrollRef(node.children[node.children.length - 1]);
        }, [
            scrollRef
        ]);
        const ref = (0, (0, parcelRequire("3Du7S")).useMergeRefs)([
            drawerRef,
            assignSecondChildRef
        ]);
        (0, (0, parcelRequire("7QPC8")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $54ba1e1bfd9baa64$var$wrapperStyles,
            style: $54ba1e1bfd9baa64$export$f693ac40d0904cc2[width],
            className: className,
            "data-testid": testId,
            ref: ref,
            "aria-modal": true,
            role: "dialog",
            "aria-label": label,
            "aria-labelledby": titleId
        }, children);
    });
    var $54ba1e1bfd9baa64$export$2e2bcd8739ae039 = $54ba1e1bfd9baa64$var$DrawerWrapper;
});
parcelRegister("7QPC8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1591f088f46d28f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    function $b1591f088f46d28f$var$getScrollDistance() {
        return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
    }
    function $b1591f088f46d28f$export$2e2bcd8739ae039() {
        const [scrollTopOffset, setScrollTopOffset] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setScrollTopOffset($b1591f088f46d28f$var$getScrollDistance());
        }, []);
        const onWindowScroll = (0, $5uXOq.useCallback)(()=>{
            if ($b1591f088f46d28f$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
        }, [
            scrollTopOffset
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'scroll',
                listener: onWindowScroll
            });
        }, [
            onWindowScroll
        ]);
        return scrollTopOffset;
    }
});
parcelRegister("48IQt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c75d715bb1837c34$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $2alJM = parcelRequire("2alJM");
    parcelRequire("3joPi");
    var $6cAn5 = parcelRequire("6cAn5");
    const $c75d715bb1837c34$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            if (typeof autoFocusFirstElem === 'function' && isFocusLockEnabled) {
                const elem = autoFocusFirstElem();
                if (elem && elem.focus) elem.focus();
            }
        }, [
            autoFocusFirstElem,
            isFocusLockEnabled
        ]);
        const getFocusTarget = ()=>{
            if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
            return false;
        };
        const onDeactivation = ()=>{
            if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
                shouldReturnFocus?.current?.focus();
            }, 0);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
            disabled: !isFocusLockEnabled,
            autoFocus: !!autoFocusFirstElem,
            returnFocus: getFocusTarget(),
            onDeactivation: onDeactivation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($2alJM))), null, children));
    };
    var $c75d715bb1837c34$export$2e2bcd8739ae039 = $c75d715bb1837c34$var$FocusLock;
});
parcelRegister("c2VLg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a591c4d66bd1dc2d$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $a591c4d66bd1dc2d$var$defaultStyle = {
        alignItems: 'center',
        boxSizing: 'border-box',
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        display: 'flex',
        flexShrink: 0,
        flexDirection: 'column',
        height: '100vh',
        paddingBottom: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-300, 24px)",
        width: "var(--ds-space-800, 64px)"
    };
    const $a591c4d66bd1dc2d$var$sidebarCSS = ()=>$a591c4d66bd1dc2d$var$defaultStyle;
    const $a591c4d66bd1dc2d$var$Sidebar = ({ cssFn: cssFn, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("f8Sb3")).css)(cssFn($a591c4d66bd1dc2d$var$defaultStyle)),
            ...props
        });
    };
    const $a591c4d66bd1dc2d$var$sidebarDefaults = {
        component: $a591c4d66bd1dc2d$var$Sidebar,
        cssFn: $a591c4d66bd1dc2d$var$sidebarCSS
    };
    var $a591c4d66bd1dc2d$export$2e2bcd8739ae039 = $a591c4d66bd1dc2d$var$sidebarDefaults;
});
parcelRegister("jnhNB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90dd6416d3b8b9cd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $ujWmd;
    var $eGmKJ;
    var $fsuMn;
    var $9UCCQ;
    var $1I7E8;
    var $k5uoT;
    var $3bDjY;
    var $9Prrp;
    var $8APWV;
    var $ibUQm;
    var $6tB70;
    var $3PuF6;
    var $lFwF6;
    var $4VtSA;
    const $90dd6416d3b8b9cd$var$MAX_COUNT = {
        grid: 11,
        stack: 5
    };
    function $90dd6416d3b8b9cd$var$getOverrides(overrides) {
        return {
            AvatarGroupItem: {
                render: (Component, props, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
                        ...props,
                        key: (0, (0, parcelRequire("4VtSA")).composeUniqueKey)(props.avatar, index)
                    }),
                ...overrides && overrides.AvatarGroupItem
            },
            Avatar: {
                render: (Component, props, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
                        ...props,
                        key: (0, (0, parcelRequire("4VtSA")).composeUniqueKey)(props, index)
                    }),
                ...overrides && overrides.Avatar
            }
        };
    }
    const $90dd6416d3b8b9cd$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, (0, parcelRequire("ujWmd")).default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
        const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        const handleTriggerClicked = (0, $5uXOq.useCallback)((event)=>{
            const { clientX: clientX, clientY: clientY, type: type } = event;
            if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
            setIsOpen((isOpen)=>!isOpen);
        }, []);
        const { isFocused: isFocused, bindFocus: bindFocus } = (0, (0, parcelRequire("fsuMn")).default)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isOpen) setTriggeredUsingKeyboard(false);
            if (!isFocused) return 0, (0, parcelRequire("eGmKJ")).default;
            if (isOpen) return 0, (0, parcelRequire("eGmKJ")).default;
            (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
            const unbind = ()=>{
                (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: function openOnKeyDown(e) {
                        if (e.key === (0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)) {
                            e.preventDefault();
                            handleTriggerClicked(e);
                        }
                    }
                });
            };
            return unbind;
        }, [
            isFocused,
            isOpen,
            handleTriggerClicked
        ]);
        function renderMoreDropdown(max, total) {
            if (total <= max) return null;
            const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3PuF6")).default), {
                    buttonProps: showMoreButtonProps,
                    borderColor: borderColor,
                    count: total - max,
                    size: size,
                    testId: testId && `${testId}--overflow-menu--trigger`,
                    isActive: isOpen,
                    ...props,
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    onClick: onClick
                });
            if (typeof onMoreClick === 'function') return renderMoreButton({
                onClick: onMoreClick
            });
            const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
            const rootBoundary = (()=>{
                if (boundariesElement === 'scrollParent') return undefined;
                return boundariesElement === 'window' ? 'document' : 'viewport';
            })();
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: isOpen,
                onClose: onClose,
                placement: "bottom-end",
                boundary: boundary,
                rootBoundary: rootBoundary,
                shouldFlip: true,
                zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
                shouldRenderToParent: shouldPopupRenderToParent,
                content: ({ setInitialFocusRef: setInitialFocusRef })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ibUQm")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6tB70")).default), {
                        onClick: (e)=>e.stopPropagation(),
                        minWidth: 250,
                        maxHeight: 300,
                        setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9UCCQ")).default), null, data.slice(max).map((avatar, index)=>$90dd6416d3b8b9cd$var$getOverrides(overrides).AvatarGroupItem.render((0, (0, parcelRequire("9Prrp")).default), {
                            avatar: avatar,
                            onAvatarClick: onAvatarClick,
                            testId: testId && `${testId}--avatar-group-item-${index + max}`,
                            index: index + max
                        }, index + max))))),
                trigger: (triggerProps)=>renderMoreButton({
                        ...triggerProps,
                        ...bindFocus,
                        onClick: handleTriggerClicked
                    }),
                testId: testId && `${testId}--overflow-menu`
            });
        }
        const max = maxCount === undefined || maxCount === 0 ? $90dd6416d3b8b9cd$var$MAX_COUNT[appearance] : maxCount;
        const total = data.length;
        const maxAvatar = total > max ? max - 1 : max;
        const Group = appearance === 'stack' ? (0, (0, parcelRequire("lFwF6")).default) : (0, (0, parcelRequire("8APWV")).default);
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Group, {
            testId: testId && `${testId}--avatar-group`,
            "aria-label": label
        }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
            const callback = avatarData.onClick || onAvatarClick;
            const finalAvatar = $90dd6416d3b8b9cd$var$getOverrides(overrides).Avatar.render(avatar, {
                ...avatarData,
                size: size,
                borderColor: borderColor || avatarData.borderColor,
                testId: testId && `${testId}--avatar-${idx}`,
                onClick: callback ? (event, analyticsEvent)=>{
                    callback(event, analyticsEvent, idx);
                } : undefined,
                stackIndex: max - idx
            }, idx);
            return !isTooltipDisabled && !avatarData.isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                key: (0, (0, parcelRequire("4VtSA")).composeUniqueKey)(avatarData, idx),
                content: avatarData.name,
                testId: testId && `${testId}--tooltip-${idx}`,
                position: tooltipPosition
            }, finalAvatar) : finalAvatar;
        }), renderMoreDropdown(+maxAvatar, total));
    };
    var $90dd6416d3b8b9cd$export$2e2bcd8739ae039 = $90dd6416d3b8b9cd$var$AvatarGroup;
});
parcelRegister("ujWmd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e439760307c6b7fd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2NMNM;
    var $9KnKW;
    var $jhVLw;
    var $VSDnB;
    var $5w8ML;
    var $vIiRg;
    var $620nX;
    var $lrlju;
    var $cEhko;
    var $kyyq3;
    const $e439760307c6b7fd$var$packageName = "platform-pkg";
    const $e439760307c6b7fd$var$packageVersion = "0.0.0-use.local";
    const $e439760307c6b7fd$var$getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--inner`
        } : {
            testId: `${testId}--inner`
        };
    const $e439760307c6b7fd$var$getStyles = (css, { size: size, radius: radius, appearance: appearance, borderColor: borderColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-surface-overlay, ${0, $829f609a65d26a98$export$29a4f05edc054374})`, stackIndex: stackIndex, isInteractive: isInteractive, isDisabled: isDisabled })=>css`
		height: ${size}px;
		width: ${size}px;
		align-items: stretch;
		background-color: ${borderColor};
		border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
		box-sizing: content-box;
		cursor: inherit;
		display: flex;
		flex-direction: column;
		justify-content: center;
		outline: none;
		overflow: hidden;
		position: static;
		transform: translateZ(0);
		transition:
			transform 200ms,
			opacity 200ms;
		box-shadow: 0 0 0 ${0, (0, parcelRequire("vIiRg")).BORDER_WIDTH}px ${borderColor};
		border: none;
		margin: ${"var(--ds-space-025, 2px)"};
		padding: ${"var(--ds-space-0, 0px)"};

		&::-moz-focus-inner {
			border: 0;
			margin: ${"var(--ds-space-0, 0px)"};
			padding: ${"var(--ds-space-0, 0px)"};
		}

		&::after {
			background-color: transparent;
			inset: 0px;

			/* Added border-radius style to fix hover issue in safari */
			border-radius: ${appearance === 'circle' ? '50%' : `${radius}px`};
			content: ' ';
			opacity: 0;
			pointer-events: none;
			position: absolute;
			transition: opacity 200ms;
			width: 100%;
		}

		:focus-visible {
			box-shadow: none;
		}

		${stackIndex && `position: relative;`}

		${isInteractive && `
      cursor: pointer;

      :hover {
        &::after {
          background-color: ${`var(--ds-interaction-hovered, ${0, $829f609a65d26a98$export$6e5e7499ff054f6d})`};
          opacity: 1;
        }
      }

      :active {
        &::after {
          background-color: ${`var(--ds-interaction-pressed, ${0, $829f609a65d26a98$export$6e5e7499ff054f6d})`};
          opacity: 1;
        }
      }

      :active {
        transform: scale(${0, (0, parcelRequire("vIiRg")).ACTIVE_SCALE_FACTOR});
      }

      @media screen and (forced-colors: active) {
        &:focus-visible {
          outline: 1px solid
        }
      }
    `}

    ${isDisabled && `
        cursor: not-allowed;

        &::after {
          opacity: ${"var(--ds-opacity-disabled, 0.7)"};
          pointer-events: none;
          background-color: ${`var(--ds-surface, ${0, $829f609a65d26a98$export$29a4f05edc054374})`};
        }
      `}
	`;
    const $e439760307c6b7fd$var$Avatar = (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div' }, ref)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const context = (0, (0, parcelRequire("620nX")).useAvatarContext)();
        const size = sizeProp ?? context?.size ?? 'medium';
        const customPresenceNode = (0, $5uXOq.isValidElement)(presence) ? presence : null;
        const customStatusNode = (0, $5uXOq.isValidElement)(status) ? status : null;
        const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
        const lastAnalytics = (0, $5uXOq.useRef)(analyticsContext);
        const labelId = (0, (0, parcelRequire("9KnKW")).useId)();
        (0, $5uXOq.useEffect)(()=>{
            lastAnalytics.current = analyticsContext;
        }, [
            analyticsContext
        ]);
        const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
            if (isDisabled || typeof onClick !== 'function') return;
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'avatar',
                attributes: {
                    componentName: 'avatar',
                    packageName: $e439760307c6b7fd$var$packageName,
                    packageVersion: $e439760307c6b7fd$var$packageVersion
                }
            });
            const context = {
                componentName: 'avatar',
                packageName: $e439760307c6b7fd$var$packageName,
                packageVersion: $e439760307c6b7fd$var$packageVersion,
                ...lastAnalytics.current
            };
            analyticsEvent.context.push(context);
            const clone = analyticsEvent.clone();
            if (clone) clone.fire('atlaskit');
            onClick(event, analyticsEvent);
        }, [
            createAnalyticsEvent,
            isDisabled,
            onClick
        ]);
        const componentProps = ()=>{
            if (isDisabled) return {
                disabled: true
            };
            return {
                ...href && (0, (0, parcelRequire("kyyq3")).getLinkProps)(href, target),
                ...onClick && !href ? (0, (0, parcelRequire("kyyq3")).getButtonProps)(onClickHandler) : {
                    onClick: onClick
                }
            };
        };
        const isPresence = isValidIconSize && presence && !status;
        const isStatus = isValidIconSize && status;
        const defaultLabel = [
            name,
            isStatus && !customStatusNode && `(${status})`,
            isPresence && !customPresenceNode && `(${presence})`
        ].filter(Boolean).join(' ');
        const isInteractive = onClick || href || isDisabled;
        const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
        return (0, (0, parcelRequire("f8Sb3")).jsx)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                display: 'inline-block',
                position: 'relative',
                outline: 0,
                zIndex: stackIndex
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: css })=>{
            const props = {
                className: $e439760307c6b7fd$var$getStyles(css, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    radius: (0, (0, parcelRequire("vIiRg")).AVATAR_RADIUS)[size],
                    appearance: appearance,
                    borderColor: borderColor,
                    stackIndex: stackIndex,
                    isInteractive: Boolean(href || onClick) && !isDisabled,
                    isDisabled: isDisabled
                }),
                ...componentProps(),
                ...testId && $e439760307c6b7fd$var$getTestId(testId, children),
                ...(isInteractive || children) && {
                    'aria-label': label || defaultLabel
                },
                children: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5w8ML")).default), {
                    alt: !containerShouldBeImage && src ? name : undefined,
                    appearance: appearance,
                    size: size,
                    src: src,
                    testId: testId
                }),
                ref: ref
            };
            if (children) return children(props);
            const element = (0, (0, parcelRequire("kyyq3")).getCustomElement)(isDisabled, href, onClick);
            return element === 'a' || element === 'button' ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), null, (0, $5uXOq.createElement)(element, props)) : (0, $5uXOq.createElement)(element, props);
        }), isPresence && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lrlju")).PresenceWrapper), {
            appearance: appearance,
            size: size,
            presence: typeof presence === 'string' ? presence : undefined,
            testId: testId
        }, customPresenceNode), isStatus && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cEhko")).StatusWrapper), {
            appearance: appearance,
            size: size,
            borderColor: borderColor,
            status: typeof status === 'string' ? status : undefined,
            testId: testId
        }, customStatusNode), containerShouldBeImage ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId && `${testId}--label`,
            id: labelId,
            hidden: true
        }, defaultLabel) : undefined);
    });
    $e439760307c6b7fd$var$Avatar.displayName = 'Avatar';
    var $e439760307c6b7fd$export$2e2bcd8739ae039 = $e439760307c6b7fd$var$Avatar;
});
parcelRegister("5w8ML", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31b65af695a47def$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $e16Mp;
    var $esjuM;
    var $1bKdn;
    var $2Ljwn;
    var $VSDnB;
    var $vIiRg;
    function $31b65af695a47def$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $31b65af695a47def$var$avatarDefaultIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`
    });
    const $31b65af695a47def$var$avatarDefaultIconVisualRefreshStyles = {
        name: "dg8dij",
        styles: "display:block;width:100%;height:100%;background-color:var(--ds-background-accent-gray-subtler, #DCDFE4)"
    };
    const $31b65af695a47def$var$nestedAvatarStyles = Object.entries((0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)).reduce((styles, [key, size])=>{
        return {
            ...styles,
            [key]: (0, (0, parcelRequire("f8Sb3")).css)({
                lineHeight: 0,
                '& svg': {
                    width: `${size}px`,
                    height: `${size}px`
                }
            })
        };
    }, {});
    const $31b65af695a47def$var$avatarImageStyles = {
        name: "1gr7gcv",
        styles: "display:flex;width:100%;height:100%;flex:1 1 100%"
    };
    const $31b65af695a47def$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId })=>{
        const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
        const borderRadius = appearance === 'circle' ? '50%' : `${(0, (0, parcelRequire("vIiRg")).AVATAR_RADIUS)[size]}px`;
        const isHidden = !alt ? true : undefined;
        (0, $5uXOq.useEffect)(()=>{
            setHasImageErrored(false);
        }, [
            src
        ]);
        if (!src || hasImageErrored) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $31b65af695a47def$var$avatarDefaultIconVisualRefreshStyles : $31b65af695a47def$var$avatarDefaultIconStyles,
                $31b65af695a47def$var$nestedAvatarStyles[size]
            ]
        }, appearance === 'circle' ? (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("1bKdn"))))), {
            label: alt,
            color: "var(--ds-icon-subtle, #626F86)",
            testId: testId && `${testId}--person`,
            spacing: "spacious"
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("e16Mp"))))), {
            label: alt,
            color: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            LEGACY_secondaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`,
            testId: testId && `${testId}--person`,
            spacing: "spacious"
        }) : (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("2Ljwn"))))), {
            label: alt,
            color: "var(--ds-icon-subtle, #626F86)",
            testId: testId && `${testId}--ship`,
            spacing: "spacious"
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("esjuM"))))), {
            label: alt,
            color: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            LEGACY_secondaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`,
            testId: testId && `${testId}--ship`,
            spacing: "spacious"
        }));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            src: src,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            css: $31b65af695a47def$var$avatarImageStyles,
            style: {
                borderRadius: borderRadius
            },
            onError: ()=>setHasImageErrored(true),
            "aria-hidden": isHidden,
            "data-vc": testId ? `${testId}--image` : 'avatar-image',
            "data-ssr-placeholder-ignored": true
        });
    };
    var $31b65af695a47def$export$2e2bcd8739ae039 = $31b65af695a47def$var$AvatarImage;
});
parcelRegister("e16Mp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a3466b06ce7a773e$var$_react = $a3466b06ce7a773e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a3466b06ce7a773e$var$_person = $a3466b06ce7a773e$var$_interopRequireDefault((parcelRequire("1bKdn")));
    var $a3466b06ce7a773e$var$_person2 = $a3466b06ce7a773e$var$_interopRequireDefault((parcelRequire("j85Tc")));
    function $a3466b06ce7a773e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a3466b06ce7a773e$var$PersonIcon = (props)=>$a3466b06ce7a773e$var$_react.default.createElement($a3466b06ce7a773e$var$_person.default, Object.assign({
            LEGACY_fallbackIcon: $a3466b06ce7a773e$var$_person2.default
        }, props));
    $a3466b06ce7a773e$var$PersonIcon.Name = 'PersonIconMigration';
    var $a3466b06ce7a773e$var$_default = module.exports.default = $a3466b06ce7a773e$var$PersonIcon;
});
parcelRegister("esjuM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a862cd9a944ef962$var$_react = $a862cd9a944ef962$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a862cd9a944ef962$var$_release = $a862cd9a944ef962$var$_interopRequireDefault((parcelRequire("2Ljwn")));
    var $a862cd9a944ef962$var$_ship = $a862cd9a944ef962$var$_interopRequireDefault((parcelRequire("jUUuf")));
    function $a862cd9a944ef962$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a862cd9a944ef962$var$ReleaseIcon = (props)=>$a862cd9a944ef962$var$_react.default.createElement($a862cd9a944ef962$var$_release.default, Object.assign({
            LEGACY_fallbackIcon: $a862cd9a944ef962$var$_ship.default
        }, props));
    $a862cd9a944ef962$var$ReleaseIcon.Name = 'ReleaseIconMigration';
    var $a862cd9a944ef962$var$_default = module.exports.default = $a862cd9a944ef962$var$ReleaseIcon;
});
parcelRegister("620nX", function(module, exports) {
    $parcel$export(module.exports, "AvatarContext", ()=>$77861849a3cd2fa6$export$a20dad690e1279e2);
    $parcel$export(module.exports, "useAvatarContext", ()=>$77861849a3cd2fa6$export$b50b87a1c4086b23);
    var $5uXOq = parcelRequire("5uXOq");
    const $77861849a3cd2fa6$export$a20dad690e1279e2 = (0, $5uXOq.createContext)(undefined);
    const $77861849a3cd2fa6$export$b50b87a1c4086b23 = ()=>(0, $5uXOq.useContext)($77861849a3cd2fa6$export$a20dad690e1279e2);
});
parcelRegister("lrlju", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d98bbac7bd20e695$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "PresenceWrapper", ()=>$d98bbac7bd20e695$export$972c5e90200fa0ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $vIiRg;
    var $hTCXk;
    const $d98bbac7bd20e695$var$BusyIndicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        cx: "4",
        cy: "4",
        r: "4"
    }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
    }));
    const $d98bbac7bd20e695$var$FocusIndicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
        fill: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    }));
    const $d98bbac7bd20e695$var$OfflineIndicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
        fill: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
    }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
    }));
    const $d98bbac7bd20e695$var$OnlineIndicator = (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
        cx: "4",
        cy: "4",
        r: "4"
    });
    function $d98bbac7bd20e695$var$getPresence(presence) {
        switch(presence){
            case 'busy':
                return $d98bbac7bd20e695$var$BusyIndicator;
            case 'focus':
                return $d98bbac7bd20e695$var$FocusIndicator;
            case 'offline':
                return $d98bbac7bd20e695$var$OfflineIndicator;
            case 'online':
                return $d98bbac7bd20e695$var$OnlineIndicator;
        }
    }
    const $d98bbac7bd20e695$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTCXk")).default), {
            bgColor: borderColor
        }, presence ? (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg"
        }, $d98bbac7bd20e695$var$getPresence(presence)) : children);
    var $d98bbac7bd20e695$export$2e2bcd8739ae039 = $d98bbac7bd20e695$var$AvatarPresence;
    const $d98bbac7bd20e695$export$972c5e90200fa0ef = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
        const position = appearance === 'square' ? -4 : (0, (0, parcelRequire("vIiRg")).ICON_OFFSET)[size];
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": testId && `${testId}--presence`,
            style: {
                pointerEvents: 'none',
                position: 'absolute',
                bottom: `${position}px`,
                height: `${(0, (0, parcelRequire("vIiRg")).ICON_SIZES)[size]}px`,
                right: `${position}px`,
                width: `${(0, (0, parcelRequire("vIiRg")).ICON_SIZES)[size]}px`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d98bbac7bd20e695$var$AvatarPresence, {
            borderColor: borderColor,
            presence: !children ? presence : undefined
        }, children));
    };
});
parcelRegister("hTCXk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99650c9d2a283f44$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $vIiRg;
    function $99650c9d2a283f44$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $99650c9d2a283f44$var$iconWrapperStyles = {
        name: "1kwqznv",
        styles: "display:flex;box-sizing:border-box;width:100%;height:100%;align-items:center;align-content:center;border-radius:var(--ds-border-radius-circle, 50%);overflow:hidden"
    };
    const $99650c9d2a283f44$var$IconWrapper = ({ bgColor: bgColor = `var(--ds-surface-overlay, ${0, $829f609a65d26a98$export$29a4f05edc054374})`, children: children })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $99650c9d2a283f44$var$iconWrapperStyles,
            role: "presentation",
            style: {
                border: `${(0, (0, parcelRequire("vIiRg")).BORDER_WIDTH)}px solid ${bgColor}`,
                backgroundColor: bgColor
            }
        }, children);
    var $99650c9d2a283f44$export$2e2bcd8739ae039 = $99650c9d2a283f44$var$IconWrapper;
});
parcelRegister("cEhko", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$29c1eab79794ef03$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "StatusWrapper", ()=>$29c1eab79794ef03$export$8045894f255f9726);
    var $5uXOq = parcelRequire("5uXOq");
    var $vIiRg;
    var $hTCXk;
    const $29c1eab79794ef03$var$ApprovedIndicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        cx: "4",
        cy: "4",
        r: "4"
    }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
    }));
    const $29c1eab79794ef03$var$DeclinedIndicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        cx: "4",
        cy: "4",
        r: "4"
    }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
    }));
    const $29c1eab79794ef03$var$LockedIndicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        cx: "4",
        cy: "4",
        r: "4"
    }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
        fill: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
    }));
    function $29c1eab79794ef03$var$getStatus(status) {
        switch(status){
            case 'approved':
                return $29c1eab79794ef03$var$ApprovedIndicator;
            case 'declined':
                return $29c1eab79794ef03$var$DeclinedIndicator;
            case 'locked':
                return $29c1eab79794ef03$var$LockedIndicator;
        }
    }
    const $29c1eab79794ef03$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTCXk")).default), {
            bgColor: borderColor
        }, status ? (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg"
        }, $29c1eab79794ef03$var$getStatus(status)) : children);
    var $29c1eab79794ef03$export$2e2bcd8739ae039 = $29c1eab79794ef03$var$AvatarStatus;
    const $29c1eab79794ef03$export$8045894f255f9726 = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
        const position = appearance === 'square' ? 0 : (0, (0, parcelRequire("vIiRg")).ICON_OFFSET)[size];
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": testId && `${testId}--status`,
            style: {
                position: 'absolute',
                height: `${(0, (0, parcelRequire("vIiRg")).ICON_SIZES)[size]}px`,
                right: `${position}px`,
                top: `${position}px`,
                width: `${(0, (0, parcelRequire("vIiRg")).ICON_SIZES)[size]}px`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($29c1eab79794ef03$var$AvatarStatus, {
            borderColor: borderColor,
            status: !children ? status : undefined
        }, children));
    };
});
parcelRegister("kyyq3", function(module, exports) {
    $parcel$export(module.exports, "getLinkProps", ()=>$336c0ca94b4731ff$export$60113ebe1cf0ecf);
    $parcel$export(module.exports, "getButtonProps", ()=>$336c0ca94b4731ff$export$cca6f1bef43616d3);
    $parcel$export(module.exports, "getCustomElement", ()=>$336c0ca94b4731ff$export$83ee468102cdf04c);
    const $336c0ca94b4731ff$export$60113ebe1cf0ecf = (href, target)=>({
            href: href,
            rel: target === '_blank' ? 'noopener noreferrer' : null,
            target: target
        });
    const $336c0ca94b4731ff$export$cca6f1bef43616d3 = (onClick)=>({
            type: 'button',
            onClick: onClick
        });
    const $336c0ca94b4731ff$export$83ee468102cdf04c = (isDisabled, href, onClick)=>{
        if (href && !isDisabled) return 'a';
        if (onClick || isDisabled) return 'button';
        return 'span';
    };
});
parcelRegister("9Prrp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70f7ee1b8d27f0de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $kiqun;
    const $70f7ee1b8d27f0de$var$AvatarGroupItem = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { avatar: avatar, index: index, onAvatarClick: onAvatarClick, testId: testId } = props;
        const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, key: key, label: label, name: name, onClick: onClick, presence: presence, size: size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: groupItemTestId, ...rest } = avatar;
        const itemRef = (0, (0, parcelRequire("kiqun")).default)();
        const CustomComponent = ({ children: children, className: className, disabled: disabled, draggable: draggable, onClick: onClick, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref, tabIndex: tabIndex, 'data-testid': testId, ...props })=>{
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                type: "button",
                className: className,
                disabled: disabled,
                draggable: draggable,
                onClick: onClick,
                onDragStart: onDragStart,
                onMouseDown: onMouseDown,
                ref: ref,
                tabIndex: tabIndex,
                "data-testid": testId,
                ...props
            }, children));
        };
        const AvatarIcon = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            ...rest,
            analyticsContext: analyticsContext,
            appearance: appearance,
            as: as,
            borderColor: "transparent",
            children: children,
            isDisabled: isDisabled,
            label: label,
            name: "",
            presence: presence,
            size: "small",
            src: src,
            stackIndex: stackIndex,
            status: status,
            tabIndex: tabIndex,
            testId: testId && `${testId}--avatar`
        });
        const callback = onClick || onAvatarClick;
        if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined,
            iconBefore: AvatarIcon,
            testId: testId,
            onClick: (event)=>callback && callback(event, undefined, index)
        }, name);
        if (typeof callback === 'function') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            onClick: (event)=>callback && callback(event, undefined, index),
            iconBefore: AvatarIcon,
            testId: testId
        }, name);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            iconBefore: AvatarIcon,
            component: CustomComponent,
            testId: testId
        }, name);
    });
    var $70f7ee1b8d27f0de$export$2e2bcd8739ae039 = $70f7ee1b8d27f0de$var$AvatarGroupItem;
});
parcelRegister("kiqun", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7253832d56a8089b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ibUQm;
    function $7253832d56a8089b$var$useRegisterItemWithFocusManager() {
        const { registerRef: registerRef } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ibUQm")).FocusManagerContext));
        const itemRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (itemRef.current !== null) registerRef(itemRef.current);
        }, [
            registerRef
        ]);
        return itemRef;
    }
    var $7253832d56a8089b$export$2e2bcd8739ae039 = $7253832d56a8089b$var$useRegisterItemWithFocusManager;
});
parcelRegister("ibUQm", function(module, exports) {
    $parcel$export(module.exports, "FocusManagerContext", ()=>$55ca5414cf1fda71$export$f18c1d4fc7326096);
    $parcel$export(module.exports, "default", ()=>$55ca5414cf1fda71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $eGmKJ;
    var $kmker;
    const $55ca5414cf1fda71$export$f18c1d4fc7326096 = (0, $5uXOq.createContext)({
        menuItemRefs: [],
        registerRef: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $55ca5414cf1fda71$var$FocusManager = ({ children: children })=>{
        const menuItemRefs = (0, $5uXOq.useRef)([]);
        const registerRef = (0, $5uXOq.useCallback)((ref)=>{
            if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'keydown',
                listener: (0, (0, parcelRequire("kmker")).default)(menuItemRefs.current)
            });
            const unbind = ()=>{
                (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: (0, (0, parcelRequire("kmker")).default)(menuItemRefs.current)
                });
            };
            return unbind;
        }, []);
        const contextValue = {
            menuItemRefs: menuItemRefs.current,
            registerRef: registerRef
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($55ca5414cf1fda71$export$f18c1d4fc7326096.Provider, {
            value: contextValue
        }, children);
    };
    var $55ca5414cf1fda71$export$2e2bcd8739ae039 = $55ca5414cf1fda71$var$FocusManager;
});
parcelRegister("kmker", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3817c9dabf013561$export$2e2bcd8739ae039);
    const $3817c9dabf013561$var$actionMap = {
        [(0, $5e71d9a7b5ef77ee$export$a80636c6f41931fe)]: 'next',
        [(0, $5e71d9a7b5ef77ee$export$390330c10ff2b9a1)]: 'prev',
        [(0, $5e71d9a7b5ef77ee$export$4af703091671bc)]: 'first',
        [(0, $5e71d9a7b5ef77ee$export$e2bc30913faa5db7)]: 'last'
    };
    const $3817c9dabf013561$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
        while(currentFocusedIdx + 1 < refs.length){
            const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
            if (!isDisabled) return refs[currentFocusedIdx + 1];
            currentFocusedIdx++;
        }
    };
    const $3817c9dabf013561$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
        while(currentFocusedIdx > 0){
            const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
            if (!isDisabled) return refs[currentFocusedIdx - 1];
            currentFocusedIdx--;
        }
    };
    function $3817c9dabf013561$export$2e2bcd8739ae039(refs) {
        return (e)=>{
            const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
            const action = $3817c9dabf013561$var$actionMap[e.key];
            switch(action){
                case 'next':
                    if (currentFocusedIdx < refs.length - 1) {
                        e.preventDefault();
                        const nextFocusableElement = $3817c9dabf013561$var$getNextFocusableElement(refs, currentFocusedIdx);
                        nextFocusableElement?.focus();
                    }
                    break;
                case 'prev':
                    if (currentFocusedIdx > 0) {
                        e.preventDefault();
                        const prevFocusableElement = $3817c9dabf013561$var$getPrevFocusableElement(refs, currentFocusedIdx);
                        prevFocusableElement?.focus();
                    }
                    break;
                case 'first':
                    e.preventDefault();
                    const nextFocusableElement = $3817c9dabf013561$var$getNextFocusableElement(refs, -1);
                    nextFocusableElement?.focus();
                    break;
                case 'last':
                    e.preventDefault();
                    const prevFocusableElement = $3817c9dabf013561$var$getPrevFocusableElement(refs, refs.length);
                    prevFocusableElement?.focus();
                    break;
                default:
                    return;
            }
        };
    }
});
parcelRegister("8APWV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb6c6550ac6ffd68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $fb6c6550ac6ffd68$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fb6c6550ac6ffd68$var$gutter = "var(--ds-space-negative-050, -4px)";
    const $fb6c6550ac6ffd68$var$listStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: "var(--ds-space-0, 0px)",
        padding: "var(--ds-space-0, 0px)",
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        isolation: 'isolate',
        lineHeight: 1,
        listStyleType: 'none !important',
        marginInlineEnd: $fb6c6550ac6ffd68$var$gutter,
        marginInlineStart: $fb6c6550ac6ffd68$var$gutter
    });
    const $fb6c6550ac6ffd68$var$listItemStyles = {
        name: "3unxte",
        styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
    };
    const $fb6c6550ac6ffd68$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>(0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
            "data-testid": testId,
            "aria-label": label,
            css: $fb6c6550ac6ffd68$var$listStyles
        }, (0, $5uXOq.Children).map(children, (child)=>child && (0, (0, parcelRequire("f8Sb3")).jsx)("li", {
                css: $fb6c6550ac6ffd68$var$listItemStyles
            }, child)));
    var $fb6c6550ac6ffd68$export$2e2bcd8739ae039 = $fb6c6550ac6ffd68$var$Grid;
});
parcelRegister("6tB70", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76f8303bf50b0794$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eZUJu;
    var $ibUQm;
    const $76f8303bf50b0794$var$PopupAvatarGroup = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
        const { menuItemRefs: menuItemRefs } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ibUQm")).FocusManagerContext));
        (0, $5uXOq.useEffect)(()=>{
            setInitialFocusRef?.(menuItemRefs[0]);
        }, [
            menuItemRefs,
            setInitialFocusRef
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZUJu")).default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            minHeight: minHeight,
            minWidth: minWidth,
            onClick: onClick,
            role: role,
            spacing: spacing,
            testId: testId,
            ...rest
        }, children);
    };
    var $76f8303bf50b0794$export$2e2bcd8739ae039 = $76f8303bf50b0794$var$PopupAvatarGroup;
});
parcelRegister("3PuF6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$107bc22aecddc7e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $vIiRg;
    var $ujWmd;
    var $VSDnB;
    const $107bc22aecddc7e7$var$buttonSizes = {
        small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $107bc22aecddc7e7$var$buttonActiveStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&&': {
            backgroundColor: `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            boxShadow: `0 0 0 ${(0, (0, parcelRequire("vIiRg")).BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`}`,
            color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            transform: `scale(${(0, (0, parcelRequire("vIiRg")).ACTIVE_SCALE_FACTOR)})`,
            '&:hover': {
                backgroundColor: `var(--ds-background-selected-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
                color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            },
            '&:active': {
                backgroundColor: `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
                color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
            }
        }
    });
    const $107bc22aecddc7e7$var$buttonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&&': {
            backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
                color: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
            },
            '&:active': {
                backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
                color: `var(--ds-text, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
            },
            '&::after': {
                display: 'none'
            }
        }
    });
    const $107bc22aecddc7e7$var$MAX_DISPLAY_COUNT = 99;
    const $107bc22aecddc7e7$var$MoreIndicator = (0, $5uXOq.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $829f609a65d26a98$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
        const onClickHander = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            if (buttonProps.onClick) buttonProps.onClick(event);
            onClick(event, analyticsEvent);
        }, [
            buttonProps.onClick,
            onClick
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ujWmd")).default), {
            appearance: appearance,
            size: size,
            borderColor: borderColor,
            ref: ref,
            onClick: onClickHander
        }, ({ testId: _, className: className, ref: ref, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("button", {
                type: "submit",
                ...buttonProps,
                ...props,
                ref: ref,
                "data-testid": testId,
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHaspopup,
                style: {
                    font: $107bc22aecddc7e7$var$buttonSizes[size]
                },
                css: [
                    $107bc22aecddc7e7$var$buttonStyles,
                    isActive && $107bc22aecddc7e7$var$buttonActiveStyles
                ],
                className: className
            }, "+", count > $107bc22aecddc7e7$var$MAX_DISPLAY_COUNT ? $107bc22aecddc7e7$var$MAX_DISPLAY_COUNT : count));
    });
    $107bc22aecddc7e7$var$MoreIndicator.displayName = 'MoreIndicator';
    var $107bc22aecddc7e7$export$2e2bcd8739ae039 = $107bc22aecddc7e7$var$MoreIndicator;
});
parcelRegister("lFwF6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7bab9e2cbf400fcb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $vIiRg;
    var $k5uoT;
    const $7bab9e2cbf400fcb$var$gutter = (0, (0, parcelRequire("vIiRg")).BORDER_WIDTH) * 2 + (0, (0, parcelRequire("k5uoT")).gridSize)() / 2;
    const $7bab9e2cbf400fcb$var$listStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: "var(--ds-space-0, 0px)",
        padding: "var(--ds-space-0, 0px)",
        isolation: 'isolate',
        lineHeight: 1,
        listStyleType: 'none !important',
        marginInlineEnd: $7bab9e2cbf400fcb$var$gutter
    });
    const $7bab9e2cbf400fcb$var$listItemStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: "var(--ds-space-0, 0px)",
        marginInlineEnd: -$7bab9e2cbf400fcb$var$gutter
    });
    const $7bab9e2cbf400fcb$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>(0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
            "data-testid": testId,
            "aria-label": label,
            css: $7bab9e2cbf400fcb$var$listStyles
        }, (0, $5uXOq.Children).map(children, (child)=>child && (0, (0, parcelRequire("f8Sb3")).jsx)("li", {
                css: $7bab9e2cbf400fcb$var$listItemStyles
            }, child)));
    var $7bab9e2cbf400fcb$export$2e2bcd8739ae039 = $7bab9e2cbf400fcb$var$Stack;
});
parcelRegister("4VtSA", function(module, exports) {
    $parcel$export(module.exports, "composeUniqueKey", ()=>$71c6d3b80b1d879f$export$b067756944994c79);
    const $71c6d3b80b1d879f$export$b067756944994c79 = (props, index)=>{
        if (props.key) return props.key;
        return index;
    };
});
parcelRegister("lj8SI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d0fb02cd496bf13$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    function $2d0fb02cd496bf13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2d0fb02cd496bf13$var$baseStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        borderRadius: 'border.radius',
        blockSize: 'min-content',
        position: 'static',
        overflow: 'hidden'
    });
    const $2d0fb02cd496bf13$var$styles = {
        container: {
            name: "1s8rs5f",
            styles: "display:inline-flex;box-sizing:border-box;position:static;block-size:min-content;border-radius:3px;overflow:hidden;padding-inline:var(--ds-space-050, 4px)"
        },
        background: {
            bold: {
                default: {
                    name: "1007ca",
                    styles: "background-color:#DDDEE1"
                },
                inprogress: {
                    name: "5nwhd8",
                    styles: "background-color:#8FB8F6"
                },
                moved: {
                    name: "1v45608",
                    styles: "background-color:#F9C84E"
                },
                new: {
                    name: "1ra4w2w",
                    styles: "background-color:#D8A0F7"
                },
                removed: {
                    name: "1y25gsq",
                    styles: "background-color:#FD9891"
                },
                success: {
                    name: "2bpbki",
                    styles: "background-color:#B3DF72"
                }
            },
            subtle: {
                default: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                inprogress: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                moved: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                new: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                removed: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                },
                success: {
                    name: "1v09iay",
                    styles: "background-color:var(--ds-background-neutral-subtle, #00000000)"
                }
            }
        },
        border: {
            subtle: {
                default: (0, (0, parcelRequire("f8Sb3")).css)({
                    border: `1px solid #B7B9BE`
                }),
                inprogress: (0, (0, parcelRequire("f8Sb3")).css)({
                    border: `1px solid #669DF1`
                }),
                moved: (0, (0, parcelRequire("f8Sb3")).css)({
                    border: `1px solid #FCA700`
                }),
                new: (0, (0, parcelRequire("f8Sb3")).css)({
                    border: `1px solid #C97CF4`
                }),
                removed: (0, (0, parcelRequire("f8Sb3")).css)({
                    border: `1px solid #F87168`
                }),
                success: (0, (0, parcelRequire("f8Sb3")).css)({
                    border: `1px solid #94C748`
                })
            }
        },
        text: {
            subtle: {
                name: "nws7uq",
                styles: "color:var(--ds-text, #172B4D)"
            },
            bold: {
                name: "14qj9ca",
                styles: "color:#292A2E"
            }
        }
    };
    const $2d0fb02cd496bf13$var$textStyles = {
        name: "1bkq1y7",
        styles: "font-family:ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif;font-size:11px;font-style:normal;font-weight:var(--ds-font-weight-bold, 700);line-height:16px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap"
    };
    const $2d0fb02cd496bf13$var$Lozenge = (0, $5uXOq.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
        const appearanceStyle = isBold ? 'bold' : 'subtle';
        const appearanceType = appearance in $2d0fb02cd496bf13$var$styles.background[appearanceStyle] ? appearance : 'default';
        const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
        const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            style: {
                backgroundColor: style?.backgroundColor,
                maxWidth: maxWidthIsPc ? maxWidth : '100%'
            },
            css: [
                $2d0fb02cd496bf13$var$styles.container,
                $2d0fb02cd496bf13$var$styles.background[appearanceStyle][appearanceType],
                appearanceStyle === 'subtle' && $2d0fb02cd496bf13$var$styles.border.subtle[appearanceType]
            ],
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $2d0fb02cd496bf13$var$textStyles,
                $2d0fb02cd496bf13$var$styles.text[appearanceStyle]
            ],
            style: {
                color: style?.color,
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`
        }, children));
        const appearanceTypeOld = appearance in $2d0fb02cd496bf13$var$backgroundColorsOld[appearanceStyle] ? appearance : 'default';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            backgroundColor: $2d0fb02cd496bf13$var$backgroundColorsOld[appearanceStyle][appearanceTypeOld],
            style: {
                backgroundColor: style?.backgroundColor,
                maxWidth: maxWidthIsPc ? maxWidth : '100%'
            },
            paddingInline: "space.050",
            xcss: $2d0fb02cd496bf13$var$baseStylesOld,
            testId: testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $2d0fb02cd496bf13$var$textStyles,
                $2d0fb02cd496bf13$var$textColorsOld[appearanceStyle][appearanceType]
            ],
            style: {
                color: style?.color,
                maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
            },
            "data-testid": testId && `${testId}--text`
        }, children));
    });
    $2d0fb02cd496bf13$var$Lozenge.displayName = 'Lozenge';
    var $2d0fb02cd496bf13$export$2e2bcd8739ae039 = $2d0fb02cd496bf13$var$Lozenge;
    const $2d0fb02cd496bf13$var$backgroundColorsOld = {
        bold: {
            default: 'color.background.neutral.bold',
            inprogress: 'color.background.information.bold',
            moved: 'color.background.warning.bold',
            new: 'color.background.discovery.bold',
            removed: 'color.background.danger.bold',
            success: 'color.background.success.bold'
        },
        subtle: {
            default: 'color.background.neutral',
            inprogress: 'color.background.information',
            moved: 'color.background.warning',
            new: 'color.background.discovery',
            removed: 'color.background.danger',
            success: 'color.background.success'
        }
    };
    const $2d0fb02cd496bf13$var$textColorsOld = {
        bold: {
            default: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            },
            inprogress: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            },
            moved: {
                name: "tgubtb",
                styles: "color:var(--ds-text-warning-inverse, #172B4D)"
            },
            new: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            },
            removed: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            },
            success: {
                name: "1wvsb8v",
                styles: "color:var(--ds-text-inverse, #FFFFFF)"
            }
        },
        subtle: {
            default: {
                name: "kmxsjg",
                styles: "color:var(--ds-text-subtle, #42526E)"
            },
            inprogress: {
                name: "3j31nl",
                styles: "color:var(--ds-text-information, #0052CC)"
            },
            moved: {
                name: "1g2i1rp",
                styles: "color:var(--ds-text-warning, #974F0C)"
            },
            new: {
                name: "3juofh",
                styles: "color:var(--ds-text-discovery, #403294)"
            },
            removed: {
                name: "18zo14t",
                styles: "color:var(--ds-text-danger, #DE350B)"
            },
            success: {
                name: "1ychrch",
                styles: "color:var(--ds-text-success, #006644)"
            }
        }
    };
});
parcelRegister("iwwXK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97b85b059b286d19$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $cYuZM;
    var $eGmKJ;
    var $k5uoT;
    var $baKwq;
    function $97b85b059b286d19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $97b85b059b286d19$var$gridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $97b85b059b286d19$var$borderRadius = (0, (0, parcelRequire("k5uoT")).borderRadius)();
    const $97b85b059b286d19$var$itemElemSpacing = $97b85b059b286d19$var$gridSize * 1.5;
    const $97b85b059b286d19$var$itemExpectedElemSize = $97b85b059b286d19$var$gridSize * 3;
    const $97b85b059b286d19$var$itemMinHeight = $97b85b059b286d19$var$gridSize * 5;
    const $97b85b059b286d19$var$skeletonItemElemSize = $97b85b059b286d19$var$gridSize * 2.5;
    const $97b85b059b286d19$var$itemElemSkeletonOffset = ($97b85b059b286d19$var$itemExpectedElemSize - $97b85b059b286d19$var$skeletonItemElemSize) / 2;
    const $97b85b059b286d19$var$skeletonTextBorderRadius = 100;
    const $97b85b059b286d19$var$skeletonContentHeight = 9;
    const $97b85b059b286d19$var$skeletonColor = `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`;
    const $97b85b059b286d19$var$skeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        minHeight: $97b85b059b286d19$var$itemMinHeight,
        padding: `0 ${"var(--ds-space-250, 20px)"}`,
        alignItems: 'center',
        pointerEvents: 'none',
        '::after': {
            height: $97b85b059b286d19$var$skeletonContentHeight,
            backgroundColor: $97b85b059b286d19$var$skeletonColor,
            borderRadius: $97b85b059b286d19$var$skeletonTextBorderRadius,
            content: '""',
            marginBlockStart: 1
        }
    });
    const $97b85b059b286d19$var$defaultWidthStyles = {
        name: "sljcv5",
        styles: ":nth-of-type(1n)::after{flex-basis:70%;}:nth-of-type(2n)::after{flex-basis:50%;}:nth-of-type(3n)::after{flex-basis:60%;}:nth-of-type(4n)::after{flex-basis:90%;}:nth-of-type(5n)::after{flex-basis:35%;}:nth-of-type(6n)::after{flex-basis:77%;}"
    };
    const $97b85b059b286d19$var$customWidthStyles = {
        name: "nsk3fe",
        styles: "::after{flex-basis:var(--width);}"
    };
    const $97b85b059b286d19$var$beforeElementStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '::before': {
            width: $97b85b059b286d19$var$skeletonItemElemSize,
            height: $97b85b059b286d19$var$skeletonItemElemSize,
            flexShrink: 0,
            backgroundColor: $97b85b059b286d19$var$skeletonColor,
            content: '""',
            marginInlineEnd: $97b85b059b286d19$var$itemElemSpacing + $97b85b059b286d19$var$itemElemSkeletonOffset,
            marginInlineStart: "var(--ds-space-025, 2px)"
        }
    });
    const $97b85b059b286d19$var$avatarStyles = {
        name: "lz1zvf",
        styles: "::before{border-radius:100%;}"
    };
    const $97b85b059b286d19$var$iconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '::before': {
            borderRadius: $97b85b059b286d19$var$borderRadius
        }
    });
    const $97b85b059b286d19$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, (0, parcelRequire("eGmKJ")).default) })=>{
        (0, (0, parcelRequire("cYuZM")).propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, (0, parcelRequire("eGmKJ")).default), '');
        const UNSAFE_overrides = (0, (0, parcelRequire("f8Sb3")).css)(cssFn());
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("baKwq")).default), {
            isShimmering: isShimmering
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                className: className,
                style: {
                    '--width': width
                },
                css: [
                    $97b85b059b286d19$var$skeletonStyles,
                    (hasAvatar || hasIcon) && $97b85b059b286d19$var$beforeElementStyles,
                    hasAvatar && $97b85b059b286d19$var$avatarStyles,
                    hasIcon && $97b85b059b286d19$var$iconStyles,
                    width ? $97b85b059b286d19$var$customWidthStyles : $97b85b059b286d19$var$defaultWidthStyles,
                    UNSAFE_overrides
                ],
                "data-testid": testId
            }));
    };
    var $97b85b059b286d19$export$2e2bcd8739ae039 = $97b85b059b286d19$var$SkeletonItem;
});
parcelRegister("baKwq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$04660292477cff34$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $04660292477cff34$var$shimmerKeyframes = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        from: {
            backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
        },
        to: {
            backgroundColor: `var(--ds-skeleton-subtle, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
        }
    });
    const $04660292477cff34$var$shimmerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '::before, ::after': {
            animationDirection: 'alternate',
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationName: `${$04660292477cff34$var$shimmerKeyframes}`,
            animationTimingFunction: 'linear',
            backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
        }
    });
    const $04660292477cff34$var$SkeletonShimmer = ({ children: children, isShimmering: isShimmering = false })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: css })=>children({
                className: isShimmering ? css($04660292477cff34$var$shimmerStyles) : undefined
            }));
    };
    var $04660292477cff34$export$2e2bcd8739ae039 = $04660292477cff34$var$SkeletonShimmer;
});
parcelRegister("9mVKx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f1d4f215b977897$export$2e2bcd8739ae039);
    var $VSDnB;
    var $f8twK;
    var $hdU6u;
    var $imVhc;
    var $31Wet;
    var $bDESO;
    const $8f1d4f215b977897$var$defaultColorMode = 'light';
    const $8f1d4f215b977897$var$defaultContrastMode = 'no-preference';
    const $8f1d4f215b977897$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['colorMode'], dark: dark = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['dark'], light: light = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['light'], contrastMode: contrastMode = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['contrastMode'], shape: shape = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['shape'], spacing: spacing = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['spacing'], typography: typography = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
        const themeAttribute = (0, (0, parcelRequire("imVhc")).themeObjectToString)({
            dark: dark,
            light: light,
            shape: shape,
            spacing: spacing,
            typography: typography
        });
        let result = {
            [(0, (0, parcelRequire("f8twK")).THEME_DATA_ATTRIBUTE)]: themeAttribute,
            [(0, (0, parcelRequire("f8twK")).COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $8f1d4f215b977897$var$defaultColorMode : colorMode
        };
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_increased-contrast-themes')) result = {
            ...result,
            [(0, (0, parcelRequire("f8twK")).CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $8f1d4f215b977897$var$defaultContrastMode : contrastMode
        };
        if (UNSAFE_themeOptions && (0, (0, parcelRequire("31Wet")).isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
            const optionString = JSON.stringify(UNSAFE_themeOptions);
            const uniqueId = (0, (0, parcelRequire("bDESO")).hash)(optionString);
            result[0, (0, parcelRequire("f8twK")).CUSTOM_THEME_ATTRIBUTE] = uniqueId;
        }
        return result;
    };
    var $8f1d4f215b977897$export$2e2bcd8739ae039 = $8f1d4f215b977897$var$getThemeHtmlAttrs;
});
parcelRegister("31Wet", function(module, exports) {
    $parcel$export(module.exports, "isValidBrandHex", ()=>$5b69e7b6787ca4fb$export$53031ac1ecb71f44);
    $parcel$export(module.exports, "rgbToHex", ()=>$5b69e7b6787ca4fb$export$34d09c4a771c46ef);
    $parcel$export(module.exports, "hexToRgbA", ()=>$5b69e7b6787ca4fb$export$b36dbdb4f463f05c);
    $parcel$export(module.exports, "hexToRgb", ()=>$5b69e7b6787ca4fb$export$5a544e13ad4e1fa5);
    $parcel$export(module.exports, "hexToHSL", ()=>$5b69e7b6787ca4fb$export$47ea145a83f50dc0);
    $parcel$export(module.exports, "HSLToRGB", ()=>$5b69e7b6787ca4fb$export$1ff93e992dd58bec);
    $parcel$export(module.exports, "relativeLuminanceW3C", ()=>$5b69e7b6787ca4fb$export$e770b01b744f3745);
    $parcel$export(module.exports, "getContrastRatio", ()=>$5b69e7b6787ca4fb$export$d061e26956a60b0a);
    $parcel$export(module.exports, "deltaE", ()=>$5b69e7b6787ca4fb$export$e8ddad763b4bebf9);
    const $5b69e7b6787ca4fb$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
    const $5b69e7b6787ca4fb$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
    function $5b69e7b6787ca4fb$export$34d09c4a771c46ef(r, g, b) {
        return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    function $5b69e7b6787ca4fb$export$1212645cf40ebf71(hex) {
        if (hex.length === 9) {
            const int = parseInt(hex.slice(7, 9), 16) / 255;
            return Number(parseFloat(int.toString()).toFixed(2));
        }
        return 1;
    }
    function $5b69e7b6787ca4fb$export$b36dbdb4f463f05c(hex) {
        if (!$5b69e7b6787ca4fb$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let c;
        c = hex.substring(1).split('');
        if (c.length === 3) c = [
            c[0],
            c[0],
            c[1],
            c[1],
            c[2],
            c[2]
        ];
        c = '0x' + c.join('');
        return [
            c >> 16 & 255,
            c >> 8 & 255,
            c & 255,
            $5b69e7b6787ca4fb$export$1212645cf40ebf71(hex)
        ];
    }
    function $5b69e7b6787ca4fb$export$5a544e13ad4e1fa5(hex) {
        if (!$5b69e7b6787ca4fb$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let c;
        c = hex.substring(1).split('');
        if (c.length === 3) c = [
            c[0],
            c[0],
            c[1],
            c[1],
            c[2],
            c[2]
        ];
        c = '0x' + c.join('');
        return [
            c >> 16 & 255,
            c >> 8 & 255,
            c & 255
        ];
    }
    function $5b69e7b6787ca4fb$export$47ea145a83f50dc0(hex) {
        if (!$5b69e7b6787ca4fb$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let r = 0, g = 0, b = 0;
        if (hex.length === 4) {
            r = '0x' + hex[1] + hex[1];
            g = '0x' + hex[2] + hex[2];
            b = '0x' + hex[3] + hex[3];
        } else if (hex.length === 7) {
            r = '0x' + hex[1] + hex[2];
            g = '0x' + hex[3] + hex[4];
            b = '0x' + hex[5] + hex[6];
        }
        r /= 255;
        g /= 255;
        b /= 255;
        let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
        if (delta === 0) h = 0;
        else if (cmax === r) h = (g - b) / delta % 6;
        else if (cmax === g) h = (b - r) / delta + 2;
        else h = (r - g) / delta + 4;
        h = Math.round(h * 60);
        if (h < 0) h += 360;
        l = (cmax + cmin) / 2;
        s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
        s = +(s * 100).toFixed(1);
        l = +(l * 100).toFixed(1);
        return [
            h,
            s,
            l
        ];
    }
    function $5b69e7b6787ca4fb$export$1ff93e992dd58bec(h, s, l) {
        s /= 100;
        l /= 100;
        const k = (n)=>(n + h / 30) % 12;
        const a = s * Math.min(l, 1 - l);
        const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
        return [
            255 * f(0),
            255 * f(8),
            255 * f(4)
        ];
    }
    function $5b69e7b6787ca4fb$export$e770b01b744f3745(r, g, b) {
        const RsRGB = r / 255;
        const GsRGB = g / 255;
        const BsRGB = b / 255;
        const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
        return L;
    }
    function $5b69e7b6787ca4fb$export$d061e26956a60b0a(foreground, background) {
        if (!$5b69e7b6787ca4fb$var$isValidHex(foreground) || !$5b69e7b6787ca4fb$var$isValidHex(background)) throw new Error('Invalid HEX');
        const foregroundRgb = $5b69e7b6787ca4fb$export$5a544e13ad4e1fa5(foreground);
        const backgroundRgb = $5b69e7b6787ca4fb$export$5a544e13ad4e1fa5(background);
        const foregroundLuminance = $5b69e7b6787ca4fb$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
        const backgroundLuminance = $5b69e7b6787ca4fb$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
        var brightest = Math.max(foregroundLuminance, backgroundLuminance);
        var darkest = Math.min(foregroundLuminance, backgroundLuminance);
        return (brightest + 0.05) / (darkest + 0.05);
    }
    function $5b69e7b6787ca4fb$export$e8ddad763b4bebf9(rgbA, rgbB) {
        let labA = $5b69e7b6787ca4fb$var$rgbToLab(rgbA);
        let labB = $5b69e7b6787ca4fb$var$rgbToLab(rgbB);
        let deltaL = labA[0] - labB[0];
        let deltaA = labA[1] - labB[1];
        let deltaB = labA[2] - labB[2];
        let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
        let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
        let deltaC = c1 - c2;
        let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
        deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
        let sc = 1.0 + 0.045 * c1;
        let sh = 1.0 + 0.015 * c1;
        let deltaLKlsl = deltaL / 1.0;
        let deltaCkcsc = deltaC / sc;
        let deltaHkhsh = deltaH / sh;
        let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
        return i < 0 ? 0 : Math.sqrt(i);
    }
    function $5b69e7b6787ca4fb$var$rgbToLab(rgb) {
        let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
        x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
        y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
        z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
        return [
            116 * y - 16,
            500 * (x - y),
            200 * (y - z)
        ];
    }
});
parcelRegister("bDESO", function(module, exports) {
    $parcel$export(module.exports, "hash", ()=>$43d583a5e7299761$export$d6af199866bfb566);
    const $43d583a5e7299761$export$d6af199866bfb566 = (str)=>{
        let hash = 0;
        for(let i = 0; i < str.length; i++){
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash &= hash;
        }
        return new Uint32Array([
            hash
        ])[0].toString(36);
    };
});
parcelRegister("9mHmN", function(module, exports) {
    $parcel$export(module.exports, "getThemePreferences", ()=>$37f8be660dd1191e$export$dd6aeb7c823fc03d);
    $parcel$export(module.exports, "getThemeOverridePreferences", ()=>$37f8be660dd1191e$export$5d76d7014f4a5d08);
    var $VSDnB;
    var $iDyon;
    const $37f8be660dd1191e$export$dd6aeb7c823fc03d = (themeState)=>{
        const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography } = themeState;
        const autoColorModeThemes = [
            light,
            dark
        ];
        const themePreferences = [];
        if (colorMode === 'auto') {
            if (contrastMode !== 'no-preference' && (0, (0, parcelRequire("VSDnB")).fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
                const increasedContrastTheme = (0, (0, parcelRequire("iDyon")).default)(normalTheme);
                if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
            });
            themePreferences.push(...autoColorModeThemes);
        } else {
            themePreferences.push(themeState[colorMode]);
            if (contrastMode !== 'no-preference' && (0, (0, parcelRequire("VSDnB")).fg)('platform_increased-contrast-themes')) {
                const increasedContrastTheme = (0, (0, parcelRequire("iDyon")).default)(themeState[colorMode]);
                if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
            }
        }
        [
            shape,
            spacing,
            typography
        ].forEach((themeId)=>{
            if (themeId) themePreferences.push(themeId);
        });
        return [
            ...new Set(themePreferences)
        ];
    };
    const $37f8be660dd1191e$export$5d76d7014f4a5d08 = (_themeState)=>{
        const themeOverridePreferences = [];
        return [
            ...new Set(themeOverridePreferences)
        ];
    };
});
parcelRegister("iDyon", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1388cb358683ad9$export$2e2bcd8739ae039);
    var $hdU6u;
    function $b1388cb358683ad9$export$2e2bcd8739ae039(themeId) {
        return Object.entries((0, (0, parcelRequire("hdU6u")).default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
            return increasesContrastFor === themeId;
        })?.[1].id;
    }
});
parcelRegister("caSeK", function(module, exports) {
    $parcel$export(module.exports, "loadAndAppendThemeCss", ()=>$86176f76153a16e1$export$26cd7ae85c7144e5);
    $parcel$export(module.exports, "loadThemeCss", ()=>$86176f76153a16e1$export$8a48286ed7df6720);
    $parcel$export(module.exports, "darkModeMediaQuery", ()=>$86176f76153a16e1$export$bb1e815119d30f8b);
    $parcel$export(module.exports, "moreContrastMediaQuery", ()=>$86176f76153a16e1$export$8662df6937d86fcb);
    var $VSDnB;
    var $hKzN0;
    var $f8twK;
    const $86176f76153a16e1$export$26cd7ae85c7144e5 = async (themeId)=>{
        if (document.head.querySelector(`style[${(0, (0, parcelRequire("f8twK")).THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, (0, parcelRequire("f8twK")).CUSTOM_THEME_ATTRIBUTE)}])`)) return;
        if (!themeId) return;
        const themeCss = await $86176f76153a16e1$export$8a48286ed7df6720(themeId);
        const style = document.createElement('style');
        style.textContent = themeCss;
        style.dataset.theme = themeId;
        document.head.appendChild(style);
    };
    const $86176f76153a16e1$export$8a48286ed7df6720 = async (themeId)=>{
        if ((themeId === 'light' || themeId === 'dark') && (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
        const { default: themeCss } = await (0, (0, parcelRequire("hKzN0")).default)[themeId]();
        return themeCss;
    };
    const $86176f76153a16e1$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
    const $86176f76153a16e1$export$8662df6937d86fcb = '(prefers-contrast: more)';
});
parcelRegister("hKzN0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8f78a79dcac3478c$export$2e2bcd8739ae039);
    const $8f78a79dcac3478c$var$themeImportsMap = {
        'light': ()=>(parcelRequire("dbL91")),
        'light-future': ()=>(parcelRequire("fpmhX")),
        'light-increased-contrast': ()=>(parcelRequire("4MDO2")),
        'dark': ()=>(parcelRequire("lxzcd")),
        'dark-future': ()=>(parcelRequire("3TzsW")),
        'dark-increased-contrast': ()=>(parcelRequire("dhfHL")),
        'legacy-light': ()=>(parcelRequire("2kBMz")),
        'legacy-dark': ()=>(parcelRequire("ijs9d")),
        'spacing': ()=>(parcelRequire("Jl98Y")),
        'typography-adg3': ()=>(parcelRequire("i9yqc")),
        'shape': ()=>(parcelRequire("3bwp1")),
        'typography-modernized': ()=>(parcelRequire("cJV5Y")),
        'typography-refreshed': ()=>(parcelRequire("ipz99")),
        'light-brand-refresh': ()=>(parcelRequire("cgzGQ")),
        'dark-brand-refresh': ()=>(parcelRequire("8w5mo"))
    };
    var $8f78a79dcac3478c$export$2e2bcd8739ae039 = $8f78a79dcac3478c$var$themeImportsMap;
});
parcelRegister("dbL91", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7pjvK").then(()=>parcelRequire('iscuj'));
});
parcelRegister("6fhBS", function(module, exports) {
    "use strict";
    function $48c1cdc5229a6006$var$load(id) {
        return import((parcelRequire("dy9lH")).resolve(id));
    }
    module.exports = $48c1cdc5229a6006$var$load;
});
parcelRegister("dy9lH", function(module, exports) {
    $parcel$export(module.exports, "register", ()=>$9dd5b3e06d7b5702$export$6503ec6e8aabbaf, (v)=>$9dd5b3e06d7b5702$export$6503ec6e8aabbaf = v);
    $parcel$export(module.exports, "resolve", ()=>$9dd5b3e06d7b5702$export$f7ad0328861e2f03, (v)=>$9dd5b3e06d7b5702$export$f7ad0328861e2f03 = v);
    var $9dd5b3e06d7b5702$export$6503ec6e8aabbaf;
    var $9dd5b3e06d7b5702$export$f7ad0328861e2f03;
    "use strict";
    var $9dd5b3e06d7b5702$var$mapping = new Map();
    function $9dd5b3e06d7b5702$var$register(baseUrl, manifest) {
        for(var i = 0; i < manifest.length - 1; i += 2)$9dd5b3e06d7b5702$var$mapping.set(manifest[i], {
            baseUrl: baseUrl,
            path: manifest[i + 1]
        });
    }
    function $9dd5b3e06d7b5702$var$resolve(id) {
        var resolved = $9dd5b3e06d7b5702$var$mapping.get(id);
        if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
        return new URL(resolved.path, resolved.baseUrl).toString();
    }
    $9dd5b3e06d7b5702$export$6503ec6e8aabbaf = $9dd5b3e06d7b5702$var$register;
    $9dd5b3e06d7b5702$export$f7ad0328861e2f03 = $9dd5b3e06d7b5702$var$resolve;
});
parcelRegister("fpmhX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bOQCu").then(()=>parcelRequire('4dVBj'));
});
parcelRegister("4MDO2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5Agr5").then(()=>parcelRequire('ljoQC'));
});
parcelRegister("lxzcd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bxNLP").then(()=>parcelRequire('kJWHz'));
});
parcelRegister("3TzsW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iBWXC").then(()=>parcelRequire('foDOQ'));
});
parcelRegister("dhfHL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3HkFq").then(()=>parcelRequire('6XJvL'));
});
parcelRegister("2kBMz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6iCxM").then(()=>parcelRequire('49EkV'));
});
parcelRegister("ijs9d", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1tQbg").then(()=>parcelRequire('5hDHe'));
});
parcelRegister("Jl98Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aOvi5").then(()=>parcelRequire('hA9wZ'));
});
parcelRegister("i9yqc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("88rz2").then(()=>parcelRequire('78NH5'));
});
parcelRegister("3bwp1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("88cza").then(()=>parcelRequire('7eY2Z'));
});
parcelRegister("cJV5Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eYDbq").then(()=>parcelRequire('i2ikM'));
});
parcelRegister("ipz99", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("boDIU").then(()=>parcelRequire('2DMsg'));
});
parcelRegister("cgzGQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eKFCm").then(()=>parcelRequire('9m5Rp'));
});
parcelRegister("8w5mo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9tV1K").then(()=>parcelRequire('7gle3'));
});
parcelRegister("dqUdo", function(module, exports) {
    $parcel$export(module.exports, "findMissingCustomStyleElements", ()=>$97dbd21cb4f6cca4$export$bd1ac9300b0e885a);
    $parcel$export(module.exports, "limitSizeOfCustomStyleElements", ()=>$97dbd21cb4f6cca4$export$e7ae172320e03461);
    $parcel$export(module.exports, "reduceTokenMap", ()=>$97dbd21cb4f6cca4$export$e673f367da2ff23e);
    var $hAKJr;
    var $f8twK;
    var $bDESO;
    function $97dbd21cb4f6cca4$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, (0, parcelRequire("bDESO")).hash)(optionString);
        const attrOfMissingCustomStyles = [];
        (mode === 'auto' ? [
            'light',
            'dark'
        ] : [
            mode
        ]).forEach((themeId)=>{
            const element = document.head.querySelector(`style[${(0, (0, parcelRequire("f8twK")).CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, (0, parcelRequire("f8twK")).THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
            if (element) document.head.appendChild(element);
            else attrOfMissingCustomStyles.push(themeId);
        });
        return attrOfMissingCustomStyles;
    }
    function $97dbd21cb4f6cca4$export$e7ae172320e03461(sizeThreshold) {
        const styleTags = [
            ...Array.from(document.head.querySelectorAll(`style[${(0, (0, parcelRequire("f8twK")).CUSTOM_THEME_ATTRIBUTE)}][${(0, (0, parcelRequire("f8twK")).THEME_DATA_ATTRIBUTE)}]`))
        ];
        if (styleTags.length < sizeThreshold) return;
        styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach((element)=>element.remove());
    }
    function $97dbd21cb4f6cca4$export$e673f367da2ff23e(tokenMap, themeRamp) {
        return Object.entries(tokenMap).reduce((acc, [key, value])=>{
            const cssVar = (0, (0, parcelRequire("hAKJr")).default)[key];
            return cssVar ? `${acc}\n  ${cssVar}: ${typeof value === 'string' ? value : themeRamp[value]};` : acc;
        }, '');
    }
});
parcelRegister("9NXG8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0abfa3a3a9e806a4$export$2e2bcd8739ae039);
    var $VSDnB;
    var $hdU6u;
    var $31Wet;
    var $9GmyU;
    var $dqUdo;
    var $9mHmN;
    var $caSeK;
    const $0abfa3a3a9e806a4$var$setGlobalTheme = async ({ colorMode: colorMode = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['contrastMode'], dark: dark = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['dark'], light: light = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['light'], shape: shape = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['shape'], spacing: spacing = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['spacing'], typography: typography = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['typography'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['UNSAFE_themeOptions'] } = {}, themeLoader)=>{
        if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_increased-contrast-themes')) {
            if (light === 'light-increased-contrast') light = 'light';
            if (dark === 'dark-increased-contrast') dark = 'dark';
        }
        const themeState = {
            colorMode: colorMode,
            contrastMode: contrastMode,
            dark: dark,
            light: light,
            shape: shape,
            spacing: spacing,
            typography: typography,
            UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
        };
        let themePreferences = (0, (0, parcelRequire("9mHmN")).getThemePreferences)(themeState);
        const loadingStrategy = themeLoader ? themeLoader : (0, (0, parcelRequire("caSeK")).loadAndAppendThemeCss);
        const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
        if (!themeLoader && UNSAFE_themeOptions && (0, (0, parcelRequire("31Wet")).isValidBrandHex)(UNSAFE_themeOptions?.brandColor)) {
            const mode = colorMode || (0, (0, parcelRequire("hdU6u")).themeStateDefaults)['colorMode'];
            const attrOfMissingCustomStyles = (0, (0, parcelRequire("dqUdo")).findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
            if (attrOfMissingCustomStyles.length > 0) loadingTasks.push((async ()=>{
                const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("3VlHD"));
                loadAndAppendCustomThemeCss({
                    colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : attrOfMissingCustomStyles[0],
                    UNSAFE_themeOptions: UNSAFE_themeOptions
                });
            })());
        }
        await Promise.all(loadingTasks);
        const themeOverridePreferences = (0, (0, parcelRequire("9mHmN")).getThemeOverridePreferences)(themeState);
        for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
        const autoUnbind = (0, (0, parcelRequire("9GmyU")).default)(themeState);
        return autoUnbind;
    };
    var $0abfa3a3a9e806a4$export$2e2bcd8739ae039 = $0abfa3a3a9e806a4$var$setGlobalTheme;
});
parcelRegister("9GmyU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28a1bca1aa5a408d$export$2e2bcd8739ae039);
    var $VSDnB;
    var $9mVKx;
    var $gV7Ao;
    var $eZkgC;
    function $28a1bca1aa5a408d$export$2e2bcd8739ae039(themeState) {
        if (themeState.colorMode === 'auto') {
            themeState.colorMode = (0, (0, parcelRequire("gV7Ao")).default).getColorMode();
            (0, (0, parcelRequire("gV7Ao")).default).bind();
        } else (0, (0, parcelRequire("gV7Ao")).default).unbind();
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_increased-contrast-themes')) {
            if (themeState.contrastMode === 'auto') {
                themeState.contrastMode = (0, (0, parcelRequire("eZkgC")).default).getContrastMode();
                (0, (0, parcelRequire("eZkgC")).default).bind();
            } else (0, (0, parcelRequire("eZkgC")).default).unbind();
        }
        const themeAttributes = (0, (0, parcelRequire("9mVKx")).default)(themeState);
        Object.entries(themeAttributes).forEach(([key, value])=>{
            document.documentElement.setAttribute(key, value);
        });
        return ()=>{
            (0, (0, parcelRequire("gV7Ao")).default).unbind();
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_increased-contrast-themes')) (0, (0, parcelRequire("eZkgC")).default).unbind();
        };
    }
});
parcelRegister("gV7Ao", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$276fb674d0bfcc1f$export$2e2bcd8739ae039);
    var $cBeZP;
    var $f8twK;
    var $caSeK;
    const $276fb674d0bfcc1f$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
    function $276fb674d0bfcc1f$var$checkNativeListener(e) {
        const element = document.documentElement;
        element.setAttribute((0, (0, parcelRequire("f8twK")).COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
    }
    const $276fb674d0bfcc1f$var$darkModeMql = $276fb674d0bfcc1f$var$isMatchMediaAvailable && window.matchMedia((0, (0, parcelRequire("caSeK")).darkModeMediaQuery));
    class $276fb674d0bfcc1f$var$ColorModeObserver {
        getColorMode() {
            if (!$276fb674d0bfcc1f$var$darkModeMql) return 'light';
            return $276fb674d0bfcc1f$var$darkModeMql?.matches ? 'dark' : 'light';
        }
        bind() {
            if ($276fb674d0bfcc1f$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, (0, parcelRequire("cBeZP")).bind)($276fb674d0bfcc1f$var$darkModeMql, {
                type: 'change',
                listener: $276fb674d0bfcc1f$var$checkNativeListener
            });
        }
        unbind() {
            if (this.unbindThemeChangeListener) {
                this.unbindThemeChangeListener();
                this.unbindThemeChangeListener = null;
            }
        }
        constructor(){
            this.unbindThemeChangeListener = null;
        }
    }
    const $276fb674d0bfcc1f$var$SingletonColorModeObserver = new $276fb674d0bfcc1f$var$ColorModeObserver();
    var $276fb674d0bfcc1f$export$2e2bcd8739ae039 = $276fb674d0bfcc1f$var$SingletonColorModeObserver;
});
parcelRegister("eZkgC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$025f9528f4e449a3$export$2e2bcd8739ae039);
    var $cBeZP;
    var $f8twK;
    var $caSeK;
    const $025f9528f4e449a3$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
    function $025f9528f4e449a3$var$checkNativeListener(e) {
        const element = document.documentElement;
        element.setAttribute((0, (0, parcelRequire("f8twK")).CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
    }
    const $025f9528f4e449a3$var$contrastModeMql = $025f9528f4e449a3$var$isMatchMediaAvailable && window.matchMedia((0, (0, parcelRequire("caSeK")).moreContrastMediaQuery));
    class $025f9528f4e449a3$var$ContrastModeObserver {
        getContrastMode() {
            if (!$025f9528f4e449a3$var$contrastModeMql) return 'no-preference';
            return $025f9528f4e449a3$var$contrastModeMql?.matches ? 'more' : 'no-preference';
        }
        bind() {
            if ($025f9528f4e449a3$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, (0, parcelRequire("cBeZP")).bind)($025f9528f4e449a3$var$contrastModeMql, {
                type: 'change',
                listener: $025f9528f4e449a3$var$checkNativeListener
            });
        }
        unbind() {
            if (this.unbindContrastChangeListener) {
                this.unbindContrastChangeListener();
                this.unbindContrastChangeListener = null;
            }
        }
        constructor(){
            this.unbindContrastChangeListener = null;
        }
    }
    const $025f9528f4e449a3$var$SingletonContrastModeObserver = new $025f9528f4e449a3$var$ContrastModeObserver();
    var $025f9528f4e449a3$export$2e2bcd8739ae039 = $025f9528f4e449a3$var$SingletonContrastModeObserver;
});
parcelRegister("3VlHD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1GPFH").then(()=>parcelRequire('msaV2'));
});
parcelRegister("eCCin", function(module, exports) {
    $parcel$export(module.exports, "AtlassianNavigation", ()=>$58c8bcec2d2f91c7$export$f66ccb39f60980e5);
    var $f8Sb3;
    var $1PVpv = parcelRequire("1PVpv");
    var $VSDnB;
    var $k2eCO;
    var $hBZh1;
    var $fSH9K;
    function $58c8bcec2d2f91c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $58c8bcec2d2f91c7$var$containerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        height: (0, $8acc83d90e579622$export$30fa7cc5f2690a43),
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
        paddingInlineEnd: "var(--ds-space-150, 12px)",
        paddingInlineStart: "var(--ds-space-150, 12px)"
    });
    const $58c8bcec2d2f91c7$var$leftStyles = {
        name: "vtikxo",
        styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
    };
    const $58c8bcec2d2f91c7$var$rightStyles = {
        name: "1mwlrd6",
        styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
    };
    const $58c8bcec2d2f91c7$var$noRightMarginStyles = {
        name: "1oo7nc3",
        styles: "margin-inline-end:0"
    };
    const $58c8bcec2d2f91c7$var$analyticsData = {
        attributes: {
            navigationLayer: 'global'
        },
        componentName: 'atlassianNavigation'
    };
    const $58c8bcec2d2f91c7$export$f66ccb39f60980e5 = (props)=>{
        const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, (0, parcelRequire("k2eCO")).defaultTheme), testId: testId, isServer: isServer = false } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hBZh1")).ThemeProvider), {
            value: theme
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $1PVpv.NavigationAnalyticsContext), {
            data: $58c8bcec2d2f91c7$var$analyticsData
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("header", {
            style: theme.mode.navigation,
            css: $58c8bcec2d2f91c7$var$containerStyles,
            "data-testid": testId && `${testId}-header`,
            role: "banner",
            "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
            ...isServer && (0, (0, parcelRequire("VSDnB")).fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
                'data-ssr-placeholder': 'atlassian-navigation-placeholder'
            },
            ...!isServer && (0, (0, parcelRequire("VSDnB")).fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
                'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("nav", {
            css: $58c8bcec2d2f91c7$var$leftStyles,
            "aria-label": label
        }, AppSwitcher && (0, (0, parcelRequire("f8Sb3")).jsx)(AppSwitcher, null), ProductHome && (0, (0, parcelRequire("f8Sb3")).jsx)(ProductHome, null), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fSH9K")).PrimaryItemsContainer), {
            testId: testId,
            moreLabel: moreLabel,
            items: primaryItems,
            create: create,
            theme: theme
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $58c8bcec2d2f91c7$var$rightStyles,
            "data-testid": testId && `${testId}-secondary-actions`
        }, Search && (0, (0, parcelRequire("f8Sb3")).jsx)(Search, null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "list",
            css: [
                $58c8bcec2d2f91c7$var$rightStyles,
                $58c8bcec2d2f91c7$var$noRightMarginStyles
            ],
            "data-vc": "atlassian-navigation-secondary-actions"
        }, Notifications && (0, (0, parcelRequire("f8Sb3")).jsx)(Notifications, null), Help && (0, (0, parcelRequire("f8Sb3")).jsx)(Help, null), Settings && (0, (0, parcelRequire("f8Sb3")).jsx)(Settings, null), SignIn && (0, (0, parcelRequire("f8Sb3")).jsx)(SignIn, null), Profile && (0, (0, parcelRequire("f8Sb3")).jsx)(Profile, null))))));
    };
    var $58c8bcec2d2f91c7$export$2e2bcd8739ae039 = $58c8bcec2d2f91c7$export$f66ccb39f60980e5;
});
const $8acc83d90e579622$export$30fa7cc5f2690a43 = 56;
const $8acc83d90e579622$export$4033a111ca79977d = 1280;
const $8acc83d90e579622$export$24ec62cee78b7042 = 1130;
const $8acc83d90e579622$export$d8bde68ac946124f = '--ds--ans--fbc';
const $8acc83d90e579622$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $8acc83d90e579622$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $8acc83d90e579622$export$d81606c1fc5119bc = '--ds--ans--c';
const $8acc83d90e579622$export$65f656ad520ea71 = '--ds--ans--bc';
parcelRegister("k2eCO", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$150e98c6d1394c9a$export$164de7ab8df77ef0);
    var $eQhNM;
    var $4sCvx;
    const $150e98c6d1394c9a$export$eeee8619e1b91cb0 = (0, (0, parcelRequire("4sCvx")).generateTheme)({
        name: (0, (0, parcelRequire("eQhNM")).DEFAULT_THEME_NAME),
        backgroundColor: (0, $829f609a65d26a98$export$29a4f05edc054374),
        highlightColor: (0, $829f609a65d26a98$export$b3de0ae08da2ce64)
    });
    const $150e98c6d1394c9a$export$164de7ab8df77ef0 = $150e98c6d1394c9a$export$eeee8619e1b91cb0;
});
parcelRegister("eQhNM", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_THEME_NAME", ()=>$7e5624dfecdc168c$export$2491e13b198e597d);
    $parcel$export(module.exports, "default", ()=>$7e5624dfecdc168c$export$2e2bcd8739ae039);
    var $g16iD;
    const $7e5624dfecdc168c$var$defaultTheme = {
        mode: {
            create: {
                active: {
                    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                    backgroundColor: `var(--ds-background-brand-bold-pressed, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$b3de0ae08da2ce64), 0.8)})`,
                    boxShadow: ''
                },
                default: {
                    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                    backgroundColor: `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    boxShadow: ''
                },
                focus: {
                    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                    backgroundColor: '',
                    boxShadow: ''
                },
                hover: {
                    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                    backgroundColor: `var(--ds-background-brand-bold-hovered, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$b3de0ae08da2ce64), 0.9)})`,
                    boxShadow: ''
                },
                selected: {
                    color: '',
                    backgroundColor: '',
                    boxShadow: ''
                }
            },
            iconButton: {
                active: {
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-neutral-pressed, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.6)})`,
                    boxShadow: ''
                },
                default: {
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
                    backgroundColor: 'transparent',
                    boxShadow: ''
                },
                focus: {
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
                    backgroundColor: '',
                    boxShadow: ''
                },
                hover: {
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-neutral-hovered, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.9)})`,
                    boxShadow: ''
                },
                selected: {
                    color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-selected, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.6)})`,
                    boxShadow: ''
                },
                selectedHover: {
                    color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-selected-hovered, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.6)})`,
                    boxShadow: ''
                }
            },
            navigation: {
                backgroundColor: `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
            },
            productHome: {
                backgroundColor: `var(--ds-text-brand, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                color: `var(--ds-text, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
                borderRight: `1px solid ${`var(--ds-border, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$f563ee71e9ee74cd), 0.3)})`}`,
                iconColor: '#357DE8'
            },
            primaryButton: {
                active: {
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-neutral-pressed, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.7)})`,
                    boxShadow: ''
                },
                default: {
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
                    backgroundColor: 'transparent',
                    boxShadow: ''
                },
                focus: {
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7090862dc3038a9f)})`,
                    backgroundColor: '',
                    boxShadow: ''
                },
                hover: {
                    color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-neutral-hovered, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.9)})`,
                    boxShadow: ''
                },
                selected: {
                    color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-selected, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.7)})`,
                    boxShadow: '',
                    borderColor: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
                },
                selectedHover: {
                    color: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                    backgroundColor: `var(--ds-background-selected-hovered, ${(0, (0, parcelRequire("g16iD")).hexToRGBA)((0, $829f609a65d26a98$export$226de0355ed012f8), 0.6)})`,
                    boxShadow: '',
                    borderColor: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
                }
            },
            search: {
                default: {
                    backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
                    color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
                    borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
                },
                focus: {
                    borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
                },
                hover: {
                    backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
                }
            },
            skeleton: {
                backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
                opacity: 1
            }
        }
    };
    const $7e5624dfecdc168c$export$2491e13b198e597d = 'atlassian';
    var $7e5624dfecdc168c$export$2e2bcd8739ae039 = $7e5624dfecdc168c$var$defaultTheme;
});
parcelRegister("g16iD", function(module, exports) {
    $parcel$export(module.exports, "hexToRGBA", ()=>$e44f5a74bfef19bf$export$7229be6d7219ee6a);
    $parcel$export(module.exports, "getBoxShadow", ()=>$e44f5a74bfef19bf$export$bba5a971afe05444);
    $parcel$export(module.exports, "generateTextColor", ()=>$e44f5a74bfef19bf$export$10a10e7cd1193377);
    $parcel$export(module.exports, "getContrastColor", ()=>$e44f5a74bfef19bf$export$77a1051494882576);
    var $dBl98 = parcelRequire("dBl98");
    const $e44f5a74bfef19bf$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
        const rgba = {
            ...(0, $dBl98.default).convert(hex).rgb,
            a: opacity
        };
        return `rgba(${Object.values(rgba).join(', ')})`;
    };
    const $e44f5a74bfef19bf$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
    const $e44f5a74bfef19bf$var$hex = '[a-z0-9]';
    const $e44f5a74bfef19bf$var$shortHandHexColorPattern = new RegExp(`#(${$e44f5a74bfef19bf$var$hex})(${$e44f5a74bfef19bf$var$hex})(${$e44f5a74bfef19bf$var$hex})`, 'i');
    const $e44f5a74bfef19bf$var$repeat = (str, times)=>[
            ...Array(times)
        ].map(()=>str).join('');
    const $e44f5a74bfef19bf$var$isShortHexColor = (color)=>color && color.length === 4;
    const $e44f5a74bfef19bf$var$completeHexColor = (colors)=>{
        const hex = colors.map((color)=>$e44f5a74bfef19bf$var$repeat(color, 2)).join('');
        return `#${hex}`;
    };
    const $e44f5a74bfef19bf$var$completeTriplet = (colors)=>`#${$e44f5a74bfef19bf$var$repeat(colors[1], 6)}`;
    const $e44f5a74bfef19bf$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
    const $e44f5a74bfef19bf$export$db8d2130677f868c = (color)=>{
        if ($e44f5a74bfef19bf$var$isShortHexColor(color)) {
            const matches = color.match($e44f5a74bfef19bf$var$shortHandHexColorPattern);
            if (matches) {
                const colors = matches.slice(1, 4);
                if ($e44f5a74bfef19bf$var$isTriplet(colors)) return $e44f5a74bfef19bf$var$completeTriplet(colors);
                else return $e44f5a74bfef19bf$var$completeHexColor(colors);
            }
        }
        return color;
    };
    const $e44f5a74bfef19bf$export$10a10e7cd1193377 = (color)=>{
        const converted = $e44f5a74bfef19bf$export$db8d2130677f868c(color);
        return (0, $dBl98.default).contrastRatio(converted).hex;
    };
    const $e44f5a74bfef19bf$export$77a1051494882576 = (contrastValue, opacityValue, color)=>$e44f5a74bfef19bf$export$7229be6d7219ee6a((0, $dBl98.default).contrast(contrastValue, color).hex, opacityValue);
});
parcelRegister("4sCvx", function(module, exports) {
    $parcel$export(module.exports, "generateTheme", ()=>$2e1eacd2d53fa96f$export$2e4ecffaca289a18);
    var $eQhNM;
    var $g16iD;
    const $2e1eacd2d53fa96f$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
    const $2e1eacd2d53fa96f$var$generateButtonCSSStates = (colors, buttonType)=>{
        const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
        const opacityValue = $2e1eacd2d53fa96f$var$generateOpacityValue(color);
        const isCreateButton = buttonType === 'create';
        return {
            active: {
                backgroundColor: isCreateButton ? (0, (0, parcelRequire("g16iD")).hexToRGBA)(backgroundColor, 0.65) : (0, (0, parcelRequire("g16iD")).getContrastColor)(0.3, opacityValue, backgroundColor),
                boxShadow: (0, (0, parcelRequire("g16iD")).getBoxShadow)('transparent'),
                color: color
            },
            default: {
                backgroundColor: backgroundColor,
                boxShadow: (0, (0, parcelRequire("g16iD")).getBoxShadow)('transparent'),
                color: color
            },
            focus: {
                boxShadow: 'none',
                color: color,
                backgroundColor: backgroundColor
            },
            hover: {
                backgroundColor: isCreateButton ? (0, (0, parcelRequire("g16iD")).hexToRGBA)(backgroundColor, 0.8) : (0, (0, parcelRequire("g16iD")).getContrastColor)(0.1, opacityValue, backgroundColor),
                boxShadow: (0, (0, parcelRequire("g16iD")).getBoxShadow)('transparent'),
                color: color
            },
            selected: {
                color: color,
                backgroundColor: (0, (0, parcelRequire("g16iD")).getContrastColor)(0.3, opacityValue, backgroundColor),
                borderColor: highlightColor,
                boxShadow: (0, (0, parcelRequire("g16iD")).getBoxShadow)('transparent')
            },
            selectedHover: {
                color: color,
                backgroundColor: (0, (0, parcelRequire("g16iD")).getContrastColor)(0.3, opacityValue, backgroundColor),
                borderColor: highlightColor,
                boxShadow: (0, (0, parcelRequire("g16iD")).getBoxShadow)('transparent')
            }
        };
    };
    const $2e1eacd2d53fa96f$var$generateCreateButtonColors = (themeBackground, themeHighlight)=>({
            backgroundColor: themeHighlight,
            color: (0, (0, parcelRequire("g16iD")).generateTextColor)(themeHighlight),
            highlightColor: themeHighlight
        });
    const $2e1eacd2d53fa96f$export$2e4ecffaca289a18 = (themeColors)=>{
        const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
        const color = (0, (0, parcelRequire("g16iD")).generateTextColor)(backgroundColor);
        const colors = {
            ...themeColors,
            color: color
        };
        if (name === (0, (0, parcelRequire("eQhNM")).DEFAULT_THEME_NAME)) return 0, (0, parcelRequire("eQhNM")).default;
        return {
            mode: {
                create: $2e1eacd2d53fa96f$var$generateButtonCSSStates($2e1eacd2d53fa96f$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
                iconButton: $2e1eacd2d53fa96f$var$generateButtonCSSStates(colors, 'iconButton'),
                primaryButton: $2e1eacd2d53fa96f$var$generateButtonCSSStates(colors, 'primaryButton'),
                navigation: {
                    backgroundColor: backgroundColor,
                    color: color
                },
                productHome: {
                    color: color,
                    backgroundColor: highlightColor,
                    borderRight: `1px solid ${(0, (0, parcelRequire("g16iD")).hexToRGBA)(color, 0.5)}`
                },
                search: {
                    default: {
                        backgroundColor: backgroundColor,
                        color: color,
                        borderColor: (0, (0, parcelRequire("g16iD")).hexToRGBA)(color, 0.5)
                    },
                    focus: {
                        borderColor: (0, (0, parcelRequire("g16iD")).hexToRGBA)(highlightColor, 0.8),
                        boxShadow: (0, (0, parcelRequire("g16iD")).getBoxShadow)((0, (0, parcelRequire("g16iD")).hexToRGBA)(highlightColor, 0.5))
                    },
                    hover: {
                        backgroundColor: (0, (0, parcelRequire("g16iD")).getContrastColor)(0.1, $2e1eacd2d53fa96f$var$generateOpacityValue(color), backgroundColor),
                        color: color
                    }
                },
                skeleton: {
                    backgroundColor: color,
                    opacity: 0.08
                }
            }
        };
    };
    var $2e1eacd2d53fa96f$export$2e2bcd8739ae039 = $2e1eacd2d53fa96f$export$2e4ecffaca289a18;
});
parcelRegister("hBZh1", function(module, exports) {
    $parcel$export(module.exports, "ThemeContext", ()=>$7322cc82d03b9ede$export$2c657da244d00bd6);
    $parcel$export(module.exports, "ThemeProvider", ()=>$7322cc82d03b9ede$export$d8964aec282183a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2eCO;
    const $7322cc82d03b9ede$export$2c657da244d00bd6 = (0, $5uXOq.createContext)((0, (0, parcelRequire("k2eCO")).defaultTheme));
    const $7322cc82d03b9ede$export$d8964aec282183a3 = $7322cc82d03b9ede$export$2c657da244d00bd6.Provider;
});
parcelRegister("fSH9K", function(module, exports) {
    $parcel$export(module.exports, "PrimaryItemsContainer", ()=>$6fdfdcc72d14d5cb$export$43e704064d596a9e);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $1I7E8;
    var $gJlZe;
    var $2bzBV;
    var $7ownK;
    function $6fdfdcc72d14d5cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6fdfdcc72d14d5cb$var$containerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'relative',
        alignItems: 'stretch',
        flexBasis: 0,
        flexGrow: 1,
        flexShrink: 0,
        '& > *': {
            margin: `0 ${"var(--ds-space-050, 4px)"}`,
            flexShrink: 0
        }
    });
    const $6fdfdcc72d14d5cb$var$widthObserverContainerStyles = {
        name: "o1tvrz",
        styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
    };
    const $6fdfdcc72d14d5cb$var$overflowItemsStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
    });
    const $6fdfdcc72d14d5cb$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, theme: theme, testId: testId })=>{
        const [isMoreOpen, setIsMoreOpen] = (0, $5uXOq.useState)(false);
        const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, (0, parcelRequire("2bzBV")).useOverflowController)(items);
        const onMoreClick = (0, $5uXOq.useCallback)(()=>{
            setIsMoreOpen(!isMoreOpen);
        }, [
            isMoreOpen,
            setIsMoreOpen
        ]);
        const onMoreClose = (0, $5uXOq.useCallback)(()=>{
            setIsMoreOpen(false);
        }, []);
        const openOverflowMenu = (0, $5uXOq.useCallback)(()=>{
            setIsMoreOpen(true);
        }, []);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7ownK")).PrimaryDropdownButton), {
                onClick: onMoreClick,
                isSelected: isMoreOpen,
                testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
                ...triggerProps
            }, moreLabel), [
            moreLabel,
            onMoreClick,
            isMoreOpen,
            testId
        ]);
        const content = (0, $5uXOq.useCallback)(()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2bzBV")).OverflowProvider), {
                isVisible: false,
                openOverflowMenu: openOverflowMenu,
                closeOverflowMenu: onMoreClose
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $6fdfdcc72d14d5cb$var$overflowItemsStyles
            }, overflowItems)), [
            overflowItems.length,
            openOverflowMenu,
            onMoreClose
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $6fdfdcc72d14d5cb$var$containerStyles,
            "data-testid": testId && `${testId}-primary-actions`,
            role: "list"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2bzBV")).OverflowProvider), {
            isVisible: true,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, visibleItems), overflowItems.length > 0 && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1I7E8")).default), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            content: content,
            isOpen: isMoreOpen,
            onClose: onMoreClose,
            trigger: trigger,
            testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
        }), Create && (0, (0, parcelRequire("f8Sb3")).jsx)(Create, null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $6fdfdcc72d14d5cb$var$widthObserverContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gJlZe")).WidthObserver), {
            offscreen: true,
            setWidth: updateWidth
        })));
    };
});
parcelRegister("gJlZe", function(module, exports) {
    $parcel$export(module.exports, "WidthObserver", ()=>$f3c667de71b5760d$export$b2ad68b9bc407b80);
    var $5uXOq = parcelRequire("5uXOq");
    var $jWz2c;
    const $f3c667de71b5760d$export$b2ad68b9bc407b80 = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWz2c")).WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
    });
    var $f3c667de71b5760d$export$2e2bcd8739ae039 = $f3c667de71b5760d$export$b2ad68b9bc407b80;
});
parcelRegister("jWz2c", function(module, exports) {
    $parcel$export(module.exports, "WidthDetectorObserver", ()=>$76470ef26276f9f4$export$ff983d2a2b6112ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $1LwQL;
    const $76470ef26276f9f4$export$ff983d2a2b6112ea = (0, ($parcel$interopDefault($5uXOq))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
        const [inViewRef, inView, target] = (0, (0, parcelRequire("1LwQL")).useInView)({
            threshold: 0
        });
        const observer = (0, ($parcel$interopDefault($5uXOq))).useRef(()=>{
            if (typeof window === 'undefined') return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        });
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            target,
            inView,
            offscreen
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                display: 'block',
                width: '100%',
                position: 'absolute'
            },
            ref: inViewRef
        });
    });
});
parcelRegister("1LwQL", function(module, exports) {
    $parcel$export(module.exports, "useInView", ()=>$1dfb7d23cdbb03d0$export$2f62ee6831462844);
    var $5uXOq = parcelRequire("5uXOq");
    function $1dfb7d23cdbb03d0$export$2f62ee6831462844(options = {}) {
        const ref = (0, ($parcel$interopDefault($5uXOq))).useRef();
        const observerInstance = (0, ($parcel$interopDefault($5uXOq))).useRef();
        const [state, setState] = (0, ($parcel$interopDefault($5uXOq))).useState({
            inView: false,
            entry: undefined,
            target: undefined
        });
        const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
        const setRef = (0, ($parcel$interopDefault($5uXOq))).useCallback((node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        }, [
            threshold,
            root,
            rootMargin
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            return ()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        }, []);
        return [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
    }
});
parcelRegister("2bzBV", function(module, exports) {
    $parcel$export(module.exports, "OverflowProvider", ()=>$a09db1d7916aff70$export$a3a2def3937905a0);
    $parcel$export(module.exports, "useOverflowStatus", ()=>$a09db1d7916aff70$export$3fcfc71fab3314f2);
    $parcel$export(module.exports, "useOverflowController", ()=>$a09db1d7916aff70$export$705aa66a39c35bf7);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    var $eGmKJ;
    const $a09db1d7916aff70$var$THROTTLE_INTERVAL = 64;
    const $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH = 70;
    const $a09db1d7916aff70$var$calculateHash = (w, n)=>w + '#' + n;
    const $a09db1d7916aff70$var$updateHashRef = (currentRef, value)=>{
        currentRef.unshift(value);
        currentRef.length = 3;
    };
    const $a09db1d7916aff70$var$OverflowContext = (0, $5uXOq.createContext)({
        isVisible: true,
        openOverflowMenu: (0, (0, parcelRequire("eGmKJ")).default),
        closeOverflowMenu: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $a09db1d7916aff70$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
        const { Provider: Provider } = $a09db1d7916aff70$var$OverflowContext;
        const value = (0, $5uXOq.useMemo)(()=>({
                isVisible: isVisible,
                openOverflowMenu: openOverflowMenu,
                closeOverflowMenu: closeOverflowMenu
            }), [
            isVisible,
            openOverflowMenu,
            closeOverflowMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Provider, {
            value: value
        }, children);
    };
    const $a09db1d7916aff70$export$3fcfc71fab3314f2 = ()=>(0, $5uXOq.useContext)($a09db1d7916aff70$var$OverflowContext);
    const $a09db1d7916aff70$export$705aa66a39c35bf7 = (nodes)=>{
        const items = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(nodes);
        const [width, setWidth] = (0, $5uXOq.useState)(9999);
        const [itemsLimit, setItemsLimit] = (0, $5uXOq.useState)(items.length);
        const [forceEffectValue, triggerForceEffect] = (0, $5uXOq.useState)({});
        const itemsWidths = (0, $5uXOq.useRef)([]).current;
        const hashRef = (0, $5uXOq.useRef)([]);
        const throttleSetWidth = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))(setWidth, $a09db1d7916aff70$var$THROTTLE_INTERVAL), [
            setWidth
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const lastItemWidth = itemsWidths[itemsLimit] || 0;
            const wasJustLimited = lastItemWidth < 0;
            const currentHash = $a09db1d7916aff70$var$calculateHash(width, itemsLimit);
            if (hashRef.current[0] === currentHash) {
                const t = setTimeout(()=>{
                    $a09db1d7916aff70$var$updateHashRef(hashRef.current, '');
                    triggerForceEffect({});
                }, $a09db1d7916aff70$var$THROTTLE_INTERVAL * 1.5);
                return ()=>clearTimeout(t);
            }
            if (wasJustLimited) {
                const partialWidth = Math.max(Math.min(width + lastItemWidth, $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH * 2), $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH);
                itemsWidths[itemsLimit] = partialWidth;
            }
            if (width < $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
                const nextHash = $a09db1d7916aff70$var$calculateHash(width, itemsLimit - 1);
                if (hashRef.current.indexOf(nextHash) === -1) {
                    setItemsLimit(itemsLimit - 1);
                    itemsWidths[itemsLimit - 1] = -(width || 1);
                    $a09db1d7916aff70$var$updateHashRef(hashRef.current, nextHash);
                }
                return;
            }
            const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
            if (width - currentLastItemWidth > $a09db1d7916aff70$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
                const nextHash = $a09db1d7916aff70$var$calculateHash(width, itemsLimit + 1);
                if (hashRef.current.indexOf(nextHash) === -1) {
                    setItemsLimit(itemsLimit + 1);
                    $a09db1d7916aff70$var$updateHashRef(hashRef.current, nextHash);
                }
                return;
            }
        }, [
            width,
            hashRef,
            itemsLimit,
            itemsWidths,
            forceEffectValue,
            items.length
        ]);
        return {
            visibleItems: items.slice(0, itemsLimit),
            overflowItems: items.slice(itemsLimit),
            updateWidth: throttleSetWidth
        };
    };
    var $a09db1d7916aff70$export$2e2bcd8739ae039 = (props)=>{};
});
parcelRegister("7ownK", function(module, exports) {
    $parcel$export(module.exports, "PrimaryDropdownButton", ()=>$07ec44e10e1bbcf4$export$bb3af89fb196520d);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hORKG;
    var $c8Oei;
    var $VSDnB;
    var $711X2;
    const $07ec44e10e1bbcf4$export$bb3af89fb196520d = (0, $5uXOq.forwardRef)((props, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("711X2")).PrimaryButton), {
            iconAfter: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("hORKG"))))), {
                label: "",
                color: "currentColor"
            }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                LEGACY_margin: `0 ${"var(--ds-space-negative-050, -4px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
                color: "currentColor",
                label: ""
            }),
            ref: ref,
            ...props
        });
    });
    var $07ec44e10e1bbcf4$export$2e2bcd8739ae039 = $07ec44e10e1bbcf4$export$bb3af89fb196520d;
});
parcelRegister("711X2", function(module, exports) {
    $parcel$export(module.exports, "PrimaryButton", ()=>$52863ca42b4251a4$export$ac16a6a04d9b7c84);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9yOBd;
    var $3bDjY;
    var $gKAEK;
    var $d8hYi;
    function $52863ca42b4251a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $52863ca42b4251a4$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
    const $52863ca42b4251a4$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
    const $52863ca42b4251a4$var$buttonBaseStyles = {
        name: "8cx1fx",
        styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
    };
    const $52863ca42b4251a4$var$buttonHighlightedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&& > *': {
            color: `var(${$52863ca42b4251a4$var$VAR_BUTTON_SELECTED_COLOR})`
        },
        '&:after': {
            height: 3,
            position: 'absolute',
            backgroundColor: `var(${$52863ca42b4251a4$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
            borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
            borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
            content: '""',
            insetBlockEnd: 0,
            insetInlineEnd: "var(--ds-space-050, 4px)",
            insetInlineStart: "var(--ds-space-050, 4px)"
        }
    });
    const $52863ca42b4251a4$export$ac16a6a04d9b7c84 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, tooltip: tooltip, isSelected: isSelected, isHighlighted: isHighlighted, ...buttonProps } = props;
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const button = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                [$52863ca42b4251a4$var$VAR_BUTTON_SELECTED_COLOR]: theme.mode.primaryButton.selected.color,
                [$52863ca42b4251a4$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: theme.mode.primaryButton.selected.borderColor
            },
            css: [
                $52863ca42b4251a4$var$buttonBaseStyles,
                isHighlighted && $52863ca42b4251a4$var$buttonHighlightedStyles
            ],
            role: "listitem",
            "data-vc": "primary-button"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), {
            appearance: "primary",
            testId: testId,
            ref: ref,
            isSelected: isSelected,
            theme: (0, (0, parcelRequire("d8hYi")).getPrimaryButtonTheme)(theme),
            ...buttonProps
        }, children));
        if (tooltip) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip,
            hideTooltipOnClick: true
        }, button);
        return button;
    });
    var $52863ca42b4251a4$export$2e2bcd8739ae039 = $52863ca42b4251a4$export$ac16a6a04d9b7c84;
});
parcelRegister("gKAEK", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$c0c8fd8c606cf4da$export$93d4e7f90805808f);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBZh1;
    const $c0c8fd8c606cf4da$export$93d4e7f90805808f = ()=>(0, $5uXOq.useContext)((0, (0, parcelRequire("hBZh1")).ThemeContext));
});
parcelRegister("d8hYi", function(module, exports) {
    $parcel$export(module.exports, "getPrimaryButtonTheme", ()=>$655194713e502995$export$14dd6915caf431fe);
    const $655194713e502995$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...primaryButton.default,
                    ...props.isSelected && primaryButton.selected,
                    fontWeight: "var(--ds-font-weight-medium, 500)",
                    padding: `0 ${"var(--ds-space-050, 4px)"}`,
                    marginLeft: 0,
                    marginRight: 0,
                    ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                    ':focus': primaryButton.focus,
                    '&&': {
                        ...props.state === 'active' && primaryButton.active
                    }
                },
                spinnerStyles: spinnerStyles
            };
        };
});
parcelRegister("6q3np", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4ac7ca4c7140a0af$var$_react = $4ac7ca4c7140a0af$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4ac7ca4c7140a0af$var$_UNSAFE_baseNew = $4ac7ca4c7140a0af$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $4ac7ca4c7140a0af$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4ac7ca4c7140a0af$var$LogOutIcon = (props)=>$4ac7ca4c7140a0af$var$_react.default.createElement($4ac7ca4c7140a0af$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 1.75H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h5M14.25 8H6m4.75-3.5 3.5 3.5-3.5 3.5"/>`
        }, props));
    $4ac7ca4c7140a0af$var$LogOutIcon.displayName = 'LogOutIcon';
    var $4ac7ca4c7140a0af$var$_default = module.exports.default = $4ac7ca4c7140a0af$var$LogOutIcon;
});
parcelRegister("k2tiP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e96ab9793163191d$var$_react = $e96ab9793163191d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e96ab9793163191d$var$_settings = $e96ab9793163191d$var$_interopRequireDefault((parcelRequire("epOG5")));
    var $e96ab9793163191d$var$_settings2 = $e96ab9793163191d$var$_interopRequireDefault((parcelRequire("lzUP9")));
    function $e96ab9793163191d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e96ab9793163191d$var$SettingsIcon = (props)=>$e96ab9793163191d$var$_react.default.createElement($e96ab9793163191d$var$_settings.default, Object.assign({
            LEGACY_fallbackIcon: $e96ab9793163191d$var$_settings2.default
        }, props));
    $e96ab9793163191d$var$SettingsIcon.Name = 'SettingsIconMigration';
    var $e96ab9793163191d$var$_default = module.exports.default = $e96ab9793163191d$var$SettingsIcon;
});
parcelRegister("bxqXD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e95afbc1e679aeb6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $e95afbc1e679aeb6$var$PeopleIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "currentColor",
            d: "M10.523 11.3a4.5 4.5 0 0 1 4.5 4.5v2.5a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2.5a4.5 4.5 0 0 1 4.5-4.5h3Zm6 0 .212.005a4.5 4.5 0 0 1 4.283 4.277l.005.218v2.5l-.005.15a2 2 0 0 1-1.838 1.844l-.157.006h-2l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h2v-2.5l-.005-.165a2.5 2.5 0 0 0-2.33-2.33l-.165-.005h-.5l-.116-.007a1 1 0 0 1 0-1.986l.116-.007h.5Zm-6 2h-3a2.5 2.5 0 0 0-2.5 2.5v2.5h8v-2.5a2.5 2.5 0 0 0-2.5-2.5Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm4.61.294a3.5 3.5 0 1 1 0 6.412 1 1 0 0 1 .694-1.872l.24.09a1.5 1.5 0 1 0 .012-2.852l-.252.094a1 1 0 0 1-.693-1.872ZM9.024 5.3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        }));
    const $e95afbc1e679aeb6$var$PeopleIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $e95afbc1e679aeb6$var$PeopleIconGlyph
        });
    var $e95afbc1e679aeb6$export$2e2bcd8739ae039 = $e95afbc1e679aeb6$var$PeopleIcon;
});
parcelRegister("dNE6G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$207169627fdfed4e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $207169627fdfed4e$var$PersonIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "currentColor",
            d: "M13.523 11.3a4.504 4.504 0 0 1 4.478 4.063l.017.218.005.219v2.5c0 .964-.685 1.78-1.66 1.966l-.165.025-.175.009h-8c-.964 0-1.78-.686-1.966-1.66l-.025-.166-.009-.174v-2.5a4.504 4.504 0 0 1 4.064-4.478l.217-.017.22-.005h3Zm0 2H10.55l-.165.003a2.5 2.5 0 0 0-2.356 2.332l-.006.165-.001 2.442.001.058 7.943.002.057-.002v-2.473l-.003-.165a2.5 2.5 0 0 0-2.332-2.357l-.165-.005Zm-1.5-10a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
        }));
    const $207169627fdfed4e$var$PersonIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $207169627fdfed4e$var$PersonIconGlyph
        });
    var $207169627fdfed4e$export$2e2bcd8739ae039 = $207169627fdfed4e$var$PersonIcon;
});
parcelRegister("d9wnW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b0fe4e7c205728d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $3b0fe4e7c205728d$var$SignOutIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "currentColor",
            d: "m6.023 4.3-.149.005A2 2 0 0 0 4.024 6.3v12l.005.15a2 2 0 0 0 1.994 1.85h5l.117-.007a1 1 0 0 0-.117-1.993h-5v-12h5l.117-.007a1 1 0 0 0-.117-1.993h-5Zm9.293 4.293a1 1 0 0 0-.083 1.32l.084.094 1.292 1.292H9.023a1 1 0 0 0-.125 1.993l.125.008 7.586-.001-1.293 1.294a1 1 0 0 0-.083 1.32l.084.094a1 1 0 0 0 1.32.083l.094-.083 2.974-2.975c.096-.09.175-.198.23-.32l.011-.028a.757.757 0 0 0 .031-.083l.008-.027a.767.767 0 0 0 .02-.08l.007-.042a.767.767 0 0 0 .011-.133v-.039c0-.024-.002-.05-.004-.074l.004.094a1 1 0 0 0-.022-.215l-.008-.031a.807.807 0 0 0-.021-.074l-.018-.046a.64.64 0 0 0-.025-.062l-.019-.035a.64.64 0 0 0-.049-.083.667.667 0 0 0-.047-.07l-.084-.093-3-2.998a1 1 0 0 0-1.414 0Z"
        }));
    const $3b0fe4e7c205728d$var$SignOutIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $3b0fe4e7c205728d$var$SignOutIconGlyph
        });
    var $3b0fe4e7c205728d$export$2e2bcd8739ae039 = $3b0fe4e7c205728d$var$SignOutIcon;
});
parcelRegister("7FST0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5966eff7ccf8ae58$var$_react = $5966eff7ccf8ae58$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5966eff7ccf8ae58$var$_personAvatar = $5966eff7ccf8ae58$var$_interopRequireDefault((parcelRequire("bdVbi")));
    var $5966eff7ccf8ae58$var$_userAvatarCircle = $5966eff7ccf8ae58$var$_interopRequireDefault((parcelRequire("iZZ4y")));
    function $5966eff7ccf8ae58$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5966eff7ccf8ae58$var$PersonAvatarIcon = (props)=>$5966eff7ccf8ae58$var$_react.default.createElement($5966eff7ccf8ae58$var$_personAvatar.default, Object.assign({
            LEGACY_fallbackIcon: $5966eff7ccf8ae58$var$_userAvatarCircle.default
        }, props));
    $5966eff7ccf8ae58$var$PersonAvatarIcon.Name = 'PersonAvatarIconMigration';
    var $5966eff7ccf8ae58$var$_default = module.exports.default = $5966eff7ccf8ae58$var$PersonAvatarIcon;
});
parcelRegister("a5n5E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f2ae0874fee50c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $j7LBE;
    var $kJpBP;
    var $VSDnB;
    var $28ffy;
    var $gbxMX;
    var $l7Q0F;
    var $6ERoD;
    var $6cAn5 = parcelRequire("6cAn5");
    const $2f2ae0874fee50c1$var$DropdownItemRadio = ({ children: children, defaultSelected: defaultSelected, testId: testId, id: id, title: title, description: description, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, (0, parcelRequire("eGmKJ")).default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, interactionName: interactionName, ...rest })=>{
        typeof $6cAn5;
        const [selected, setSelected] = (0, (0, parcelRequire("gbxMX")).default)({
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        });
        const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
            setSelected((selected)=>!selected);
            providedOnClick(event);
        }, [
            providedOnClick,
            setSelected
        ]);
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j7LBE")).SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            "aria-checked": selected,
            description: description,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("28ffy")).default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: (0, (0, parcelRequire("6ERoD")).default)() ? 'radio' : 'menuitemradio',
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            title: title,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children));
    };
    var $2f2ae0874fee50c1$export$2e2bcd8739ae039 = $2f2ae0874fee50c1$var$DropdownItemRadio;
});
parcelRegister("28ffy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$076dbb2cdd3c6ce4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV6Te;
    var $VSDnB;
    const $076dbb2cdd3c6ce4$var$RadioIcon = ({ checked: checked })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            size: "medium",
            primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
            secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : 'transparent'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "12",
            cy: "12",
            r: "7.5",
            fill: "currentColor",
            stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
            strokeWidth: "1"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "12",
            cy: "12",
            r: "3",
            fill: "inherit"
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            fill: "currentColor",
            cx: "12",
            cy: "12",
            r: "6",
            stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
            strokeWidth: 1
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            fill: "inherit",
            cx: "12",
            cy: "12",
            r: "2"
        }))));
    };
    var $076dbb2cdd3c6ce4$export$2e2bcd8739ae039 = $076dbb2cdd3c6ce4$var$RadioIcon;
});
parcelRegister("gbxMX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5135edb54d9cd4f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b2TJP;
    var $iY6id;
    var $1xPgO;
    function $5135edb54d9cd4f5$var$useRadioState({ id: id, isSelected: isSelected, defaultSelected: defaultSelected }) {
        const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iY6id")).SelectionStoreContext));
        const { id: group, radioGroupState: radioGroupState, selectRadioItem: selectRadioItem } = (0, $5uXOq.useContext)((0, (0, parcelRequire("b2TJP")).RadioGroupContext));
        const persistedIsSelected = radioGroupState[id];
        const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
        const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
            if (!persistedIsSelected) {
                const nextValue = newValue(persistedIsSelected);
                selectRadioItem(id, nextValue);
                setLocalIsSelected(nextValue);
            }
        }, [
            persistedIsSelected,
            id,
            selectRadioItem
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setLocalIsSelected(()=>{
                const existing = radioGroupState[id];
                return existing !== undefined ? existing : defaultSelected || false;
            });
        }, [
            radioGroupState,
            group,
            id,
            defaultSelected
        ]);
        if (typeof isSelected === 'boolean') return [
            isSelected,
            ()=>false
        ];
        if (persistedIsSelected === undefined) {
            const existing = getGroupState(group);
            setGroupState(group, {
                ...(0, (0, parcelRequire("1xPgO")).default)(existing || {}),
                [id]: defaultSelected || false
            });
        }
        return [
            localIsSelected,
            setLocalState
        ];
    }
    var $5135edb54d9cd4f5$export$2e2bcd8739ae039 = $5135edb54d9cd4f5$var$useRadioState;
});
parcelRegister("b2TJP", function(module, exports) {
    $parcel$export(module.exports, "RadioGroupContext", ()=>$414fcc0c0db30c2f$export$a79eda4ff50e30b6);
    $parcel$export(module.exports, "default", ()=>$414fcc0c0db30c2f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    var $iY6id;
    var $1xPgO;
    const $414fcc0c0db30c2f$export$a79eda4ff50e30b6 = (0, $5uXOq.createContext)({
        id: '',
        radioGroupState: {},
        selectRadioItem: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $414fcc0c0db30c2f$var$DropdownItemRadioGroup = ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, overrides: overrides, testId: testId, title: title, ...rest })=>{
        const { setGroupState: setGroupState, getGroupState: getGroupState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("iY6id")).SelectionStoreContext));
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-radio-group-title-${uid}`;
        const [radioGroupState, setRadioGroupState] = (0, $5uXOq.useState)(()=>getGroupState(id));
        const selectRadioItem = (childId, value)=>{
            const newValue = {
                ...(0, (0, parcelRequire("1xPgO")).default)(getGroupState(id)),
                [childId]: value
            };
            setRadioGroupState(newValue);
            setGroupState(id, newValue);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($414fcc0c0db30c2f$export$a79eda4ff50e30b6.Provider, {
            value: {
                id: id,
                radioGroupState: radioGroupState,
                selectRadioItem: selectRadioItem
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            overrides: overrides,
            testId: testId,
            titleId: title ? titleId : undefined,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children));
    };
    var $414fcc0c0db30c2f$export$2e2bcd8739ae039 = $414fcc0c0db30c2f$var$DropdownItemRadioGroup;
});
parcelRegister("1xPgO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2bae1dbc1eac2ebc$export$2e2bcd8739ae039);
    const $2bae1dbc1eac2ebc$var$resetOptionsInGroup = (group)=>{
        return Object.keys(group || {}).reduce((accumulator, current)=>({
                ...accumulator,
                [current]: typeof group[current] === 'undefined' ? undefined : false
            }), {});
    };
    var $2bae1dbc1eac2ebc$export$2e2bcd8739ae039 = $2bae1dbc1eac2ebc$var$resetOptionsInGroup;
});
parcelRegister("6ERoD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$343be4cd326415bb$export$2e2bcd8739ae039);
    const $343be4cd326415bb$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $343be4cd326415bb$var$isVoiceOverSupported = ()=>/Mac OS X/.test($343be4cd326415bb$var$canUseDOM() ? navigator.userAgent : '');
    var $343be4cd326415bb$export$2e2bcd8739ae039 = $343be4cd326415bb$var$isVoiceOverSupported;
});
parcelRegister("826f6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5d935a46a5831652$var$_react = $5d935a46a5831652$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5d935a46a5831652$var$_UNSAFE_baseNew = $5d935a46a5831652$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5d935a46a5831652$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5d935a46a5831652$var$ThemeIcon = (props)=>$5d935a46a5831652$var$_react.default.createElement($5d935a46a5831652$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M8 12.25a4.25 4.25 0 0 0 0-8.5z"/><path fill="currentcolor" fill-rule="evenodd" d="M12.25 8A4.25 4.25 0 0 1 8 12.25v-8.5A4.25 4.25 0 0 1 12.25 8" clip-rule="evenodd"/><path stroke="currentcolor" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Zm-3 0A4.25 4.25 0 0 1 8 12.25v-8.5A4.25 4.25 0 0 1 12.25 8Z"/>`
        }, props));
    $5d935a46a5831652$var$ThemeIcon.displayName = 'ThemeIcon';
    var $5d935a46a5831652$var$_default = module.exports.default = $5d935a46a5831652$var$ThemeIcon;
});
parcelRegister("hWZau", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d1174d32c3ea0a52$var$_react = $d1174d32c3ea0a52$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d1174d32c3ea0a52$var$_chevronRight = $d1174d32c3ea0a52$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $d1174d32c3ea0a52$var$_chevronRight2 = $d1174d32c3ea0a52$var$_interopRequireDefault((parcelRequire("ebd3R")));
    function $d1174d32c3ea0a52$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d1174d32c3ea0a52$var$ChevronRightIcon = (props)=>$d1174d32c3ea0a52$var$_react.default.createElement($d1174d32c3ea0a52$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $d1174d32c3ea0a52$var$_chevronRight2.default
        }, props));
    $d1174d32c3ea0a52$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $d1174d32c3ea0a52$var$_default = module.exports.default = $d1174d32c3ea0a52$var$ChevronRightIcon;
});
parcelRegister("ex8Nz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a15b1d3d61d052b6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $a15b1d3d61d052b6$var$ThemeIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 20V4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
            fill: "currentColor"
        }));
    const $a15b1d3d61d052b6$var$ThemeIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $a15b1d3d61d052b6$var$ThemeIconGlyph
        });
    var $a15b1d3d61d052b6$export$2e2bcd8739ae039 = $a15b1d3d61d052b6$var$ThemeIcon;
});
parcelRegister("8Pko5", function(module, exports) {
    $parcel$export(module.exports, "Profile", ()=>$845b77966dafc84c$export$5120f2d0b8d4cab8);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Onh2;
    const $845b77966dafc84c$export$5120f2d0b8d4cab8 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { label: labelProp, tooltip: tooltip } = props;
        const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "listitem"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Onh2")).IconButton), {
            label: label,
            ref: ref,
            ...props
        }));
    });
    var $845b77966dafc84c$export$2e2bcd8739ae039 = (props)=>{};
});
parcelRegister("7Onh2", function(module, exports) {
    $parcel$export(module.exports, "IconButton", ()=>$0f6c597d56619c44$export$c25acd513dcc8062);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yOBd;
    var $3bDjY;
    var $gKAEK;
    var $2MeWs;
    const $0f6c597d56619c44$export$c25acd513dcc8062 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { icon: icon, label: label, testId: testId, tooltip: tooltip, ...buttonProps } = props;
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const button = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            appearance: "primary",
            "aria-label": label,
            testId: testId,
            iconBefore: icon,
            ref: ref,
            theme: (0, (0, parcelRequire("2MeWs")).getIconButtonTheme)(theme),
            ...buttonProps
        });
        if (tooltip) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip,
            hideTooltipOnClick: true
        }, button);
        return button;
    });
});
parcelRegister("2MeWs", function(module, exports) {
    $parcel$export(module.exports, "getIconButtonTheme", ()=>$067a1b7a48c81cf7$export$f32bddcb857301f3);
    const $067a1b7a48c81cf7$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    borderRadius: "var(--ds-border-radius-circle, 100%)",
                    display: 'flex',
                    margin: `0 ${"var(--ds-space-025, 2px)"}`,
                    padding: "var(--ds-space-050, 4px)",
                    height: 'auto',
                    fontWeight: "var(--ds-font-weight-medium, 500)",
                    ...iconButton.default,
                    ':hover': iconButton.hover,
                    ':focus': iconButton.focus,
                    '&&': {
                        ...props.state === 'active' && iconButton.active
                    },
                    ...props.state === 'selected' && iconButton.selected,
                    '> span': {
                        margin: 0
                    }
                },
                spinnerStyles: spinnerStyles
            };
        };
});
parcelRegister("5Fk4Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00a6b48fc5d47e1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $LnCko;
    var $imZsD;
    const $00a6b48fc5d47e1d$var$SpotlightTarget = ({ children: children, name: name })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imZsD")).TargetConsumer), null, (targetRef)=>targetRef ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("LnCko")).default), {
                name: name,
                hasNodeResolver: !(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_onboarding_noderesolve'),
                targetRef: targetRef
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)) : children);
    var $00a6b48fc5d47e1d$export$2e2bcd8739ae039 = $00a6b48fc5d47e1d$var$SpotlightTarget;
});
parcelRegister("LnCko", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76b01a6bc446afce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dI393 = parcelRequire("dI393");
    function $76b01a6bc446afce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $76b01a6bc446afce$var$spanStyles = {
        name: "49aokf",
        styles: "display:contents"
    };
    const $76b01a6bc446afce$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, targetRef: targetRef, name: name })=>{
        const divRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!hasNodeResolver) targetRef(name)(divRef.current?.firstElementChild);
            return ()=>{
                !hasNodeResolver && targetRef(name)(undefined);
            };
        }, [
            hasNodeResolver,
            name,
            targetRef
        ]);
        if (hasNodeResolver) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($dI393))), {
            innerRef: targetRef(name)
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ref: divRef,
            css: $76b01a6bc446afce$var$spanStyles
        }, children);
    };
    var $76b01a6bc446afce$export$2e2bcd8739ae039 = $76b01a6bc446afce$var$NodeResolverSpotlightTarget;
});
parcelRegister("1ZDWg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $173a77f26aba4973$var$_react = $173a77f26aba4973$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $173a77f26aba4973$var$_UNSAFE_baseNew = $173a77f26aba4973$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $173a77f26aba4973$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $173a77f26aba4973$var$AppsIcon = (props)=>$173a77f26aba4973$var$_react.default.createElement($173a77f26aba4973$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12 9v6m-3-3h6M3 14.25h2c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Zm8-8h2c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25h-2c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Zm-8 0h2c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $173a77f26aba4973$var$AppsIcon.displayName = 'AppsIcon';
    var $173a77f26aba4973$var$_default = module.exports.default = $173a77f26aba4973$var$AppsIcon;
});
parcelRegister("dXQDI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a2a99e2d5e8e6c58$var$_react = $a2a99e2d5e8e6c58$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a2a99e2d5e8e6c58$var$_UNSAFE_baseNew = $a2a99e2d5e8e6c58$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a2a99e2d5e8e6c58$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a2a99e2d5e8e6c58$var$ProjectIcon = (props)=>$a2a99e2d5e8e6c58$var$_react.default.createElement($a2a99e2d5e8e6c58$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.25 10.25 3.5 8 1.25 5.75l.884-.884a1.25 1.25 0 0 1 .884-.366H7.25l2.384-2.384a1.25 1.25 0 0 1 .884-.366H13c.69 0 1.25.56 1.25 1.25v2.482c0 .332-.132.65-.366.884L11.5 8.75v4.232c0 .332-.132.65-.366.884l-.884.884L8 12.5l-2.25 2.25m-4.5 0 5-5"/><circle cx="11.375" cy="4.625" r="1.125" fill="currentcolor"/>`
        }, props));
    $a2a99e2d5e8e6c58$var$ProjectIcon.displayName = 'ProjectIcon';
    var $a2a99e2d5e8e6c58$var$_default = module.exports.default = $a2a99e2d5e8e6c58$var$ProjectIcon;
});
parcelRegister("c781K", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8d1c5d7d8bf36ee2$var$_react = $8d1c5d7d8bf36ee2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8d1c5d7d8bf36ee2$var$_UNSAFE_baseNew = $8d1c5d7d8bf36ee2$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8d1c5d7d8bf36ee2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8d1c5d7d8bf36ee2$var$TeamsIcon = (props)=>$8d1c5d7d8bf36ee2$var$_react.default.createElement($8d1c5d7d8bf36ee2$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M6 14.25H2c-.69 0-1.25-.56-1.25-1.25v-1.25a3 3 0 0 1 3-3h1.149a3 3 0 0 1 2.82 1.975l.563 1.55a3 3 0 0 0 2.82 1.975H14c.69 0 1.25-.56 1.25-1.25v-1.25a3 3 0 0 0-3-3H12c-1.625 0-2.125.25-2.125.25M6.25 4a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm8 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
        }, props));
    $8d1c5d7d8bf36ee2$var$TeamsIcon.displayName = 'TeamsIcon';
    var $8d1c5d7d8bf36ee2$var$_default = module.exports.default = $8d1c5d7d8bf36ee2$var$TeamsIcon;
});
parcelRegister("c4wuJ", function(module, exports) {
    $parcel$export(module.exports, "HomeActionsElement", ()=>$e31dc6e30458fc76$export$4128169e0878a41d);
    $parcel$export(module.exports, "HomeActionsAttachRef", ()=>$e31dc6e30458fc76$export$762fcfeaa67873eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $e31dc6e30458fc76$export$4128169e0878a41d = (0, $5uXOq.createContext)(null);
    const $e31dc6e30458fc76$export$762fcfeaa67873eb = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
});
parcelRegister("Ee6JC", function(module, exports) {
    $parcel$export(module.exports, "IconButton", ()=>$57458b64a0b37d0d$export$c25acd513dcc8062);
    $parcel$export(module.exports, "Button", ()=>$57458b64a0b37d0d$export$353f5b6fc5456de1);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $42CjB;
    var $krXdA;
    var $65VCl;
    var $7K1Hj;
    const $57458b64a0b37d0d$export$c25acd513dcc8062 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const hasCustomTheme = (0, (0, parcelRequire("7K1Hj")).useHasCustomTheme)();
        const Component = hasCustomTheme ? (0, (0, parcelRequire("65VCl")).ThemedIconButton) : (0, (0, parcelRequire("42CjB")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            ref: ref,
            ...props
        });
    });
    const $57458b64a0b37d0d$export$edad7fca51b767e1 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const hasCustomTheme = (0, (0, parcelRequire("7K1Hj")).useHasCustomTheme)();
        const Component = hasCustomTheme ? (0, (0, parcelRequire("65VCl")).ThemedLinkIconButton) : (0, (0, parcelRequire("krXdA")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            ref: ref,
            ...props
        });
    });
    const $57458b64a0b37d0d$export$353f5b6fc5456de1 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const hasCustomTheme = (0, (0, parcelRequire("7K1Hj")).useHasCustomTheme)();
        const Component = hasCustomTheme ? (0, (0, parcelRequire("65VCl")).ThemedButton) : (0, (0, parcelRequire("eCeGD")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            ref: ref,
            ...props
        });
    });
});
parcelRegister("krXdA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96efa4c9353641ec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $3bDjY;
    var $jVkxy;
    const $96efa4c9353641ec$var$LinkIconButtonBase = ({ 'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("jVkxy")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            icon: icon,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shape: shape,
            spacing: spacing,
            testId: testId
        });
        if (!isTooltipDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltip?.content ?? label,
            testId: tooltip?.testId,
            position: tooltip?.position,
            delay: tooltip?.delay,
            onShow: tooltip?.onShow,
            onHide: tooltip?.onHide,
            mousePosition: tooltip?.mousePosition,
            analyticsContext: tooltip?.analyticsContext,
            strategy: tooltip?.strategy,
            tag: tooltip?.tag,
            truncate: tooltip?.truncate,
            component: tooltip?.component,
            hideTooltipOnClick: tooltip?.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
            ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents
        }, (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
                ...saferRest,
                "aria-labelledby": baseProps['aria-labelledby'],
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                onClick: (event, analyticsEvent)=>{
                    baseProps?.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (ref)=>{
                    baseProps.ref(ref);
                    triggerProps?.ref?.(ref);
                },
                xcss: baseProps.xcss,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture,
                href: baseProps.isDisabled ? undefined : href,
                role: baseProps.isDisabled ? 'link' : undefined,
                "aria-disabled": baseProps.isDisabled === true ? true : undefined
            }, baseProps.children));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            ...saferRest,
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName
        }, baseProps.children);
    };
    const $96efa4c9353641ec$var$WithRef = (0, $5uXOq.forwardRef)($96efa4c9353641ec$var$LinkIconButtonBase);
    const $96efa4c9353641ec$var$LinkIconButton = (0, $5uXOq.memo)($96efa4c9353641ec$var$WithRef);
    var $96efa4c9353641ec$export$2e2bcd8739ae039 = $96efa4c9353641ec$var$LinkIconButton;
});
parcelRegister("65VCl", function(module, exports) {
    $parcel$export(module.exports, "themedButtonBackground", ()=>$402ff993fb2a3bca$export$b93b81aa41a8061a);
    $parcel$export(module.exports, "themedButtonBackgroundHovered", ()=>$402ff993fb2a3bca$export$96a2312c81489aa1);
    $parcel$export(module.exports, "themedButtonBackgroundPressed", ()=>$402ff993fb2a3bca$export$9db7a918ddfed23e);
    $parcel$export(module.exports, "themedButtonBorder", ()=>$402ff993fb2a3bca$export$2b00bded80635cbb);
    $parcel$export(module.exports, "themedButtonPrimaryText", ()=>$402ff993fb2a3bca$export$eca746d7c1a9cd6e);
    $parcel$export(module.exports, "themedButtonPrimaryBackground", ()=>$402ff993fb2a3bca$export$2c2bc298cddb8aca);
    $parcel$export(module.exports, "themedButtonPrimaryBackgroundHovered", ()=>$402ff993fb2a3bca$export$6b28e650669cd3c7);
    $parcel$export(module.exports, "themedButtonPrimaryBackgroundPressed", ()=>$402ff993fb2a3bca$export$1656be06aad539b9);
    $parcel$export(module.exports, "themedButtonSelectedText", ()=>$402ff993fb2a3bca$export$c26a897d419ef487);
    $parcel$export(module.exports, "themedButtonSelectedBackground", ()=>$402ff993fb2a3bca$export$4e50e625ccffdb13);
    $parcel$export(module.exports, "themedButtonSelectedBackgroundHovered", ()=>$402ff993fb2a3bca$export$55c84c90f36bda4d);
    $parcel$export(module.exports, "themedButtonSelectedBackgroundPressed", ()=>$402ff993fb2a3bca$export$c5c0213472126c08);
    $parcel$export(module.exports, "themedButtonSelectedBorder", ()=>$402ff993fb2a3bca$export$22928007ff541429);
    $parcel$export(module.exports, "themedButtonDisabledText", ()=>$402ff993fb2a3bca$export$787ad93d0f2276af);
    $parcel$export(module.exports, "themedButtonDisabledBackground", ()=>$402ff993fb2a3bca$export$5e774f44b77335d6);
    $parcel$export(module.exports, "ThemedButton", ()=>$402ff993fb2a3bca$export$f67fb575035cc7d0);
    $parcel$export(module.exports, "ThemedIconButton", ()=>$402ff993fb2a3bca$export$d9c2d067feb61447);
    $parcel$export(module.exports, "ThemedLinkIconButton", ()=>$402ff993fb2a3bca$export$a1ab08e79d264ec8);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $DEWI6;
    var $5JjdN;
    var $jhmo0;
    var $5ILhZ;
    var $3bDjY;
    var $jldZL;
    function $402ff993fb2a3bca$var$getPrimitiveSpreadProps({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
        return props;
    }
    const $402ff993fb2a3bca$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
    const $402ff993fb2a3bca$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
    const $402ff993fb2a3bca$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
    const $402ff993fb2a3bca$export$2b00bded80635cbb = '--ds-top-bar-button-border';
    const $402ff993fb2a3bca$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
    const $402ff993fb2a3bca$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
    const $402ff993fb2a3bca$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
    const $402ff993fb2a3bca$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
    const $402ff993fb2a3bca$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
    const $402ff993fb2a3bca$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
    const $402ff993fb2a3bca$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
    const $402ff993fb2a3bca$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
    const $402ff993fb2a3bca$export$22928007ff541429 = '--ds-top-bar-button-selected-border';
    const $402ff993fb2a3bca$export$787ad93d0f2276af = '--ds-top-bar-button-disabled-text';
    const $402ff993fb2a3bca$export$5e774f44b77335d6 = '--ds-top-bar-button-disabled-background';
    const $402ff993fb2a3bca$var$styles = {
        root: "_1e0c1txw _zulp12x7 _4cvr1h6o _1bah1h6o _11c81oud _4t3i5r7u _2rkosqtm _v5649dqc _1rjcze3t _kqswh2mm",
        border: "_aetrb3bt _14mj1kw7 _1tv3nqa1 _39yqe4h9 _18postnw _9v7aze3t",
        selected: "_syazw5ct _11q71qds _8l3m15jn _1053w5ct _30l3w5ct _19lcjrv1 _9h8hw5ct _j6xtnh62",
        disabled: "_syaz1i3i _11q71c9b _8l3m3acm _10531i3i _30l31i3i _19lc1c9b _9h8h1i3i _j6xt1c9b"
    };
    const $402ff993fb2a3bca$var$shapeStyles = {
        default: "_18zrutpp",
        square: "_1bsb5r7u _18zrze3t _vwz4idpf"
    };
    const $402ff993fb2a3bca$var$appearanceStyles = {
        default: "_syaz1r31 _11q7pkxg _8l3maykr _10531r31 _30l31r31 _19lc1rps _9h8h1r31 _j6xtqtgh",
        subtle: "_syaz1r31 _11q7pkxg _10531r31 _30l31r31 _19lc1rps _9h8h1r31 _j6xtqtgh",
        primary: "_syaz15o7 _11q7esko _105315o7 _30l315o7 _19lcp6hf _9h8h15o7 _j6xt5sko"
    };
    const $402ff993fb2a3bca$var$forwardRefWithGeneric = (0, $5uXOq.forwardRef);
    const $402ff993fb2a3bca$var$ThemedPressable = (0, $5uXOq.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
        const hasBorder = appearance === 'default' || isSelected;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ...$402ff993fb2a3bca$var$getPrimitiveSpreadProps(props),
            ref: ref,
            type: "button",
            xcss: (0, (0, parcelRequire("DEWI6")).cx)($402ff993fb2a3bca$var$styles.root, $402ff993fb2a3bca$var$shapeStyles[shape], hasBorder && $402ff993fb2a3bca$var$styles.border, $402ff993fb2a3bca$var$appearanceStyles[appearance], isSelected && $402ff993fb2a3bca$var$styles.selected, isDisabled && $402ff993fb2a3bca$var$styles.disabled),
            isDisabled: isDisabled
        });
    });
    const $402ff993fb2a3bca$var$ThemedAnchor = $402ff993fb2a3bca$var$forwardRefWithGeneric(function ThemedAnchor({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
        const hasBorder = appearance === 'default' || isSelected;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            ...$402ff993fb2a3bca$var$getPrimitiveSpreadProps(props),
            ref: ref,
            xcss: (0, (0, parcelRequire("DEWI6")).cx)($402ff993fb2a3bca$var$styles.root, $402ff993fb2a3bca$var$shapeStyles[shape], hasBorder && $402ff993fb2a3bca$var$styles.border, $402ff993fb2a3bca$var$appearanceStyles[appearance], isSelected && $402ff993fb2a3bca$var$styles.selected, isDisabled && $402ff993fb2a3bca$var$styles.disabled)
        });
    });
    const $402ff993fb2a3bca$var$textButtonStyles = {
        iconBefore: "_vwz4idpf",
        text: "_k48p1wq8"
    };
    const $402ff993fb2a3bca$export$f67fb575035cc7d0 = (0, $5uXOq.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement($402ff993fb2a3bca$var$ThemedPressable, {
            ...props,
            ref: ref
        }, IconBefore && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $402ff993fb2a3bca$var$textButtonStyles.iconBefore
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(IconBefore, {
            label: "",
            color: "currentColor"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $402ff993fb2a3bca$var$textButtonStyles.text
            ])
        }, children));
    });
    const $402ff993fb2a3bca$export$d9c2d067feb61447 = (0, $5uXOq.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            ...tooltip,
            content: tooltip?.content ?? label
        }, (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement($402ff993fb2a3bca$var$ThemedPressable, {
                ...props,
                shape: "square",
                ref: (0, (0, parcelRequire("5JjdN")).default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                label: "",
                color: "currentColor"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, label)));
    });
    const $402ff993fb2a3bca$export$a1ab08e79d264ec8 = $402ff993fb2a3bca$var$forwardRefWithGeneric(function ThemedLinkIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            ...tooltip,
            content: tooltip?.content ?? label
        }, (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement($402ff993fb2a3bca$var$ThemedAnchor, {
                ...props,
                shape: "square",
                ref: (0, (0, parcelRequire("5JjdN")).default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                label: "",
                color: "currentColor"
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jldZL")).default), null, label)));
    });
});
parcelRegister("7K1Hj", function(module, exports) {
    $parcel$export(module.exports, "HasCustomThemeContext", ()=>$661b09480c788004$export$d158fa15757a1890);
    $parcel$export(module.exports, "useHasCustomTheme", ()=>$661b09480c788004$export$abfcaeeca4ae7a55);
    var $5uXOq = parcelRequire("5uXOq");
    const $661b09480c788004$export$d158fa15757a1890 = (0, $5uXOq.createContext)(false);
    function $661b09480c788004$export$abfcaeeca4ae7a55() {
        return (0, $5uXOq.useContext)($661b09480c788004$export$d158fa15757a1890);
    }
});
parcelRegister("eZOeM", function(module, exports) {
    $parcel$export(module.exports, "SideNavToggleButtonElement", ()=>$42ecc156c1fc66f0$export$9c1768094bef896);
    $parcel$export(module.exports, "SideNavToggleButtonAttachRef", ()=>$42ecc156c1fc66f0$export$fb8fa9a80240785e);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $42ecc156c1fc66f0$export$9c1768094bef896 = (0, $5uXOq.createContext)(null);
    const $42ecc156c1fc66f0$export$fb8fa9a80240785e = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
});
parcelRegister("ecbZX", function(module, exports) {
    $parcel$export(module.exports, "useSideNavVisibility", ()=>$251628ab22f05abd$export$4a602ad7e09bdb2c);
    var $5uXOq = parcelRequire("5uXOq");
    var $b0CFU;
    const $251628ab22f05abd$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
        const visibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SideNavDesktopVisibility));
        const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavDesktopVisibility));
        const visibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SideNavMobileVisibility));
        const setVisibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavMobileVisibility));
        return {
            visibleOnDesktop: visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop,
            visibleOnMobile: visibleOnMobile,
            setVisibleOnDesktop: setVisibleOnDesktop,
            setVisibleOnMobile: setVisibleOnMobile
        };
    };
});
parcelRegister("b0CFU", function(module, exports) {
    $parcel$export(module.exports, "SideNavDesktopVisibility", ()=>$4ad787a6949993a9$export$1771e3b63861d206);
    $parcel$export(module.exports, "SideNavMobileVisibility", ()=>$4ad787a6949993a9$export$c5f483eeea865395);
    $parcel$export(module.exports, "SetSideNavDesktopVisibility", ()=>$4ad787a6949993a9$export$5edca135c5bde4af);
    $parcel$export(module.exports, "SetSideNavMobileVisibility", ()=>$4ad787a6949993a9$export$64be6ca751606276);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $4ad787a6949993a9$export$1771e3b63861d206 = (0, $5uXOq.createContext)(null);
    const $4ad787a6949993a9$export$c5f483eeea865395 = (0, $5uXOq.createContext)(false);
    const $4ad787a6949993a9$export$5edca135c5bde4af = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
    const $4ad787a6949993a9$export$64be6ca751606276 = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
});
parcelRegister("6qnkT", function(module, exports) {
    $parcel$export(module.exports, "useToggleSideNav", ()=>$0e2ff6e3f286dc0d$export$477ee35601a0a8ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $b0CFU;
    function $0e2ff6e3f286dc0d$export$477ee35601a0a8ce() {
        const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavDesktopVisibility));
        const setVisibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("b0CFU")).SetSideNavMobileVisibility));
        const toggleSideNav = (0, $5uXOq.useCallback)(()=>{
            const { matches: matches } = window.matchMedia('(min-width: 64rem)');
            if (matches) setVisibleOnDesktop((prev)=>!prev);
            else setVisibleOnMobile((prev)=>!prev);
        }, [
            setVisibleOnDesktop,
            setVisibleOnMobile
        ]);
        return toggleSideNav;
    }
});
parcelRegister("34gGM", function(module, exports) {
    $parcel$export(module.exports, "JiraProductDiscoveryIcon", ()=>$2494f88679192657$export$21bfbeb62fdcce8d);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $2494f88679192657$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
    };
    const $2494f88679192657$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $2494f88679192657$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("bOVbW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $89b0ba45464c36f9$var$_react = $89b0ba45464c36f9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $89b0ba45464c36f9$var$_UNSAFE_baseNew = $89b0ba45464c36f9$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $89b0ba45464c36f9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $89b0ba45464c36f9$var$EditionsIcon = (props)=>$89b0ba45464c36f9$var$_react.default.createElement($89b0ba45464c36f9$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m5.25 5.75 1.25-4m-1.25 4h5.5m-5.5 0H1m4.25 0L7.92 14h.16l2.67-8.25m-4.25-4H3.25l-2.5 4L8 14.25l7.25-8.5-2.5-4H9.5m-3 0h3m1.25 4-1.25-4m1.25 4h4.125"/>`
        }, props));
    $89b0ba45464c36f9$var$EditionsIcon.displayName = 'EditionsIcon';
    var $89b0ba45464c36f9$var$_default = module.exports.default = $89b0ba45464c36f9$var$EditionsIcon;
});
parcelRegister("i7S2n", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d322cc20711ec758$var$_react = $d322cc20711ec758$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d322cc20711ec758$var$_creditCard = $d322cc20711ec758$var$_interopRequireDefault((parcelRequire("yJt0Y")));
    var $d322cc20711ec758$var$_creditcardFilled = $d322cc20711ec758$var$_interopRequireDefault((parcelRequire("kbAiU")));
    function $d322cc20711ec758$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d322cc20711ec758$var$CreditCardIcon = (props)=>$d322cc20711ec758$var$_react.default.createElement($d322cc20711ec758$var$_creditCard.default, Object.assign({
            LEGACY_fallbackIcon: $d322cc20711ec758$var$_creditcardFilled.default
        }, props));
    $d322cc20711ec758$var$CreditCardIcon.Name = 'CreditCardIconMigration';
    var $d322cc20711ec758$var$_default = module.exports.default = $d322cc20711ec758$var$CreditCardIcon;
});
parcelRegister("bZC6Q", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8bb2f3f40a6108ea$var$_react = $8bb2f3f40a6108ea$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8bb2f3f40a6108ea$var$_UNSAFE_baseNew = $8bb2f3f40a6108ea$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8bb2f3f40a6108ea$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8bb2f3f40a6108ea$var$WarningIcon = (props)=>$8bb2f3f40a6108ea$var$_react.default.createElement($8bb2f3f40a6108ea$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.702 9.137A1.25 1.25 0 0 1 10.612 11H1.388a1.25 1.25 0 0 1-1.09-1.863l4.614-8.2a1.25 1.25 0 0 1 2.178 0zM6.75 2.75V6.5h-1.5V2.75zm-.75 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $8bb2f3f40a6108ea$var$WarningIcon.displayName = 'WarningIcon';
    var $8bb2f3f40a6108ea$var$_default = module.exports.default = $8bb2f3f40a6108ea$var$WarningIcon;
});
parcelRegister("fxNl3", function(module, exports) {
    $parcel$export(module.exports, "JiraProductDiscoveryLogo", ()=>$b429ec418bceed55$export$c49a2b642fe9eef4);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $b429ec418bceed55$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor,
            textColor: textColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
    };
    const $b429ec418bceed55$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: $b429ec418bceed55$var$svg({
                appearance: appearance,
                iconColor: iconColor,
                textColor: textColor
            }, colorMode),
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("5qRwM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3e92bcc4cb7160f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $4NS88;
    var $hxoiH;
    function $b3e92bcc4cb7160f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b3e92bcc4cb7160f$var$baseImageStyles = {
        name: "1hyxgad",
        styles: "max-width:100%;height:auto"
    };
    const $b3e92bcc4cb7160f$var$themedImageStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        content: `url(var(--img-source))`,
        'html[data-color-mode=dark] &': {
            content: `var(--img-source-dark)`
        }
    });
    function $b3e92bcc4cb7160f$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, ...props }) {
        const imgRef = (0, $5uXOq.useRef)(null);
        const providedColorMode = (0, (0, parcelRequire("4NS88")).UNSAFE_useColorModeForMigration)();
        const { colorMode: observedColorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const colorMode = providedColorMode || observedColorMode;
        (0, $5uXOq.useEffect)(()=>{
            if (imgRef === null || imgRef.current === null) return;
            if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
            else if (src) imgRef.current.src = src;
        }, [
            src,
            srcDark,
            colorMode
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            alt: alt,
            "data-testid": testId,
            src: src,
            style: {
                '--img-source': src,
                '--img-source-dark': srcDark || src
            },
            css: [
                $b3e92bcc4cb7160f$var$baseImageStyles,
                $b3e92bcc4cb7160f$var$themedImageStyles
            ],
            ref: imgRef,
            ...props
        });
    }
});
parcelRegister("4NS88", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_useColorModeForMigration", ()=>$c865b9b4a27ce99e$export$ce91654eb9fea460);
    $parcel$export(module.exports, "useColorMode", ()=>$c865b9b4a27ce99e$export$20f3076712c8dfa);
    $parcel$export(module.exports, "default", ()=>$c865b9b4a27ce99e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $9NXG8;
    const $c865b9b4a27ce99e$var$defaultThemeSettings = {
        dark: 'dark',
        light: 'light',
        spacing: 'spacing'
    };
    const $c865b9b4a27ce99e$var$ColorModeContext = (0, $5uXOq.createContext)(undefined);
    const $c865b9b4a27ce99e$var$SetColorModeContext = (0, $5uXOq.createContext)(undefined);
    const $c865b9b4a27ce99e$var$ThemeContext = (0, $5uXOq.createContext)(undefined);
    const $c865b9b4a27ce99e$var$SetThemeContext = (0, $5uXOq.createContext)(undefined);
    function $c865b9b4a27ce99e$export$ce91654eb9fea460() {
        const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ColorModeContext);
        return value;
    }
    function $c865b9b4a27ce99e$export$20f3076712c8dfa() {
        const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ColorModeContext);
        if (!value) throw new Error('useColorMode must be used within AppProvider.');
        return value;
    }
    function $c865b9b4a27ce99e$export$e2afe7397c3d11c7() {
        const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$SetColorModeContext);
        if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
        return value;
    }
    function $c865b9b4a27ce99e$export$93d4e7f90805808f() {
        const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$ThemeContext);
        if (!value) throw new Error('useTheme must be used within AppProvider.');
        return value;
    }
    function $c865b9b4a27ce99e$export$501aa0dcd5527a48() {
        const value = (0, $5uXOq.useContext)($c865b9b4a27ce99e$var$SetThemeContext);
        if (!value) throw new Error('useSetTheme must be used within AppProvider.');
        return value;
    }
    const $c865b9b4a27ce99e$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
    const $c865b9b4a27ce99e$var$prefersDarkModeMql = $c865b9b4a27ce99e$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
    function $c865b9b4a27ce99e$var$getReconciledColorMode(colorMode) {
        if (colorMode === 'auto') return $c865b9b4a27ce99e$var$prefersDarkModeMql?.matches ? 'dark' : 'light';
        return colorMode;
    }
    function $c865b9b4a27ce99e$export$d8964aec282183a3({ children: children, defaultColorMode: defaultColorMode, defaultTheme: { dark: dark = 'dark', light: light = 'light', spacing: spacing = 'spacing', typography: typography, shape: shape } = $c865b9b4a27ce99e$var$defaultThemeSettings }) {
        const [chosenColorMode, setChosenColorMode] = (0, $5uXOq.useState)(defaultColorMode);
        const [reconciledColorMode, setReconciledColorMode] = (0, $5uXOq.useState)($c865b9b4a27ce99e$var$getReconciledColorMode(defaultColorMode));
        const [theme, setTheme] = (0, $5uXOq.useState)({
            dark: dark,
            light: light,
            spacing: spacing,
            typography: typography,
            shape: shape
        });
        const setColorMode = (0, $5uXOq.useCallback)((colorMode)=>{
            setChosenColorMode(colorMode);
            setReconciledColorMode($c865b9b4a27ce99e$var$getReconciledColorMode(colorMode));
        }, []);
        const setPartialTheme = (0, $5uXOq.useCallback)((nextTheme)=>{
            setTheme((theme)=>({
                    ...theme,
                    ...nextTheme
                }));
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("9NXG8")).default)({
                ...theme,
                colorMode: reconciledColorMode
            });
        }, [
            theme,
            reconciledColorMode
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!$c865b9b4a27ce99e$var$prefersDarkModeMql) return;
            const unbindListener = (0, (0, parcelRequire("cBeZP")).bind)($c865b9b4a27ce99e$var$prefersDarkModeMql, {
                type: 'change',
                listener: (event)=>{
                    if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
                }
            });
            return unbindListener;
        }, [
            chosenColorMode
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c865b9b4a27ce99e$var$ColorModeContext.Provider, {
            value: reconciledColorMode
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c865b9b4a27ce99e$var$SetColorModeContext.Provider, {
            value: setColorMode
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c865b9b4a27ce99e$var$ThemeContext.Provider, {
            value: theme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c865b9b4a27ce99e$var$SetThemeContext.Provider, {
            value: setPartialTheme
        }, children))));
    }
    var $c865b9b4a27ce99e$export$2e2bcd8739ae039 = $c865b9b4a27ce99e$export$d8964aec282183a3;
});
parcelRegister("kxZMz", function(module, exports) {
    $parcel$export(module.exports, "JiraServiceManagementLogo", ()=>$fa32ebd87a25ffa6$export$dabef2be6cd28c20);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $fa32ebd87a25ffa6$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor,
            textColor: textColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
    };
    const $fa32ebd87a25ffa6$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: $fa32ebd87a25ffa6$var$svg({
                appearance: appearance,
                iconColor: iconColor,
                textColor: textColor
            }, colorMode),
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("ijIzb", function(module, exports) {
    $parcel$export(module.exports, "JiraLogo", ()=>$3445978e5e6e1849$export$17d3acb0b4379d02);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $3445978e5e6e1849$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor,
            textColor: textColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
    };
    const $3445978e5e6e1849$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            iconColor: iconColor,
            size: size,
            svg: $3445978e5e6e1849$var$svg({
                appearance: appearance,
                iconColor: iconColor,
                textColor: textColor
            }, colorMode),
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("bgrar", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$caed9dac4f56dc1e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $55sHU;
    var $8CUq3;
    function $caed9dac4f56dc1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $caed9dac4f56dc1e$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
    const $caed9dac4f56dc1e$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
    const $caed9dac4f56dc1e$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
    const $caed9dac4f56dc1e$var$justifyContentMap = {
        start: {
            name: "j1lm6p",
            styles: "justify-content:start"
        },
        center: {
            name: "f7ay7b",
            styles: "justify-content:center"
        },
        end: {
            name: "jab4lt",
            styles: "justify-content:end"
        },
        'space-between': {
            name: "2o6p8u",
            styles: "justify-content:space-between"
        },
        'space-around': {
            name: "46cjum",
            styles: "justify-content:space-around"
        },
        'space-evenly': {
            name: "16166rn",
            styles: "justify-content:space-evenly"
        },
        stretch: {
            name: "11z2bqs",
            styles: "justify-content:stretch"
        }
    };
    const $caed9dac4f56dc1e$var$justifyItemsMap = {
        start: {
            name: "lno2ya",
            styles: "justify-items:start"
        },
        center: {
            name: "1wg53za",
            styles: "justify-items:center"
        },
        end: {
            name: "3f7lhf",
            styles: "justify-items:end"
        },
        stretch: {
            name: "16hnylu",
            styles: "justify-items:stretch"
        }
    };
    const $caed9dac4f56dc1e$var$alignContentMap = {
        start: {
            name: "iqu4as",
            styles: "align-content:start"
        },
        center: {
            name: "13vy23x",
            styles: "align-content:center"
        },
        end: {
            name: "1fj2toh",
            styles: "align-content:end"
        },
        'space-between': {
            name: "1pem0lx",
            styles: "align-content:space-between"
        },
        'space-around': {
            name: "127p7gk",
            styles: "align-content:space-around"
        },
        'space-evenly': {
            name: "kcqjal",
            styles: "align-content:space-evenly"
        },
        stretch: {
            name: "1f8yzab",
            styles: "align-content:stretch"
        }
    };
    const $caed9dac4f56dc1e$var$alignItemsMap = {
        start: {
            name: "yvwru5",
            styles: "align-items:start"
        },
        center: {
            name: "1h3rtzg",
            styles: "align-items:center"
        },
        baseline: {
            name: "fzr848",
            styles: "align-items:baseline"
        },
        end: {
            name: "uj5xqj",
            styles: "align-items:end"
        }
    };
    const $caed9dac4f56dc1e$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        boxSizing: 'border-box',
        gridTemplateAreas: `var(${$caed9dac4f56dc1e$var$gridTemplateAreasVar})`,
        gridTemplateColumns: `var(${$caed9dac4f56dc1e$var$gridTemplateColumnsVar})`,
        gridTemplateRows: `var(${$caed9dac4f56dc1e$var$gridTemplateRowsVar})`
    });
    const $caed9dac4f56dc1e$var$gridAutoFlowMap = {
        row: {
            name: "k3yepi",
            styles: "grid-auto-flow:row"
        },
        column: {
            name: "qu4z1d",
            styles: "grid-auto-flow:column"
        },
        dense: {
            name: "mgx7bc",
            styles: "grid-auto-flow:dense"
        },
        'row dense': {
            name: "1u50cee",
            styles: "grid-auto-flow:row dense"
        },
        'column dense': {
            name: "5ak4pc",
            styles: "grid-auto-flow:column dense"
        }
    };
    const $caed9dac4f56dc1e$var$Grid = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
        const Component = as || 'div';
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        const style = (0, $5uXOq.useMemo)(()=>({
                [$caed9dac4f56dc1e$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
                [$caed9dac4f56dc1e$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
                [$caed9dac4f56dc1e$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
            }), [
            gridTemplateAreas,
            gridTemplateColumns,
            gridTemplateRows
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
            id: id,
            role: role,
            style: style,
            className: resolvedStyles.static,
            css: [
                $caed9dac4f56dc1e$var$baseStyles,
                gap && (0, (0, parcelRequire("55sHU")).spaceStylesMap).gap[gap],
                columnGap && (0, (0, parcelRequire("55sHU")).spaceStylesMap).columnGap[columnGap],
                rowGap && (0, (0, parcelRequire("55sHU")).spaceStylesMap).rowGap[rowGap],
                alignItems && $caed9dac4f56dc1e$var$alignItemsMap[alignItems],
                alignContent && $caed9dac4f56dc1e$var$alignContentMap[alignContent],
                justifyContent && $caed9dac4f56dc1e$var$justifyContentMap[justifyContent],
                autoFlow && $caed9dac4f56dc1e$var$gridAutoFlowMap[autoFlow],
                resolvedStyles.emotion
            ],
            "data-testid": testId,
            ref: ref
        }, children);
    }));
    $caed9dac4f56dc1e$var$Grid.displayName = 'Grid';
    var $caed9dac4f56dc1e$export$2e2bcd8739ae039 = $caed9dac4f56dc1e$var$Grid;
});
parcelRegister("epnSS", function(module, exports) {
    $parcel$export(module.exports, "JiraServiceManagementIcon", ()=>$46071877c5367215$export$3c6158790f5e01c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $46071877c5367215$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
    };
    const $46071877c5367215$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $46071877c5367215$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("6R0Et", function(module, exports) {
    $parcel$export(module.exports, "SkeletonPrimaryButton", ()=>$9c211af0799e6e88$export$4a3049f952d3f130);
    var $f8Sb3;
    var $gKAEK;
    var $3mMDm;
    function $9c211af0799e6e88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR = '--primary-button-before-highlighted-background-color';
    const $9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR = '--primary-button-after-dropdown-border-color';
    const $9c211af0799e6e88$var$primaryButtonSkeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0 ${"var(--ds-space-075, 6px)"}`,
        padding: `0 ${"var(--ds-space-050, 4px)"}`,
        position: 'relative',
        appearance: 'none',
        border: 0,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        pointerEvents: 'none',
        ':focus, :active, :hover': {
            appearance: 'none',
            border: 0,
            outline: 0
        },
        '::-moz-focus-inner': {
            border: 0
        }
    });
    const $9c211af0799e6e88$var$isHighlightedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:before': {
            height: 3,
            position: 'absolute',
            backgroundColor: `var(${$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR})`,
            borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
            borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
            content: '""',
            insetBlockEnd: 0,
            insetInlineStart: "var(--ds-space-025, 2px)"
        }
    });
    const $9c211af0799e6e88$var$isHighlightedAndDropdownButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:before': {
            insetInlineEnd: -10
        }
    });
    const $9c211af0799e6e88$var$isHighlightedNotDropdownButtonStyles = {
        name: "1sue5tp",
        styles: "&:before{inset-inline-end:var(--ds-space-025, 2px);}"
    };
    const $9c211af0799e6e88$var$isDropdownButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginInlineEnd: 18,
        '&:after': {
            display: 'inline-block',
            width: 4,
            height: 4,
            position: 'absolute',
            borderBlockEnd: '2px solid',
            borderColor: `var(${$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR})`,
            borderInlineEnd: '2px solid',
            borderRadius: "var(--ds-border-radius-050, 1px)",
            content: '""',
            insetBlockStart: 'calc(50% - 4px)',
            insetInlineStart: 'calc(100% - 3px)',
            marginInlineStart: "var(--ds-space-050, 4px)",
            transform: 'rotate(45deg) scale(1.05)',
            verticalAlign: 'middle'
        }
    });
    const $9c211af0799e6e88$var$buttonWrapperStyles = {
        name: "rfxc55",
        styles: "display:flex;margin:0"
    };
    const $9c211af0799e6e88$export$4a3049f952d3f130 = ({ isDropdownButton: isDropdownButton = false, isHighlighted: isHighlighted = false, text: text, children: children, testId: testId })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const dynamicStyles = (0, (0, parcelRequire("3mMDm")).stripEmptyProperties)({
            ...primaryButton.default,
            ...isHighlighted && {
                color: primaryButton.selected.color
            },
            [$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_BEFORE_HIGHLIGHTED_BACKGROUND_COLOR]: primaryButton.selected.borderColor,
            [$9c211af0799e6e88$var$VAR_PRIMARY_BUTTON_AFTER_DROPDOWN_BORDER_COLOR]: isHighlighted ? primaryButton.default.borderColor : primaryButton.default.color
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "listitem",
            css: $9c211af0799e6e88$var$buttonWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            type: "button",
            style: dynamicStyles,
            css: [
                $9c211af0799e6e88$var$primaryButtonSkeletonStyles,
                isHighlighted && $9c211af0799e6e88$var$isHighlightedStyles,
                isDropdownButton && $9c211af0799e6e88$var$isDropdownButtonStyles,
                isHighlighted && (isDropdownButton ? $9c211af0799e6e88$var$isHighlightedAndDropdownButtonStyles : $9c211af0799e6e88$var$isHighlightedNotDropdownButtonStyles)
            ],
            "data-testid": testId
        }, text || children));
    };
});
parcelRegister("3mMDm", function(module, exports) {
    $parcel$export(module.exports, "stripEmptyProperties", ()=>$59fdda837c8257e3$export$e03bb5c7fd72635);
    function $59fdda837c8257e3$export$e03bb5c7fd72635(obj) {
        return Object.entries(obj).reduce((acc, [key, value])=>{
            if (value !== null && value !== undefined && value !== '') acc[key] = value;
            return acc;
        }, {});
    }
});
parcelRegister("eaGfl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e8a00667b2b14b7$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $cYuZM;
    var $eGmKJ;
    var $baKwq;
    function $5e8a00667b2b14b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5e8a00667b2b14b7$var$skeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingBlock: "var(--ds-space-0, 0px)",
        paddingInline: "var(--ds-space-200, 16px)",
        '::after': {
            display: 'block',
            width: '30%',
            height: "var(--ds-space-100, 8px)",
            backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`,
            borderRadius: 100,
            content: '""'
        }
    });
    const $5e8a00667b2b14b7$var$defaultWidthStyles = {
        name: "me8tg7",
        styles: "::after{width:30%;}"
    };
    const $5e8a00667b2b14b7$var$customWidthStyles = {
        name: "ms0ivw",
        styles: "::after{width:var(--width);}"
    };
    const $5e8a00667b2b14b7$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, cssFn: cssFn = (0, (0, parcelRequire("eGmKJ")).default) })=>{
        (0, (0, parcelRequire("cYuZM")).propDeprecationWarning)("platform-pkg", 'cssFn', cssFn !== (0, (0, parcelRequire("eGmKJ")).default), '');
        const UNSAFE_overrides = (0, (0, parcelRequire("f8Sb3")).css)(cssFn(undefined));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("baKwq")).default), {
            isShimmering: isShimmering
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                className: className,
                style: {
                    '--width': width
                },
                css: [
                    $5e8a00667b2b14b7$var$skeletonStyles,
                    width ? $5e8a00667b2b14b7$var$customWidthStyles : $5e8a00667b2b14b7$var$defaultWidthStyles,
                    UNSAFE_overrides
                ],
                "data-ds--menu--skeleton-heading-item": true,
                "data-testid": testId
            }));
    };
    var $5e8a00667b2b14b7$export$2e2bcd8739ae039 = $5e8a00667b2b14b7$var$SkeletonHeadingItem;
});
parcelRegister("vNVcd", function(module, exports) {
    $parcel$export(module.exports, "AppSwitcher", ()=>$a1d820a02703cd98$export$9923361bd43fa030);
    $parcel$export(module.exports, "AppSwitcherNav4", ()=>$a1d820a02703cd98$export$28833e0dfbd2ac80);
    var $5uXOq = parcelRequire("5uXOq");
    var $3fDjf;
    var $9sGJX;
    var $7Onh2;
    const $a1d820a02703cd98$export$9923361bd43fa030 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Onh2")).IconButton), {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9sGJX"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
            }),
            tooltip: tooltip,
            ref: ref,
            ...iconButtonProps
        });
    });
    const $a1d820a02703cd98$export$28833e0dfbd2ac80 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Onh2")).IconButton), {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3fDjf"))))), {
                label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
                color: "var(--ds-icon, #44546F)"
            }),
            tooltip: tooltip,
            ref: ref,
            ...iconButtonProps
        });
    });
    var $a1d820a02703cd98$export$2e2bcd8739ae039 = (props)=>{};
});
parcelRegister("9sGJX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6e37e1e25d776240$var$_react = $6e37e1e25d776240$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $6e37e1e25d776240$var$_appSwitcher = $6e37e1e25d776240$var$_interopRequireDefault((parcelRequire("3fDjf")));
    var $6e37e1e25d776240$var$_appSwitcher2 = $6e37e1e25d776240$var$_interopRequireDefault((parcelRequire("4PKNr")));
    function $6e37e1e25d776240$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6e37e1e25d776240$var$AppSwitcherIcon = (props)=>$6e37e1e25d776240$var$_react.default.createElement($6e37e1e25d776240$var$_appSwitcher.default, Object.assign({
            LEGACY_fallbackIcon: $6e37e1e25d776240$var$_appSwitcher2.default
        }, props));
    $6e37e1e25d776240$var$AppSwitcherIcon.Name = 'AppSwitcherIconMigration';
    var $6e37e1e25d776240$var$_default = module.exports.default = $6e37e1e25d776240$var$AppSwitcherIcon;
});
parcelRegister("3qye2", function(module, exports) {
    $parcel$export(module.exports, "SkeletonSwitcherButton", ()=>$cbbf4d27993dbc7a$export$41b1bb24b7702cc2);
    $parcel$export(module.exports, "Nav4SkeletonSwitcherButton", ()=>$cbbf4d27993dbc7a$export$68afc1d9d20a7bd8);
    var $f8Sb3;
    var $3fDjf;
    var $9sGJX;
    var $3XuTW;
    var $gKAEK;
    const $cbbf4d27993dbc7a$var$skeletonSwitcherButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: 0,
        marginRight: "var(--ds-space-050, 4px)",
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
        border: 0,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        pointerEvents: 'none',
        ':focus, :active, :hover': {
            appearance: 'none',
            border: 0,
            outline: 0
        },
        '&:only-of-type': {
            marginRight: 0
        },
        '& > span': {
            lineHeight: 'normal'
        },
        '& > img': {
            width: 24,
            height: 24,
            borderRadius: "var(--ds-border-radius-circle, 100%)",
            verticalAlign: 'middle'
        }
    });
    const $cbbf4d27993dbc7a$export$41b1bb24b7702cc2 = ({ label: label = '', testId: testId })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            style: theme.mode.iconButton.default,
            "data-testid": testId,
            css: $cbbf4d27993dbc7a$var$skeletonSwitcherButtonStyles,
            type: "button"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("9sGJX"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: label
        })));
    };
    const $cbbf4d27993dbc7a$export$68afc1d9d20a7bd8 = ({ label: label = '', testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3XuTW")).SkeletonIconButton), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("3fDjf"))))), {
            label: label,
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }));
});
parcelRegister("3XuTW", function(module, exports) {
    $parcel$export(module.exports, "SkeletonIconButton", ()=>$666894f166710a66$export$7b398af37f6177e);
    var $f8Sb3;
    var $gKAEK;
    function $666894f166710a66$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $666894f166710a66$var$skeletonIconButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: 0,
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`,
        border: 0,
        borderRadius: "var(--ds-border-radius-circle, 100%)",
        pointerEvents: 'none',
        ':focus, :active, :hover': {
            appearance: 'none',
            border: 0,
            outline: 0
        },
        '& > span': {
            lineHeight: 'normal'
        },
        '& > img': {
            width: 24,
            height: 24,
            borderRadius: "var(--ds-border-radius-circle, 100%)",
            verticalAlign: 'middle'
        }
    });
    const $666894f166710a66$var$buttonWrapperStyles = {
        name: "khzvr",
        styles: "margin-inline-end:var(--ds-space-050, 4px);&:only-of-type{margin-inline-end:0;}"
    };
    const $666894f166710a66$export$7b398af37f6177e = ({ children: children, testId: testId })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "listitem",
            css: $666894f166710a66$var$buttonWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            style: theme.mode.iconButton.default,
            "data-testid": testId,
            css: $666894f166710a66$var$skeletonIconButtonStyles,
            type: "button"
        }, children));
    };
});
parcelRegister("fL0AO", function(module, exports) {
    $parcel$export(module.exports, "AppSwitcher", ()=>$15d1a88fcd7214c3$export$9923361bd43fa030);
    var $5uXOq = parcelRequire("5uXOq");
    var $3fDjf;
    var $Ee6JC;
    const $15d1a88fcd7214c3$var$toggleButtonTooltipOptions = {
        ignoreTooltipPointerEvents: true
    };
    const $15d1a88fcd7214c3$export$9923361bd43fa030 = (0, $5uXOq.forwardRef)(({ label: label = 'App switcher', onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Ee6JC")).IconButton), {
            ref: ref,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("3fDjf"))))),
            label: label,
            appearance: "subtle",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            interactionName: interactionName,
            isTooltipDisabled: false,
            tooltip: $15d1a88fcd7214c3$var$toggleButtonTooltipOptions,
            isSelected: isSelected
        }));
});
parcelRegister("7paD5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $56431cfb6cb87beb$var$_react = $56431cfb6cb87beb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $56431cfb6cb87beb$var$_linkExternal = $56431cfb6cb87beb$var$_interopRequireDefault((parcelRequire("ggICg")));
    var $56431cfb6cb87beb$var$_shortcut = $56431cfb6cb87beb$var$_interopRequireDefault((parcelRequire("17Ngn")));
    function $56431cfb6cb87beb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $56431cfb6cb87beb$var$LinkExternalIcon = (props)=>$56431cfb6cb87beb$var$_react.default.createElement($56431cfb6cb87beb$var$_linkExternal.default, Object.assign({
            LEGACY_fallbackIcon: $56431cfb6cb87beb$var$_shortcut.default
        }, props));
    $56431cfb6cb87beb$var$LinkExternalIcon.Name = 'LinkExternalIconMigration';
    var $56431cfb6cb87beb$var$_default = module.exports.default = $56431cfb6cb87beb$var$LinkExternalIcon;
});
parcelRegister("dg0Fl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9a6d49390b09b82e$var$_react = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9a6d49390b09b82e$var$_questionCircle = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("8nk07")));
    var $9a6d49390b09b82e$var$_questionCircle2 = $9a6d49390b09b82e$var$_interopRequireDefault((parcelRequire("eJS47")));
    function $9a6d49390b09b82e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9a6d49390b09b82e$var$QuestionCircleIcon = (props)=>$9a6d49390b09b82e$var$_react.default.createElement($9a6d49390b09b82e$var$_questionCircle.default, Object.assign({
            LEGACY_fallbackIcon: $9a6d49390b09b82e$var$_questionCircle2.default
        }, props));
    $9a6d49390b09b82e$var$QuestionCircleIcon.Name = 'QuestionCircleIconMigration';
    var $9a6d49390b09b82e$var$_default = module.exports.default = $9a6d49390b09b82e$var$QuestionCircleIcon;
});
parcelRegister("26g7Y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1878a6eab82c2b68$var$_react = $1878a6eab82c2b68$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1878a6eab82c2b68$var$_search = $1878a6eab82c2b68$var$_interopRequireDefault((parcelRequire("hyOJh")));
    var $1878a6eab82c2b68$var$_search2 = $1878a6eab82c2b68$var$_interopRequireDefault((parcelRequire("tvuR8")));
    function $1878a6eab82c2b68$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1878a6eab82c2b68$var$SearchIcon = (props)=>$1878a6eab82c2b68$var$_react.default.createElement($1878a6eab82c2b68$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $1878a6eab82c2b68$var$_search2.default
        }, props));
    $1878a6eab82c2b68$var$SearchIcon.Name = 'SearchIconMigration';
    var $1878a6eab82c2b68$var$_default = module.exports.default = $1878a6eab82c2b68$var$SearchIcon;
});
parcelRegister("j9VTE", function(module, exports) {
    $parcel$export(module.exports, "NestedContext", ()=>$1d9622231f6b7781$export$46b2c2071c8c725a);
    $parcel$export(module.exports, "useNestedContext", ()=>$1d9622231f6b7781$export$f24166abe9ed712b);
    $parcel$export(module.exports, "useShouldNestedElementRender", ()=>$1d9622231f6b7781$export$37e8646a1abfc3e6);
    var $5uXOq = parcelRequire("5uXOq");
    const $1d9622231f6b7781$export$46b2c2071c8c725a = (0, $5uXOq.createContext)(undefined);
    const $1d9622231f6b7781$export$f24166abe9ed712b = ()=>{
        const context = (0, $5uXOq.useContext)($1d9622231f6b7781$export$46b2c2071c8c725a);
        if (!context) {
            let error = '';
            throw new Error(error);
        }
        return context;
    };
    const $1d9622231f6b7781$export$37e8646a1abfc3e6 = ()=>{
        const context = (0, $5uXOq.useContext)($1d9622231f6b7781$export$46b2c2071c8c725a);
        if (!context) return {
            shouldRender: true
        };
        return {
            shouldRender: context.currentStackId === context.parentId
        };
    };
});
parcelRegister("g6jiF", function(module, exports) {
    $parcel$export(module.exports, "Create", ()=>$f43287fd6bbef582$export$8ade6fcbf3a7de5d);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9yOBd;
    var $faod6;
    var $3bDjY;
    var $gKAEK;
    var $7Onh2;
    var $kN8y7;
    const $f43287fd6bbef582$var$wrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        alignItems: 'center',
        '& [data-hide-on-smallscreens]': {
            [`@media (max-width: ${(0, $8acc83d90e579622$export$24ec62cee78b7042) - 1}px)`]: {
                display: 'none !important'
            }
        },
        '& [data-hide-on-largescreens]': {
            [`@media (min-width: ${0, $8acc83d90e579622$export$24ec62cee78b7042}px)`]: {
                display: 'none !important'
            }
        },
        '&&': {
            marginInlineStart: "var(--ds-space-150, 12px)"
        }
    });
    const $f43287fd6bbef582$var$TooltipSwitch = ({ buttonTooltip: buttonTooltip, children: children })=>buttonTooltip ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: buttonTooltip,
            hideTooltipOnClick: true
        }, children) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, children);
    const $f43287fd6bbef582$export$8ade6fcbf3a7de5d = ({ onClick: onClick, href: href, text: text, buttonTooltip: buttonTooltip, iconButtonTooltip: iconButtonTooltip, testId: testId, label: label })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f43287fd6bbef582$var$wrapperStyles,
            role: "listitem",
            "data-testid": "create-button-wrapper"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($f43287fd6bbef582$var$TooltipSwitch, {
            buttonTooltip: buttonTooltip
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9yOBd")).default), {
            id: "createGlobalItem",
            "aria-label": label,
            onClick: onClick,
            href: href,
            theme: (0, (0, parcelRequire("kN8y7")).getCreateButtonTheme)(theme),
            testId: testId && `${testId}-button`,
            "data-hide-on-smallscreens": true
        }, text)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7Onh2")).IconButton), {
            id: "createGlobalItemIconButton",
            testId: testId && `${testId}-icon-button`,
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("faod6"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: text
            }),
            onClick: onClick,
            href: href,
            tooltip: iconButtonTooltip,
            theme: (0, (0, parcelRequire("kN8y7")).getCreateButtonTheme)(theme),
            "aria-label": text,
            "data-hide-on-largescreens": true
        }));
    };
    var $f43287fd6bbef582$export$2e2bcd8739ae039 = $f43287fd6bbef582$export$8ade6fcbf3a7de5d;
});
parcelRegister("faod6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b0aa91dd45a22c5b$var$_react = $b0aa91dd45a22c5b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b0aa91dd45a22c5b$var$_add = $b0aa91dd45a22c5b$var$_interopRequireDefault((parcelRequire("dZbEw")));
    var $b0aa91dd45a22c5b$var$_add2 = $b0aa91dd45a22c5b$var$_interopRequireDefault((parcelRequire("9lMrf")));
    function $b0aa91dd45a22c5b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b0aa91dd45a22c5b$var$AddIcon = (props)=>$b0aa91dd45a22c5b$var$_react.default.createElement($b0aa91dd45a22c5b$var$_add.default, Object.assign({
            LEGACY_fallbackIcon: $b0aa91dd45a22c5b$var$_add2.default
        }, props));
    $b0aa91dd45a22c5b$var$AddIcon.Name = 'AddIconMigration';
    var $b0aa91dd45a22c5b$var$_default = module.exports.default = $b0aa91dd45a22c5b$var$AddIcon;
});
parcelRegister("kN8y7", function(module, exports) {
    $parcel$export(module.exports, "getCreateButtonTheme", ()=>$adc5cd243919440f$export$256eebed8e934f30);
    const $adc5cd243919440f$export$256eebed8e934f30 = ({ mode: { create: create } })=>(current, props)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...create.default,
                    margin: 0,
                    fontWeight: "var(--ds-font-weight-medium, 500)",
                    ':hover': create.hover,
                    ':focus': create.focus,
                    '&&': {
                        ...props.state === 'active' && create.active
                    }
                },
                spinnerStyles: spinnerStyles
            };
        };
});
parcelRegister("83yN3", function(module, exports) {
    $parcel$export(module.exports, "SkeletonCreateButton", ()=>$a4ea4ac62a17ab73$export$e321b2260435e302);
    var $f8Sb3;
    var $gKAEK;
    function $a4ea4ac62a17ab73$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a4ea4ac62a17ab73$var$skeletonCreateButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: 32,
        padding: `0 ${"var(--ds-space-150, 12px)"}`,
        alignSelf: 'center',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        pointerEvents: 'none',
        ':focus, :active, :hover': {
            appearance: 'none',
            border: 0,
            outline: 0
        },
        '&&': {
            marginInlineStart: "var(--ds-space-150, 12px)"
        }
    });
    const $a4ea4ac62a17ab73$var$buttonWrapperStyles = {
        name: "rfxc55",
        styles: "display:flex;margin:0"
    };
    const $a4ea4ac62a17ab73$export$e321b2260435e302 = ({ text: text, testId: testId })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "listitem",
            css: $a4ea4ac62a17ab73$var$buttonWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            style: theme.mode.create.default,
            css: $a4ea4ac62a17ab73$var$skeletonCreateButtonStyles,
            "data-testid": testId,
            type: "button"
        }, text));
    };
});
parcelRegister("2tvF5", function(module, exports) {
    $parcel$export(module.exports, "CreateButton", ()=>$f2c2ffda8d778b24$export$6d3c345ce7c38fd9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZbEw;
    var $Ee6JC;
    const $f2c2ffda8d778b24$export$6d3c345ce7c38fd9 = ({ children: children, onClick: onClick, testId: testId, interactionName: interactionName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Ee6JC")).Button), {
            appearance: "primary",
            iconBefore: (0, ($parcel$interopDefault((0, parcelRequire("dZbEw"))))),
            onClick: onClick,
            testId: testId,
            interactionName: interactionName
        }, children);
});
parcelRegister("7FtaJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5952fdbb28afd899$var$_react = $5952fdbb28afd899$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5952fdbb28afd899$var$_UNSAFE_baseNew = $5952fdbb28afd899$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5952fdbb28afd899$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5952fdbb28afd899$var$StarStarredIcon = (props)=>$5952fdbb28afd899$var$_react.default.createElement($5952fdbb28afd899$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M6 8.917 2.597 11.25l1.07-3.986L.75 4.834l3.792-.292L6 .75l1.458 3.792 3.792.291-2.917 2.43 1.07 3.987z"/><path fill="currentcolor" d="m6 8.917.424-.619L6 8.008l-.424.29zM2.597 11.25l-.724-.194a.75.75 0 0 0 1.148.813zm1.07-3.986.724.194.124-.463-.368-.307zM.75 4.834l-.058-.748A.75.75 0 0 0 .27 5.41zm3.792-.292.057.747.473-.036.17-.442zM6 .75l.7-.27a.75.75 0 0 0-1.4 0zm1.458 3.792-.7.269.17.442.473.036zm3.792.291.48.577a.75.75 0 0 0-.423-1.324zm-2.917 2.43-.48-.575-.368.307.124.463zm1.07 3.987-.424.618a.75.75 0 0 0 1.148-.812zM5.576 8.298l-3.403 2.334.848 1.236 3.403-2.333zm-2.254 3.146L4.39 7.458 2.942 7.07l-1.07 3.986zm.825-4.756L1.23 4.258.27 5.41l2.917 2.43zM.807 5.58 4.6 5.29l-.115-1.495-3.792.292zm4.435-.77L6.7 1.019 5.3.481 3.842 4.272zM5.3 1.019l1.458 3.792 1.4-.539L6.7.481zm2.1 4.27 3.793.292.114-1.495-3.791-.292zm3.37-1.032-2.917 2.43.96 1.153 2.917-2.43zM7.609 7.458l1.07 3.986 1.448-.388-1.07-3.986zm2.218 3.174L6.424 8.298l-.848 1.237 3.403 2.333z"/>`,
            type: 'utility'
        }, props));
    $5952fdbb28afd899$var$StarStarredIcon.displayName = 'StarStarredIcon';
    var $5952fdbb28afd899$var$_default = module.exports.default = $5952fdbb28afd899$var$StarStarredIcon;
});
parcelRegister("4ZIaA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$046aa419aa6d0212$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    const $046aa419aa6d0212$var$bannerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: (0, (0, parcelRequire("22jFS")).BANNER_HEIGHT),
        gridArea: (0, (0, parcelRequire("22jFS")).BANNER)
    });
    const $046aa419aa6d0212$var$bannerFixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'fixed',
        zIndex: 2,
        insetBlockStart: 0,
        insetInlineEnd: (0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH),
        insetInlineStart: (0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)
    });
    const $046aa419aa6d0212$var$Banner = (props)=>{
        const { children: children, height: height = (0, (0, parcelRequire("22jFS")).DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
        const bannerHeight = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_BANNER_HEIGHT), height, shouldPersistHeight);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_BANNER_HEIGHT)]: bannerHeight
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_BANNER_HEIGHT)]: 0
                });
            };
        }, [
            bannerHeight
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $046aa419aa6d0212$var$bannerStyles,
                    isFixed && $046aa419aa6d0212$var$bannerFixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('banner')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_BANNER_HEIGHT),
                value: bannerHeight
            }), children));
    };
    var $046aa419aa6d0212$export$2e2bcd8739ae039 = $046aa419aa6d0212$var$Banner;
});
parcelRegister("8XpIo", function(module, exports) {
    $parcel$export(module.exports, "mergeGridStateIntoStorage", ()=>$45f0612699d6a600$export$f8355a2df0f4a946);
    $parcel$export(module.exports, "getGridStateFromStorage", ()=>$45f0612699d6a600$export$d95e99d8116d17dc);
    $parcel$export(module.exports, "removeFromGridStateInStorage", ()=>$45f0612699d6a600$export$17e3760e0b35f1cd);
    $parcel$export(module.exports, "resolveDimension", ()=>$45f0612699d6a600$export$74732e47915c7839);
    $parcel$export(module.exports, "getLeftPanelWidth", ()=>$45f0612699d6a600$export$b089e01213f07bd);
    $parcel$export(module.exports, "getLeftSidebarPercentage", ()=>$45f0612699d6a600$export$2bca58b6ee823bf7);
    $parcel$export(module.exports, "getPageLayoutSlotSelector", ()=>$45f0612699d6a600$export$e895e3e8b708ae2a);
    $parcel$export(module.exports, "getPageLayoutSlotCSSSelector", ()=>$45f0612699d6a600$export$218ece2c32b7db0e);
    var $22jFS;
    var $1Dapo;
    const $45f0612699d6a600$export$576dabd404a1ed99 = (0, (0, parcelRequire("22jFS")).DIMENSIONS).reduce((acc, currentValue)=>({
            ...acc,
            [currentValue]: 0
        }), {});
    const $45f0612699d6a600$export$f8355a2df0f4a946 = (key, value)=>{
        const storageValue = JSON.parse((0, (0, parcelRequire("1Dapo")).default)().getItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY)) || '{}');
        if (value !== null && typeof value === 'object') storageValue[key] = {
            ...storageValue[key],
            ...value
        };
        else storageValue[key] = value;
        (0, (0, parcelRequire("1Dapo")).default)().setItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
    };
    const $45f0612699d6a600$export$d95e99d8116d17dc = (key)=>{
        const storageValue = JSON.parse((0, (0, parcelRequire("1Dapo")).default)().getItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY)) || '{}');
        return storageValue[key];
    };
    const $45f0612699d6a600$export$17e3760e0b35f1cd = (key, secondKey)=>{
        const storageValue = JSON.parse((0, (0, parcelRequire("1Dapo")).default)().getItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY)) || '{}');
        if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
        else delete storageValue[key];
        (0, (0, parcelRequire("1Dapo")).default)().setItem((0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
    };
    const $45f0612699d6a600$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
        if (shouldPersist) {
            const cachedGridState = $45f0612699d6a600$export$d95e99d8116d17dc('gridState');
            return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
        }
        return dimension;
    };
    const $45f0612699d6a600$export$b089e01213f07bd = ()=>{
        if (typeof window === 'undefined') return 0;
        return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)}`), 10) || 0;
    };
    const $45f0612699d6a600$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
        const total = (currentWidth - (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH));
        if (total < 0) return 0;
        if (total > 1) return 100;
        return Math.floor(total * 100);
    };
    const $45f0612699d6a600$export$e895e3e8b708ae2a = (slotName)=>({
            [(0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
        });
    const $45f0612699d6a600$export$218ece2c32b7db0e = (slotName)=>`[${0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;
});
parcelRegister("1Dapo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8542dfb7c79e1b98$export$2e2bcd8739ae039);
    const $8542dfb7c79e1b98$var$isLocalStorageSupported = ()=>{
        try {
            const testKey = `__test_${Date.now()}__`;
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    };
    const $8542dfb7c79e1b98$var$safeLocalStorage = ()=>{
        if ($8542dfb7c79e1b98$var$isLocalStorageSupported()) return localStorage;
        if (typeof window === 'undefined') return {
            getItem: (_key)=>null,
            setItem: (_key, _value)=>null,
            removeItem: (_key)=>null,
            clear: ()=>null,
            key: (_index)=>null,
            get length () {
                return 0;
            }
        };
        if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
        const storageAPI = {
            getItem: (key)=>{
                if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
                return null;
            },
            setItem: (key, value)=>{
                window.__localStorageFallback[key] = String(value);
            },
            removeItem: (key)=>{
                delete window.__localStorageFallback[key];
            },
            clear: ()=>{
                for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
            },
            get length () {
                if (!window.__localStorageFallback) return 0;
                return Object.keys(window.__localStorageFallback).length;
            }
        };
        window.__localStorageFallback = Object.create(storageAPI);
        return window.__localStorageFallback;
    };
    var $8542dfb7c79e1b98$export$2e2bcd8739ae039 = $8542dfb7c79e1b98$var$safeLocalStorage;
});
parcelRegister("2Pb5D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69aa5d485af555af$export$2e2bcd8739ae039);
    var $8XpIo;
    const $69aa5d485af555af$var$publishGridState = (gridState)=>{
        Object.entries(gridState).forEach(([slotName, value])=>{
            if (!value) {
                document.documentElement.style.removeProperty(`--${slotName}`);
                (0, (0, parcelRequire("8XpIo")).removeFromGridStateInStorage)('gridState', slotName);
                return;
            }
            document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
            (0, (0, parcelRequire("8XpIo")).mergeGridStateIntoStorage)('gridState', {
                [slotName]: value
            });
        });
    };
    var $69aa5d485af555af$export$2e2bcd8739ae039 = $69aa5d485af555af$var$publishGridState;
});
parcelRegister("amcy7", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContext", ()=>$9d139aaa63675775$export$4c5cc3b14c7678a);
    $parcel$export(module.exports, "useSkipLinks", ()=>$9d139aaa63675775$export$c9d9cb2ee9590f87);
    $parcel$export(module.exports, "useSkipLink", ()=>$9d139aaa63675775$export$89d9323301efc7d6);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $9d139aaa63675775$export$4c5cc3b14c7678a = (0, $5uXOq.createContext)({
        skipLinksData: [],
        registerSkipLink: (0, (0, parcelRequire("eGmKJ")).default),
        unregisterSkipLink: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $9d139aaa63675775$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($9d139aaa63675775$export$4c5cc3b14c7678a);
    const $9d139aaa63675775$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $9d139aaa63675775$export$c9d9cb2ee9590f87();
        (0, $5uXOq.useEffect)(()=>{
            if (id && skipLinkTitle) registerSkipLink({
                id: id,
                skipLinkTitle: skipLinkTitle
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            skipLinkTitle,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("fZqMW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be1b215f3de827c6$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $be1b215f3de827c6$var$focusStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':focus': {
            outline: 'none',
            '> div': {
                boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
                outline: 'none'
            }
        }
    });
    const $be1b215f3de827c6$var$sidebarFocusStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':focus': {
            outline: 'none',
            '> div > div': {
                boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
                outline: 'none'
            }
        }
    });
    const $be1b215f3de827c6$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: css })=>children({
                className: isSidebar ? css($be1b215f3de827c6$var$sidebarFocusStyles) : css($be1b215f3de827c6$var$focusStyles)
            }));
    };
    var $be1b215f3de827c6$export$2e2bcd8739ae039 = $be1b215f3de827c6$var$SlotFocusRing;
});
parcelRegister("jUxG6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16bb67776ddc8896$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $h9kUS;
    const $16bb67776ddc8896$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
        let style = `:root{--${variableName}:${value}px;}`;
        if (mobileValue) style += ` ${(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("style", null, style));
    };
    var $16bb67776ddc8896$export$2e2bcd8739ae039 = $16bb67776ddc8896$var$SlotDimensions;
});
parcelRegister("c8E4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a355cc90b3ba1759$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $22jFS;
    const $a355cc90b3ba1759$var$contentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'relative',
        gridArea: (0, (0, parcelRequire("22jFS")).CONTENT)
    });
    const $a355cc90b3ba1759$var$Content = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: $a355cc90b3ba1759$var$contentStyles
        }, children);
    };
    var $a355cc90b3ba1759$export$2e2bcd8739ae039 = $a355cc90b3ba1759$var$Content;
});
parcelRegister("eX4XX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0feeff252d3697c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    const $0feeff252d3697c9$var$leftPanelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gridArea: (0, (0, parcelRequire("22jFS")).LEFT_PANEL)
    });
    const $0feeff252d3697c9$var$leftPanelFixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    });
    const $0feeff252d3697c9$var$LeftPanel = (props)=>{
        const { children: children, isFixed: isFixed, width: width = (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const leftPanelWidth = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_LEFT_PANEL_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_LEFT_PANEL_WIDTH)]: leftPanelWidth
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_PANEL_WIDTH)]: 0
                });
            };
        }, [
            leftPanelWidth
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $0feeff252d3697c9$var$leftPanelStyles,
                    isFixed && $0feeff252d3697c9$var$leftPanelFixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('left-panel')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_LEFT_PANEL_WIDTH),
                value: leftPanelWidth
            }), children));
    };
    var $0feeff252d3697c9$export$2e2bcd8739ae039 = $0feeff252d3697c9$var$LeftPanel;
});
parcelRegister("aKz2G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24d471261e665f40$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $71YXv;
    var $oGXFy;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $j3yGs;
    var $amcy7;
    var $b8DIB;
    var $2QObc;
    var $aY3ai;
    var $1hxaZ;
    var $jUxG6;
    const $24d471261e665f40$var$openBackdropStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        background: `var(--ds-blanket, ${(0, $829f609a65d26a98$export$486ab785e4bac3c6)})`,
        opacity: 1
    });
    const $24d471261e665f40$var$hiddenBackdropStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: 0,
        transition: `opacity ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    });
    const $24d471261e665f40$var$LeftSidebar = (props)=>{
        const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
        const flyoutTimerRef = (0, $5uXOq.useRef)();
        const mouseOverEventRef = (0, $5uXOq.useRef)();
        const leftSideBarRef = (0, $5uXOq.useRef)(null);
        const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("j3yGs")).SidebarResizeContext));
        const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth } = leftSidebarState;
        const isLocked = flyoutLockCount > 0;
        const isLockedRef = (0, $5uXOq.useRef)(isLocked);
        const mouseXRef = (0, $5uXOq.useRef)(0);
        const handlerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            isLockedRef.current = isLocked;
            if (isLocked && !handlerRef.current) {
                handlerRef.current = (event)=>{
                    mouseXRef.current = event.clientX;
                };
                document.addEventListener('mousemove', handlerRef.current);
            }
            if (!isLocked && handlerRef.current) {
                if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                document.removeEventListener('mousemove', handlerRef.current);
                handlerRef.current = null;
            }
            return ()=>{
                if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
            };
        }, [
            isLocked,
            lastLeftSidebarWidth,
            setLeftSidebarState
        ]);
        const _width = Math.max(width || 0, (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH));
        const collapsedStateOverrideOpen = collapsedState === 'expanded';
        let leftSidebarWidthOnMount;
        if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
        else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH);
        else leftSidebarWidthOnMount = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, (0, parcelRequire("8XpIo")).getGridStateFromStorage)('isLeftSidebarCollapsed'));
        (0, $5uXOq.useEffect)(()=>{
            const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, (0, parcelRequire("8XpIo")).getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
            const cachedGridState = (0, (0, parcelRequire("8XpIo")).getGridStateFromStorage)('gridState') || {};
            let leftSidebarWidth = !width && cachedGridState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT], (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
            const lastLeftSidebarWidth = !width && cachedGridState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT], (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
            if (cachedCollapsedState) leftSidebarWidth = (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH);
            setLeftSidebarState({
                isFlyoutOpen: false,
                isResizing: isResizing,
                isLeftSidebarCollapsed: cachedCollapsedState,
                leftSidebarWidth: leftSidebarWidth,
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                flyoutLockCount: 0,
                isFixed: isFixed
            });
        }, []);
        const notFirstRun = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (notFirstRun.current) {
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
                });
                (0, (0, parcelRequire("8XpIo")).mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
            }
            if (!notFirstRun.current) notFirstRun.current = true;
            return ()=>{
                removeMouseOverListener();
            };
        }, [
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            id
        ]);
        const onMouseOver = (event)=>{
            const isMouseOnResizeButton = event.target.matches(`[${(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)}] *`);
            if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
            event.persist();
            flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
            if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
                const leftSidebar = leftSideBarRef.current;
                if (leftSidebar === null || isLockedRef.current) return;
                if (!leftSidebar.contains(event.target)) {
                    flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                    onFlyoutCollapse && onFlyoutCollapse();
                    setLeftSidebarState((current)=>({
                            ...current,
                            isFlyoutOpen: false
                        }));
                    removeMouseOverListener();
                }
            };
            document.addEventListener('mouseover', mouseOverEventRef.current, {
                capture: true,
                passive: true
            });
            flyoutTimerRef.current = setTimeout(()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: true
                    }));
                onFlyoutExpand && onFlyoutExpand();
            }, (0, (0, parcelRequire("22jFS")).FLYOUT_DELAY));
        };
        const removeMouseOverListener = ()=>{
            mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
                capture: true,
                passive: true
            });
        };
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        const onMouseLeave = (event)=>{
            const isMouseOnResizeButton = event.target.matches(`[${(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)}] *`);
            if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
            onFlyoutCollapse && onFlyoutCollapse();
            setTimeout(()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
            }, (0, (0, parcelRequire("22jFS")).FLYOUT_DELAY));
        };
        const mobileMediaQuery = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)('below.sm');
        const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
            if (!mobileMediaQuery?.matches) return;
            setLeftSidebarState((current)=>{
                if (current.isFlyoutOpen) return current;
                return {
                    ...current,
                    isFlyoutOpen: true
                };
            });
        }, [
            setLeftSidebarState,
            mobileMediaQuery
        ]);
        const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
            if (!mobileMediaQuery?.matches) return;
            setLeftSidebarState((current)=>{
                if (!current.isFlyoutOpen) return current;
                return {
                    ...current,
                    isFlyoutOpen: false
                };
            });
        }, [
            setLeftSidebarState,
            mobileMediaQuery
        ]);
        (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)('below.sm', (event)=>{
            setLeftSidebarState((current)=>{
                if (event.matches && !current.isLeftSidebarCollapsed) return {
                    ...current,
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: current.leftSidebarWidth,
                    isFlyoutOpen: true
                };
                else if (!event.matches && current.isFlyoutOpen) return {
                    ...current,
                    isResizing: false,
                    isLeftSidebarCollapsed: false,
                    leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)),
                    isFlyoutOpen: false
                };
                return current;
            });
        });
        (0, (0, parcelRequire("71YXv")).default)({
            onClose: closeMobileFlyout,
            isDisabled: !isFlyoutOpen
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $24d471261e665f40$var$hiddenBackdropStyles,
                isFlyoutOpen && $24d471261e665f40$var$openBackdropStyles
            ],
            onClick: closeMobileFlyout
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aY3ai")).default), {
            ref: leftSideBarRef,
            testId: testId,
            onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
            onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
            onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
            id: id,
            isFixed: isFixed
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
            variableName: (0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH),
            value: notFirstRun.current ? leftSidebarWidth : leftSidebarWidthOnMount,
            mobileValue: (0, (0, parcelRequire("22jFS")).MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2QObc")).default), {
            isFixed: isFixed,
            isFlyoutOpen: isFlyoutOpen
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1hxaZ")).default), {
            isFlyoutOpen: isFlyoutOpen,
            isLeftSidebarCollapsed: isLeftSidebarCollapsed,
            hasCollapsedState: !notFirstRun.current && collapsedState === 'collapsed',
            testId: testId && `${testId}-resize-children-wrapper`
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("b8DIB")).default), {
            testId: testId,
            valueTextLabel: valueTextLabel,
            resizeGrabAreaLabel: resizeGrabAreaLabel,
            resizeButtonLabel: resizeButtonLabel,
            overrides: overrides,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd
        }))));
    };
    var $24d471261e665f40$export$2e2bcd8739ae039 = $24d471261e665f40$var$LeftSidebar;
});
parcelRegister("j3yGs", function(module, exports) {
    $parcel$export(module.exports, "SidebarResizeContext", ()=>$423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
    $parcel$export(module.exports, "usePageLayoutResize", ()=>$423fcd7a7dc715d5$export$10c7104037a7af62);
    $parcel$export(module.exports, "useLeftSidebarFlyoutLock", ()=>$423fcd7a7dc715d5$export$94561f6055639ef7);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $423fcd7a7dc715d5$var$leftSidebarState = {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    };
    const $423fcd7a7dc715d5$export$aa5a712eea4c2ae8 = (0, $5uXOq.createContext)({
        isLeftSidebarCollapsed: false,
        expandLeftSidebar: (0, (0, parcelRequire("eGmKJ")).default),
        collapseLeftSidebar: (0, (0, parcelRequire("eGmKJ")).default),
        leftSidebarState: $423fcd7a7dc715d5$var$leftSidebarState,
        setLeftSidebarState: (0, (0, parcelRequire("eGmKJ")).default),
        toggleLeftSidebar: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $423fcd7a7dc715d5$export$10c7104037a7af62 = ()=>{
        const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
        return context;
    };
    const $423fcd7a7dc715d5$export$94561f6055639ef7 = ()=>{
        const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($423fcd7a7dc715d5$export$aa5a712eea4c2ae8);
        (0, $5uXOq.useEffect)(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount + 1
                }));
            return ()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        flyoutLockCount: current.flyoutLockCount - 1
                    }));
            };
        }, [
            setLeftSidebarState
        ]);
    };
});
parcelRegister("b8DIB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$035100f87b948476$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $7nRxN;
    var $oGXFy;
    var $22jFS;
    var $8XpIo;
    var $j3yGs;
    var $gYx5U;
    var $7nOWs;
    var $3bMab;
    function $035100f87b948476$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $035100f87b948476$var$cssSelector = {
        [(0, (0, parcelRequire("22jFS")).RESIZE_CONTROL_SELECTOR)]: true
    };
    const $035100f87b948476$var$resizeControlStyles = {
        name: "ow3ovp",
        styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
    };
    const $035100f87b948476$var$showResizeButtonStyles = {
        name: "1a6byq5",
        styles: "--ds--resize-button--opacity:1"
    };
    const $035100f87b948476$var$globalResizingStyles = {
        name: "e4avm6",
        styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
    };
    const $035100f87b948476$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
        const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("j3yGs")).SidebarResizeContext));
        const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
        const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH]);
        const offset = (0, $5uXOq.useRef)(0);
        const keyboardEventTimeout = (0, $5uXOq.useRef)();
        const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
        const unbindEvents = (0, $5uXOq.useRef)(null);
        const mobileMediaQuery = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)('below.sm');
        const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
        (0, $5uXOq.useEffect)(()=>{
            stableSidebarState.current = leftSidebarState;
        }, [
            leftSidebarState
        ]);
        const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
            event?.stopPropagation();
            toggleLeftSidebar();
        }, [
            toggleLeftSidebar
        ]);
        const onMouseDown = (event)=>{
            if (isLeftSidebarCollapsed) return;
            if (event.button !== 0) return;
            if (leftSidebarState.isResizing) return;
            offset.current = event.clientX - leftSidebarState[0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH] - (0, (0, parcelRequire("8XpIo")).getLeftPanelWidth)();
            unbindEvents.current = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
                {
                    type: 'mousemove',
                    listener: function(event) {
                        onUpdateResize({
                            clientX: event.clientX
                        });
                    }
                },
                {
                    type: 'mouseup',
                    listener: onFinishResizing
                },
                {
                    type: 'mousedown',
                    listener: (()=>{
                        let hasFramePassed = false;
                        requestAnimationFrame(()=>{
                            hasFramePassed = true;
                        });
                        return function listener() {
                            if (hasFramePassed) onFinishResizing();
                        };
                    })()
                },
                {
                    type: 'visibilitychange',
                    listener: onFinishResizing
                },
                {
                    type: 'click',
                    listener: onFinishResizing
                },
                {
                    type: 'keydown',
                    listener: (event)=>{
                        if (event.key === 'Escape') {
                            sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH));
                            document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                            onFinishResizing();
                        }
                    }
                }
            ]);
            document.documentElement.setAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING), 'true');
            const newLeftbarState = {
                ...leftSidebarState,
                isResizing: true
            };
            setLeftSidebarState(newLeftbarState);
            onResizeStart && onResizeStart(newLeftbarState);
        };
        const onResizeOffLeftOfScreen = ()=>{
            onUpdateResize.cancel();
            unbindEvents.current?.();
            unbindEvents.current = null;
            document.documentElement.removeAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING));
            offset.current = 0;
            collapseLeftSidebar(undefined, true);
        };
        const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, (0, parcelRequire("7nRxN")).default)(({ clientX: clientX })=>{
                const maxWidth = Math.round(window.innerWidth / 2);
                const leftPanelWidth = (0, (0, parcelRequire("8XpIo")).getLeftPanelWidth)();
                const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
                const hasResizedOffLeftOfScreen = clientX < 0;
                if (hasResizedOffLeftOfScreen) {
                    onResizeOffLeftOfScreen();
                    return;
                }
                const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
                sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH));
                document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
            }));
        const onFinishResizing = ()=>{
            if (isLeftSidebarCollapsed) return;
            document.documentElement.removeAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING));
            let updatedLeftSidebarState = null;
            if (sidebarWidth.current < (0, (0, parcelRequire("22jFS")).MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
                document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
                collapseLeftSidebar(undefined, true);
            } else if (sidebarWidth.current > (0, (0, parcelRequire("22jFS")).MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
                updatedLeftSidebarState = {
                    ...leftSidebarState,
                    isResizing: false,
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)
                };
                setLeftSidebarState(updatedLeftSidebarState);
            } else {
                updatedLeftSidebarState = {
                    ...leftSidebarState,
                    isResizing: false,
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                    lastLeftSidebarWidth: sidebarWidth.current
                };
                setLeftSidebarState(updatedLeftSidebarState);
            }
            unbindEvents.current?.();
            unbindEvents.current = null;
            onUpdateResize.cancel();
            sidebarWidth.current = 0;
            offset.current = 0;
            requestAnimationFrame(()=>{
                setIsGrabAreaFocused(false);
                onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
            });
        };
        const onKeyDown = (event)=>{
            if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
            const { key: key } = event;
            const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
            const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
            const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
            if (isSpaceOrEnter) {
                toggleSideBar(event);
                event.preventDefault();
            }
            if (isLeftOrTopArrow || isRightOrBottomArrow) {
                event.preventDefault();
                onResizeStart && onResizeStart(leftSidebarState);
                const step = 10;
                const stepValue = isLeftOrTopArrow ? -step : step;
                const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
                const maxWidth = Math.round(window.innerWidth / 2) - (0, (0, parcelRequire("8XpIo")).getLeftPanelWidth)();
                const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
                let width = leftSidebarWidth + stepValue;
                if (width <= (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                    width = (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH);
                    document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
                } else if (width > maxWidth) {
                    width = maxWidth;
                    document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
                } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH);
                requestAnimationFrame(()=>{
                    keyboardEventTimeout.current = window.setTimeout(()=>{
                        keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                        document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                        const updatedLeftSidebarState = {
                            ...leftSidebarState,
                            [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: width,
                            lastLeftSidebarWidth: width
                        };
                        setLeftSidebarState(updatedLeftSidebarState);
                        onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                    }, 50);
                });
            }
        };
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            setIsGrabAreaFocused(true);
        }, []);
        const onBlur = (0, $5uXOq.useCallback)(()=>{
            setIsGrabAreaFocused(false);
        }, []);
        const resizeButton = {
            render: (Component, props)=>(0, (0, parcelRequire("f8Sb3")).jsx)(Component, props),
            ...overrides && overrides.ResizeButton
        };
        const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
            const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
            return Math.round(innerWidth / 2) - (0, (0, parcelRequire("8XpIo")).getLeftPanelWidth)();
        }, []);
        const leftSidebarPercentageExpanded = (0, (0, parcelRequire("8XpIo")).getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...$035100f87b948476$var$cssSelector,
            css: [
                $035100f87b948476$var$resizeControlStyles,
                (isGrabAreaFocused || isLeftSidebarCollapsed) && $035100f87b948476$var$showResizeButtonStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bMab")).default), {
            testId: testId && `${testId}-shadow`
        }), !mobileMediaQuery?.matches && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gYx5U")).default), {
            isDisabled: isLeftSidebarCollapsed,
            isLeftSidebarCollapsed: isLeftSidebarCollapsed,
            label: resizeGrabAreaLabel,
            valueTextLabel: valueTextLabel,
            leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            testId: testId && `${testId}-grab-area`
        }), resizeButton.render((0, (0, parcelRequire("7nOWs")).default), {
            isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
            label: resizeButtonLabel,
            onClick: toggleSideBar,
            testId: testId && `${testId}-resize-button`
        })), leftSidebarState.isResizing ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).Global), {
            styles: $035100f87b948476$var$globalResizingStyles
        }) : null);
    };
    var $035100f87b948476$export$2e2bcd8739ae039 = $035100f87b948476$var$ResizeControl;
});
parcelRegister("gYx5U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$859a4bb5bdb6af39$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $22jFS;
    function $859a4bb5bdb6af39$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $859a4bb5bdb6af39$var$varLineColor = '--ds-line';
    const $859a4bb5bdb6af39$var$grabAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: "var(--ds-space-200, 16px)",
        height: '100%',
        padding: 0,
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'ew-resize',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:focus': {
            outline: 0
        },
        '&:enabled:hover, &:enabled:focus, &:enabled:active': {
            [$859a4bb5bdb6af39$var$varLineColor]: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
        }
    });
    const $859a4bb5bdb6af39$var$grabAreaCollapsedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
        padding: 0,
        position: 'absolute',
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'default',
        insetBlockEnd: 0
    });
    const $859a4bb5bdb6af39$var$lineStyles = {
        name: "w4swnc",
        styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
    };
    const $859a4bb5bdb6af39$var$grabAreaLineSelector = {
        [(0, (0, parcelRequire("22jFS")).GRAB_AREA_LINE_SELECTOR)]: true
    };
    const $859a4bb5bdb6af39$var$grabAreaSelector = {
        [(0, (0, parcelRequire("22jFS")).GRAB_AREA_SELECTOR)]: true
    };
    const $859a4bb5bdb6af39$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            ...$859a4bb5bdb6af39$var$grabAreaSelector,
            "aria-label": label,
            "data-testid": testId,
            disabled: isDisabled,
            "aria-hidden": isLeftSidebarCollapsed,
            type: "button",
            role: "slider",
            css: [
                $859a4bb5bdb6af39$var$grabAreaStyles,
                isLeftSidebarCollapsed && $859a4bb5bdb6af39$var$grabAreaCollapsedStyles
            ],
            "aria-orientation": "vertical",
            "aria-valuenow": leftSidebarPercentageExpanded,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            onFocus: onFocus,
            onBlur: onBlur,
            ...rest
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $859a4bb5bdb6af39$var$lineStyles,
            ...$859a4bb5bdb6af39$var$grabAreaLineSelector
        }));
    var $859a4bb5bdb6af39$export$2e2bcd8739ae039 = $859a4bb5bdb6af39$var$GrabArea;
});
parcelRegister("7nOWs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ee2fadf0239ec76$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $hWZau;
    var $lObw7;
    var $h9kUS;
    var $22jFS;
    function $8ee2fadf0239ec76$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8ee2fadf0239ec76$var$increaseHitAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'absolute',
        insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
        insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
        insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
        insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
    });
    const $8ee2fadf0239ec76$var$mobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            opacity: 1
        }
    });
    const $8ee2fadf0239ec76$var$resizeIconButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 24,
        height: 24,
        padding: "var(--ds-space-0, 0px)",
        position: 'absolute',
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        border: 0,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        boxShadow: `0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}`,
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        cursor: 'pointer',
        insetBlockStart: "var(--ds-space-400, 32px)",
        insetInlineStart: 0,
        opacity: `var(--ds--resize-button--opacity,0)`,
        outline: 0,
        transform: 'translateX(-50%)',
        transition: `
    background-color ${(0, (0, parcelRequire("lObw7")).smallDurationMs)}ms linear,
    color ${(0, (0, parcelRequire("lObw7")).smallDurationMs)}ms linear,
    opacity ${(0, (0, parcelRequire("lObw7")).mediumDurationMs)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}
  `,
        ':hover': {
            backgroundColor: `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
            color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            opacity: 1
        },
        ':active, :focus': {
            backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
            color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            opacity: 1
        }
    });
    const $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles = {
        name: "1bl2513",
        styles: "transform:rotate(180deg);transform-origin:7px"
    };
    const $8ee2fadf0239ec76$var$preventDefault = (event)=>event.preventDefault();
    const $8ee2fadf0239ec76$var$cssSelector = {
        [(0, (0, parcelRequire("22jFS")).RESIZE_BUTTON_SELECTOR)]: true
    };
    const $8ee2fadf0239ec76$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            ...$8ee2fadf0239ec76$var$cssSelector,
            "aria-expanded": !isLeftSidebarCollapsed,
            "aria-label": label,
            type: "button",
            css: [
                $8ee2fadf0239ec76$var$resizeIconButtonStyles,
                $8ee2fadf0239ec76$var$mobileStyles,
                !isLeftSidebarCollapsed && $8ee2fadf0239ec76$var$resizeIconButtonExpandedStyles
            ],
            "data-testid": testId,
            onMouseDown: $8ee2fadf0239ec76$var$preventDefault,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
            label: "",
            color: "currentColor"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $8ee2fadf0239ec76$var$increaseHitAreaStyles
        }));
    var $8ee2fadf0239ec76$export$2e2bcd8739ae039 = $8ee2fadf0239ec76$var$ResizeButton;
});
parcelRegister("3bMab", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31b1337ced2d81f3$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dwLzP;
    const $31b1337ced2d81f3$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
    const $31b1337ced2d81f3$var$direction = 'to left';
    const $31b1337ced2d81f3$var$transitionDuration = '0.22s';
    const $31b1337ced2d81f3$var$shadowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 3,
        position: 'absolute',
        background: `var(--ds-border, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: -1,
        opacity: 0.5,
        pointerEvents: 'none',
        transitionDuration: $31b1337ced2d81f3$var$transitionDuration,
        transitionProperty: 'left, opacity, width',
        transitionTimingFunction: (0, $eba99f58997c09b3$export$57636bb43b1ccbb0)
    });
    const $31b1337ced2d81f3$var$draggingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 6,
        background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$31b1337ced2d81f3$var$direction}, ${$31b1337ced2d81f3$var$colorStops})`})`,
        insetInlineStart: "var(--ds-space-negative-075, -6px)",
        opacity: 0.8
    });
    const $31b1337ced2d81f3$var$Shadow = ({ testId: testId })=>{
        const isDragging = (0, (0, parcelRequire("dwLzP")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: [
                $31b1337ced2d81f3$var$shadowStyles,
                isDragging && $31b1337ced2d81f3$var$draggingStyles
            ]
        });
    };
    var $31b1337ced2d81f3$export$2e2bcd8739ae039 = $31b1337ced2d81f3$var$Shadow;
});
parcelRegister("dwLzP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe6bed85a32a6108$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $22jFS;
    const $fe6bed85a32a6108$var$getIsDragging = ()=>{
        if (typeof document === 'undefined') return false;
        return document.documentElement.getAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING)) === 'true';
    };
    const $fe6bed85a32a6108$var$useIsSidebarDragging = ()=>{
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)($fe6bed85a32a6108$var$getIsDragging);
        (0, $5uXOq.useEffect)(()=>{
            const observer = new MutationObserver(()=>{
                setIsDragging($fe6bed85a32a6108$var$getIsDragging);
            });
            observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, (0, parcelRequire("22jFS")).IS_SIDEBAR_DRAGGING)
                ]
            });
            return ()=>{
                observer.disconnect();
            };
        }, []);
        return isDragging;
    };
    var $fe6bed85a32a6108$export$2e2bcd8739ae039 = $fe6bed85a32a6108$var$useIsSidebarDragging;
});
parcelRegister("2QObc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd36b127ab52f290$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dWt6p;
    var $h9kUS;
    var $22jFS;
    var $dwLzP;
    function $fd36b127ab52f290$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fd36b127ab52f290$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $fd36b127ab52f290$var$mobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            width: `${(0, (0, parcelRequire("22jFS")).MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
            position: 'fixed',
            insetBlockEnd: 0,
            insetBlockStart: `calc(${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)} + ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)})`,
            insetInlineStart: `${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)}`,
            transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
        }
    });
    const $fd36b127ab52f290$var$mobileInnerFlyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            width: `min(90vw, ${(0, (0, parcelRequire("22jFS")).MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
            maxWidth: (0, (0, parcelRequire("22jFS")).MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
        }
    });
    const $fd36b127ab52f290$var$fixedInnerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)}`,
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: `calc(${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)} + ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)})`,
        insetInlineStart: `${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)}`,
        transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    });
    const $fd36b127ab52f290$var$fixedInnerFlyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_FLYOUT_WIDTH)
    });
    const $fd36b127ab52f290$var$staticInnerStyles = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $fd36b127ab52f290$var$draggingStyles = {
        name: "jlx54q",
        styles: "cursor:ew-resize;transition:none"
    };
    const $fd36b127ab52f290$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
        const isDragging = (0, (0, parcelRequire("dwLzP")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $fd36b127ab52f290$var$mobileStyles,
                isFlyoutOpen && $fd36b127ab52f290$var$mobileInnerFlyoutStyles,
                !isFixed && $fd36b127ab52f290$var$staticInnerStyles,
                isFixed && $fd36b127ab52f290$var$fixedInnerStyles,
                isFixed && isFlyoutOpen && $fd36b127ab52f290$var$fixedInnerFlyoutStyles,
                isDragging && $fd36b127ab52f290$var$draggingStyles,
                $fd36b127ab52f290$var$prefersReducedMotionStyles
            ]
        }, children);
    };
    var $fd36b127ab52f290$export$2e2bcd8739ae039 = $fd36b127ab52f290$var$LeftSidebarInner;
});
parcelRegister("aY3ai", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$579ca93715ca9047$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dWt6p;
    var $h9kUS;
    var $22jFS;
    var $dwLzP;
    var $8XpIo;
    var $j3yGs;
    var $fZqMW;
    function $579ca93715ca9047$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $579ca93715ca9047$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $579ca93715ca9047$var$mobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            width: (0, (0, parcelRequire("22jFS")).MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
            cursor: 'pointer',
            opacity: 1,
            transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
            '&::after': {
                display: 'inline-block',
                maxWidth: (0, (0, parcelRequire("22jFS")).MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
                content: "''"
            }
        }
    });
    const $579ca93715ca9047$var$mobileFlyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            cursor: 'revert'
        }
    });
    const $579ca93715ca9047$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH),
        position: 'relative',
        zIndex: 1,
        marginInlineStart: "var(--ds-space-0, 0px)",
        transition: `width ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`,
        ':hover': {
            '--ds--resize-button--opacity': 1
        }
    });
    const $579ca93715ca9047$var$draggingStyles = {
        name: "jlx54q",
        styles: "cursor:ew-resize;transition:none"
    };
    const $579ca93715ca9047$var$fixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '::after': {
            display: 'inline-block',
            width: `${(0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_WIDTH)}`,
            content: "''"
        }
    });
    const $579ca93715ca9047$var$flyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).LEFT_SIDEBAR_FLYOUT_WIDTH)
    });
    const $579ca93715ca9047$var$flyoutFixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH)
    });
    const $579ca93715ca9047$var$selector = (0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('left-sidebar');
    const $579ca93715ca9047$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
        const isDragging = (0, (0, parcelRequire("dwLzP")).default)();
        const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, (0, parcelRequire("j3yGs")).SidebarResizeContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), {
            isSidebar: true
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $579ca93715ca9047$var$mobileStyles,
                    isFlyoutOpen && $579ca93715ca9047$var$mobileFlyoutStyles,
                    $579ca93715ca9047$var$outerStyles,
                    isFixed && $579ca93715ca9047$var$fixedStyles,
                    isFlyoutOpen && $579ca93715ca9047$var$flyoutStyles,
                    isFlyoutOpen && isFixed && $579ca93715ca9047$var$flyoutFixedStyles,
                    isDragging && $579ca93715ca9047$var$draggingStyles,
                    $579ca93715ca9047$var$prefersReducedMotionStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                onMouseOver: onMouseOver,
                onMouseLeave: onMouseLeave,
                onClick: onClick,
                ref: ref,
                ...$579ca93715ca9047$var$selector
            }, children));
    };
    const $579ca93715ca9047$var$LeftSidebarOuter = (0, $5uXOq.forwardRef)($579ca93715ca9047$var$LeftSidebarOuterComponent);
    var $579ca93715ca9047$export$2e2bcd8739ae039 = $579ca93715ca9047$var$LeftSidebarOuter;
});
parcelRegister("1hxaZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2beb7a521c0e059$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $dWt6p;
    var $22jFS;
    var $2qAWW;
    function $b2beb7a521c0e059$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b2beb7a521c0e059$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: 0,
        transition: `opacity 0ms linear, visibility 0ms linear`,
        transitionDelay: `${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION) - 100}ms`,
        visibility: 'hidden'
    });
    const $b2beb7a521c0e059$var$resizableChildrenWrapperStyles = {
        name: "xz78rr",
        styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
    };
    const $b2beb7a521c0e059$var$fixedChildrenWrapperStyles = {
        name: "ax3w45",
        styles: "min-width:240px;height:100%"
    };
    const $b2beb7a521c0e059$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
        const isCollapsing = (0, (0, parcelRequire("2qAWW")).default)();
        const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
        const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b2beb7a521c0e059$var$resizableChildrenWrapperStyles,
                isHidden && $b2beb7a521c0e059$var$hideLeftSidebarContentsStyles,
                $b2beb7a521c0e059$var$prefersReducedMotionStyles
            ],
            "aria-hidden": isHidden,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b2beb7a521c0e059$var$fixedChildrenWrapperStyles
        }, children));
    };
    var $b2beb7a521c0e059$export$2e2bcd8739ae039 = $b2beb7a521c0e059$var$ResizableChildrenWrapper;
});
parcelRegister("2qAWW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed1c7c9bc9db6ce1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $22jFS;
    const $ed1c7c9bc9db6ce1$var$getIsCollapsing = ()=>{
        if (typeof document === 'undefined') return false;
        return document.documentElement.getAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_COLLAPSING)) === 'true';
    };
    const $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing = ()=>{
        const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($ed1c7c9bc9db6ce1$var$getIsCollapsing);
        (0, $5uXOq.useEffect)(()=>{
            const observer = new MutationObserver(()=>{
                setIsCollapsing($ed1c7c9bc9db6ce1$var$getIsCollapsing);
            });
            observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, (0, parcelRequire("22jFS")).IS_SIDEBAR_COLLAPSING)
                ]
            });
            return ()=>{
                observer.disconnect();
            };
        }, []);
        return isCollapsing;
    };
    var $ed1c7c9bc9db6ce1$export$2e2bcd8739ae039 = $ed1c7c9bc9db6ce1$var$useIsSidebarCollapsing;
});
parcelRegister("aj7M6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c26851ff0e51eadd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $2QObc;
    var $aY3ai;
    var $jUxG6;
    const $c26851ff0e51eadd$var$LeftSidebarWithoutResize = (props)=>{
        const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
        const leftSidebarWidth = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH)]: 0
                });
            };
        }, [
            leftSidebarWidth
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aY3ai")).default), {
            id: id,
            testId: testId,
            isFixed: isFixed
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
            variableName: (0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_WIDTH),
            value: leftSidebarWidth
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2QObc")).default), {
            isFixed: isFixed
        }, children));
    };
    var $c26851ff0e51eadd$export$2e2bcd8739ae039 = $c26851ff0e51eadd$var$LeftSidebarWithoutResize;
});
parcelRegister("kUAkd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8aae2c1ff30f289$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dWt6p;
    var $22jFS;
    var $dwLzP;
    var $8XpIo;
    var $j3yGs;
    var $amcy7;
    var $fZqMW;
    function $e8aae2c1ff30f289$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e8aae2c1ff30f289$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $e8aae2c1ff30f289$var$mainStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        flexGrow: 1,
        marginInlineStart: 0,
        transition: `margin-left ${(0, (0, parcelRequire("22jFS")).TRANSITION_DURATION)}ms ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)} 0s`
    });
    const $e8aae2c1ff30f289$var$draggingStyles = {
        name: "1wx2bp",
        styles: "transition:none"
    };
    const $e8aae2c1ff30f289$var$flyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginInlineStart: `calc(-1 * var(--${(0, (0, parcelRequire("22jFS")).VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
    });
    const $e8aae2c1ff30f289$var$Main = (props)=>{
        const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        const isDragging = (0, (0, parcelRequire("dwLzP")).default)();
        const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, (0, parcelRequire("j3yGs")).SidebarResizeContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("main", {
                "data-testid": testId,
                css: [
                    $e8aae2c1ff30f289$var$mainStyles,
                    isDragging && $e8aae2c1ff30f289$var$draggingStyles,
                    isFlyoutOpen && !isFixed && $e8aae2c1ff30f289$var$flyoutStyles,
                    $e8aae2c1ff30f289$var$prefersReducedMotionStyles
                ],
                className: className,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('main')
            }, children));
    };
    var $e8aae2c1ff30f289$export$2e2bcd8739ae039 = $e8aae2c1ff30f289$var$Main;
});
parcelRegister("3WK4F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$864a3c4908a9e1b7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $h9kUS;
    var $22jFS;
    var $hhjNo;
    var $ln2Pp;
    var $crY4K;
    const $864a3c4908a9e1b7$var$pageLayoutSelector = {
        [(0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
    };
    const $864a3c4908a9e1b7$var$gridTemplateAreasMobile = `
${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).BANNER)}"
  ${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION)}"
  ${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).CONTENT)}"
 `;
    const $864a3c4908a9e1b7$var$gridTemplateAreas = `
${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).BANNER)} ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL)}"
  ${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION)} ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL)}"
${''}
  "${(0, (0, parcelRequire("22jFS")).LEFT_PANEL)} ${(0, (0, parcelRequire("22jFS")).CONTENT)} ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL)}"
 `;
    const $864a3c4908a9e1b7$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        height: '100%',
        gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreas,
        gridTemplateColumns: `${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)}`,
        gridTemplateRows: `${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)} ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)} auto`,
        outline: 'none'
    });
    const $864a3c4908a9e1b7$var$gridStylesMobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("h9kUS")).UNSAFE_media).below.sm]: {
            gridTemplateAreas: $864a3c4908a9e1b7$var$gridTemplateAreasMobile,
            gridTemplateColumns: `${(0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
        }
    });
    const $864a3c4908a9e1b7$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, (0, parcelRequire("22jFS")).DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ln2Pp")).SkipLinksController), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("crY4K")).SkipLinkWrapper), {
            skipLinksLabel: skipLinksLabel
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...$864a3c4908a9e1b7$var$pageLayoutSelector,
            "data-testid": testId,
            css: [
                $864a3c4908a9e1b7$var$gridStyles,
                $864a3c4908a9e1b7$var$gridStylesMobileStyles
            ],
            tabIndex: -1,
            "data-vc": "page-layout"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hhjNo")).SidebarResizeController), {
            onLeftSidebarCollapse: onLeftSidebarCollapse,
            onLeftSidebarExpand: onLeftSidebarExpand
        }, children))));
    };
    var $864a3c4908a9e1b7$export$2e2bcd8739ae039 = $864a3c4908a9e1b7$var$PageLayout;
});
parcelRegister("hhjNo", function(module, exports) {
    $parcel$export(module.exports, "SidebarResizeController", ()=>$592e749dad0a6cf7$export$850bd1bba41f1448);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $eGmKJ;
    var $dWt6p;
    var $oGXFy;
    var $22jFS;
    var $8XpIo;
    var $j3yGs;
    const $592e749dad0a6cf7$var$handleDataAttributesAndCb = (callback = (0, (0, parcelRequire("eGmKJ")).default), leftSidebarState)=>{
        document.documentElement.removeAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_COLLAPSING));
        callback(leftSidebarState);
    };
    const $592e749dad0a6cf7$var$leftSidebarSelector = (0, (0, parcelRequire("8XpIo")).getPageLayoutSlotCSSSelector)('left-sidebar');
    const $592e749dad0a6cf7$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
        const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
            isFlyoutOpen: false,
            isResizing: false,
            isLeftSidebarCollapsed: false,
            leftSidebarWidth: 0,
            lastLeftSidebarWidth: 0,
            flyoutLockCount: 0,
            isFixed: true
        });
        const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen } = leftSidebarState;
        const stableRef = (0, $5uXOq.useRef)({
            onExpand: onExpand,
            onCollapse: onCollapse
        });
        (0, $5uXOq.useEffect)(()=>{
            stableRef.current = {
                onExpand: onExpand,
                onCollapse: onCollapse
            };
        }, [
            onExpand,
            onCollapse
        ]);
        const transition = (0, $5uXOq.useRef)(null);
        const mobileMediaQuery = (0, (0, parcelRequire("oGXFy")).UNSAFE_useMediaQuery)('below.sm');
        const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
        const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
            if (isOpen) return;
            if (mobileMediaQuery?.matches) {
                const flyoutOpenSidebarState = {
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: leftSidebarWidth,
                    isFlyoutOpen: true,
                    flyoutLockCount: 0,
                    isFixed: isFixed
                };
                setLeftSidebarState(flyoutOpenSidebarState);
                transition.current?.complete();
                $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
                return;
            }
            if (isResizing || !isLeftSidebarCollapsed || transition.current?.action === 'expand') return;
            transition.current?.complete();
            const width = Math.max(lastLeftSidebarWidth, (0, (0, parcelRequire("22jFS")).DEFAULT_LEFT_SIDEBAR_WIDTH));
            const updatedLeftSidebarState = {
                isLeftSidebarCollapsed: false,
                isFlyoutOpen: false,
                leftSidebarWidth: width,
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isResizing: isResizing,
                flyoutLockCount: flyoutLockCount,
                isFixed: isFixed
            };
            setLeftSidebarState(updatedLeftSidebarState);
            function finish() {
                $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
            }
            const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
            if ((0, (0, parcelRequire("dWt6p")).isReducedMotion)() || !sidebar) {
                finish();
                return;
            }
            const unbindEvent = (0, (0, parcelRequire("cBeZP")).bind)(sidebar, {
                type: 'transitionend',
                listener (event) {
                    if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
                }
            });
            const value = {
                action: 'expand',
                complete: ()=>{
                    value.abort();
                    finish();
                },
                abort: ()=>{
                    unbindEvent();
                    transition.current = null;
                }
            };
            transition.current = value;
        }, [
            isOpen,
            mobileMediaQuery,
            isResizing,
            isLeftSidebarCollapsed,
            lastLeftSidebarWidth,
            flyoutLockCount,
            isFixed,
            leftSidebarWidth
        ]);
        const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
            if (!isOpen) return;
            if (mobileMediaQuery?.matches) {
                const flyoutCloseSidebarState = {
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: lastLeftSidebarWidth,
                    isFlyoutOpen: false,
                    flyoutLockCount: 0,
                    isFixed: isFixed
                };
                setLeftSidebarState(flyoutCloseSidebarState);
                transition.current?.complete();
                $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
                return;
            }
            if (isResizing || isLeftSidebarCollapsed || transition.current?.action === 'collapse') return;
            transition.current?.complete();
            document.documentElement.setAttribute((0, (0, parcelRequire("22jFS")).IS_SIDEBAR_COLLAPSING), 'true');
            const updatedLeftSidebarState = {
                isLeftSidebarCollapsed: true,
                isFlyoutOpen: false,
                leftSidebarWidth: (0, (0, parcelRequire("22jFS")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isResizing: isResizing,
                flyoutLockCount: flyoutLockCount,
                isFixed: isFixed
            };
            setLeftSidebarState(updatedLeftSidebarState);
            function finish() {
                $592e749dad0a6cf7$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
            }
            const sidebar = document.querySelector($592e749dad0a6cf7$var$leftSidebarSelector);
            if (collapseWithoutTransition || (0, (0, parcelRequire("dWt6p")).isReducedMotion)() || !sidebar) {
                finish();
                return;
            }
            const unbindEvent = (0, (0, parcelRequire("cBeZP")).bind)(sidebar, {
                type: 'transitionend',
                listener (event) {
                    if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
                }
            });
            const value = {
                action: 'collapse',
                complete: ()=>{
                    value.abort();
                    finish();
                },
                abort: ()=>{
                    unbindEvent();
                    transition.current = null;
                }
            };
            transition.current = value;
        }, [
            isOpen,
            mobileMediaQuery,
            isResizing,
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            flyoutLockCount,
            isFixed,
            lastLeftSidebarWidth
        ]);
        const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
            if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
            else expandLeftSidebar();
        }, [
            isOpen,
            expandLeftSidebar,
            collapseLeftSidebar
        ]);
        (0, $5uXOq.useEffect)(function mount() {
            return function unmount() {
                transition.current?.abort();
            };
        }, []);
        const context = (0, $5uXOq.useMemo)(()=>({
                isLeftSidebarCollapsed: !isOpen,
                expandLeftSidebar: expandLeftSidebar,
                collapseLeftSidebar: collapseLeftSidebar,
                leftSidebarState: leftSidebarState,
                setLeftSidebarState: setLeftSidebarState,
                toggleLeftSidebar: toggleLeftSidebar
            }), [
            isOpen,
            expandLeftSidebar,
            collapseLeftSidebar,
            leftSidebarState,
            toggleLeftSidebar
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j3yGs")).SidebarResizeContext).Provider, {
            value: context
        }, children);
    };
});
parcelRegister("ln2Pp", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksController", ()=>$66b4ac88f2caca0d$export$da7be99d6a868f3d);
    var $5uXOq = parcelRequire("5uXOq");
    var $22jFS;
    var $amcy7;
    const $66b4ac88f2caca0d$var$byDOMOrder = (a, b)=>{
        const elems = Array.from(document.querySelectorAll(`[${(0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_SLOT_SELECTOR)}]`));
        const elemA = document.getElementById(a.id);
        const elemB = document.getElementById(b.id);
        const indexA = a.listIndex ?? elems.indexOf(elemA);
        const indexB = b.listIndex ?? elems.indexOf(elemB);
        if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
    const $66b4ac88f2caca0d$export$da7be99d6a868f3d = ({ children: children })=>{
        const [links, setLinks] = (0, $5uXOq.useState)([]);
        const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
            setLinks((oldLinks)=>{
                if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
                return [
                    ...oldLinks,
                    skipLinkData
                ].sort($66b4ac88f2caca0d$var$byDOMOrder);
            });
        });
        const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
            setLinks((links)=>links.filter((link)=>link.id !== id));
        });
        const context = {
            registerSkipLink: registerSkipLink.current,
            skipLinksData: links,
            unregisterSkipLink: unregisterSkipLink.current
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("amcy7")).SkipLinksContext).Provider, {
            value: context
        }, children);
    };
});
parcelRegister("crY4K", function(module, exports) {
    $parcel$export(module.exports, "SkipLinkWrapper", ()=>$c39a22bbdce5fcea$export$4241a460557ba901);
    var $f8Sb3;
    var $e4yMr;
    var $dWt6p;
    var $22jFS;
    var $amcy7;
    function $c39a22bbdce5fcea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c39a22bbdce5fcea$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("dWt6p")).prefersReducedMotion)());
    const $c39a22bbdce5fcea$var$skipLinkStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: "var(--ds-space-250, 10px)",
        padding: '0.8rem 1rem',
        position: 'fixed',
        zIndex: -1,
        background: "var(--ds-surface-overlay, white)",
        border: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 2px 10px ${(0, $829f609a65d26a98$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        insetInlineStart: -999999,
        opacity: 0,
        transform: 'translateY(-50%)',
        transition: `transform 0.3s ${(0, $eba99f58997c09b3$export$57636bb43b1ccbb0)}`,
        '&:focus-within': {
            zIndex: 2147483640,
            insetInlineStart: 0,
            opacity: 1,
            transform: 'translateY(0%)'
        }
    });
    const $c39a22bbdce5fcea$var$skipLinkHeadingStyles = {
        name: "16ceglb",
        styles: "font-weight:600"
    };
    const $c39a22bbdce5fcea$var$skipLinkListStyles = {
        name: "1xay72g",
        styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
    };
    const $c39a22bbdce5fcea$var$skipLinkListItemStyles = {
        name: "19m435s",
        styles: "margin-block-start:0"
    };
    const $c39a22bbdce5fcea$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $c39a22bbdce5fcea$var$assignIndex(num + 1, arr);
    };
    const $c39a22bbdce5fcea$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
        const { skipLinksData: skipLinksData } = (0, (0, parcelRequire("amcy7")).useSkipLinks)();
        if (skipLinksData.length === 0) return null;
        const sortSkipLinks = (arr)=>{
            const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
            if (customLinks.length === 0) return arr;
            const usedIndexes = customLinks.map((a)=>a.listIndex);
            const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
                const listIndex = $c39a22bbdce5fcea$var$assignIndex(idx, usedIndexes);
                usedIndexes.push(listIndex);
                return {
                    ...link,
                    listIndex: listIndex
                };
            });
            return [
                ...customLinks,
                ...regularLinksWithIdx
            ].sort((a, b)=>a.listIndex - b.listIndex);
        };
        const escapeHandler = (event)=>{
            if (event.keyCode === 27) {
                const container = document.querySelector(`[${(0, (0, parcelRequire("22jFS")).PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
                if (container !== null) container.focus();
            }
        };
        const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
        const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
        const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
        const label = skipLinksLabel || (0, (0, parcelRequire("22jFS")).DEFAULT_I18N_PROPS_SKIP_LINKS);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onFocus: attachEscHandler,
            onBlur: removeEscHandler,
            css: [
                $c39a22bbdce5fcea$var$skipLinkStyles,
                $c39a22bbdce5fcea$var$prefersReducedMotionStyles
            ],
            "data-skip-link-wrapper": true
        }, emptyLabelOverride ? null : (0, (0, parcelRequire("f8Sb3")).jsx)("p", {
            css: $c39a22bbdce5fcea$var$skipLinkHeadingStyles
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("ol", {
            css: $c39a22bbdce5fcea$var$skipLinkListStyles
        }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>(0, (0, parcelRequire("f8Sb3")).jsx)($c39a22bbdce5fcea$export$ef95c37428582a65, {
                key: id,
                href: `#${id}`,
                isFocusable: true
            }, skipLinkTitle)))));
    };
    const $c39a22bbdce5fcea$var$handleBlur = (event)=>{
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
    };
    const $c39a22bbdce5fcea$var$focusTargetRef = (href)=>(event)=>{
            event.preventDefault();
            const targetRef = document.querySelector(href);
            const key = event.which || event.keycode;
            if (key && key !== 13 && key !== 32) return;
            if (targetRef) {
                targetRef.setAttribute('tabindex', '-1');
                targetRef.addEventListener('blur', $c39a22bbdce5fcea$var$handleBlur);
                targetRef.focus();
                document.activeElement && document.activeElement.scrollIntoView({
                    behavior: 'smooth'
                });
                window.scrollTo(0, 0);
            }
            return false;
        };
    const $c39a22bbdce5fcea$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("li", {
            css: $c39a22bbdce5fcea$var$skipLinkListItemStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e4yMr")).default), {
            tabIndex: isFocusable ? 0 : -1,
            href: href,
            onClick: $c39a22bbdce5fcea$var$focusTargetRef(href)
        }, children));
    };
});
parcelRegister("4CWca", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9295d31affd013c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    const $d9295d31affd013c$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gridArea: (0, (0, parcelRequire("22jFS")).RIGHT_PANEL)
    });
    const $d9295d31affd013c$var$fixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineEnd: 0
    });
    const $d9295d31affd013c$var$RightPanel = (props)=>{
        const { children: children, isFixed: isFixed, width: width = (0, (0, parcelRequire("22jFS")).DEFAULT_RIGHT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const rightPanelWidth = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_RIGHT_PANEL_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_RIGHT_PANEL_WIDTH)]: rightPanelWidth
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_RIGHT_PANEL_WIDTH)]: 0
                });
            };
        }, [
            rightPanelWidth
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $d9295d31affd013c$var$baseStyles,
                    isFixed && $d9295d31affd013c$var$fixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('right-panel')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_RIGHT_PANEL_WIDTH),
                value: rightPanelWidth
            }), children));
    };
    var $d9295d31affd013c$export$2e2bcd8739ae039 = $d9295d31affd013c$var$RightPanel;
});
parcelRegister("9xmqY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a07a1808f1030823$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    function $a07a1808f1030823$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a07a1808f1030823$var$fixedInnerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: `calc(${(0, (0, parcelRequire("22jFS")).BANNER_HEIGHT)} + ${(0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT)})`,
        insetInlineEnd: `calc(${(0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH)})`
    });
    const $a07a1808f1030823$var$staticInnerStyles = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $a07a1808f1030823$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH)
    });
    const $a07a1808f1030823$var$fixedOuterStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::after': {
            display: 'inline-block',
            width: (0, (0, parcelRequire("22jFS")).RIGHT_SIDEBAR_WIDTH),
            content: "''"
        }
    });
    const $a07a1808f1030823$var$RightSidebar = (props)=>{
        const { children: children, width: width = (0, (0, parcelRequire("22jFS")).DEFAULT_RIGHT_SIDEBAR_WIDTH), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const rightSidebarWidth = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_RIGHT_SIDEBAR_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_RIGHT_SIDEBAR_WIDTH)]: rightSidebarWidth
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_RIGHT_SIDEBAR_WIDTH)]: 0
                });
            };
        }, [
            rightSidebarWidth,
            id
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), {
            isSidebar: true
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-testid": testId,
                css: [
                    $a07a1808f1030823$var$outerStyles,
                    isFixed && $a07a1808f1030823$var$fixedOuterStyles
                ],
                className: className,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('right-sidebar')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_RIGHT_SIDEBAR_WIDTH),
                value: rightSidebarWidth
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    isFixed && $a07a1808f1030823$var$fixedInnerStyles,
                    !isFixed && $a07a1808f1030823$var$staticInnerStyles
                ]
            }, children)));
    };
    var $a07a1808f1030823$export$2e2bcd8739ae039 = $a07a1808f1030823$var$RightSidebar;
});
parcelRegister("31ERv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7bf5fc6d75e2417f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $22jFS;
    var $8XpIo;
    var $2Pb5D;
    var $amcy7;
    var $fZqMW;
    var $jUxG6;
    const $7bf5fc6d75e2417f$var$topNavigationStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: (0, (0, parcelRequire("22jFS")).TOP_NAVIGATION_HEIGHT),
        gridArea: (0, (0, parcelRequire("22jFS")).TOP_NAVIGATION)
    });
    const $7bf5fc6d75e2417f$var$fixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'fixed',
        zIndex: 2,
        insetBlockStart: (0, (0, parcelRequire("22jFS")).BANNER_HEIGHT),
        insetInlineEnd: (0, (0, parcelRequire("22jFS")).RIGHT_PANEL_WIDTH),
        insetInlineStart: (0, (0, parcelRequire("22jFS")).LEFT_PANEL_WIDTH)
    });
    const $7bf5fc6d75e2417f$var$TopNavigation = (props)=>{
        const { children: children, height: height = (0, (0, parcelRequire("22jFS")).DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const topNavigationHeight = (0, (0, parcelRequire("8XpIo")).resolveDimension)((0, (0, parcelRequire("22jFS")).VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2Pb5D")).default)({
                [(0, (0, parcelRequire("22jFS")).VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
            });
            return ()=>{
                (0, (0, parcelRequire("2Pb5D")).default)({
                    [(0, (0, parcelRequire("22jFS")).VAR_TOP_NAVIGATION_HEIGHT)]: 0
                });
            };
        }, [
            topNavigationHeight
        ]);
        (0, (0, parcelRequire("amcy7")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZqMW")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $7bf5fc6d75e2417f$var$topNavigationStyles,
                    isFixed && $7bf5fc6d75e2417f$var$fixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("8XpIo")).getPageLayoutSlotSelector)('top-navigation')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUxG6")).default), {
                variableName: (0, (0, parcelRequire("22jFS")).VAR_TOP_NAVIGATION_HEIGHT),
                value: topNavigationHeight
            }), children));
    };
    var $7bf5fc6d75e2417f$export$2e2bcd8739ae039 = $7bf5fc6d75e2417f$var$TopNavigation;
});
parcelRegister("cIcFn", function(module, exports) {
    $parcel$export(module.exports, "useCustomSkipLink", ()=>$a8132564ed4ca271$export$ee6b12c2613bdf8e);
    var $5uXOq = parcelRequire("5uXOq");
    var $amcy7;
    const $a8132564ed4ca271$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, (0, parcelRequire("amcy7")).useSkipLinks)();
        (0, $5uXOq.useEffect)(()=>{
            registerSkipLink({
                id: id,
                skipLinkTitle: skipLinkTitle,
                listIndex: listIndex
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            listIndex,
            skipLinkTitle,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("2MLVq", function(module, exports) {
    $parcel$export(module.exports, "Aside", ()=>$77d6f7adcd563578$export$ac3bdfe4cb17f64e);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $lp9re;
    var $h9kUS;
    var $585q9;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $fVO1C;
    var $l9xvw;
    const $77d6f7adcd563578$var$panelSplitterResizingVar = '--n_asdRsz';
    const $77d6f7adcd563578$var$asideWidthSlotBounds = {
        min: '0px',
        max: '50vw'
    };
    const $77d6f7adcd563578$var$asideWidthResizeBounds = {
        min: '120px',
        max: '50vw'
    };
    const $77d6f7adcd563578$var$styles = {
        root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
        fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
    };
    function $77d6f7adcd563578$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330, label: label = 'Aside', testId: testId, id: id }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        const ref = (0, $5uXOq.useRef)(null);
        const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
        const previousWidthProp = (0, (0, parcelRequire("lp9re")).default)(defaultWidth);
        (0, $5uXOq.useEffect)(()=>{
            setWidth(defaultWidth);
        }, [
            defaultWidth
        ]);
        (0, $5uXOq.useEffect)(()=>{}, [
            defaultWidth,
            previousWidthProp
        ]);
        const asideVariableWidth = `clamp(${$77d6f7adcd563578$var$asideWidthSlotBounds.min}, ${width}px, ${$77d6f7adcd563578$var$asideWidthSlotBounds.max})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("aside", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $77d6f7adcd563578$var$styles.root,
                xcss
            ]),
            style: {
                [(0, (0, parcelRequire("ilnvx")).asideVar)]: asideVariableWidth
            },
            "data-testid": testId,
            ref: ref
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_asideLayoutVar),
            value: "0px",
            mediaQuery: (0, (0, parcelRequire("h9kUS")).media).above.md,
            responsiveValue: asideVariableWidth
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVO1C")).PanelSplitterProvider), {
            panelRef: ref,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $77d6f7adcd563578$var$asideWidthResizeBounds,
            resizingCssVar: $77d6f7adcd563578$var$panelSplitterResizingVar,
            position: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isFixed && $77d6f7adcd563578$var$styles.fixedContentArea
            ])
        }, children)));
    }
});
parcelRegister("585q9", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContext", ()=>$ac664e290f9d7ee4$export$4c5cc3b14c7678a);
    $parcel$export(module.exports, "useSkipLink", ()=>$ac664e290f9d7ee4$export$89d9323301efc7d6);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $ac664e290f9d7ee4$export$4c5cc3b14c7678a = (0, $5uXOq.createContext)({
        registerSkipLink: (0, (0, parcelRequire("eGmKJ")).default),
        unregisterSkipLink: (0, (0, parcelRequire("eGmKJ")).default)
    });
    const $ac664e290f9d7ee4$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($ac664e290f9d7ee4$export$4c5cc3b14c7678a);
    const $ac664e290f9d7ee4$export$89d9323301efc7d6 = (id, label, listIndex)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $ac664e290f9d7ee4$export$c9d9cb2ee9590f87();
        (0, $5uXOq.useEffect)(()=>{
            registerSkipLink({
                id: id,
                label: label,
                listIndex: listIndex
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            label,
            listIndex,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("ilnvx", function(module, exports) {
    $parcel$export(module.exports, "sideNavVar", ()=>$7e0cfbaebce245b0$export$951bf5156e86d974);
    $parcel$export(module.exports, "asideVar", ()=>$7e0cfbaebce245b0$export$594e6a30db7c057e);
    $parcel$export(module.exports, "panelVar", ()=>$7e0cfbaebce245b0$export$db0c2e1d744fb281);
    $parcel$export(module.exports, "bannerMountedVar", ()=>$7e0cfbaebce245b0$export$515a0b1baafe906c);
    $parcel$export(module.exports, "topBarMountedVar", ()=>$7e0cfbaebce245b0$export$a96e934b2a1eeee);
    $parcel$export(module.exports, "UNSAFE_topBarVar", ()=>$7e0cfbaebce245b0$export$f4afb213f937404c);
    $parcel$export(module.exports, "UNSAFE_bannerVar", ()=>$7e0cfbaebce245b0$export$26354f9814213292);
    $parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", ()=>$7e0cfbaebce245b0$export$6bfc931a04ec5741);
    $parcel$export(module.exports, "UNSAFE_asideLayoutVar", ()=>$7e0cfbaebce245b0$export$bbbace2ff0c7ae1b);
    $parcel$export(module.exports, "UNSAFE_panelLayoutVar", ()=>$7e0cfbaebce245b0$export$753bf7651b25db91);
    $parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", ()=>$7e0cfbaebce245b0$export$6460bd6a2446260);
    $parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", ()=>$7e0cfbaebce245b0$export$3055529fab2b4edf);
    $parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", ()=>$7e0cfbaebce245b0$export$166d8fd766c3eb92);
    const $7e0cfbaebce245b0$export$951bf5156e86d974 = '--n_sNvw';
    const $7e0cfbaebce245b0$export$594e6a30db7c057e = '--n_asDw';
    const $7e0cfbaebce245b0$export$db0c2e1d744fb281 = '--n_pnlW';
    const $7e0cfbaebce245b0$export$515a0b1baafe906c = '--n_bnrM';
    const $7e0cfbaebce245b0$export$a96e934b2a1eeee = '--n_tbrM';
    const $7e0cfbaebce245b0$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
    const $7e0cfbaebce245b0$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
    const $7e0cfbaebce245b0$export$f4afb213f937404c = '--topNavigationHeight';
    const $7e0cfbaebce245b0$export$26354f9814213292 = '--bannerHeight';
    const $7e0cfbaebce245b0$export$6bfc931a04ec5741 = '--leftSidebarWidth';
    const $7e0cfbaebce245b0$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
    const $7e0cfbaebce245b0$export$753bf7651b25db91 = '--rightPanelWidth';
    const $7e0cfbaebce245b0$export$6460bd6a2446260 = `calc(var(${$7e0cfbaebce245b0$export$26354f9814213292}, 0px) + var(${$7e0cfbaebce245b0$export$f4afb213f937404c}, 0px))`;
    const $7e0cfbaebce245b0$export$3055529fab2b4edf = `var(${$7e0cfbaebce245b0$export$6bfc931a04ec5741}, 0px)`;
    const $7e0cfbaebce245b0$export$166d8fd766c3eb92 = `calc(var(${$7e0cfbaebce245b0$export$bbbace2ff0c7ae1b}, 0px) + var(${$7e0cfbaebce245b0$export$753bf7651b25db91}, 0px))`;
    const $7e0cfbaebce245b0$export$61156ceb1a99f6a0 = {
        topBar: 4,
        banner: 4,
        topBarBorder: 3,
        sideNav: 2,
        contentBlockBorder: 2,
        contentInlineBorder: 1,
        panelSmallViewports: 1
    };
});
parcelRegister("8oF23", function(module, exports) {
    $parcel$export(module.exports, "DangerouslyHoistSlotSizes", ()=>$1ee0f763875d3fec$export$66e2c1a0115af861);
    var $5uXOq = parcelRequire("5uXOq");
    const $1ee0f763875d3fec$export$66e2c1a0115af861 = (0, $5uXOq.createContext)(false);
});
parcelRegister("2WR37", function(module, exports) {
    $parcel$export(module.exports, "HoistCssVarToLocalGrid", ()=>$cbb560d7ba4917d9$export$cfa3cd08d675e56e);
    $parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", ()=>$cbb560d7ba4917d9$export$9f45a1325e3cdfb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $1EWMr;
    const $cbb560d7ba4917d9$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", null, `#${(0, (0, parcelRequire("1EWMr")).gridRootId)} { ${variableName}: ${value}px }`);
    const $cbb560d7ba4917d9$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
    const $cbb560d7ba4917d9$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
        let style = `:root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(value)} }`;
        if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$cbb560d7ba4917d9$var$getCssStringValue(responsiveValue)} } }`;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("style", null, style));
    };
});
parcelRegister("1EWMr", function(module, exports) {
    $parcel$export(module.exports, "gridRootId", ()=>$f4db93acd3b1ab5b$export$a6d827031bcb31d1);
    $parcel$export(module.exports, "Root", ()=>$f4db93acd3b1ab5b$export$be92b6f5f03c0fe9);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iuUiD;
    var $df6Ex;
    var $ivVtd;
    var $8oF23;
    var $k3SPh;
    var $jDR0c;
    var $UTmRP;
    const $f4db93acd3b1ab5b$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
    const $f4db93acd3b1ab5b$var$styles = {
        root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
    };
    function $f4db93acd3b1ab5b$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            var child;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("UTmRP")).SideNavVisibilityProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jDR0c")).SideNavToggleButtonProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3SPh")).SideNavFlyoutLockProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("df6Ex")).HomeActionsProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes).Provider, {
            value: UNSAFE_dangerouslyHoistSlotSizes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ivVtd")).SkipLinksProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuUiD")).SkipLinksContainer), {
            label: skipLinksLabel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f4db93acd3b1ab5b$var$styles.root,
                xcss
            ]),
            id: $f4db93acd3b1ab5b$export$a6d827031bcb31d1,
            "data-testid": testId
        }, children)))))));
    }
});
parcelRegister("iuUiD", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContainer", ()=>$8a6fecf6d9ada26f$export$fce25a0c32fbc1e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cgL5K;
    var $4SKIy;
    var $hgvjm;
    const $8a6fecf6d9ada26f$var$styles = {
        root: "_18s8v47k _1rjcu2gc _18zr12x7 _kqsw1n9t _1pby1mrw _bfhk1bhr _2rkoglpi _16qs1cd0 _1e02qkuk _tzy4idpf _t9ec1i34 _1digjh3g _gtjaze3t _1mygkb7n _66dk1kli",
        skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozgze3t"
    };
    const $8a6fecf6d9ada26f$var$handleBlur = (event)=>{
        if (!(event.target instanceof Element)) return;
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $8a6fecf6d9ada26f$var$handleBlur);
    };
    const $8a6fecf6d9ada26f$var$escapeHandler = (event)=>{
        if (event.key === 'Escape') {
            const activeElement = document.activeElement;
            if (activeElement !== null) activeElement.blur();
        }
    };
    const $8a6fecf6d9ada26f$var$attachEscHandler = ()=>window.addEventListener('keydown', $8a6fecf6d9ada26f$var$escapeHandler, false);
    const $8a6fecf6d9ada26f$var$removeEscHandler = ()=>window.removeEventListener('keydown', $8a6fecf6d9ada26f$var$escapeHandler, false);
    const $8a6fecf6d9ada26f$export$fce25a0c32fbc1e1 = ({ label: label })=>{
        const sortedSkipLinks = (0, (0, parcelRequire("4SKIy")).useSortedSkipLinks)();
        if (sortedSkipLinks.length === 0) return null;
        const emptyLabelOverride = !!label?.match(/^\s+$/);
        return $5uXOq.createElement("div", {
            onFocus: $8a6fecf6d9ada26f$var$attachEscHandler,
            onBlur: $8a6fecf6d9ada26f$var$removeEscHandler,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $8a6fecf6d9ada26f$var$styles.root
            ])
        }, emptyLabelOverride ? null : $5uXOq.createElement((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium"
        }, label), $5uXOq.createElement("ol", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $8a6fecf6d9ada26f$var$styles.skipLinkList
            ])
        }, sortedSkipLinks.map(({ id: id, label: label })=>$5uXOq.createElement((0, (0, parcelRequire("hgvjm")).SkipLink), {
                key: id,
                href: `#${id}`,
                isFocusable: true
            }, label))));
    };
});
parcelRegister("4SKIy", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksDataContext", ()=>$a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
    $parcel$export(module.exports, "useSortedSkipLinks", ()=>$a6322a25f6b08ecb$export$b0b0d4fc1b356759);
    var $5uXOq = parcelRequire("5uXOq");
    const $a6322a25f6b08ecb$export$e9ab38ce6147d3d2 = (0, $5uXOq.createContext)([]);
    const $a6322a25f6b08ecb$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $a6322a25f6b08ecb$var$assignIndex(num + 1, arr);
    };
    const $a6322a25f6b08ecb$var$sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
            const listIndex = $a6322a25f6b08ecb$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const $a6322a25f6b08ecb$export$b0b0d4fc1b356759 = ()=>{
        const skipLinksData = (0, $5uXOq.useContext)($a6322a25f6b08ecb$export$e9ab38ce6147d3d2);
        return (0, $5uXOq.useMemo)(()=>{
            return $a6322a25f6b08ecb$var$sortSkipLinks(skipLinksData);
        }, [
            skipLinksData
        ]);
    };
});
parcelRegister("hgvjm", function(module, exports) {
    $parcel$export(module.exports, "SkipLink", ()=>$ca929d4ef6b95820$export$ef95c37428582a65);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jhmo0;
    const $ca929d4ef6b95820$var$styles = {
        skipLinkListItem: "_1pfhze3t"
    };
    const $ca929d4ef6b95820$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $ca929d4ef6b95820$var$assignIndex(num + 1, arr);
    };
    const $ca929d4ef6b95820$var$handleBlur = (event)=>{
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $ca929d4ef6b95820$var$handleBlur);
    };
    const $ca929d4ef6b95820$var$focusTargetRef = (href)=>(event)=>{
            event.preventDefault();
            const targetRef = document.querySelector(href);
            const key = event.which || event.keycode;
            if (key && key !== 13 && key !== 32) return;
            if (targetRef) {
                targetRef.setAttribute('tabindex', '-1');
                targetRef.addEventListener('blur', $ca929d4ef6b95820$var$handleBlur);
                targetRef.focus();
                document.activeElement && document.activeElement.scrollIntoView({
                    behavior: 'smooth'
                });
                window.scrollTo(0, 0);
            }
            return false;
        };
    const $ca929d4ef6b95820$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
        return $5uXOq.createElement("li", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $ca929d4ef6b95820$var$styles.skipLinkListItem
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("jhmo0")).default), {
            tabIndex: isFocusable ? 0 : -1,
            href: href,
            onClick: $ca929d4ef6b95820$var$focusTargetRef(href)
        }, children));
    };
});
parcelRegister("df6Ex", function(module, exports) {
    $parcel$export(module.exports, "HomeActionsProvider", ()=>$311e667ddca00164$export$8b9089606266983e);
    var $5uXOq = parcelRequire("5uXOq");
    var $c4wuJ;
    const $311e667ddca00164$export$8b9089606266983e = ({ children: children })=>{
        const [element, setElement] = (0, $5uXOq.useState)(null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4wuJ")).HomeActionsElement).Provider, {
            value: element
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4wuJ")).HomeActionsAttachRef).Provider, {
            value: setElement
        }, children));
    };
});
parcelRegister("ivVtd", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksProvider", ()=>$04aeed0b84d4da87$export$fe514f9f7b03d46f);
    var $5uXOq = parcelRequire("5uXOq");
    var $585q9;
    var $4SKIy;
    const $04aeed0b84d4da87$var$getByDomOrderSortFunction = ()=>{
        const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
        return (a, b)=>{
            const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
            const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
            if (indexA === indexB) {
                if (a.listIndex !== undefined) return -1;
                else return 1;
            }
            return indexA - indexB;
        };
    };
    const $04aeed0b84d4da87$export$fe514f9f7b03d46f = ({ children: children })=>{
        const [links, setLinks] = (0, $5uXOq.useState)([]);
        const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
            setLinks((oldLinks)=>{
                if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
                return [
                    ...oldLinks,
                    skipLinkData
                ].sort($04aeed0b84d4da87$var$getByDomOrderSortFunction());
            });
        }, []);
        const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
            setLinks((links)=>links.filter((link)=>link.id !== id));
        }, []);
        const contextValue = (0, $5uXOq.useMemo)(()=>{
            const data = {
                registerSkipLink: registerSkipLink,
                unregisterSkipLink: unregisterSkipLink
            };
            return data;
        }, [
            registerSkipLink,
            unregisterSkipLink
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("585q9")).SkipLinksContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4SKIy")).SkipLinksDataContext).Provider, {
            value: links
        }, children));
    };
});
parcelRegister("k3SPh", function(module, exports) {
    $parcel$export(module.exports, "SideNavFlyoutLockProvider", ()=>$4d4c2cd4cedcc93a$export$7003dd76deb92ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $1ma7Z;
    const $4d4c2cd4cedcc93a$export$7003dd76deb92ad = ({ children: children })=>{
        const [flyoutLock, setFlyoutLock] = (0, $5uXOq.useState)(0);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ma7Z")).FlyoutLockCount).Provider, {
            value: flyoutLock
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1ma7Z")).SetFlyoutLockCount).Provider, {
            value: setFlyoutLock
        }, children));
    };
});
parcelRegister("1ma7Z", function(module, exports) {
    $parcel$export(module.exports, "FlyoutLockCount", ()=>$b049cb649a0db0a3$export$962eb1e8d553c86f);
    $parcel$export(module.exports, "SetFlyoutLockCount", ()=>$b049cb649a0db0a3$export$52e873d56b3942a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    const $b049cb649a0db0a3$export$962eb1e8d553c86f = (0, $5uXOq.createContext)(0);
    const $b049cb649a0db0a3$export$52e873d56b3942a3 = (0, $5uXOq.createContext)((0, (0, parcelRequire("eGmKJ")).default));
});
parcelRegister("jDR0c", function(module, exports) {
    $parcel$export(module.exports, "SideNavToggleButtonProvider", ()=>$e430d141e8d30234$export$ceb8e60e9790fc0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZOeM;
    const $e430d141e8d30234$export$ceb8e60e9790fc0f = ({ children: children })=>{
        const [element, setElement] = (0, $5uXOq.useState)(null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZOeM")).SideNavToggleButtonElement).Provider, {
            value: element
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZOeM")).SideNavToggleButtonAttachRef).Provider, {
            value: setElement
        }, children));
    };
});
parcelRegister("UTmRP", function(module, exports) {
    $parcel$export(module.exports, "SideNavVisibilityProvider", ()=>$2510be1036df6cd8$export$aac8e996360f6ad9);
    var $5uXOq = parcelRequire("5uXOq");
    var $b0CFU;
    const $2510be1036df6cd8$export$aac8e996360f6ad9 = ({ children: children })=>{
        const [visibleOnDesktop, setVisibleOnDesktop] = (0, $5uXOq.useState)(null);
        const [visibleOnMobile, setVisibleOnMobile] = (0, $5uXOq.useState)(false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b0CFU")).SideNavDesktopVisibility).Provider, {
            value: visibleOnDesktop
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b0CFU")).SetSideNavDesktopVisibility).Provider, {
            value: setVisibleOnDesktop
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b0CFU")).SideNavMobileVisibility).Provider, {
            value: visibleOnMobile
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b0CFU")).SetSideNavMobileVisibility).Provider, {
            value: setVisibleOnMobile
        }, children))));
    };
});
parcelRegister("fVO1C", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitterProvider", ()=>$0739b5288fba2b3a$export$f662bfb764348932);
    var $5uXOq = parcelRequire("5uXOq");
    var $9NI3h;
    const $0739b5288fba2b3a$export$f662bfb764348932 = ({ panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
        const portalRef = (0, $5uXOq.useRef)(null);
        const context = (0, $5uXOq.useMemo)(()=>({
                panelWidth: panelWidth,
                onCompleteResize: onCompleteResize,
                resizeBounds: resizeBounds,
                portalRef: portalRef,
                resizingCssVar: resizingCssVar,
                position: position,
                panelRef: panelRef,
                isEnabled: isEnabled
            }), [
            isEnabled,
            onCompleteResize,
            panelRef,
            panelWidth,
            position,
            resizeBounds,
            resizingCssVar
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NI3h")).PanelSplitterContext).Provider, {
            value: context
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: portalRef
        }));
    };
});
parcelRegister("9NI3h", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitterContext", ()=>$ec571489384d3ca6$export$7a4054f2c546f2cd);
    var $5uXOq = parcelRequire("5uXOq");
    const $ec571489384d3ca6$export$7a4054f2c546f2cd = (0, $5uXOq.createContext)(null);
});
parcelRegister("l9xvw", function(module, exports) {
    $parcel$export(module.exports, "usePrefixedUID", ()=>$93943d3b0eb37778$export$86433d4fd18455f4);
    var $9KnKW;
    const $93943d3b0eb37778$export$86433d4fd18455f4 = (prefix = 'element')=>`${prefix}-${(0, (0, parcelRequire("9KnKW")).useId)()}`;
});
parcelRegister("jjRN8", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$365358079a8d32db$export$3b4e64e77073e307);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $585q9;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $l9xvw;
    const $365358079a8d32db$var$styles = {
        root: "_nd5ldkfm _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat _1reo15vq _18m915vq"
    };
    function $365358079a8d32db$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64, label: label = 'Banner', testId: testId, id: id }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: CID,
            role: "banner",
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $365358079a8d32db$var$styles.root,
                xcss
            ]),
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).HoistCssVarToLocalGrid), {
            variableName: (0, (0, parcelRequire("ilnvx")).bannerMountedVar),
            value: UNSAFE_height
        }), dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_bannerVar),
            value: UNSAFE_height
        }), children);
    }
});
parcelRegister("hOWCC", function(module, exports) {
    $parcel$export(module.exports, "Main", ()=>$325f1d6156df91d8$export$861edd1ccea2f746);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $585q9;
    var $l9xvw;
    var $2GcIE;
    const $325f1d6156df91d8$var$conditionalCurvedBorderRadiusCSSSelector = 'html:not(:has([data-private-do-not-show-curved-border-on-main="true"])):has([data-private-request-curved-border-on-main="true"]) &';
    const $325f1d6156df91d8$var$conditionalBorderInlineStartCSSSelector = 'html:has([data-private-show-inline-start-border-on-main="true"]) &';
    const $325f1d6156df91d8$var$mainElementStyles = {
        root: "_nd5l1gzg _19121cl4 _qwfh1wug",
        mainCurvedCorner: "_z0yti2wt",
        fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
    };
    const $325f1d6156df91d8$var$contentBorderStyles = {
        largeViewportTop: "_vchhusvi _h7aloyrj _mqm2zgxb _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbycs5v _1e0cglyw _jnn7i2wt _dm2518uv",
        largeViewportLeft: "_vchhusvi _izbqoyrj _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbykb7n _1e0cglyw _jnn7i2wt _ml4lzgxb _dm2518uv"
    };
    function $325f1d6156df91d8$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, label: label = 'Main Content', testId: testId, id: id }) {
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $325f1d6156df91d8$var$mainElementStyles.root,
                $325f1d6156df91d8$var$mainElementStyles.mainCurvedCorner,
                isFixed && $325f1d6156df91d8$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2GcIE")).MainStickyContext).Provider, {
            value: Boolean(isFixed)
        }, children)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $325f1d6156df91d8$var$contentBorderStyles.largeViewportLeft
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $325f1d6156df91d8$var$contentBorderStyles.largeViewportTop
            ])
        }));
    }
});
parcelRegister("2GcIE", function(module, exports) {
    $parcel$export(module.exports, "MainStickyContext", ()=>$7ccaf10616775f74$export$3b369e2c6c1ec840);
    var $5uXOq = parcelRequire("5uXOq");
    const $7ccaf10616775f74$export$3b369e2c6c1ec840 = (0, $5uXOq.createContext)(false);
});
parcelRegister("ZlCus", function(module, exports) {
    $parcel$export(module.exports, "Panel", ()=>$05534568732462ab$export$2ddb90ad54e5f587);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $h9kUS;
    var $585q9;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $fVO1C;
    var $l9xvw;
    const $05534568732462ab$var$panelSplitterResizingVar = '--n_pnlRsz';
    const $05534568732462ab$var$panelWidthSlotBounds = {
        min: '0px',
        max: '50vw'
    };
    const $05534568732462ab$var$panelWidthResizeBounds = {
        min: '120px',
        max: '50vw'
    };
    const $05534568732462ab$var$styles = {
        root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
        scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
        hidden: "_1e0cglyw"
    };
    function $05534568732462ab$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', testId: testId, id: id, xcss: xcss }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        const ref = (0, $5uXOq.useRef)(null);
        const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
        const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
        (0, $5uXOq.useEffect)(()=>{
            if (defaultWidthRef.current === defaultWidth) return;
            defaultWidthRef.current = defaultWidth;
            setWidth(defaultWidth);
        }, [
            defaultWidth
        ]);
        const panelVariableWidth = `clamp(${$05534568732462ab$var$panelWidthSlotBounds.min}, ${width}px, ${$05534568732462ab$var$panelWidthSlotBounds.max})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $05534568732462ab$var$styles.root,
                defaultWidth === 0 && $05534568732462ab$var$styles.hidden,
                xcss
            ]),
            style: {
                [(0, (0, parcelRequire("ilnvx")).panelVar)]: panelVariableWidth
            },
            "data-testid": testId,
            ref: ref
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_panelLayoutVar),
            value: "0px",
            mediaQuery: (0, (0, parcelRequire("h9kUS")).media).above.lg,
            responsiveValue: panelVariableWidth
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVO1C")).PanelSplitterProvider), {
            panelRef: ref,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $05534568732462ab$var$panelWidthResizeBounds,
            resizingCssVar: $05534568732462ab$var$panelSplitterResizingVar,
            position: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $05534568732462ab$var$styles.scrollContainer
            ])
        }, children)));
    }
});
parcelRegister("kTus1", function(module, exports) {
    $parcel$export(module.exports, "SideNav", ()=>$be4966f89908f895$export$1a35787d6353cf6a);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $dlnxJ;
    var $e4cTf;
    var $h9kUS;
    var $c4wuJ;
    var $585q9;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $fVO1C;
    var $l9xvw;
    var $eZOeM;
    var $ecbZX;
    var $27t8Q;
    var $6qnkT;
    const $be4966f89908f895$var$panelSplitterResizingVar = '--n_snvRsz';
    const $be4966f89908f895$var$widthResizeBounds = {
        min: '240px',
        max: '50vw'
    };
    const $be4966f89908f895$var$sideNavFlyoutCloseDelayMs = 400;
    const $be4966f89908f895$var$getSideNavState = ({ visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, isFlyoutVisible: isFlyoutVisible })=>{
        if (visibleOnDesktop && visibleOnMobile) return 'visible-all';
        if (!visibleOnMobile && visibleOnDesktop) return 'hidden-mobile-only';
        if (!visibleOnDesktop && isFlyoutVisible) return 'flyout';
        if (visibleOnMobile && !visibleOnDesktop) return 'hidden-desktop-only';
        return 'hidden-mobile-and-desktop';
    };
    const $be4966f89908f895$var$styles = {
        root: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _4ap3vuon _scbpglyw _qilnk0mc",
        flyout: "_4ap31bhr _scbp1cd0 _qiln1gzg",
        interactionSurface: "_1bsb1osq _4t3i1osq",
        flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
        hiddenMobileAndDesktop: "_1e0cglyw",
        hiddenMobileOnly: "_1e0cglyw _dm2518uv",
        hiddenDesktopOnly: "_dm25glyw"
    };
    function $be4966f89908f895$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        const { visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, setVisibleOnDesktop: setVisibleOnDesktop } = (0, (0, parcelRequire("ecbZX")).useSideNavVisibility)({
            defaultCollapsed: defaultCollapsed
        });
        const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
        const clampedWidth = `clamp(${$be4966f89908f895$var$widthResizeBounds.min}, ${width}px, ${$be4966f89908f895$var$widthResizeBounds.max})`;
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const navRef = (0, $5uXOq.useRef)(null);
        const toggleButtonElement = (0, $5uXOq.useContext)((0, (0, parcelRequire("eZOeM")).SideNavToggleButtonElement));
        const homeActionsElement = (0, $5uXOq.useContext)((0, (0, parcelRequire("c4wuJ")).HomeActionsElement));
        const devTimeOnlyAttributes = {};
        const [isFlyoutVisible, setIsFlyoutVisible] = (0, $5uXOq.useState)(false);
        const openLayerObserver = (0, (0, parcelRequire("e4cTf")).useOpenLayerObserver)();
        const flyoutStateRef = (0, $5uXOq.useRef)({
            type: 'not-active'
        });
        const sideNavState = $be4966f89908f895$var$getSideNavState({
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile,
            isFlyoutVisible: isFlyoutVisible
        });
        const updateFlyoutState = (0, $5uXOq.useCallback)((action)=>{
            if (action === 'open') {
                if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
                flyoutStateRef.current = {
                    type: 'open'
                };
                setIsFlyoutVisible(true);
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, $be4966f89908f895$var$sideNavFlyoutCloseDelayMs);
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                if (openLayerObserver.getCount() === 0) {
                    flyoutStateRef.current = {
                        type: 'not-active'
                    };
                    setIsFlyoutVisible(false);
                }
                return;
            }
            if (action === 'force-close') {
                flyoutStateRef.current = {
                    type: 'not-active'
                };
                setIsFlyoutVisible(false);
                return;
            }
        }, [
            openLayerObserver
        ]);
        const toggleVisibility = (0, (0, parcelRequire("6qnkT")).useToggleSideNav)();
        (0, $5uXOq.useEffect)(()=>{
            setVisibleOnDesktop(visibleOnDesktop);
        }, [
            setVisibleOnDesktop,
            visibleOnDesktop
        ]);
        const handleExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            onExpand?.({
                screen: screen
            });
            updateFlyoutState('force-close');
        }, [
            onExpand,
            updateFlyoutState
        ]);
        const handleCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            onCollapse?.({
                screen: screen
            });
            updateFlyoutState('force-close');
        }, [
            onCollapse,
            updateFlyoutState
        ]);
        (0, (0, parcelRequire("27t8Q")).useSideNavVisibilityCallbacks)({
            onExpand: handleExpand,
            onCollapse: handleCollapse,
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile
        });
        (0, $5uXOq.useEffect)(()=>{
            const mediaQueryList = window.matchMedia('(min-width: 64rem)');
            return (0, (0, parcelRequire("cBeZP")).bind)(mediaQueryList, {
                type: 'change',
                listener () {
                    if (mediaQueryList.matches) {
                        if (visibleOnMobile && !visibleOnDesktop) toggleVisibility();
                    }
                }
            });
        }, [
            toggleVisibility,
            visibleOnDesktop,
            visibleOnMobile
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(toggleButtonElement, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop) return;
                    const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                    if (matches) updateFlyoutState('open');
                }
            });
        }, [
            updateFlyoutState,
            toggleButtonElement,
            visibleOnDesktop
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(toggleButtonElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            isFlyoutVisible,
            toggleButtonElement,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(navRef.current, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    updateFlyoutState('open');
                }
            });
        }, [
            isFlyoutVisible,
            updateFlyoutState,
            visibleOnDesktop
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(navRef.current, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            isFlyoutVisible,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!homeActionsElement || !toggleButtonElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(homeActionsElement, {
                type: 'mouseover',
                listener (event) {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    if (event.target === homeActionsElement) {
                        updateFlyoutState('open');
                        return;
                    }
                    if (event.target instanceof Element && toggleButtonElement.contains(event.target)) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            homeActionsElement,
            isFlyoutVisible,
            toggleButtonElement,
            visibleOnDesktop,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!homeActionsElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(homeActionsElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            homeActionsElement,
            isFlyoutVisible,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return openLayerObserver.onChange(function onChange({ count: count }) {
                if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) {
                    setIsFlyoutVisible(false);
                    flyoutStateRef.current = {
                        type: 'not-active'
                    };
                }
            });
        }, [
            openLayerObserver,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return function cleanupPendingFlyoutClose() {
                if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("nav", {
            id: CID,
            ...devTimeOnlyAttributes,
            "data-layout-slot": true,
            "data-private-request-curved-border-on-main": sideNavState === 'visible-all' || sideNavState === 'hidden-mobile-only' ? true : undefined,
            "data-private-show-inline-start-border-on-main": sideNavState === 'visible-all' || sideNavState === 'hidden-mobile-only' ? true : undefined,
            "aria-label": label,
            style: {
                [(0, (0, parcelRequire("ilnvx")).sideNavVar)]: clampedWidth
            },
            ref: navRef,
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $be4966f89908f895$var$styles.root,
                sideNavState === 'hidden-mobile-only' && $be4966f89908f895$var$styles.hiddenMobileOnly,
                sideNavState === 'hidden-desktop-only' && $be4966f89908f895$var$styles.hiddenDesktopOnly,
                sideNavState === 'hidden-mobile-and-desktop' && $be4966f89908f895$var$styles.hiddenMobileAndDesktop,
                sideNavState === 'flyout' && $be4966f89908f895$var$styles.flyout
            ])
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_sideNavLayoutVar),
            value: "0px",
            mediaQuery: (0, (0, parcelRequire("h9kUS")).media).above.md,
            responsiveValue: visibleOnDesktop ? clampedWidth : 0
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVO1C")).PanelSplitterProvider), {
            panelRef: navRef,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $be4966f89908f895$var$widthResizeBounds,
            resizingCssVar: $be4966f89908f895$var$panelSplitterResizingVar,
            isEnabled: sideNavState === 'visible-all' || sideNavState === 'hidden-mobile-only'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $be4966f89908f895$var$styles.flexContainer
            ])
        }, children)));
    }
    function $be4966f89908f895$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dlnxJ")).OpenLayerObserver), null, (0, ($parcel$interopDefault($5uXOq))).createElement($be4966f89908f895$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id
        }, children));
    }
});
parcelRegister("dlnxJ", function(module, exports) {
    $parcel$export(module.exports, "OpenLayerObserver", ()=>$db6ff2d140327fd6$export$97afddda23bcd287);
    var $5uXOq = parcelRequire("5uXOq");
    var $kEhTY;
    function $db6ff2d140327fd6$var$createInternalAPI() {
        let count = 0;
        const registry = new Set();
        function onChange(listener) {
            function wrapped(...args) {
                listener(...args);
            }
            registry.add(wrapped);
            return function unsubscribe() {
                registry.delete(wrapped);
            };
        }
        function increment() {
            count += 1;
            Array.from(registry).forEach((listener)=>listener({
                    count: count
                }));
        }
        function decrement() {
            count -= 1;
            Array.from(registry).forEach((listener)=>listener({
                    count: count
                }));
        }
        return {
            getCount () {
                return count;
            },
            onChange: onChange,
            increment: increment,
            decrement: decrement
        };
    }
    function $db6ff2d140327fd6$export$97afddda23bcd287({ children: children }) {
        const [internalAPI] = (0, $5uXOq.useState)(()=>$db6ff2d140327fd6$var$createInternalAPI());
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kEhTY")).OpenLayerObserverContext));
        const increment = (0, $5uXOq.useCallback)(()=>{
            internalAPI.increment();
            if (parentContext !== null) parentContext.increment();
        }, [
            internalAPI,
            parentContext
        ]);
        const decrement = (0, $5uXOq.useCallback)(()=>{
            internalAPI.decrement();
            if (parentContext !== null) parentContext.decrement();
        }, [
            internalAPI,
            parentContext
        ]);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                getCount: internalAPI.getCount,
                onChange: internalAPI.onChange,
                increment: increment,
                decrement: decrement
            }), [
            decrement,
            increment,
            internalAPI.getCount,
            internalAPI.onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kEhTY")).OpenLayerObserverContext).Provider, {
            value: contextValue
        }, children);
    }
});
parcelRegister("e4cTf", function(module, exports) {
    $parcel$export(module.exports, "useOpenLayerObserver", ()=>$ea3ab92c791f0d5d$export$750f5b0d6c51617e);
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    var $kEhTY;
    function $ea3ab92c791f0d5d$export$750f5b0d6c51617e() {
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("kEhTY")).OpenLayerObserverContext));
        (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
        const publicAPI = (0, $5uXOq.useMemo)(()=>({
                getCount: context.getCount,
                onChange: context.onChange
            }), [
            context.getCount,
            context.onChange
        ]);
        return publicAPI;
    }
});
parcelRegister("27t8Q", function(module, exports) {
    $parcel$export(module.exports, "useSideNavVisibilityCallbacks", ()=>$cb86acb1b056338b$export$1904b8f2577aba9a);
    var $5uXOq = parcelRequire("5uXOq");
    var $lp9re;
    function $cb86acb1b056338b$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile }) {
        const onExpandRef = (0, $5uXOq.useRef)(onExpand);
        const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
        (0, $5uXOq.useEffect)(()=>{
            onExpandRef.current = onExpand;
            onCollapseRef.current = onCollapse;
        }, [
            onExpand,
            onCollapse
        ]);
        const previousVisibleOnDesktop = (0, (0, parcelRequire("lp9re")).default)(visibleOnDesktop);
        (0, $5uXOq.useEffect)(()=>{
            if (previousVisibleOnDesktop === undefined || previousVisibleOnDesktop === visibleOnDesktop) return;
            if (visibleOnDesktop) onExpandRef.current?.({
                screen: 'desktop'
            });
            else onCollapseRef.current?.({
                screen: 'desktop'
            });
        }, [
            previousVisibleOnDesktop,
            visibleOnDesktop
        ]);
        const previousVisibleOnMobile = (0, (0, parcelRequire("lp9re")).default)(visibleOnMobile);
        (0, $5uXOq.useEffect)(()=>{
            if (previousVisibleOnMobile === undefined || previousVisibleOnMobile === visibleOnMobile) return;
            if (visibleOnMobile) onExpandRef.current?.({
                screen: 'mobile'
            });
            else onCollapseRef.current?.({
                screen: 'mobile'
            });
        }, [
            previousVisibleOnMobile,
            visibleOnMobile
        ]);
    }
});
parcelRegister("fod7Z", function(module, exports) {
    $parcel$export(module.exports, "TopBar", ()=>$474d185125d63dcd$export$c4e96258f3b6511);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $585q9;
    var $7K1Hj;
    var $C93Ef;
    var $ilnvx;
    var $8oF23;
    var $2WR37;
    var $l9xvw;
    const $474d185125d63dcd$var$styles = {
        root: "_1e0c11p5 _yv0e1mfv _zulpu2gc _nd5l8cbt _18zrutpp _4cvr1h6o _bfhkvuon _vchhusvi _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1rqtc57g"
    };
    const $474d185125d63dcd$var$contentBorderStyles = {
        smallViewportTop: "_nd5l8cbt _179rzgxb _152t1nws _lcxvglyw _kqsw1if8 _t9ec2nsj _1pby11wp _dm25glyw"
    };
    function $474d185125d63dcd$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, label: label = 'Top Bar', testId: testId, id: id, UNSAFE_theme: UNSAFE_theme }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("8oF23")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("l9xvw")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("585q9")).useSkipLink)(CID, label);
        const customTheme = (0, (0, parcelRequire("C93Ef")).useCustomTheme)(UNSAFE_theme);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K1Hj")).HasCustomThemeContext).Provider, {
            value: customTheme.isEnabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("header", {
            id: CID,
            "data-layout-slot": true,
            "data-private-do-not-show-curved-border-on-main": customTheme.isEnabled ? true : undefined,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $474d185125d63dcd$var$styles.root,
                xcss
            ]),
            "data-testid": testId,
            style: customTheme.isEnabled ? customTheme.style : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).HoistCssVarToLocalGrid), {
            variableName: (0, (0, parcelRequire("ilnvx")).topBarMountedVar),
            value: UNSAFE_height
        }), dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WR37")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("ilnvx")).UNSAFE_topBarVar),
            value: UNSAFE_height
        }), children), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $474d185125d63dcd$var$contentBorderStyles.smallViewportTop
            ])
        }));
    }
});
parcelRegister("C93Ef", function(module, exports) {
    $parcel$export(module.exports, "useCustomTheme", ()=>$7d674db87d8ae404$export$c0c5f5b297b77726);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $408XH;
    function $7d674db87d8ae404$export$c0c5f5b297b77726(theme) {
        const value = (0, $5uXOq.useMemo)(()=>{
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_nav4_top_bar_theming')) return {
                isEnabled: false
            };
            if (!theme?.backgroundColor || !theme?.highlightColor) return {
                isEnabled: false
            };
            const value = {
                backgroundColor: theme.backgroundColor,
                highlightColor: theme.highlightColor
            };
            const style = (0, (0, parcelRequire("408XH")).getCustomThemeStyles)(value);
            return {
                isEnabled: true,
                style: style
            };
        }, [
            theme?.backgroundColor,
            theme?.highlightColor
        ]);
        return value;
    }
});
parcelRegister("408XH", function(module, exports) {
    $parcel$export(module.exports, "getCustomThemeStyles", ()=>$0ea127ed833ce03d$export$3986d75fe2da3239);
    var $g8Ctp;
    var $65VCl;
    var $kuLvb;
    var $3ysBv;
    var $al2bB;
    const $0ea127ed833ce03d$var$buttonStyles = {
        light: {
            [(0, (0, parcelRequire("65VCl")).themedButtonBackground)]: 'transparent',
            [(0, (0, parcelRequire("65VCl")).themedButtonBackgroundHovered)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral200A,
            [(0, (0, parcelRequire("65VCl")).themedButtonBackgroundPressed)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonBorder)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackground)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackgroundHovered)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral400A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackgroundPressed)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral500A,
            [(0, (0, parcelRequire("65VCl")).themedButtonDisabledText)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral400A,
            [(0, (0, parcelRequire("65VCl")).themedButtonDisabledBackground)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral100A
        },
        dark: {
            [(0, (0, parcelRequire("65VCl")).themedButtonBackground)]: 'transparent',
            [(0, (0, parcelRequire("65VCl")).themedButtonBackgroundHovered)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral200A,
            [(0, (0, parcelRequire("65VCl")).themedButtonBackgroundPressed)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonBorder)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackground)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral300A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackgroundHovered)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral400A,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBackgroundPressed)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral500A,
            [(0, (0, parcelRequire("65VCl")).themedButtonDisabledText)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral400A,
            [(0, (0, parcelRequire("65VCl")).themedButtonDisabledBackground)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral100A
        }
    };
    const $0ea127ed833ce03d$var$logoStyles = {
        light: {
            [(0, (0, parcelRequire("g8Ctp")).themedLogoIcon)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral0,
            [(0, (0, parcelRequire("g8Ctp")).themedLogoText)]: (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral0
        },
        dark: {
            [(0, (0, parcelRequire("g8Ctp")).themedLogoIcon)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral0,
            [(0, (0, parcelRequire("g8Ctp")).themedLogoText)]: (0, (0, parcelRequire("3ysBv")).palette).Neutral0
        }
    };
    function $0ea127ed833ce03d$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
        const backgroundRgb = (0, (0, parcelRequire("kuLvb")).hexToRGB)(backgroundColor);
        const highlightRgb = (0, (0, parcelRequire("kuLvb")).hexToRGB)(highlightColor);
        const textColor = (0, (0, parcelRequire("kuLvb")).getTextColor)(backgroundRgb);
        const colorMode = (0, (0, parcelRequire("kuLvb")).getColorMode)(backgroundRgb);
        const highlightTextColor = (0, (0, parcelRequire("kuLvb")).getTextColor)(highlightRgb);
        return {
            backgroundColor: backgroundColor,
            color: textColor.hex,
            ...$0ea127ed833ce03d$var$buttonStyles[colorMode],
            ...$0ea127ed833ce03d$var$logoStyles[colorMode],
            ...$0ea127ed833ce03d$var$getSelectedStyles({
                backgroundColor: backgroundRgb,
                colorMode: colorMode
            }),
            [(0, (0, parcelRequire("al2bB")).themedSearchBorder)]: (0, (0, parcelRequire("kuLvb")).toRGBAString)({
                ...textColor.rgb,
                a: 0.5
            }),
            [(0, (0, parcelRequire("al2bB")).themedSearchBorderFocused)]: (0, (0, parcelRequire("kuLvb")).toRGBAString)({
                ...highlightRgb,
                a: 0.8
            }),
            [(0, (0, parcelRequire("65VCl")).themedButtonPrimaryBackground)]: highlightColor,
            [(0, (0, parcelRequire("65VCl")).themedButtonPrimaryBackgroundHovered)]: (0, (0, parcelRequire("kuLvb")).toRGBAString)({
                ...highlightRgb,
                a: 0.8
            }),
            [(0, (0, parcelRequire("65VCl")).themedButtonPrimaryBackgroundPressed)]: (0, (0, parcelRequire("kuLvb")).toRGBAString)({
                ...highlightRgb,
                a: 0.65
            }),
            [(0, (0, parcelRequire("65VCl")).themedButtonPrimaryText)]: highlightTextColor.hex
        };
    }
    const $0ea127ed833ce03d$var$selectedBackgroundRGBA = {
        light: (0, (0, parcelRequire("kuLvb")).hexToRGBA)($0ea127ed833ce03d$var$buttonStyles.light[0, (0, parcelRequire("65VCl")).themedButtonSelectedBackground]),
        dark: (0, (0, parcelRequire("kuLvb")).hexToRGBA)($0ea127ed833ce03d$var$buttonStyles.dark[0, (0, parcelRequire("65VCl")).themedButtonSelectedBackground])
    };
    function $0ea127ed833ce03d$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
        const foregroundColor = $0ea127ed833ce03d$var$selectedBackgroundRGBA[colorMode];
        const blendedBackground = (0, (0, parcelRequire("kuLvb")).simpleAlphaComposite)({
            background: backgroundColor,
            foreground: foregroundColor
        });
        return {
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedText)]: (0, (0, parcelRequire("kuLvb")).getTextColor)(blendedBackground).hex,
            [(0, (0, parcelRequire("65VCl")).themedButtonSelectedBorder)]: (0, (0, parcelRequire("kuLvb")).isLight)(blendedBackground) ? (0, (0, parcelRequire("3ysBv")).palette).Neutral1100 : (0, (0, parcelRequire("3ysBv")).palette).DarkNeutral1100
        };
    }
});
parcelRegister("g8Ctp", function(module, exports) {
    $parcel$export(module.exports, "themedLogoIcon", ()=>$293136d9291fb1c4$export$24328117f1132113);
    $parcel$export(module.exports, "themedLogoText", ()=>$293136d9291fb1c4$export$91b0830f8f4ab279);
    $parcel$export(module.exports, "NavLogo", ()=>$293136d9291fb1c4$export$b6394419753329e);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $7K1Hj;
    const $293136d9291fb1c4$export$24328117f1132113 = '--ds-top-bar-logo-icon';
    const $293136d9291fb1c4$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
    const $293136d9291fb1c4$var$navLogoStyles = {
        root: "_1e0c1txw _4cvr1h6o _4t3izwfg _2rkoiti9",
        icon: "_1e0c1txw _p12f1tcg _vchh18uv _18zr1b66 _10y4glyw",
        logo: "_1e0cglyw _p12fnklw _vchh18uv _18zru2gc _10y41txw",
        imageContainer: "_1reo15vq _18m915vq _bna71tcg _rtys1kw7 _1jpx1f51"
    };
    const $293136d9291fb1c4$export$b6394419753329e = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label = 'Home' })=>{
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            return;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            ref: ref,
            "aria-label": label,
            href: href,
            xcss: $293136d9291fb1c4$var$navLogoStyles.root,
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $293136d9291fb1c4$var$navLogoStyles.imageContainer,
                $293136d9291fb1c4$var$navLogoStyles.icon
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($293136d9291fb1c4$var$NavLogoRenderer, {
            logoOrIcon: icon
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $293136d9291fb1c4$var$navLogoStyles.imageContainer,
                $293136d9291fb1c4$var$navLogoStyles.logo
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($293136d9291fb1c4$var$NavLogoRenderer, {
            logoOrIcon: logo
        })));
    };
    function $293136d9291fb1c4$var$NavLogoRenderer({ logoOrIcon: LogoOrIcon }) {
        const hasCustomTheme = (0, (0, parcelRequire("7K1Hj")).useHasCustomTheme)();
        if (hasCustomTheme) return (0, ($parcel$interopDefault($5uXOq))).createElement(LogoOrIcon, {
            size: "small",
            label: "",
            iconColor: `var(${$293136d9291fb1c4$export$24328117f1132113})`,
            textColor: `var(${$293136d9291fb1c4$export$91b0830f8f4ab279})`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement(LogoOrIcon, {
            size: "small",
            label: "",
            appearance: "brand"
        });
    }
});
parcelRegister("kuLvb", function(module, exports) {
    $parcel$export(module.exports, "toRGBAString", ()=>$1acf112c63636f80$export$b597d7418f37d50a);
    $parcel$export(module.exports, "hexToRGBA", ()=>$1acf112c63636f80$export$7229be6d7219ee6a);
    $parcel$export(module.exports, "hexToRGB", ()=>$1acf112c63636f80$export$848d71df1f759bc);
    $parcel$export(module.exports, "isLight", ()=>$1acf112c63636f80$export$44af652f4cca9039);
    $parcel$export(module.exports, "getColorMode", ()=>$1acf112c63636f80$export$5573a5bab3e074b5);
    $parcel$export(module.exports, "getTextColor", ()=>$1acf112c63636f80$export$5357fe757c335c0d);
    $parcel$export(module.exports, "simpleAlphaComposite", ()=>$1acf112c63636f80$export$e5e64c30bee1469b);
    const $1acf112c63636f80$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
    const $1acf112c63636f80$var$isValidHexNoAlpha = (hex)=>/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
    function $1acf112c63636f80$export$b597d7418f37d50a({ r: r, g: g, b: b, a: a }) {
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    }
    function $1acf112c63636f80$export$7229be6d7219ee6a(hex) {
        if (!$1acf112c63636f80$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let channels;
        if (hex.length <= 5) channels = {
            r: hex[1].repeat(2),
            g: hex[2].repeat(2),
            b: hex[3].repeat(2),
            a: hex[4]?.repeat(2) ?? 'FF'
        };
        else channels = {
            r: hex.slice(1, 3),
            g: hex.slice(3, 5),
            b: hex.slice(5, 7),
            a: hex.slice(7, 9) || 'FF'
        };
        return {
            r: parseInt(channels.r, 16),
            g: parseInt(channels.g, 16),
            b: parseInt(channels.b, 16),
            a: parseInt(channels.a, 16) / 255
        };
    }
    function $1acf112c63636f80$export$848d71df1f759bc(hex) {
        if (!$1acf112c63636f80$var$isValidHexNoAlpha(hex)) throw new Error('Invalid HEX');
        const { r: r, g: g, b: b } = $1acf112c63636f80$export$7229be6d7219ee6a(hex);
        return {
            r: r,
            g: g,
            b: b
        };
    }
    function $1acf112c63636f80$var$linearizeRGBChannel(channel) {
        return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    function $1acf112c63636f80$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
        const normal = {
            r: r / 255,
            g: g / 255,
            b: b / 255
        };
        const linear = {
            r: $1acf112c63636f80$var$linearizeRGBChannel(normal.r),
            g: $1acf112c63636f80$var$linearizeRGBChannel(normal.g),
            b: $1acf112c63636f80$var$linearizeRGBChannel(normal.b)
        };
        const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
        return L;
    }
    function $1acf112c63636f80$export$d061e26956a60b0a({ background: background, foreground: foreground }) {
        const foregroundLuminance = $1acf112c63636f80$var$relativeLuminanceW3C(foreground);
        const backgroundLuminance = $1acf112c63636f80$var$relativeLuminanceW3C(background);
        const brightest = Math.max(foregroundLuminance, backgroundLuminance);
        const darkest = Math.min(foregroundLuminance, backgroundLuminance);
        return (brightest + 0.05) / (darkest + 0.05);
    }
    const $1acf112c63636f80$var$flipLuminance = 0.179129;
    function $1acf112c63636f80$export$44af652f4cca9039(color) {
        return $1acf112c63636f80$var$relativeLuminanceW3C(color) >= $1acf112c63636f80$var$flipLuminance;
    }
    function $1acf112c63636f80$export$5573a5bab3e074b5(backgroundColor) {
        if ($1acf112c63636f80$var$relativeLuminanceW3C(backgroundColor) >= $1acf112c63636f80$var$flipLuminance) return 'light';
        return 'dark';
    }
    const $1acf112c63636f80$var$textColor = {
        light: {
            hex: '#000',
            rgb: {
                r: 0,
                g: 0,
                b: 0
            }
        },
        dark: {
            hex: '#FFF',
            rgb: {
                r: 255,
                g: 255,
                b: 255
            }
        }
    };
    function $1acf112c63636f80$export$5357fe757c335c0d(backgroundColor) {
        const colorMode = $1acf112c63636f80$export$5573a5bab3e074b5(backgroundColor);
        return $1acf112c63636f80$var$textColor[colorMode];
    }
    function $1acf112c63636f80$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
        return {
            r: foreground.a * foreground.r + background.r * (1 - foreground.a),
            g: foreground.a * foreground.g + background.g * (1 - foreground.a),
            b: foreground.a * foreground.b + background.b * (1 - foreground.a)
        };
    }
});
parcelRegister("3ysBv", function(module, exports) {
    $parcel$export(module.exports, "palette", ()=>$7460df5260aa7edf$export$eaad8caa32d2521d);
    const $7460df5260aa7edf$export$eaad8caa32d2521d = {
        'DarkNeutral-100': '#111213',
        'DarkNeutral-100A': '#01040475',
        DarkNeutral0: '#18191A',
        DarkNeutral100: '#1F1F21',
        DarkNeutral100A: '#BDBDBD0A',
        DarkNeutral200: '#242528',
        DarkNeutral200A: '#CECED912',
        DarkNeutral250: '#2B2C2F',
        DarkNeutral250A: '#D9DAE71A',
        DarkNeutral300: '#303134',
        DarkNeutral300A: '#E3E4F21F',
        DarkNeutral350: '#3D3F43',
        DarkNeutral350A: '#E8EDFD2E',
        DarkNeutral400: '#4B4D51',
        DarkNeutral400A: '#E5E9F640',
        DarkNeutral500: '#63666B',
        DarkNeutral500A: '#E9F0FB5C',
        DarkNeutral600: '#7E8188',
        DarkNeutral700: '#96999E',
        DarkNeutral800: '#A9ABAF',
        DarkNeutral900: '#BFC1C4',
        DarkNeutral1000: '#CECFD2',
        DarkNeutral1100: '#E2E3E4',
        Neutral0: '#FFFFFF',
        Neutral100: '#F8F8F8',
        Neutral100A: '#17171708',
        Neutral200: '#F0F1F2',
        Neutral200A: '#0515240F',
        Neutral300: '#DDDEE1',
        Neutral300A: '#0B120E24',
        Neutral400: '#B7B9BE',
        Neutral400A: '#080F214A',
        Neutral500: '#8C8F97',
        Neutral500A: '#050C1F75',
        Neutral600: '#7D818A',
        Neutral700: '#6B6E76',
        Neutral800: '#505258',
        Neutral900: '#3B3D42',
        Neutral1000: '#292A2E',
        Neutral1100: '#1E1F21'
    };
});
parcelRegister("al2bB", function(module, exports) {
    $parcel$export(module.exports, "themedSearchBorder", ()=>$02c56316137b9683$export$ae6fbf5ba3a7a784);
    $parcel$export(module.exports, "themedSearchBorderFocused", ()=>$02c56316137b9683$export$ee42b8430f4c19bd);
    $parcel$export(module.exports, "useLegacySearchTheme", ()=>$02c56316137b9683$export$18a29b1ed2212823);
    var $65VCl;
    var $7K1Hj;
    const $02c56316137b9683$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
    const $02c56316137b9683$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
    const $02c56316137b9683$export$7931ecdcbff2536 = {
        default: {
            backgroundColor: 'transparent',
            color: 'currentColor',
            borderColor: `var(${$02c56316137b9683$export$ae6fbf5ba3a7a784})`
        },
        focus: {
            color: "var(--ds-text, #172B4D)",
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            borderColor: `var(${$02c56316137b9683$export$ee42b8430f4c19bd})`,
            boxShadow: `inset 0px 0px 0px 1px var(${$02c56316137b9683$export$ee42b8430f4c19bd})`
        },
        hover: {
            backgroundColor: `var(${(0, (0, parcelRequire("65VCl")).themedButtonBackgroundHovered)})`
        }
    };
    function $02c56316137b9683$export$18a29b1ed2212823() {
        const hasCustomTheme = (0, (0, parcelRequire("7K1Hj")).useHasCustomTheme)();
        if (hasCustomTheme) return $02c56316137b9683$export$7931ecdcbff2536;
        return undefined;
    }
});
parcelRegister("4YvKq", function(module, exports) {
    $parcel$export(module.exports, "Help", ()=>$8f34ba1016bafdbb$export$1be7516c0280bee8);
    var $5uXOq = parcelRequire("5uXOq");
    var $dg0Fl;
    var $gKAEK;
    var $2WekC;
    var $7Onh2;
    const $8f34ba1016bafdbb$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
    const $8f34ba1016bafdbb$export$1be7516c0280bee8 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
        const { mode: { navigation: navigation } } = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const button = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Onh2")).IconButton), {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dg0Fl"))))), {
                label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
                color: "currentColor",
                spacing: "spacious",
                LEGACY_secondaryColor: navigation.backgroundColor
            }),
            ref: ref,
            tooltip: tooltip,
            ...iconButtonProps
        });
        return badge ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WekC")).BadgeContainer), {
            id: $8f34ba1016bafdbb$var$HELP_NOTIFICATION_BADGE_ID,
            badge: badge,
            role: "listitem"
        }, button) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "listitem"
        }, button);
    });
    var $8f34ba1016bafdbb$export$2e2bcd8739ae039 = $8f34ba1016bafdbb$export$1be7516c0280bee8;
});
parcelRegister("2WekC", function(module, exports) {
    $parcel$export(module.exports, "BadgeContainer", ()=>$b5ac5d6c4dfbdac2$export$f710265eb5a003da);
    var $f8Sb3;
    function $b5ac5d6c4dfbdac2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b5ac5d6c4dfbdac2$var$badgeContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'absolute',
        insetBlockStart: `${"var(--ds-space-negative-050, -4px)"}`,
        insetInlineEnd: `${"var(--ds-space-negative-025, -2px)"}`,
        pointerEvents: 'none'
    });
    const $b5ac5d6c4dfbdac2$var$containerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $b5ac5d6c4dfbdac2$export$f710265eb5a003da = (props)=>{
        const { id: badgeId, badge: Badge, children: children, role: role } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b5ac5d6c4dfbdac2$var$containerStyles,
            role: role
        }, children, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b5ac5d6c4dfbdac2$var$badgeContainerStyles,
            id: badgeId,
            "aria-hidden": true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Badge, null)));
    };
});
parcelRegister("9kXvc", function(module, exports) {
    $parcel$export(module.exports, "SkeletonHelpButton", ()=>$70aba88b02ff347a$export$9ee5d6e291d4e456);
    $parcel$export(module.exports, "Nav4SkeletonHelpButton", ()=>$70aba88b02ff347a$export$c25bc9ca782b25f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $dg0Fl;
    var $8nk07;
    var $3XuTW;
    var $gKAEK;
    const $70aba88b02ff347a$export$9ee5d6e291d4e456 = ({ label: label = '' })=>{
        const { mode: { navigation: navigation } } = (0, (0, parcelRequire("gKAEK")).useTheme)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XuTW")).SkeletonIconButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dg0Fl"))))), {
            label: label,
            color: "currentColor",
            LEGACY_secondaryColor: navigation.backgroundColor
        }));
    };
    const $70aba88b02ff347a$export$c25bc9ca782b25f4 = ({ label: label = '' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XuTW")).SkeletonIconButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8nk07"))))), {
            label: label,
            spacing: "spacious",
            color: "var(--ds-icon, #44546F)"
        }));
});
parcelRegister("ey2zZ", function(module, exports) {
    $parcel$export(module.exports, "Help", ()=>$2fecf07e9130a44a$export$1be7516c0280bee8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8nk07;
    var $9MMay;
    var $eUDGK;
    var $Ee6JC;
    const $2fecf07e9130a44a$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
    const $2fecf07e9130a44a$export$1be7516c0280bee8 = (0, $5uXOq.forwardRef)(({ badge: badge, onClick: onClick, label: label, isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>{
        const button = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Ee6JC")).IconButton), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("8nk07"))))),
            label: label,
            onClick: onClick,
            appearance: "subtle",
            isSelected: isSelected,
            ref: forwardedRef,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName
        });
        if (!badge) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eUDGK")).ListItem), null, button);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MMay")).BadgeContainer), {
            id: $2fecf07e9130a44a$var$HELP_NOTIFICATION_BADGE_ID,
            badge: badge,
            role: "listitem"
        }, button);
    });
});
parcelRegister("9MMay", function(module, exports) {
    $parcel$export(module.exports, "BadgeContainer", ()=>$e73d1b1ea40e5fd9$export$f710265eb5a003da);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $e73d1b1ea40e5fd9$var$styles = {
        root: "_kqswh2mm _1e0c1txw",
        badgeContainer: "_kqswstnw _o5721q9c _152tr5cr _1e02utpp _lcxvglyw"
    };
    const $e73d1b1ea40e5fd9$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, role: role })=>$5uXOq.createElement("div", {
            role: role,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $e73d1b1ea40e5fd9$var$styles.root
            ])
        }, children, $5uXOq.createElement("div", {
            id: badgeId,
            "aria-hidden": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $e73d1b1ea40e5fd9$var$styles.badgeContainer
            ])
        }, $5uXOq.createElement(Badge, null)));
});
parcelRegister("eUDGK", function(module, exports) {
    $parcel$export(module.exports, "ListItem", ()=>$afd3e9c9301967e3$export$a7b06bfba60a8a78);
    var $5uXOq = parcelRequire("5uXOq");
    function $afd3e9c9301967e3$var$_ListItem({ children: children, xcss: xcss }, ref) {
        return ($5uXOq.createElement("div", {
            role: "listitem",
            ref: ref,
            className: xcss
        }, children));
    }
    const $afd3e9c9301967e3$export$a7b06bfba60a8a78 = (0, $5uXOq.forwardRef)($afd3e9c9301967e3$var$_ListItem);
});
parcelRegister("a1X0L", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $74d7c5cb5b7ac75c$var$_react = $74d7c5cb5b7ac75c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $74d7c5cb5b7ac75c$var$_notification = $74d7c5cb5b7ac75c$var$_interopRequireDefault((parcelRequire("jDorM")));
    var $74d7c5cb5b7ac75c$var$_notification2 = $74d7c5cb5b7ac75c$var$_interopRequireDefault((parcelRequire("825vU")));
    function $74d7c5cb5b7ac75c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $74d7c5cb5b7ac75c$var$NotificationIcon = (props)=>$74d7c5cb5b7ac75c$var$_react.default.createElement($74d7c5cb5b7ac75c$var$_notification.default, Object.assign({
            LEGACY_fallbackIcon: $74d7c5cb5b7ac75c$var$_notification2.default
        }, props));
    $74d7c5cb5b7ac75c$var$NotificationIcon.Name = 'NotificationIconMigration';
    var $74d7c5cb5b7ac75c$var$_default = module.exports.default = $74d7c5cb5b7ac75c$var$NotificationIcon;
});
parcelRegister("cqOtB", function(module, exports) {
    $parcel$export(module.exports, "Notifications", ()=>$97a5809923f255bf$export$36ba2f559d49a8f6);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1X0L;
    var $2WekC;
    var $7Onh2;
    const $97a5809923f255bf$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
    const $97a5809923f255bf$export$36ba2f559d49a8f6 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { badge: badge, tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WekC")).BadgeContainer), {
            id: $97a5809923f255bf$var$NOTIFICATIONS_BADGE_ID,
            badge: badge,
            role: "listitem"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Onh2")).IconButton), {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("a1X0L"))))), {
                spacing: "spacious",
                color: "currentColor",
                label: typeof tooltip === 'string' ? tooltip : 'Notification Icon'
            }),
            tooltip: tooltip,
            ref: ref,
            "aria-describedby": $97a5809923f255bf$var$NOTIFICATIONS_BADGE_ID,
            ...iconButtonProps
        }));
    });
    var $97a5809923f255bf$export$2e2bcd8739ae039 = $97a5809923f255bf$export$36ba2f559d49a8f6;
});
parcelRegister("9Ugep", function(module, exports) {
    $parcel$export(module.exports, "SkeletonNotificationButton", ()=>$ae19a5528a9df359$export$a14f01df37978534);
    $parcel$export(module.exports, "Nav4SkeletonNotificationButton", ()=>$ae19a5528a9df359$export$6df5583c56de301f);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1X0L;
    var $jDorM;
    var $3XuTW;
    const $ae19a5528a9df359$export$a14f01df37978534 = ({ label: label = '' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XuTW")).SkeletonIconButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("a1X0L"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: label
        }));
    const $ae19a5528a9df359$export$6df5583c56de301f = ({ label: label = '' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XuTW")).SkeletonIconButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jDorM"))))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        }));
});
parcelRegister("2j6pM", function(module, exports) {
    $parcel$export(module.exports, "Notifications", ()=>$3ffd5a1d23c84e5b$export$36ba2f559d49a8f6);
    var $5uXOq = parcelRequire("5uXOq");
    var $jDorM;
    var $9MMay;
    var $Ee6JC;
    const $3ffd5a1d23c84e5b$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
    const $3ffd5a1d23c84e5b$export$36ba2f559d49a8f6 = (0, $5uXOq.forwardRef)(({ badge: badge, onClick: onClick, label: label = 'Notifications', isSelected: isSelected, testId: testId, interactionName: interactionName }, forwardedRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MMay")).BadgeContainer), {
            id: $3ffd5a1d23c84e5b$var$NOTIFICATIONS_BADGE_ID,
            badge: badge,
            role: "listitem"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Ee6JC")).IconButton), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jDorM"))))),
            label: label,
            onClick: onClick,
            appearance: "subtle",
            isSelected: isSelected,
            ref: forwardedRef,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName
        })));
});
parcelRegister("68lE4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a3cfbb7a61c4e64$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKAEK;
    var $fgkqi;
    function $3a3cfbb7a61c4e64$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
    const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
    const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
    const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
    const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
    const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
    const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
    const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
    const $3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
    const $3a3cfbb7a61c4e64$var$productLogoStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $3a3cfbb7a61c4e64$var$customMaxHeightStyles = {
        name: "31vqaf",
        styles: "max-height:28px"
    };
    const $3a3cfbb7a61c4e64$var$productIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
            display: 'none'
        }
    });
    const $3a3cfbb7a61c4e64$var$productHomeButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        padding: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        background: 'none',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: 'inherit',
        cursor: 'pointer',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:first-of-type': {
            marginInlineStart: 0
        },
        '&:hover': {
            backgroundColor: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
            boxShadow: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
            color: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
        },
        '&:active': {
            backgroundColor: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
            boxShadow: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
            color: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
        },
        '&:focus-visible': {
            backgroundColor: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
            color: `var(${$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
            outline: `2px solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`
        },
        'div&': {
            pointerEvents: 'none'
        },
        [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
            margin: `0 ${"var(--ds-space-100, 8px)"}`
        },
        [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
            margin: `0 ${"var(--ds-space-200, 16px)"}`
        }
    });
    const $3a3cfbb7a61c4e64$var$siteTitleStyles = {
        name: "1q75v0",
        styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
    };
    const $3a3cfbb7a61c4e64$var$CustomProductHome = (props)=>{
        const { iconAlt: iconAlt, iconUrl: iconUrl, logoAlt: logoAlt, logoUrl: logoUrl, href: href, onClick: onClick, siteTitle: siteTitle, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, ...rest } = props;
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const Tag = (0, (0, parcelRequire("fgkqi")).getTag)(onClick, href);
        const preventFocusRing = (event)=>{
            event.preventDefault();
            onMouseDown && onMouseDown(event);
        };
        const productHomeButtonDynamicStyles = {
            [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
            [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
            [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
            [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
            [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
            [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
            [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
            [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
            [$3a3cfbb7a61c4e64$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)(Tag, {
            href: href,
            style: productHomeButtonDynamicStyles,
            css: $3a3cfbb7a61c4e64$var$productHomeButtonStyles,
            onClick: onClick,
            onMouseDown: preventFocusRing,
            "data-testid": testId && `${testId}-container`,
            ...rest
        }, logoUrl && (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            style: {
                maxWidth: logoMaxWidth
            },
            css: [
                $3a3cfbb7a61c4e64$var$customMaxHeightStyles,
                $3a3cfbb7a61c4e64$var$productLogoStyles
            ],
            src: logoUrl,
            alt: logoAlt,
            "data-testid": testId && `${testId}-logo`,
            "data-vc": "custom-product-home-logo"
        }), iconUrl && (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            style: {
                maxWidth: logoMaxWidth
            },
            css: [
                $3a3cfbb7a61c4e64$var$customMaxHeightStyles,
                $3a3cfbb7a61c4e64$var$productIconStyles
            ],
            src: iconUrl,
            alt: iconAlt,
            "data-testid": testId && `${testId}-icon`,
            "data-vc": "custom-product-home-icon"
        })), siteTitle && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                borderRight: theme.mode.productHome.borderRight
            },
            css: $3a3cfbb7a61c4e64$var$siteTitleStyles,
            "data-testid": testId && `${testId}-site-title`
        }, siteTitle));
    };
    var $3a3cfbb7a61c4e64$export$2e2bcd8739ae039 = $3a3cfbb7a61c4e64$var$CustomProductHome;
});
parcelRegister("fgkqi", function(module, exports) {
    $parcel$export(module.exports, "getTag", ()=>$eb9d291932721df9$export$dad497fe1f6e27c0);
    const $eb9d291932721df9$export$dad497fe1f6e27c0 = (onClick, href)=>{
        if (href) return 'a';
        if (onClick) return 'button';
        return 'div';
    };
});
parcelRegister("esSwC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$538bd94a54e78f12$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKAEK;
    var $3mMDm;
    var $fgkqi;
    function $538bd94a54e78f12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $538bd94a54e78f12$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
    const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
    const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
    const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
    const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
    const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
    const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
    const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
    const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
    const $538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
    const $538bd94a54e78f12$var$productHomeButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        padding: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        background: 'none',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: 'inherit',
        cursor: 'pointer',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:first-of-type': {
            marginInlineStart: 0
        },
        '&:hover': {
            backgroundColor: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
            boxShadow: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
            color: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
        },
        '&:active': {
            backgroundColor: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
            boxShadow: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
            color: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
        },
        '&:focus-visible': {
            backgroundColor: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
            color: `var(${$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${"var(--ds-border-focused, #4C9AFF)"}`
        },
        'div&': {
            pointerEvents: 'none'
        },
        [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
            margin: `0 ${"var(--ds-space-100, 8px)"}`
        },
        [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
            margin: `0 ${"var(--ds-space-200, 16px)"}`
        }
    });
    const $538bd94a54e78f12$var$productLogoStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        maxWidth: `var(${$538bd94a54e78f12$var$VAR_LOGO_MAX_WIDTH})`,
        '& > *': {
            maxHeight: 24
        },
        '& > span > svg': {
            maxWidth: `var(${$538bd94a54e78f12$var$VAR_LOGO_MAX_WIDTH})`
        },
        [`@media (max-width: ${(0, $8acc83d90e579622$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $538bd94a54e78f12$var$customMaxHeightStyles = {
        name: "31vqaf",
        styles: "max-height:28px"
    };
    const $538bd94a54e78f12$var$productIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        '& > *': {
            maxHeight: 24
        },
        [`@media (min-width: ${0, $8acc83d90e579622$export$4033a111ca79977d}px)`]: {
            display: 'none'
        }
    });
    const $538bd94a54e78f12$var$siteTitleStyles = {
        name: "1q75v0",
        styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
    };
    const $538bd94a54e78f12$var$ProductHome = ({ icon: Icon, logo: Logo, siteTitle: siteTitle, onClick: onClick, href: href, onMouseDown: onMouseDown, testId: testId, logoMaxWidth: logoMaxWidth = 260, 'aria-label': ariaLabel, ...rest })=>{
        const theme = (0, (0, parcelRequire("gKAEK")).useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const { iconColor: iconColor = 'inherit', textColor: textColor = theme.mode.productHome.color } = theme.mode.productHome;
        const Tag = (0, (0, parcelRequire("fgkqi")).getTag)(onClick, href);
        const preventFocusRing = (e)=>{
            e.preventDefault();
            onMouseDown && onMouseDown(e);
        };
        const productHomeButtonDynamicStyles = (0, (0, parcelRequire("3mMDm")).stripEmptyProperties)({
            [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
            [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
            [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
            [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
            [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
            [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
            [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
            [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
            [$538bd94a54e78f12$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
            [$538bd94a54e78f12$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)(Tag, {
            style: productHomeButtonDynamicStyles,
            css: $538bd94a54e78f12$var$productHomeButtonStyles,
            href: href,
            onClick: onClick,
            onMouseDown: preventFocusRing,
            "data-testid": testId && `${testId}-container`,
            "aria-label": ariaLabel,
            ...rest
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $538bd94a54e78f12$var$customMaxHeightStyles,
                $538bd94a54e78f12$var$productLogoStyles
            ],
            "data-testid": testId && `${testId}-logo`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Logo, {
            iconColor: iconColor,
            textColor: textColor
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $538bd94a54e78f12$var$customMaxHeightStyles,
                $538bd94a54e78f12$var$productIconStyles
            ],
            "data-testid": testId && `${testId}-icon`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
            iconColor: iconColor
        }))), siteTitle && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                borderRight: theme.mode.productHome.borderRight
            },
            css: $538bd94a54e78f12$var$siteTitleStyles,
            "data-testid": testId && `${testId}-site-title`
        }, siteTitle));
    };
    var $538bd94a54e78f12$export$2e2bcd8739ae039 = $538bd94a54e78f12$var$ProductHome;
});
parcelRegister("8TWpC", function(module, exports) {
    $parcel$export(module.exports, "Settings", ()=>$a8d50d5b33301a3d$export$c72f6eaae7b9adff);
    var $5uXOq = parcelRequire("5uXOq");
    var $epOG5;
    var $6Dtpf;
    const $a8d50d5b33301a3d$export$c72f6eaae7b9adff = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Dtpf")).UserAction), {
            ...props,
            ref: ref,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("epOG5")))))
        }));
});
parcelRegister("6Dtpf", function(module, exports) {
    $parcel$export(module.exports, "UserAction", ()=>$594fea2a6857b8ff$export$d344b04822cd68e8);
    var $5uXOq = parcelRequire("5uXOq");
    var $eUDGK;
    var $Ee6JC;
    const $594fea2a6857b8ff$export$d344b04822cd68e8 = (0, $5uXOq.forwardRef)(({ children: children, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, forwardedRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eUDGK")).ListItem), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Ee6JC")).IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: children,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup
        })));
});
parcelRegister("3rGy0", function(module, exports) {
    $parcel$export(module.exports, "Settings", ()=>$78f794893daa6da1$export$c72f6eaae7b9adff);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2tiP;
    var $7Onh2;
    const $78f794893daa6da1$export$c72f6eaae7b9adff = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "listitem"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Onh2")).IconButton), {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("k2tiP"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: typeof tooltip === 'string' ? tooltip : 'Settings Icon'
            }),
            ref: ref,
            tooltip: tooltip,
            ...iconButtonProps
        }));
    });
    var $78f794893daa6da1$export$2e2bcd8739ae039 = $78f794893daa6da1$export$c72f6eaae7b9adff;
});
parcelRegister("cmbsU", function(module, exports) {
    $parcel$export(module.exports, "SkeletonSettingsButton", ()=>$87125a345dc924c4$export$914093d4d181ff4d);
    $parcel$export(module.exports, "Nav4SkeletonSettingsButton", ()=>$87125a345dc924c4$export$beac98f336d7b14f);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2tiP;
    var $epOG5;
    var $3XuTW;
    const $87125a345dc924c4$export$914093d4d181ff4d = ({ label: label = '' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XuTW")).SkeletonIconButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("k2tiP"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: label
        }));
    const $87125a345dc924c4$export$beac98f336d7b14f = ({ label: label = '' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XuTW")).SkeletonIconButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        }));
});
parcelRegister("35I4u", function(module, exports) {
    $parcel$export(module.exports, "SignIn", ()=>$04ceee4c8568d289$export$b64708c6f1b3ed96);
    var $5uXOq = parcelRequire("5uXOq");
    var $2zXpX;
    var $7Onh2;
    const $04ceee4c8568d289$export$b64708c6f1b3ed96 = (props)=>{
        const { tooltip: tooltip, ...iconButtonProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "listitem"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Onh2")).IconButton), {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2zXpX"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: typeof tooltip === 'string' ? tooltip : 'Sign-in Icon'
            }),
            tooltip: tooltip,
            ...iconButtonProps
        }));
    };
    var $04ceee4c8568d289$export$2e2bcd8739ae039 = $04ceee4c8568d289$export$b64708c6f1b3ed96;
});
parcelRegister("2zXpX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e0cf0c174283011$var$_react = $1e0cf0c174283011$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1e0cf0c174283011$var$_logIn = $1e0cf0c174283011$var$_interopRequireDefault((parcelRequire("pkYLA")));
    var $1e0cf0c174283011$var$_signIn = $1e0cf0c174283011$var$_interopRequireDefault((parcelRequire("71IBF")));
    function $1e0cf0c174283011$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e0cf0c174283011$var$LogInIcon = (props)=>$1e0cf0c174283011$var$_react.default.createElement($1e0cf0c174283011$var$_logIn.default, Object.assign({
            LEGACY_fallbackIcon: $1e0cf0c174283011$var$_signIn.default
        }, props));
    $1e0cf0c174283011$var$LogInIcon.Name = 'LogInIconMigration';
    var $1e0cf0c174283011$var$_default = module.exports.default = $1e0cf0c174283011$var$LogInIcon;
});
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx';
const $af03419a6de12610$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $af03419a6de12610$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $af03419a6de12610$export$13f57c02915787b3 = 'atlaskit-portal';
const $edbbaf000cbe1dd7$export$ed5835cc67e87f72 = 'akPortalMount';
const $edbbaf000cbe1dd7$export$80816bd900e5bd00 = 'akPortalUnmount';
const $ff8b18549b2c06bf$export$d6830277b06edd6 = 'normal';
const $ff8b18549b2c06bf$export$4f8f13a66ae77bdd = '--color';
const $ff8b18549b2c06bf$export$e9244ec13bd422b5 = '--bg-color';
const $ff8b18549b2c06bf$export$97e78d9745006c11 = '--bg-color-hover';
const $ff8b18549b2c06bf$export$291d63757828f290 = '--bg-color-active';
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';
$parcel$global.rlb("bYT2S");
